
export const API_ADDRESS = process.env.REACT_APP_API_ADDRESS
export const API_ADDRESS_LIVE = "https://staging-api.bnbguard.com.au"
export const BNBGUARD_COM_AU_API = "https://bnbguard.com.au/bnbguard-storage/bnbguard_api.php"
export const BNBGUARD_COM_AU_COUNCILS = "https://bnbguard.com.au/bnbguard-storage/councils"
export const BNBGUARD_COM_AU_SUBURBS = "https://bnbguard.com.au/bnbguard-storage/suburbs"
export const SOCKET_ADDRESS = process.env.REACT_APP_SOCKET_ADDRESS
export const { MONGO_CONNECTION_STRING } = process.env;
// export const LOGINAPI_ADDRESS = 'https://staging-users.bnbguard.com.au'
export const LOGINAPI_ADDRESS = 'https://login.bnbguard.com.au'; // 'https://users.bnbguard.com.au'
// export const LOGINAPI_ADDRESS = 'http://bnbguard-login'
// export const LOGINAPI_ADDRESS = 'http://localhost:5010'
export const SBI_API_ADDRESS = 'https://sbitest.sherlock.com.au/bnbguard/'
export const PLACES_API_KEY = 'AIzaSyBPBPA2YS0YhAM-Sox275fhV-WV9h8uFp0'
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiYm5iZ3VhcmQ4ODgiLCJhIjoiY2p3Nzh5cXQ1MWkwbTQ1czBtNm84NDJlbSJ9.SPGwPhu1vILcPFOglKXvDw'

export enum SuburbsDataType {
	listing = 'listing',
	property = 'property',
}

export enum SuburbDataType {
	listings = 'listings',
	properties = 'properties',
}

export const australiaTimezones = {
	nsw: 'Australia/Sydney',
	qld: 'Australia/Brisbane',
	sa: 'Australia/Adelaide',
	tas: 'Australia/Hobart',
	nt: 'Australia/Darwin',
	wa: 'Australia/Perth',
}

export const states = ['act','nsw','nt','qld','sa','tas','vic','wa']

export const listingTypesAll = [
	"",	
	"entire",
	"entire home",
	"private room",
	"shared room",
]

export const listingTypes = listingTypesAll.map( listingType => {
	return {
		label: listingType,
		value: listingType,
	}
})

export const columnWidths = {
	_id: 220,
	actions: 120,
	address: 250,
	approved: 77,
	assignedDate: 150,
	assignedByUser: 140,
	bathrooms: 120,
	bedrooms: 120,
	checked: 100,
	comment: 1300,
	created: 150,
	distance: 100,
	evidenceLink: 700,
	evidenceLink2: 700,
	geoLink: 200,
	guests: 80,
	host: 250,
	images: 70,
	imageSearch: 200,
	indicatedSuburb: 250,
	isActive: 90,
	isExact: 100,
	isRemoved: 130,
	lat: 120,
	link: 450,
	linkedListing: 120,
	listingId: 160,
	listingType: 120,
	lng: 120,
	matchType: 180,
	propertyType: 140,
	returnedByUser: 140,
	returnedReason: 300,
	roomType: 120,
	searchTitle: 185,
	sentToQADate: 150,
	status: 150,
	site: 120,
	streetName: 150,
	streetNo: 150,
	streetType: 120,
	suburb: 250,
	title: 400,
	unitId: 110,
	unitNo: 110,
	updated: 150,
	user: 150,
	userId: 150,
}

export const propertyTypesAll = [
	"",
	"aparthotel",
	"apartment",
	"barn",
	"bed and breakfast",
	"boutique hotel",
	"bungalow",
	"cabin",
	"camper/rv",
	"campsite",
	"caravan park",
	"chalet",
	"condominium",
	"cottage",
	"country house",
	"earth house",
	"farm stay",
	"farmhouse",
	"guest house",
	"guest room",
	"guest suite",
	"guesthouse",
	"holiday home",
	"holiday park",
	"hostel",
	"hotel",
	"house",
	"lodge",
	"loft",
	"motel",
	"other",
	"resort",
	"serviced apartment",
	"studio",
	"tent",
	"townhome",
	"townhouse",
	"unit",
	"villa",
	"yurt",
]

export const propertyTypes = propertyTypesAll.map( propertyType => {
	return {
		label: propertyType,
		value: propertyType,
	}
})


export const matchTypes = [
	{
		value: '',
		label: "",
	},
	{
		value: 'commercial',
		label: "Commercial",
	},
	{
		value: 'exact',
		label: "Exact",
	},
	{
		value: 'need unit id',
		label: "Need Unit ID",
	},
	{
		value: 'need street number',
		label: "Need Street Number",
	},
	{
		value: 'need street address',
		label: "Need Street Address",
	},
	{
		value: 'need more evidence',
		label: "Need More Evidence",
	},
	{
		value: 'no match',
		label: "No Match",
	},
	{
		value: 'removed',
		label: "Removed",
	},
	{
		value: 'similar',
		label: "Similar",
	},
]


export const matchValues = ['','commercial','exact','need street number', 'need street address','need unit id','need more evidence','no match','removed','similar']

export const streetTypesList = [
	{"accs": "access"},
	{"ally":"alley"},
	{"alwy":"alleyway"},
	{"ambl":"amble"},
	{"app":"approach"},
	{"arc":"arcade"},
	{"artl":"arterial"},
	{"arty":"artery"},
	{"ave":"avenue"},
	{"ba":"banan"},
	{"bank":"bank"},
	{"bend":"bend"},
	{"bwlk":"boardwalk"},
	{"blvd":"boulevard"},
	{"bvd":"boulevard"},
	{"br":"brace"},
	{"brae":"brae"},
	{"brk":"break"},
	{"brow":"brow"},
	{"bypa":"bypass"},
	{"bywy":"byway"},
	{"cct":"circuit"}, // see ct also
	{"cswy":"causeway"},
	{"ctr":"centre"},
	{"ch":"chase"},
	{"cir":"circle"},
	{"ct":"circuit"}, // see court
	{"crcs":"circus"},
	{"cl":"close"},
	{"con":"concourse"},
	{"cps":"copse"},
	{"cnr":"corner"},
	{"crn":"corner"},
	{"ct":"court"}, // see circuit
	{"ctyd":"courtyard"},
	{"cove":"cove"},
	{"cr":"crescent"},
	{"cres":"crescent"},
	{"crst":"crest"},
	{"crss":"cross"},
	{"crossing":"crossing"},
	{"cds":"cul-de-sac"},
	{"csac":"cul-de-sac"},
	{"cutt":"cutting"},
	{"dale":"dale"},
	{"dip":"dip"},
	{"dr":"drive"},
	{"dvwy":"driveway"},
	{"edge":"edge"},
	{"elb":"elbow"},
	{"end":"end"},
	{"ent":"entrance"},
	{"esp":"esplanade"},
	{"exp":"expressway"},
	{"fawy":"fairway"},
	{"firetrail":"firetrail"},
	{"folw":"follow"},
	{"form":"formation"},
	{"fwy":"freeway"},
	{"frtg":"frontage"},
	{"gap":"gap"},
	{"gdns":"gardens"},
	{"gte":"gate"},
	{"glde":"glade"},
	{"glen":"glen"},
	{"gra":"grange"},
	{"grn":"green"},
	{"gr":"grove"},
	{"hts":"heights"},
	{"hird":"highroad"},
	{"hwy":"highway"},
	{"hill":"hill"},
	{"intg":"interchange"},
	{"jnc":"junction"},
	{"key":"key"},
	{"lane":"lane"},
	{"lnwy":"laneway"},
	{"line":"line"},
	{"link":"link"},
	{"lkt":"lookout"},
	{"loop":"loop"},
	{"mall":"mall"},
	{"mndr":"meander"},
	{"mews":"mews"},
	{"mtwy":"motorway"},
	{"nook":"nook"},
	{"otlk":"outlook"},
	{"pde":"parade"},
	{"park":"park"},
	{"pwy":"parkway"},
	{"pass":"pass"},
	{"pway":"pathway"},
	{"piaz":"piazza"},
	{"pl":"place"},
	{"plza":"plaza"},
	{"pkt":"pocket"},
	{"pnt":"point"},
	{"port":"port"},
	{"prom":"promenade"},
	{"qdrt":"quadrant"},
	{"quay":"quay"},
	{"qys":"quays"},
	{"rmbl":"ramble"},
	{"rest":"rest"},
	{"rtt":"retreat"},
	{"rdge":"ridge"},
	{"rise":"rise"},
	{"rd":"road"},
	{"rty":"rotary"},
	{"rte":"route"},
	{"row":"row"},
	{"rue":"rue"},
	{"svwy":"serviceway"},
	{"shun":"shunt"},
	{"spur":"spur"},
	{"sq":"square"},
	{"st":"street"},
	{"sbwy":"subway"},
	{"tarn":"tarn"},
	{"tce":"terrace"},
	{"thfr":"thoroughfare"},
	{"tlwy":"tollway"},
	{"top":"top"},
	{"tor":"tor"},
	{"trk":"track"},
	{"trl":"trail"},
	{"turn":"turn"},
	{"upas":"underpass"},
	{"vale":"vale"},
	{"viad":"viaduct"},
	{"view":"view"},
	{"vsta":"vista"},
	{"walk":"walk"},
	{"wkwy":"walkway"},
	{"way":"way"},
	{"whrf":"wharf"},
	{"wynd":"wynd"},
]

export const streetTypesAll = [
	"",
	"access",
	"alley",
	"alleyway",
	"amble",
	"approach",
	"arcade",
	"arterial",
	"artery",
	"avenue",
	"banan",
	"bank",
	"bend",
	"boardwalk",
	"boulevard",
	"brace",
	"brae",
	"break",
	"brow",
	"bypass",
	"byway",
	"causeway",
	"centre",
	"chase",
	"circle",
	"circuit",
	"circus",
	"close",
	"concourse",
	"copse",
	"corner",
	"court",
	"courtyard",
	"cove",
	"crescent",
	"crest",
	"cross",
	"crossing",
	"cul-de-sac",
	"cutting",
	"dale",
	"dip",
	"drive",
	"driveway",
	"edge",
	"elbow",
	"end",
	"entrance",
	"esplanade",
	"expressway",
	"fairway",
	"firetrail",
	"follow",
	"formation",
	"freeway",
	"frontage",
	"gap",
	"gardens",
	"gate",
	"glade",
	"glen",
	"grange",
	"green",
	"grove",
	"heights",
	"highroad",
	"highway",
	"hill",
	"interchange",
	"junction",
	"key",
	"lane",
	"laneway",
	"line",
	"link",
	"lookout",
	"loop",
	"mall",
	"meander",
	"mews",
	"motorway",
	"nook",
	"outlook",
	"parade",
	"park",
	"parkway",
	"pass",
	"pathway",
	"piazza",
	"place",
	"plaza",
	"pocket",
	"point",
	"port",
	"promenade",
	"quadrant",
	"quay",
	"quays",
	"ramble",
	"rest",
	"retreat",
	"ridge",
	"rise",
	"road",
	"rotary",
	"route",
	"row",
	"rue",
	"serviceway",
	"shunt",
	"spur",
	"square",
	"street",
	"subway",
	"tarn",
	"terrace",
	"thoroughfare",
	"tollway",
	"top",
	"tor",
	"track",
	"trail",
	"turn",
	"underpass",
	"vale",
	"viaduct",
	"view",
	"vista",
	"walk",
	"walkway",
	"way",
	"wharf",
	"wynd",
]

export const streetTypes = streetTypesAll.map( streetType => {
	return {
		label: streetType,
		value: streetType,
	}
})

export const listingFields = {
	_id: {type: "string"},
	listingId: {type: "string"},
	site: {type: "string"},
	suburb: {type: "string"},
	link: {type: "string"},
	roomType: {type: "string"},
	propertyType: {type: "string"},
	isRemoved: {type: "dropdown", values: ["yes", "no"]},
	isExact: {type: "dropdown", values: ["yes", "no"]},
	host: {type: "string"},
	title: {type: "string"},
	guests: {type: "number"},
	bedrooms: {type: "number"},
	bathrooms: {type: "number"},
	indicatedSuburb: {type: "string"},
	address: {type: "string"},
	street: {type: "string"},
	propertyId: {type: "string"},
	property: {type: "string"},
	created: {type: "date"},
	updated: {type: "date"},
	lat: {type: "string"},
	lng: {type: "string"},
	geoLink: {type: "string"},
	imageSearch: {type: "string"},
	evidenceLink: {type: "string"},
	evidenceLink2: {type: "string"},
	unitNo: {type: "string"},
	streetNo: {type: "number"},
	streetName: {type: "string"},
	streetType: {type: "string"},
	matchType: {type: "dropdown", values: matchTypes},
	comment: {type: "string"},
}

export enum SCRAPE_TYPES {
  'listing' = 'listing',
  'meta' = 'meta',
  'info' = 'info',
  'availability' = 'availability',
  'reviews' = 'reviews',
}

export enum SCRAPE_STATUS {
  'pending' = 'pending',
  'active' = 'active',
  'finished' = 'finished',
  'skipped' = 'skipped',
  'failed' = 'failed',
}

export enum SITES {
  airbnb = 'airbnb',
  homeaway = 'homeaway',
  booking = 'booking',
}

export const suburbList = [
	{
		"town": "a1 mine settlement",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "aarons pass",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "abba river",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "abbey",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "abbeyard",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "abbeywood",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "abbotsbury",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "abbotsford",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "abbotsford",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "abbotsford",
		"state": "vic",
		"postcode": "3067"
	},
	{
		"town": "abbotsham",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "abeckett street",
		"state": "vic",
		"postcode": "8006"
	},
	{
		"town": "abels bay",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "abercorn",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "abercrombie",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "aberdare",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "aberdeen",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "aberdeen",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "aberfeldie",
		"state": "vic",
		"postcode": "3040"
	},
	{
		"town": "aberfeldy",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "aberfoyle",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "aberfoyle park",
		"state": "sa",
		"postcode": "5159"
	},
	{
		"town": "aberglasslyn",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "abergowrie",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "abermain",
		"state": "nsw",
		"postcode": "2326"
	},
	{
		"town": "abernethy",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "abington",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "abington",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "acacia creek",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "acacia gardens",
		"state": "nsw",
		"postcode": "2763"
	},
	{
		"town": "acacia hills",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "acacia hills",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "acacia park",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "acacia plateau",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "acacia ridge",
		"state": "qld",
		"postcode": "4110"
	},
	{
		"town": "acheron",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "acland",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "acton",
		"state": "act",
		"postcode": "2601"
	},
	{
		"town": "acton",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "acton park",
		"state": "tas",
		"postcode": "7170"
	},
	{
		"town": "acton park",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "adaminaby",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "adams estate",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "adamstown",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "adamstown heights",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "adare",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "adare",
		"state": "vic",
		"postcode": "3966"
	},
	{
		"town": "adavale",
		"state": "qld",
		"postcode": "4474"
	},
	{
		"town": "addington",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5001"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5800"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5810"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5839"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5880"
	},
	{
		"town": "adelaide",
		"state": "sa",
		"postcode": "5888"
	},
	{
		"town": "adelaide airport",
		"state": "sa",
		"postcode": "5950"
	},
	{
		"town": "adelaide lead",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "adelaide park",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "adelaide river",
		"state": "nt",
		"postcode": "846"
	},
	{
		"town": "adelaide university",
		"state": "sa",
		"postcode": "5005"
	},
	{
		"town": "adelong",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "adjungbilly",
		"state": "nsw",
		"postcode": "2727"
	},
	{
		"town": "advancetown",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "adventure bay",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "aeroglen",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "afterlee",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "agery",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "agnes",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "agnes banks",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "agnes water",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "agnew",
		"state": "wa",
		"postcode": "6435"
	},
	{
		"town": "aherrenge",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "ailsa",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "ainslie",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "airds",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "aire valley",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "aireys inlet",
		"state": "vic",
		"postcode": "3231"
	},
	{
		"town": "airlie beach",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "airly",
		"state": "nsw",
		"postcode": "2846"
	},
	{
		"town": "airly",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "airport west",
		"state": "vic",
		"postcode": "3042"
	},
	{
		"town": "airville",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "aitkenvale",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "ajana",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "akaroa",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "akolele",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "akuna bay",
		"state": "nsw",
		"postcode": "2084"
	},
	{
		"town": "alanvale",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "alawa",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "alawoona",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "albacutya",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "albanvale",
		"state": "vic",
		"postcode": "3021"
	},
	{
		"town": "albany",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "albany",
		"state": "wa",
		"postcode": "6332"
	},
	{
		"town": "albany creek",
		"state": "qld",
		"postcode": "4035"
	},
	{
		"town": "albert",
		"state": "nsw",
		"postcode": "2873"
	},
	{
		"town": "albert park",
		"state": "sa",
		"postcode": "5014"
	},
	{
		"town": "albert park",
		"state": "vic",
		"postcode": "3206"
	},
	{
		"town": "alberta",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "alberton",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "alberton",
		"state": "sa",
		"postcode": "5014"
	},
	{
		"town": "alberton",
		"state": "tas",
		"postcode": "7263"
	},
	{
		"town": "alberton",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "alberton west",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "albion",
		"state": "qld",
		"postcode": "4010"
	},
	{
		"town": "albion",
		"state": "vic",
		"postcode": "3020"
	},
	{
		"town": "albion heights",
		"state": "tas",
		"postcode": "7050"
	},
	{
		"town": "albion park",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "albion park rail",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "albury",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "albury msc",
		"state": "nsw",
		"postcode": "2708"
	},
	{
		"town": "alcomie",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "aldavilla",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "alderley",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "aldershot",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "aldersyde",
		"state": "wa",
		"postcode": "6306"
	},
	{
		"town": "aldgate",
		"state": "sa",
		"postcode": "5154"
	},
	{
		"town": "aldinga",
		"state": "sa",
		"postcode": "5173"
	},
	{
		"town": "aldinga beach",
		"state": "sa",
		"postcode": "5173"
	},
	{
		"town": "aldoga",
		"state": "qld",
		"postcode": "4694"
	},
	{
		"town": "alectown",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "alexander heights",
		"state": "wa",
		"postcode": "6064"
	},
	{
		"town": "alexandra",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "alexandra",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "alexandra bridge",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "alexandra headland",
		"state": "qld",
		"postcode": "4572"
	},
	{
		"town": "alexandra hills",
		"state": "qld",
		"postcode": "4161"
	},
	{
		"town": "alexandria",
		"state": "nsw",
		"postcode": "1435"
	},
	{
		"town": "alexandria",
		"state": "nsw",
		"postcode": "2015"
	},
	{
		"town": "alexandria",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "alford",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "alfords point",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "alfred cove",
		"state": "wa",
		"postcode": "6154"
	},
	{
		"town": "alfredton",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "alfredtown",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "algester",
		"state": "qld",
		"postcode": "4115"
	},
	{
		"town": "ali curung",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "alice",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "alice creek",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "alice river",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "alice springs",
		"state": "nt",
		"postcode": "870"
	},
	{
		"town": "alice springs",
		"state": "nt",
		"postcode": "871"
	},
	{
		"town": "alice springs",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "alison",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "alison",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "alkimos",
		"state": "wa",
		"postcode": "6038"
	},
	{
		"town": "allambee",
		"state": "vic",
		"postcode": "3823"
	},
	{
		"town": "allambee east",
		"state": "vic",
		"postcode": "3835"
	},
	{
		"town": "allambee reserve",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "allambee south",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "allambie",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "allambie heights",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "allanby",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "allandale",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "allandale",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "allanooka",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "allans flat",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "allans forest",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "allansford",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "allanson",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "allawah",
		"state": "nsw",
		"postcode": "2218"
	},
	{
		"town": "alleena",
		"state": "nsw",
		"postcode": "2671"
	},
	{
		"town": "allenby gardens",
		"state": "sa",
		"postcode": "5009"
	},
	{
		"town": "allendale",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "allendale east",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "allendale north",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "allens rivulet",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "allenstown",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "allenview",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "allestree",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "allgomera creek",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "alligator creek",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "alligator creek",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "allingham",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "allora",
		"state": "qld",
		"postcode": "4362"
	},
	{
		"town": "alloway",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "allworth",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "allynbrook",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "alma",
		"state": "sa",
		"postcode": "5401"
	},
	{
		"town": "alma",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "alma",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "alma park",
		"state": "nsw",
		"postcode": "2659"
	},
	{
		"town": "almaden",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "almonds",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "almurta",
		"state": "vic",
		"postcode": "3979"
	},
	{
		"town": "alonnah",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "aloomba",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "alpha",
		"state": "qld",
		"postcode": "4724"
	},
	{
		"town": "alphington",
		"state": "vic",
		"postcode": "3078"
	},
	{
		"town": "alpine",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "alroy",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "alsace",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "alstonvale",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "alstonville",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "altandi",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "alton downs",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "altona",
		"state": "sa",
		"postcode": "5351"
	},
	{
		"town": "altona",
		"state": "vic",
		"postcode": "3018"
	},
	{
		"town": "altona east",
		"state": "vic",
		"postcode": "3025"
	},
	{
		"town": "altona gate",
		"state": "vic",
		"postcode": "3025"
	},
	{
		"town": "altona meadows",
		"state": "vic",
		"postcode": "3028"
	},
	{
		"town": "altona north",
		"state": "vic",
		"postcode": "3025"
	},
	{
		"town": "alumy creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "alvie",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "alyangula",
		"state": "nt",
		"postcode": "885"
	},
	{
		"town": "amamoor",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "amaroo",
		"state": "act",
		"postcode": "2914"
	},
	{
		"town": "amaroo",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "amaroo",
		"state": "qld",
		"postcode": "4829"
	},
	{
		"town": "amata",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "ambarvale",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "ambergate",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "amberley",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "ambleside",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "ambrose",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "amby",
		"state": "qld",
		"postcode": "4462"
	},
	{
		"town": "amelup",
		"state": "wa",
		"postcode": "6338"
	},
	{
		"town": "american beach",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "american river",
		"state": "sa",
		"postcode": "5221"
	},
	{
		"town": "ameys track",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "amherst",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "amiens",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "amity point",
		"state": "qld",
		"postcode": "4183"
	},
	{
		"town": "ammerdown",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "amoonguna",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "amor",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "amphitheatre",
		"state": "vic",
		"postcode": "3468"
	},
	{
		"town": "anakie",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "anakie",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "anambah",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "ancona",
		"state": "vic",
		"postcode": "3715"
	},
	{
		"town": "andamooka",
		"state": "sa",
		"postcode": "5722"
	},
	{
		"town": "andergrove",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "anderleigh",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "anderson",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "ando",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "andover",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "andrews",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "andrews",
		"state": "sa",
		"postcode": "5454"
	},
	{
		"town": "andrews farm",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "andromache",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "anduramba",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "anembo",
		"state": "nsw",
		"postcode": "2621"
	},
	{
		"town": "angas plains",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "angas valley",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "angaston",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "angellala",
		"state": "qld",
		"postcode": "4455"
	},
	{
		"town": "angelo river",
		"state": "wa",
		"postcode": "6642"
	},
	{
		"town": "angip",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "angle park",
		"state": "sa",
		"postcode": "5010"
	},
	{
		"town": "angle vale",
		"state": "sa",
		"postcode": "5117"
	},
	{
		"town": "angledale",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "angledool",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "anglers paradise",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "anglers reach",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "anglers rest",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "anglesea",
		"state": "vic",
		"postcode": "3230"
	},
	{
		"town": "angleside",
		"state": "vic",
		"postcode": "3732"
	},
	{
		"town": "angourie",
		"state": "nsw",
		"postcode": "2464"
	},
	{
		"town": "angurugu",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "angus place",
		"state": "nsw",
		"postcode": "2845"
	},
	{
		"town": "angustown",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "anketell",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "anna bay",
		"state": "nsw",
		"postcode": "2316"
	},
	{
		"town": "annandale",
		"state": "nsw",
		"postcode": "2038"
	},
	{
		"town": "annandale",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "annangrove",
		"state": "nsw",
		"postcode": "2156"
	},
	{
		"town": "annerley",
		"state": "qld",
		"postcode": "4103"
	},
	{
		"town": "annie river",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "anniebrook",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "annuello",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "ansons bay",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "anstead",
		"state": "qld",
		"postcode": "4070"
	},
	{
		"town": "antechamber bay",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "antewenegerrde",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "anthony",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "anthonys lagoon",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "antiene",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "antigua",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "antill ponds",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "antwerp",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "anula",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "apamurra",
		"state": "sa",
		"postcode": "5237"
	},
	{
		"town": "apoinga",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "apollo bay",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "apollo bay",
		"state": "vic",
		"postcode": "3233"
	},
	{
		"town": "appila",
		"state": "sa",
		"postcode": "5480"
	},
	{
		"town": "appin",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "appin",
		"state": "vic",
		"postcode": "3578"
	},
	{
		"town": "appin park",
		"state": "vic",
		"postcode": "3677"
	},
	{
		"town": "appin south",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "apple tree creek",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "apple tree flat",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "appleby",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "applecross",
		"state": "wa",
		"postcode": "6153"
	},
	{
		"town": "applecross",
		"state": "wa",
		"postcode": "6953"
	},
	{
		"town": "applecross north lpo",
		"state": "wa",
		"postcode": "6153"
	},
	{
		"town": "applethorpe",
		"state": "qld",
		"postcode": "4378"
	},
	{
		"town": "appletree flat",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "apslawn",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "apsley",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "apsley",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "apsley",
		"state": "vic",
		"postcode": "3319"
	},
	{
		"town": "aquatic paradise",
		"state": "qld",
		"postcode": "4159"
	},
	{
		"town": "arable",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "arakoon",
		"state": "nsw",
		"postcode": "2431"
	},
	{
		"town": "araluen",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "aramac",
		"state": "qld",
		"postcode": "4726"
	},
	{
		"town": "aramara",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "arana hills",
		"state": "qld",
		"postcode": "4054"
	},
	{
		"town": "aranbanga",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "aranda",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "arapiles",
		"state": "vic",
		"postcode": "3409"
	},
	{
		"town": "ararat",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "ararat east",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "aratula",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "arawata",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "arcadia",
		"state": "nsw",
		"postcode": "2159"
	},
	{
		"town": "arcadia",
		"state": "qld",
		"postcode": "4819"
	},
	{
		"town": "arcadia",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "arcadia bay",
		"state": "qld",
		"postcode": "4819"
	},
	{
		"town": "arcadia south",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "arcadia vale",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "archdale",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "archdale junction",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "archer",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "archerfield",
		"state": "qld",
		"postcode": "4108"
	},
	{
		"town": "archerton",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "archies creek",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "ardachy",
		"state": "vic",
		"postcode": "3302"
	},
	{
		"town": "ardara",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "ardath",
		"state": "wa",
		"postcode": "6419"
	},
	{
		"town": "ardeer",
		"state": "vic",
		"postcode": "3022"
	},
	{
		"town": "ardglen",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "arding",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "ardlethan",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "ardmona",
		"state": "vic",
		"postcode": "3629"
	},
	{
		"town": "ardonachie",
		"state": "vic",
		"postcode": "3286"
	},
	{
		"town": "ardross",
		"state": "wa",
		"postcode": "6153"
	},
	{
		"town": "ardrossan",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "areegra",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "areyonga",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "argalong",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "argenton",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "argents hill",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "argoon",
		"state": "nsw",
		"postcode": "2707"
	},
	{
		"town": "argoon",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "argyle",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "argyle",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "argyle",
		"state": "wa",
		"postcode": "6239"
	},
	{
		"town": "ariah park",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "aringa",
		"state": "vic",
		"postcode": "3284"
	},
	{
		"town": "arkell",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "arkendeith",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "arkona",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "arkstone",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "armadale",
		"state": "vic",
		"postcode": "3143"
	},
	{
		"town": "armadale",
		"state": "wa",
		"postcode": "6112"
	},
	{
		"town": "armadale",
		"state": "wa",
		"postcode": "6992"
	},
	{
		"town": "armadale north",
		"state": "vic",
		"postcode": "3143"
	},
	{
		"town": "armatree",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "armidale",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "arminda",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "armstrong",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "armstrong beach",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "arncliffe",
		"state": "nsw",
		"postcode": "2205"
	},
	{
		"town": "arndell park",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "arno bay",
		"state": "sa",
		"postcode": "5603"
	},
	{
		"town": "arnold",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "arnold west",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "aroona",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "arrawarra",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "arrawarra headland",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "arrino",
		"state": "wa",
		"postcode": "6519"
	},
	{
		"town": "arrowsmith",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "artarmon",
		"state": "nsw",
		"postcode": "1570"
	},
	{
		"town": "artarmon",
		"state": "nsw",
		"postcode": "2064"
	},
	{
		"town": "arthur river",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "arthur river",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "arthurs creek",
		"state": "vic",
		"postcode": "3099"
	},
	{
		"town": "arthurs seat",
		"state": "vic",
		"postcode": "3936"
	},
	{
		"town": "arthurton",
		"state": "sa",
		"postcode": "5572"
	},
	{
		"town": "arthurville",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "arundel",
		"state": "qld",
		"postcode": "4214"
	},
	{
		"town": "arundell",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "ascot",
		"state": "qld",
		"postcode": "4007"
	},
	{
		"town": "ascot",
		"state": "qld",
		"postcode": "4359"
	},
	{
		"town": "ascot",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "ascot",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "ascot",
		"state": "wa",
		"postcode": "6104"
	},
	{
		"town": "ascot park",
		"state": "sa",
		"postcode": "5043"
	},
	{
		"town": "ascot vale",
		"state": "vic",
		"postcode": "3032"
	},
	{
		"town": "ashbourne",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "ashbourne",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "ashburton",
		"state": "vic",
		"postcode": "3147"
	},
	{
		"town": "ashbury",
		"state": "nsw",
		"postcode": "2193"
	},
	{
		"town": "ashby",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "ashby",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "ashby heights",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "ashcroft",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "ashens",
		"state": "vic",
		"postcode": "3390"
	},
	{
		"town": "ashfield",
		"state": "nsw",
		"postcode": "1800"
	},
	{
		"town": "ashfield",
		"state": "nsw",
		"postcode": "1801"
	},
	{
		"town": "ashfield",
		"state": "nsw",
		"postcode": "2131"
	},
	{
		"town": "ashfield",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "ashfield",
		"state": "wa",
		"postcode": "6054"
	},
	{
		"town": "ashford",
		"state": "nsw",
		"postcode": "2361"
	},
	{
		"town": "ashford",
		"state": "sa",
		"postcode": "5035"
	},
	{
		"town": "ashgrove",
		"state": "qld",
		"postcode": "4060"
	},
	{
		"town": "ashgrove west",
		"state": "qld",
		"postcode": "4060"
	},
	{
		"town": "ashley",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "ashmont",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "ashmore",
		"state": "qld",
		"postcode": "4214"
	},
	{
		"town": "ashmore city",
		"state": "qld",
		"postcode": "4214"
	},
	{
		"town": "ashton",
		"state": "sa",
		"postcode": "5137"
	},
	{
		"town": "ashtonfield",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "ashville",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "ashville",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "ashwell",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "ashwood",
		"state": "vic",
		"postcode": "3147"
	},
	{
		"town": "aspendale",
		"state": "vic",
		"postcode": "3195"
	},
	{
		"town": "aspendale gardens",
		"state": "vic",
		"postcode": "3195"
	},
	{
		"town": "aspley",
		"state": "qld",
		"postcode": "4034"
	},
	{
		"town": "asquith",
		"state": "nsw",
		"postcode": "2077"
	},
	{
		"town": "athelstone",
		"state": "sa",
		"postcode": "5076"
	},
	{
		"town": "atherton",
		"state": "qld",
		"postcode": "4883"
	},
	{
		"town": "athlone",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "athol",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "athol park",
		"state": "sa",
		"postcode": "5012"
	},
	{
		"town": "atholwood",
		"state": "nsw",
		"postcode": "2361"
	},
	{
		"town": "atitjere",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "atkinsons dam",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "ato activity statements",
		"state": "nsw",
		"postcode": "1391"
	},
	{
		"town": "attadale",
		"state": "wa",
		"postcode": "6156"
	},
	{
		"town": "attunga",
		"state": "nsw",
		"postcode": "2345"
	},
	{
		"town": "attwood",
		"state": "vic",
		"postcode": "3049"
	},
	{
		"town": "atwell",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "aubigny",
		"state": "qld",
		"postcode": "4401"
	},
	{
		"town": "aubinville",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "aubrey",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "auburn",
		"state": "nsw",
		"postcode": "1835"
	},
	{
		"town": "auburn",
		"state": "nsw",
		"postcode": "2144"
	},
	{
		"town": "auburn",
		"state": "sa",
		"postcode": "5451"
	},
	{
		"town": "auburn",
		"state": "tas",
		"postcode": "7209"
	},
	{
		"town": "auburn",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "auburn south",
		"state": "nsw",
		"postcode": "2144"
	},
	{
		"town": "auburn south",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "auburn vale",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "auchenflower",
		"state": "qld",
		"postcode": "4066"
	},
	{
		"town": "auchmore",
		"state": "vic",
		"postcode": "3571"
	},
	{
		"town": "audley",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "augathella",
		"state": "qld",
		"postcode": "4477"
	},
	{
		"town": "augusta",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "augustus downs",
		"state": "qld",
		"postcode": "4830"
	},
	{
		"town": "auldana",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "aurukun",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "aurville",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "austinmer",
		"state": "nsw",
		"postcode": "2515"
	},
	{
		"town": "austins ferry",
		"state": "tas",
		"postcode": "7011"
	},
	{
		"town": "austinville",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "austral",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "austral eden",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "australia fair",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "australia plains",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1209"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1210"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1211"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1212"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1213"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1214"
	},
	{
		"town": "australia square",
		"state": "nsw",
		"postcode": "1215"
	},
	{
		"town": "australian defence forces",
		"state": "nsw",
		"postcode": "2890"
	},
	{
		"town": "australian national university",
		"state": "act",
		"postcode": "200"
	},
	{
		"town": "australind",
		"state": "wa",
		"postcode": "6233"
	},
	{
		"town": "avalon",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "avalon",
		"state": "vic",
		"postcode": "3212"
	},
	{
		"town": "avalon beach",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "avenel",
		"state": "vic",
		"postcode": "3664"
	},
	{
		"town": "avenell heights",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "avenue range",
		"state": "sa",
		"postcode": "5273"
	},
	{
		"town": "avisford",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "avoca",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "avoca",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "avoca",
		"state": "tas",
		"postcode": "7213"
	},
	{
		"town": "avoca",
		"state": "vic",
		"postcode": "3467"
	},
	{
		"town": "avoca beach",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "avoca dell",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "avoca vale",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "avon",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "avon downs",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "avon plains",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "avondale",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "avondale",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "avondale heights",
		"state": "vic",
		"postcode": "3034"
	},
	{
		"town": "avonmore",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "avonsleigh",
		"state": "vic",
		"postcode": "3782"
	},
	{
		"town": "awaba",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "awonga",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "axe creek",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "axedale",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "ayers rock",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "aylmerton",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "ayr",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "ayrford",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "baala creek",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "baan baa",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "baandee",
		"state": "wa",
		"postcode": "6412"
	},
	{
		"town": "baarmutha",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "babakin",
		"state": "wa",
		"postcode": "6428"
	},
	{
		"town": "babbage island",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "babinda",
		"state": "qld",
		"postcode": "4861"
	},
	{
		"town": "bacala",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "bacchus marsh",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "back creek",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "back creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "back creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "back creek",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "back creek",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "back creek",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "back creek",
		"state": "vic",
		"postcode": "3749"
	},
	{
		"town": "back plains",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "back valley",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "backmede",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "backwater",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "baddaginnie",
		"state": "vic",
		"postcode": "3670"
	},
	{
		"town": "baddow",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "baden",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "baden powell",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "badgebup",
		"state": "wa",
		"postcode": "6317"
	},
	{
		"town": "badger creek",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "badger head",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "badgerin rock",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "badgerys creek",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "badgin",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "badgingarra",
		"state": "wa",
		"postcode": "6521"
	},
	{
		"town": "badjaling",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "badu island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "bael bael",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "baerami",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "baerami creek",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "baffle creek",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "bagdad",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "bagnoo",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "bago",
		"state": "nsw",
		"postcode": "2730"
	},
	{
		"town": "bagot",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "bagot well",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "bagotville",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "bagshot",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "bagshot north",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "bahgallah",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "bahrs scrub",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "bailey creek",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "bailieston",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "bailup",
		"state": "wa",
		"postcode": "6082"
	},
	{
		"town": "baird bay",
		"state": "sa",
		"postcode": "5671"
	},
	{
		"town": "bairnsdale",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "bajool",
		"state": "qld",
		"postcode": "4699"
	},
	{
		"town": "bakara",
		"state": "sa",
		"postcode": "5354"
	},
	{
		"town": "bakara well",
		"state": "sa",
		"postcode": "5354"
	},
	{
		"town": "bakers beach",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "bakers creek",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "bakers creek",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "bakers creek",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "bakers hill",
		"state": "wa",
		"postcode": "6562"
	},
	{
		"town": "bakers swamp",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "bakery hill",
		"state": "vic",
		"postcode": "3354"
	},
	{
		"town": "bakewell",
		"state": "nt",
		"postcode": "832"
	},
	{
		"town": "baking board",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "balaclava",
		"state": "vic",
		"postcode": "3183"
	},
	{
		"town": "balaklava",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "balarang",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "balberra",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "balcatta",
		"state": "wa",
		"postcode": "6021"
	},
	{
		"town": "balcatta",
		"state": "wa",
		"postcode": "6914"
	},
	{
		"town": "balcolyn",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "balcomba",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "balcombe",
		"state": "vic",
		"postcode": "3934"
	},
	{
		"town": "bald blair",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "bald hills",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "bald hills",
		"state": "qld",
		"postcode": "4036"
	},
	{
		"town": "bald hills",
		"state": "sa",
		"postcode": "5203"
	},
	{
		"town": "bald hills",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "bald knob",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "bald nob",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "bald ridge",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "bald rock",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "baldersleigh",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "baldina",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "baldivis",
		"state": "wa",
		"postcode": "6171"
	},
	{
		"town": "baldry",
		"state": "nsw",
		"postcode": "2867"
	},
	{
		"town": "balfes creek",
		"state": "qld",
		"postcode": "4820"
	},
	{
		"town": "balfour",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "balga",
		"state": "wa",
		"postcode": "6061"
	},
	{
		"town": "balgal",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "balgal beach",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "balgowan",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "balgowlah",
		"state": "nsw",
		"postcode": "2093"
	},
	{
		"town": "balgowlah heights",
		"state": "nsw",
		"postcode": "2093"
	},
	{
		"town": "balgownie",
		"state": "nsw",
		"postcode": "2519"
	},
	{
		"town": "balhannah",
		"state": "sa",
		"postcode": "5242"
	},
	{
		"town": "balickera",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "balingool",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "balingup",
		"state": "wa",
		"postcode": "6253"
	},
	{
		"town": "balintore",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "balkuling",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "ball bay",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "balladong",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "balladonia",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "balladoran",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "ballajura",
		"state": "wa",
		"postcode": "6066"
	},
	{
		"town": "ballalaba",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "ballan",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "ballandean",
		"state": "qld",
		"postcode": "4382"
	},
	{
		"town": "ballangeich",
		"state": "vic",
		"postcode": "3279"
	},
	{
		"town": "ballapur",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "ballarat",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "ballarat",
		"state": "vic",
		"postcode": "3353"
	},
	{
		"town": "ballarat central",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "ballarat east",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "ballarat forward no2",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "ballarat north",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "ballarat west",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "ballard",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "ballast head",
		"state": "sa",
		"postcode": "5221"
	},
	{
		"town": "ballaying",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "balldale",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "ballendella",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "ballengarra",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "balliang",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "balliang east",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "ballidu",
		"state": "wa",
		"postcode": "6606"
	},
	{
		"town": "ballimore",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "ballina",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "ballogie",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "ballymore",
		"state": "qld",
		"postcode": "4059"
	},
	{
		"town": "ballyroe",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "ballyrogan",
		"state": "vic",
		"postcode": "3375"
	},
	{
		"town": "balmain",
		"state": "nsw",
		"postcode": "2041"
	},
	{
		"town": "balmain east",
		"state": "nsw",
		"postcode": "2041"
	},
	{
		"town": "balmattum",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "balmoral",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "balmoral",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "balmoral",
		"state": "qld",
		"postcode": "4171"
	},
	{
		"town": "balmoral",
		"state": "vic",
		"postcode": "3407"
	},
	{
		"town": "balmoral ridge",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "balmoral village",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "balnagowan",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "balnarring",
		"state": "vic",
		"postcode": "3926"
	},
	{
		"town": "balnarring beach",
		"state": "vic",
		"postcode": "3926"
	},
	{
		"town": "balook",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "balranald",
		"state": "nsw",
		"postcode": "2715"
	},
	{
		"town": "balwarra heights",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "balwyn",
		"state": "vic",
		"postcode": "3103"
	},
	{
		"town": "balwyn east",
		"state": "vic",
		"postcode": "3129"
	},
	{
		"town": "balwyn north",
		"state": "vic",
		"postcode": "3104"
	},
	{
		"town": "bamaga",
		"state": "qld",
		"postcode": "4876"
	},
	{
		"town": "bamarang",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "bamawm",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "bamawm extension",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "bambaroo",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "bamboo creek",
		"state": "wa",
		"postcode": "6760"
	},
	{
		"town": "bambra",
		"state": "vic",
		"postcode": "3241"
	},
	{
		"town": "bambun",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "bamganie",
		"state": "vic",
		"postcode": "3333"
	},
	{
		"town": "ban ban",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "ban ban springs",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "banana",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "bancroft",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "bandiana",
		"state": "vic",
		"postcode": "3694"
	},
	{
		"town": "bandiana milpo",
		"state": "vic",
		"postcode": "3694"
	},
	{
		"town": "bandon",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "bandon grove",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "bandya",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "bangadang",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "bangalee",
		"state": "nsw",
		"postcode": "2541"
	},
	{
		"town": "bangalee",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "bangalow",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "bangerang",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "bangham",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "bangholme",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "bangor",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "bangor",
		"state": "sa",
		"postcode": "5481"
	},
	{
		"town": "bangor",
		"state": "tas",
		"postcode": "7267"
	},
	{
		"town": "banimboola",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "banjup",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "banks",
		"state": "act",
		"postcode": "2906"
	},
	{
		"town": "banks creek",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "banks island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "banksia",
		"state": "nsw",
		"postcode": "2216"
	},
	{
		"town": "banksia beach",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "banksia grove",
		"state": "wa",
		"postcode": "6031"
	},
	{
		"town": "banksia park",
		"state": "sa",
		"postcode": "5091"
	},
	{
		"town": "banksiadale",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "banksmeadow",
		"state": "nsw",
		"postcode": "2019"
	},
	{
		"town": "bankstown",
		"state": "nsw",
		"postcode": "1885"
	},
	{
		"town": "bankstown",
		"state": "nsw",
		"postcode": "1888"
	},
	{
		"town": "bankstown",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "bankstown aerodrome",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "bankstown north",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "bankstown square",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "bannaby",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "bannerton",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "bannister",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "bannister",
		"state": "wa",
		"postcode": "6390"
	},
	{
		"town": "bannockburn",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "bannockburn",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "banongill",
		"state": "vic",
		"postcode": "3361"
	},
	{
		"town": "banoon",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "banoon",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "banora point",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "banyabba",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "banyan",
		"state": "vic",
		"postcode": "3485"
	},
	{
		"town": "banyena",
		"state": "vic",
		"postcode": "3388"
	},
	{
		"town": "banyenong",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "banyo",
		"state": "qld",
		"postcode": "4014"
	},
	{
		"town": "banyule",
		"state": "vic",
		"postcode": "3084"
	},
	{
		"town": "bapaume",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "bar beach",
		"state": "nsw",
		"postcode": "2300"
	},
	{
		"town": "bar point",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "bara",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "barabba",
		"state": "sa",
		"postcode": "5460"
	},
	{
		"town": "baradine",
		"state": "nsw",
		"postcode": "2396"
	},
	{
		"town": "baraimal",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "baralaba",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "barambah",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "baranduda",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "barberton",
		"state": "wa",
		"postcode": "6510"
	},
	{
		"town": "barbigal",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "barcaldine",
		"state": "qld",
		"postcode": "4725"
	},
	{
		"town": "barcoongere",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "barden ridge",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "bardoc",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "bardon",
		"state": "qld",
		"postcode": "4065"
	},
	{
		"town": "bardon west",
		"state": "qld",
		"postcode": "4065"
	},
	{
		"town": "bardwell park",
		"state": "nsw",
		"postcode": "2207"
	},
	{
		"town": "bardwell valley",
		"state": "nsw",
		"postcode": "2207"
	},
	{
		"town": "baree",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "barellan",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "barellan point",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "barep",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "barfold",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "bargara",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bargo",
		"state": "nsw",
		"postcode": "2574"
	},
	{
		"town": "barham",
		"state": "nsw",
		"postcode": "2732"
	},
	{
		"town": "barigan",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "baringhup",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "baringhup west",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "barjarg",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "barker",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "barker creek flat",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "barkers creek",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "barkers vale",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "barkly",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "barkstead",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "barlil",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "barlows hill",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "barlyne",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "barmah",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "barmaryee",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "barmedman",
		"state": "nsw",
		"postcode": "2668"
	},
	{
		"town": "barmera",
		"state": "sa",
		"postcode": "5345"
	},
	{
		"town": "barmoya",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "barmundu",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "barna",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "barnadown",
		"state": "vic",
		"postcode": "3557"
	},
	{
		"town": "barnard",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "barnawartha",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "barnawartha north",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "barnes bay",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "barney point",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "barney view",
		"state": "qld",
		"postcode": "4287"
	},
	{
		"town": "barneys reef",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "barnidoota",
		"state": "sa",
		"postcode": "5434"
	},
	{
		"town": "barnsley",
		"state": "nsw",
		"postcode": "2278"
	},
	{
		"town": "baromi",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "barongarook",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "barongarook west",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "barooga",
		"state": "nsw",
		"postcode": "3644"
	},
	{
		"town": "baroon pocket",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "baroona",
		"state": "qld",
		"postcode": "4064"
	},
	{
		"town": "baroota",
		"state": "sa",
		"postcode": "5495"
	},
	{
		"town": "barraba",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "barrabool",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "barrack heights",
		"state": "nsw",
		"postcode": "2528"
	},
	{
		"town": "barrack point",
		"state": "nsw",
		"postcode": "2528"
	},
	{
		"town": "barraganyatti",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "barragga bay",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "barragup",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "barrakee",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "barrallier",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "barramornie",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "barramunga",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "barraport",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "barraport west",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "barratta",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "barren grounds",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "barrengarry",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "barretta",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "barretts creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "barrine",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "barringo",
		"state": "vic",
		"postcode": "3438"
	},
	{
		"town": "barrington",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "barrington",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "barrington tops",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "barringun",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "barrow creek",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "barrow island",
		"state": "wa",
		"postcode": "6712"
	},
	{
		"town": "barrs",
		"state": "vic",
		"postcode": "3831"
	},
	{
		"town": "barry",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "barry beach",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "barrys reef",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "bartle frere",
		"state": "qld",
		"postcode": "4861"
	},
	{
		"town": "barton",
		"state": "act",
		"postcode": "221"
	},
	{
		"town": "barton",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "barton",
		"state": "tas",
		"postcode": "7210"
	},
	{
		"town": "barton",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "barunah park",
		"state": "vic",
		"postcode": "3329"
	},
	{
		"town": "barunga",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "barunga gap",
		"state": "sa",
		"postcode": "5520"
	},
	{
		"town": "barwidgee",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "barwite",
		"state": "vic",
		"postcode": "3722"
	},
	{
		"town": "barwo",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "barwon downs",
		"state": "vic",
		"postcode": "3243"
	},
	{
		"town": "barwon heads",
		"state": "vic",
		"postcode": "3227"
	},
	{
		"town": "baryulgil",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "basalt",
		"state": "vic",
		"postcode": "3460"
	},
	{
		"town": "basin plain",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "basin pocket",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "basin view",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "baskerville",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "basket range",
		"state": "sa",
		"postcode": "5138"
	},
	{
		"town": "bass",
		"state": "vic",
		"postcode": "3991"
	},
	{
		"town": "bass hill",
		"state": "nsw",
		"postcode": "2197"
	},
	{
		"town": "bassendean",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "bassendean",
		"state": "wa",
		"postcode": "6054"
	},
	{
		"town": "bassendean",
		"state": "wa",
		"postcode": "6934"
	},
	{
		"town": "batar creek",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "batchelor",
		"state": "nt",
		"postcode": "845"
	},
	{
		"town": "batchica",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "bateau bay",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "batehaven",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "bateman",
		"state": "wa",
		"postcode": "6150"
	},
	{
		"town": "batemans bay",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "batesford",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "bathampton",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "bathumi",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "bathurst",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "bathurst island",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "bathurst street po",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "batlow",
		"state": "nsw",
		"postcode": "2730"
	},
	{
		"town": "battery hill",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "battery point",
		"state": "tas",
		"postcode": "7004"
	},
	{
		"town": "baudin",
		"state": "wa",
		"postcode": "6284"
	},
	{
		"town": "bauhinia",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "baulkamaugh",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "baulkham hills",
		"state": "nsw",
		"postcode": "1755"
	},
	{
		"town": "baulkham hills",
		"state": "nsw",
		"postcode": "2153"
	},
	{
		"town": "bauple",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "bauple forest",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "baw baw",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "baw baw village",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "bawley point",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "baxter",
		"state": "vic",
		"postcode": "3911"
	},
	{
		"town": "bay of shoals",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "bay village",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "bayah",
		"state": "sa",
		"postcode": "5260"
	},
	{
		"town": "bayfield",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "bayindeen",
		"state": "vic",
		"postcode": "3375"
	},
	{
		"town": "bayldon",
		"state": "nsw",
		"postcode": "2452"
	},
	{
		"town": "bayles",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "baynton",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "baynton",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "baynton east",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "bayonet head",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "bayrick",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "bayswater",
		"state": "vic",
		"postcode": "3153"
	},
	{
		"town": "bayswater",
		"state": "wa",
		"postcode": "6053"
	},
	{
		"town": "bayswater",
		"state": "wa",
		"postcode": "6933"
	},
	{
		"town": "bayswater north",
		"state": "vic",
		"postcode": "3153"
	},
	{
		"town": "bayview",
		"state": "nsw",
		"postcode": "2104"
	},
	{
		"town": "bayview",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "bayview heights",
		"state": "qld",
		"postcode": "4868"
	},
	{
		"town": "beach holm",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "beachlands",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "beachmere",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "beachport",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "beachside",
		"state": "tas",
		"postcode": "7005"
	},
	{
		"town": "beacon",
		"state": "wa",
		"postcode": "6472"
	},
	{
		"town": "beacon hill",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "beaconsfield",
		"state": "nsw",
		"postcode": "2014"
	},
	{
		"town": "beaconsfield",
		"state": "nsw",
		"postcode": "2015"
	},
	{
		"town": "beaconsfield",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "beaconsfield",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "beaconsfield",
		"state": "vic",
		"postcode": "3807"
	},
	{
		"town": "beaconsfield",
		"state": "wa",
		"postcode": "6162"
	},
	{
		"town": "beaconsfield upper",
		"state": "vic",
		"postcode": "3808"
	},
	{
		"town": "beadell",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "bealiba",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "bean creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bearbong",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "beardmores",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "beards",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "beargamil",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "bearii",
		"state": "vic",
		"postcode": "3641"
	},
	{
		"town": "bears lagoon",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "beauchamp",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "beaudesert",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "beaufort",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "beaufort",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "beaumaris",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "beaumaris",
		"state": "vic",
		"postcode": "3193"
	},
	{
		"town": "beaumont",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "beaumont",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "beaunart",
		"state": "vic",
		"postcode": "3695"
	},
	{
		"town": "beaury creek",
		"state": "nsw",
		"postcode": "2475"
	},
	{
		"town": "beauty point",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "beauty point",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "beauty point",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "beauville",
		"state": "vic",
		"postcode": "3163"
	},
	{
		"town": "beaver rock",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "beazleys bridge",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "beckenham",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "beckom",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "bective",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "bectric",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "bedford",
		"state": "wa",
		"postcode": "6052"
	},
	{
		"town": "bedford harbour",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "bedford park",
		"state": "sa",
		"postcode": "5042"
	},
	{
		"town": "bedford road",
		"state": "vic",
		"postcode": "3135"
	},
	{
		"town": "bedfordale",
		"state": "wa",
		"postcode": "6112"
	},
	{
		"town": "bedgerebong",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "bedourie",
		"state": "qld",
		"postcode": "4829"
	},
	{
		"town": "beeac",
		"state": "vic",
		"postcode": "3251"
	},
	{
		"town": "beebo",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "beech forest",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "beechboro",
		"state": "wa",
		"postcode": "6063"
	},
	{
		"town": "beecher",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "beechford",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "beechina",
		"state": "wa",
		"postcode": "6556"
	},
	{
		"town": "beechmont",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "beechwood",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "beechworth",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "beecroft",
		"state": "nsw",
		"postcode": "2119"
	},
	{
		"town": "beela",
		"state": "wa",
		"postcode": "6224"
	},
	{
		"town": "beelbangera",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "beelbi creek",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "beelerup",
		"state": "wa",
		"postcode": "6239"
	},
	{
		"town": "beeliar",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "beemunnel",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "beenak",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "beenleigh",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "beenong",
		"state": "wa",
		"postcode": "6353"
	},
	{
		"town": "beerburrum",
		"state": "qld",
		"postcode": "4517"
	},
	{
		"town": "beerik",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "beermullah",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "beeron",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "beerwah",
		"state": "qld",
		"postcode": "4519"
	},
	{
		"town": "bees creek",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "beetoomba",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "bega",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "beilpajah",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "bejoording",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "belair",
		"state": "sa",
		"postcode": "5052"
	},
	{
		"town": "belalie",
		"state": "sa",
		"postcode": "5491"
	},
	{
		"town": "belbora",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "belconnen",
		"state": "act",
		"postcode": "2616"
	},
	{
		"town": "belconnen",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "beldon",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "belfield",
		"state": "nsw",
		"postcode": "2191"
	},
	{
		"town": "belford",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "belfrayden",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "belgian gardens",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "belgrave",
		"state": "vic",
		"postcode": "3160"
	},
	{
		"town": "belgrave heights",
		"state": "vic",
		"postcode": "3160"
	},
	{
		"town": "belgrave south",
		"state": "vic",
		"postcode": "3160"
	},
	{
		"town": "belgravia",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "belhus",
		"state": "wa",
		"postcode": "6069"
	},
	{
		"town": "belimbla park",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "belivah",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "belka",
		"state": "wa",
		"postcode": "6417"
	},
	{
		"town": "bell",
		"state": "nsw",
		"postcode": "2786"
	},
	{
		"town": "bell",
		"state": "qld",
		"postcode": "4408"
	},
	{
		"town": "bell bay",
		"state": "tas",
		"postcode": "7253"
	},
	{
		"town": "bell bird creek",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "bell park",
		"state": "vic",
		"postcode": "3215"
	},
	{
		"town": "bell post hill",
		"state": "vic",
		"postcode": "3215"
	},
	{
		"town": "bella vista",
		"state": "nsw",
		"postcode": "2153"
	},
	{
		"town": "bellamack",
		"state": "nt",
		"postcode": "832"
	},
	{
		"town": "bellambi",
		"state": "nsw",
		"postcode": "2518"
	},
	{
		"town": "bellangry",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "bellara",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "bellarine",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "bellata",
		"state": "nsw",
		"postcode": "2397"
	},
	{
		"town": "bellawongarah",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "bellbird",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "bellbird park",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "bellbowrie",
		"state": "qld",
		"postcode": "4070"
	},
	{
		"town": "bellbrae",
		"state": "vic",
		"postcode": "3228"
	},
	{
		"town": "bellbridge",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "bellbrook",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "bellellen",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "bellenden ker",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "bellerive",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "bellevue",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "bellevue heights",
		"state": "sa",
		"postcode": "5050"
	},
	{
		"town": "bellevue hill",
		"state": "nsw",
		"postcode": "2023"
	},
	{
		"town": "bellfield",
		"state": "vic",
		"postcode": "3081"
	},
	{
		"town": "bellfield",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "bellhaven",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "belli park",
		"state": "qld",
		"postcode": "4562"
	},
	{
		"town": "bellimbopinni",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "bellingen",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "bellingham",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "bellmere",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "bellmount forest",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "bells beach",
		"state": "vic",
		"postcode": "3228"
	},
	{
		"town": "bells bridge",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "bells creek",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "bells flat",
		"state": "vic",
		"postcode": "3749"
	},
	{
		"town": "bells mountain",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "bellthorpe",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "belltrees",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "bellview",
		"state": "vic",
		"postcode": "3945"
	},
	{
		"town": "bellwood",
		"state": "nsw",
		"postcode": "2448"
	},
	{
		"town": "belmont",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "belmont",
		"state": "qld",
		"postcode": "4153"
	},
	{
		"town": "belmont",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "belmont",
		"state": "wa",
		"postcode": "6104"
	},
	{
		"town": "belmont",
		"state": "wa",
		"postcode": "6984"
	},
	{
		"town": "belmont heights",
		"state": "qld",
		"postcode": "4153"
	},
	{
		"town": "belmont north",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "belmont south",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "belmore",
		"state": "nsw",
		"postcode": "2192"
	},
	{
		"town": "belmore river",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "belmunda",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "belmunging",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "beloka",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "belowra",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "belrose",
		"state": "nsw",
		"postcode": "2085"
	},
	{
		"town": "belrose west",
		"state": "nsw",
		"postcode": "2085"
	},
	{
		"town": "belsar island",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "beltana",
		"state": "sa",
		"postcode": "5730"
	},
	{
		"town": "belton",
		"state": "sa",
		"postcode": "5432"
	},
	{
		"town": "belvedere",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "belvidere",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "bemboka",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "bemerside",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "bemm river",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "ben buckler",
		"state": "nsw",
		"postcode": "2026"
	},
	{
		"town": "ben buckley",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "ben bullen",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "ben lomond",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "ben lomond",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "ben nevis",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "ben valley",
		"state": "vic",
		"postcode": "3749"
	},
	{
		"town": "ben venue",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "bena",
		"state": "vic",
		"postcode": "3946"
	},
	{
		"town": "benair",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "benalla",
		"state": "vic",
		"postcode": "3671"
	},
	{
		"town": "benalla",
		"state": "vic",
		"postcode": "3672"
	},
	{
		"town": "benalla west",
		"state": "vic",
		"postcode": "3672"
	},
	{
		"town": "benambra",
		"state": "vic",
		"postcode": "3900"
	},
	{
		"town": "benandarah",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "benanee",
		"state": "nsw",
		"postcode": "2737"
	},
	{
		"town": "benaraby",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "benarca",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "benarch",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "benarkin",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "benarkin north",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "benayeo",
		"state": "vic",
		"postcode": "3319"
	},
	{
		"town": "benbournie",
		"state": "sa",
		"postcode": "5462"
	},
	{
		"town": "bencubbin",
		"state": "wa",
		"postcode": "6477"
	},
	{
		"town": "bend of islands",
		"state": "vic",
		"postcode": "3097"
	},
	{
		"town": "bendalong",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "bendeela",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "bendemeer",
		"state": "nsw",
		"postcode": "2355"
	},
	{
		"town": "bendering",
		"state": "wa",
		"postcode": "6367"
	},
	{
		"town": "bendick murrell",
		"state": "nsw",
		"postcode": "2803"
	},
	{
		"town": "bendigo",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "bendigo",
		"state": "vic",
		"postcode": "3552"
	},
	{
		"town": "bendigo forward",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "bendigo south",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "bendoc",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "bendolba",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "bendoura",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "beneree",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "benerembah",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "bengalla",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "benger",
		"state": "wa",
		"postcode": "6223"
	},
	{
		"town": "bengworden",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "bengworden north",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "benholme",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "beni",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "benjaberring",
		"state": "wa",
		"postcode": "6463"
	},
	{
		"town": "benjeroop",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "benloch",
		"state": "vic",
		"postcode": "3435"
	},
	{
		"town": "bennetts green",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "bennettswood",
		"state": "vic",
		"postcode": "3125"
	},
	{
		"town": "bennison",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "benobble",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "benowa",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "bensville",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "bentleigh",
		"state": "vic",
		"postcode": "3204"
	},
	{
		"town": "bentleigh east",
		"state": "vic",
		"postcode": "3165"
	},
	{
		"town": "bentley",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "bentley",
		"state": "wa",
		"postcode": "6102"
	},
	{
		"town": "bentley",
		"state": "wa",
		"postcode": "6982"
	},
	{
		"town": "benwerrin",
		"state": "vic",
		"postcode": "3235"
	},
	{
		"town": "berajondo",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "berala",
		"state": "nsw",
		"postcode": "2141"
	},
	{
		"town": "berambing",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "beremboke",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "beresfield",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "beresford",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "bergalia",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "berkeley",
		"state": "nsw",
		"postcode": "2506"
	},
	{
		"town": "berkeley vale",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "berkshire park",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "berlang",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "bermagui",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "bermagui south",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "bernier island",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "berowra",
		"state": "nsw",
		"postcode": "2081"
	},
	{
		"town": "berowra heights",
		"state": "nsw",
		"postcode": "2082"
	},
	{
		"town": "berowra waters",
		"state": "nsw",
		"postcode": "2082"
	},
	{
		"town": "berrambool",
		"state": "nsw",
		"postcode": "2548"
	},
	{
		"town": "berrambool",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "berrara",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "berremangra",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "berri",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "berrico",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "berridale",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "berriedale",
		"state": "tas",
		"postcode": "7011"
	},
	{
		"town": "berrigai",
		"state": "nsw",
		"postcode": "2397"
	},
	{
		"town": "berrigan",
		"state": "nsw",
		"postcode": "2712"
	},
	{
		"town": "berrilee",
		"state": "nsw",
		"postcode": "2159"
	},
	{
		"town": "berrima",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "berrimah",
		"state": "nt",
		"postcode": "828"
	},
	{
		"town": "berrimal",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "berrimal west",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "berrinba",
		"state": "qld",
		"postcode": "4117"
	},
	{
		"town": "berringa",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "berringama",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "berringer",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "berriwillock",
		"state": "vic",
		"postcode": "3531"
	},
	{
		"town": "berry",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "berry jerry",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "berry park",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "berry springs",
		"state": "nt",
		"postcode": "837"
	},
	{
		"town": "berrybank",
		"state": "vic",
		"postcode": "3323"
	},
	{
		"town": "berrys creek",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "berserker",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "berthong",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "bertram",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "berwick",
		"state": "vic",
		"postcode": "3806"
	},
	{
		"town": "beryl",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "bessiebelle",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "beswick",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "bet bet",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "bete belong north",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "bete bolong",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "bethanga",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "bethania",
		"state": "qld",
		"postcode": "4205"
	},
	{
		"town": "bethel",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "bethungra",
		"state": "nsw",
		"postcode": "2590"
	},
	{
		"town": "betley",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "beulah",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "beulah",
		"state": "vic",
		"postcode": "3395"
	},
	{
		"town": "beulah park",
		"state": "sa",
		"postcode": "5067"
	},
	{
		"town": "bevendale",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "beverford",
		"state": "vic",
		"postcode": "3590"
	},
	{
		"town": "beveridge",
		"state": "vic",
		"postcode": "3753"
	},
	{
		"town": "beverley",
		"state": "sa",
		"postcode": "5009"
	},
	{
		"town": "beverley",
		"state": "wa",
		"postcode": "6304"
	},
	{
		"town": "beverley park",
		"state": "nsw",
		"postcode": "2217"
	},
	{
		"town": "beverly hills",
		"state": "nsw",
		"postcode": "2209"
	},
	{
		"town": "bewong",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "bexhill",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "bexley",
		"state": "nsw",
		"postcode": "2207"
	},
	{
		"town": "bexley north",
		"state": "nsw",
		"postcode": "2207"
	},
	{
		"town": "bexley south",
		"state": "nsw",
		"postcode": "2207"
	},
	{
		"town": "beyal",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "biala",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "biarra",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "bibaringa",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "bibbenluke",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "biboohra",
		"state": "qld",
		"postcode": "4880"
	},
	{
		"town": "bibra lake",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "bicheno",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "bickley",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "bickley vale",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "bicton",
		"state": "wa",
		"postcode": "6157"
	},
	{
		"town": "biddaddaba",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "biddeston",
		"state": "qld",
		"postcode": "4401"
	},
	{
		"town": "biddon",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "bidwill",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "bidwill",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "big bell",
		"state": "wa",
		"postcode": "6640"
	},
	{
		"town": "big grove",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "big hill",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "big hill",
		"state": "vic",
		"postcode": "3231"
	},
	{
		"town": "big hill",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "big jacks creek",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "big pats creek",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "big ridge",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "big river",
		"state": "vic",
		"postcode": "3779"
	},
	{
		"town": "big springs",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "big tuan",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "bigga",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "biggara",
		"state": "vic",
		"postcode": "3707"
	},
	{
		"town": "biggenden",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "biggera waters",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "biggs flat",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "bilambil",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "bilambil heights",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "bilbarin",
		"state": "wa",
		"postcode": "6375"
	},
	{
		"town": "bilbul",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "bilgola",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "bilgola beach",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "bilgola plateau",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "bilinga",
		"state": "qld",
		"postcode": "4225"
	},
	{
		"town": "bilingurr",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "billa billa",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "billericay",
		"state": "wa",
		"postcode": "6368"
	},
	{
		"town": "billiatt",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "billimari",
		"state": "nsw",
		"postcode": "2804"
	},
	{
		"town": "billinudgel",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "billyrimba",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "billys creek",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "billywillinga",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "biloela",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "bilpin",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "bilwon",
		"state": "qld",
		"postcode": "4880"
	},
	{
		"town": "bimbaya",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "bimbi",
		"state": "nsw",
		"postcode": "2810"
	},
	{
		"town": "bimbimbie",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "bimbourne",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "binalong",
		"state": "nsw",
		"postcode": "2584"
	},
	{
		"town": "binalong bay",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "binbee",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "binda",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "bindawalla",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "bindera",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "bindi",
		"state": "vic",
		"postcode": "3896"
	},
	{
		"town": "bindi bindi",
		"state": "wa",
		"postcode": "6574"
	},
	{
		"town": "bindogundra",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "bindoon",
		"state": "wa",
		"postcode": "6502"
	},
	{
		"town": "bindoon training area",
		"state": "wa",
		"postcode": "6502"
	},
	{
		"town": "bingara",
		"state": "nsw",
		"postcode": "2404"
	},
	{
		"town": "bingeebeebra",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bingegang",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "bingie",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "bingil bay",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "binginwarri",
		"state": "vic",
		"postcode": "3966"
	},
	{
		"town": "bingleburra",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "bingo",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "bingo munjie",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "biniguy",
		"state": "nsw",
		"postcode": "2399"
	},
	{
		"town": "binjour",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "binjura",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "binna burra",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "binna burra",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "binnaway",
		"state": "nsw",
		"postcode": "2395"
	},
	{
		"town": "binningup",
		"state": "wa",
		"postcode": "6233"
	},
	{
		"town": "binnu",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "binnum",
		"state": "sa",
		"postcode": "5262"
	},
	{
		"town": "binya",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "biraganbil",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "birallee park",
		"state": "vic",
		"postcode": "3690"
	},
	{
		"town": "birchgrove",
		"state": "nsw",
		"postcode": "2041"
	},
	{
		"town": "birchip",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "birchip west",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "birchmont",
		"state": "wa",
		"postcode": "6214"
	},
	{
		"town": "birchmore",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "birchs bay",
		"state": "tas",
		"postcode": "7162"
	},
	{
		"town": "birdlip",
		"state": "nsw",
		"postcode": "2655"
	},
	{
		"town": "birdsville",
		"state": "qld",
		"postcode": "4482"
	},
	{
		"town": "birdwood",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "birdwood",
		"state": "sa",
		"postcode": "5234"
	},
	{
		"town": "birdwoodton",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "birganbigil",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "birkdale",
		"state": "qld",
		"postcode": "4159"
	},
	{
		"town": "birkenhead",
		"state": "sa",
		"postcode": "5015"
	},
	{
		"town": "birmingham gardens",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "birnam",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "birnam",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "birralee",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "birrego",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "birregurra",
		"state": "vic",
		"postcode": "3242"
	},
	{
		"town": "birriwa",
		"state": "nsw",
		"postcode": "2844"
	},
	{
		"town": "birrong",
		"state": "nsw",
		"postcode": "2143"
	},
	{
		"town": "birtinya",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "bishops bridge",
		"state": "nsw",
		"postcode": "2326"
	},
	{
		"town": "bishopsbourne",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "bithramere",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "bittern",
		"state": "vic",
		"postcode": "3918"
	},
	{
		"town": "black creek",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "black creek",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "black creek",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "black duck creek",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "black forest",
		"state": "sa",
		"postcode": "5035"
	},
	{
		"town": "black hill",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "black hill",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "black hill",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "black hills",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "black hollow",
		"state": "nsw",
		"postcode": "2828"
	},
	{
		"town": "black lead",
		"state": "vic",
		"postcode": "3357"
	},
	{
		"town": "black mountain",
		"state": "act",
		"postcode": "2601"
	},
	{
		"town": "black mountain",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "black mountain",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "black point",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "black range",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "black river",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "black river",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "black rock",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "black rock",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "black rock",
		"state": "vic",
		"postcode": "3193"
	},
	{
		"town": "black rock north",
		"state": "vic",
		"postcode": "3193"
	},
	{
		"town": "black snake",
		"state": "qld",
		"postcode": "4600"
	},
	{
		"town": "black snake creek",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "black springs",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "black springs",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "black swamp",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "black swamp",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "blackall",
		"state": "qld",
		"postcode": "4472"
	},
	{
		"town": "blackalls park",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "blackburn",
		"state": "vic",
		"postcode": "3130"
	},
	{
		"town": "blackburn north",
		"state": "vic",
		"postcode": "3130"
	},
	{
		"town": "blackburn south",
		"state": "vic",
		"postcode": "3130"
	},
	{
		"town": "blackbutt",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "blackbutt",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "blackbutt north",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "blackbutt south",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "blackdown",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "blackett",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "blackfellows creek",
		"state": "sa",
		"postcode": "5201"
	},
	{
		"town": "blackfields",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "blackford",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "blackheath",
		"state": "nsw",
		"postcode": "2785"
	},
	{
		"town": "blackheath",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "blackmans bay",
		"state": "tas",
		"postcode": "7052"
	},
	{
		"town": "blackmans flat",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "blackmans point",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "blacks beach",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "blacksmiths",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "blacksoil",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "blackstone",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "blackstone heights",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "blacktown",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "blacktown westpoint",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "blackville",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "blackwall",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "blackwall",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "blackwall",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "blackwarry",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "blackwater",
		"state": "qld",
		"postcode": "4717"
	},
	{
		"town": "blackwood",
		"state": "sa",
		"postcode": "5051"
	},
	{
		"town": "blackwood",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "blackwood creek",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "blackwood forest",
		"state": "vic",
		"postcode": "3992"
	},
	{
		"town": "blains",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "blair athol",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "blair athol",
		"state": "sa",
		"postcode": "5084"
	},
	{
		"town": "blair athol west",
		"state": "sa",
		"postcode": "5084"
	},
	{
		"town": "blairgowrie",
		"state": "vic",
		"postcode": "3942"
	},
	{
		"town": "blairmore",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "blairmount",
		"state": "nsw",
		"postcode": "2559"
	},
	{
		"town": "blakebrook",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "blakehurst",
		"state": "nsw",
		"postcode": "2221"
	},
	{
		"town": "blakeview",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "blakeville",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "blakney creek",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "blampied",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "blanchetown",
		"state": "sa",
		"postcode": "5357"
	},
	{
		"town": "blanchview",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "bland",
		"state": "nsw",
		"postcode": "2721"
	},
	{
		"town": "blandford",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "blanket flat",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "blantyre",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "blaxcell",
		"state": "nsw",
		"postcode": "2142"
	},
	{
		"town": "blaxland",
		"state": "nsw",
		"postcode": "2774"
	},
	{
		"town": "blaxland",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "blaxland east",
		"state": "nsw",
		"postcode": "2774"
	},
	{
		"town": "blaxlands creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "blaxlands flat",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "blaxlands ridge",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "blayney",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "blenheim",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "blenheim road",
		"state": "nsw",
		"postcode": "2113"
	},
	{
		"town": "blessington",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "bletchington",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "bletchley",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "blewitt springs",
		"state": "sa",
		"postcode": "5171"
	},
	{
		"town": "bli bli",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "bligh park",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "blighty",
		"state": "nsw",
		"postcode": "2713"
	},
	{
		"town": "blind bight",
		"state": "vic",
		"postcode": "3980"
	},
	{
		"town": "blinman",
		"state": "sa",
		"postcode": "5730"
	},
	{
		"town": "bloomfield",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "bloomfield",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "bloomfield",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "bloomfleet",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "bloomsbury",
		"state": "qld",
		"postcode": "4799"
	},
	{
		"town": "blowering",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "blowhard",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "blue bay",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "blue haven",
		"state": "nsw",
		"postcode": "2262"
	},
	{
		"town": "blue hills",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "blue knob",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "blue mountain",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "blue mountain heights",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "blue rocks",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "blue vale",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "bluewater",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "bluewater park",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "blueys beach",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "bluff",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "bluff beach",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "bluff point",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "bluff rock",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "blyth",
		"state": "sa",
		"postcode": "5462"
	},
	{
		"town": "blythe heads",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "blythewood",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "bo peep",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "boallia",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "boambee",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "boambee east",
		"state": "nsw",
		"postcode": "2452"
	},
	{
		"town": "boat harbour",
		"state": "nsw",
		"postcode": "2316"
	},
	{
		"town": "boat harbour",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "boat harbour",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "boat harbour beach",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "boatswain point",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "bobalong",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "bobbin head",
		"state": "nsw",
		"postcode": "2074"
	},
	{
		"town": "bobin",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "bobinawarrah",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "bobs creek",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "bobs farm",
		"state": "nsw",
		"postcode": "2316"
	},
	{
		"town": "bobundara",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "bocci",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "bochara",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "bocoble",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "bodalla",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "bodallin",
		"state": "wa",
		"postcode": "6424"
	},
	{
		"town": "bodangora",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "boddington",
		"state": "wa",
		"postcode": "6390"
	},
	{
		"town": "boeill creek",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "bogan",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "bogan gate",
		"state": "nsw",
		"postcode": "2876"
	},
	{
		"town": "bogandilla",
		"state": "qld",
		"postcode": "4425"
	},
	{
		"town": "bogangar",
		"state": "nsw",
		"postcode": "2488"
	},
	{
		"town": "bogantungan",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "bogee",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "boggabilla",
		"state": "nsw",
		"postcode": "2409"
	},
	{
		"town": "boggabri",
		"state": "nsw",
		"postcode": "2382"
	},
	{
		"town": "boggy-creek",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "bogong",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "bogong peaks wilderness",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "bohena creek",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "bohle",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "bohle plains",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "bohnock",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "boho",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "boho south",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "boigbeat",
		"state": "vic",
		"postcode": "3531"
	},
	{
		"town": "boigu",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "boigu island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "boinka",
		"state": "vic",
		"postcode": "3490"
	},
	{
		"town": "boisdale",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "bokal",
		"state": "wa",
		"postcode": "6392"
	},
	{
		"town": "bokarina",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "bokerup",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "bolangum",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "bolaro",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "bolga",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "bolgart",
		"state": "wa",
		"postcode": "6568"
	},
	{
		"town": "bolinda",
		"state": "vic",
		"postcode": "3432"
	},
	{
		"town": "bolinda vale",
		"state": "vic",
		"postcode": "3432"
	},
	{
		"town": "bolivar",
		"state": "sa",
		"postcode": "5110"
	},
	{
		"town": "bolivia",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "bollon",
		"state": "qld",
		"postcode": "4488"
	},
	{
		"town": "bolong",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "bolton",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "bolton point",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "bolwarra",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "bolwarra",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "bolwarra heights",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "bolwarrah",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "bom bom",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "bomaderry",
		"state": "nsw",
		"postcode": "2541"
	},
	{
		"town": "bombah point",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "bombala",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "bombay",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "bombira",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "bombo",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "bombowlee",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "bombowlee creek",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "bomen",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "bon accord",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "bon accord",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "bona vista",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "bona vista",
		"state": "vic",
		"postcode": "3820"
	},
	{
		"town": "bonalbo",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bonang",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "bonbeach",
		"state": "vic",
		"postcode": "3196"
	},
	{
		"town": "bond university",
		"state": "qld",
		"postcode": "4229"
	},
	{
		"town": "bondi",
		"state": "nsw",
		"postcode": "2026"
	},
	{
		"town": "bondi beach",
		"state": "nsw",
		"postcode": "2026"
	},
	{
		"town": "bondi forest",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "bondi junction",
		"state": "nsw",
		"postcode": "1355"
	},
	{
		"town": "bondi junction",
		"state": "nsw",
		"postcode": "2022"
	},
	{
		"town": "bondi junction plaza",
		"state": "nsw",
		"postcode": "2022"
	},
	{
		"town": "bondoola",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "bonegilla milpo",
		"state": "vic",
		"postcode": "3693"
	},
	{
		"town": "boneo",
		"state": "vic",
		"postcode": "3939"
	},
	{
		"town": "bong bong",
		"state": "nsw",
		"postcode": "2576"
	},
	{
		"town": "bongalong",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "bongaree",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "bongeen",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "bongongalong",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "boninjup",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "bonnells bay",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "bonnet bay",
		"state": "nsw",
		"postcode": "2226"
	},
	{
		"town": "bonnet hill",
		"state": "tas",
		"postcode": "7053"
	},
	{
		"town": "bonnie brae",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "bonnie doon",
		"state": "vic",
		"postcode": "3720"
	},
	{
		"town": "bonnie rock",
		"state": "wa",
		"postcode": "6479"
	},
	{
		"town": "bonniefield",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "bonnington park",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "bonny hills",
		"state": "nsw",
		"postcode": "2445"
	},
	{
		"town": "bonnyrigg",
		"state": "nsw",
		"postcode": "2177"
	},
	{
		"town": "bonnyrigg heights",
		"state": "nsw",
		"postcode": "2177"
	},
	{
		"town": "bonogin",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "bonshaw",
		"state": "nsw",
		"postcode": "2361"
	},
	{
		"town": "bonshaw",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "bonshaw",
		"state": "vic",
		"postcode": "3356"
	},
	{
		"town": "bonville",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "bonython",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "bonython",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "booborowie",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "boodarie",
		"state": "wa",
		"postcode": "6722"
	},
	{
		"town": "boodarockin",
		"state": "wa",
		"postcode": "6423"
	},
	{
		"town": "booerie creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "boogan",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "boogardie",
		"state": "wa",
		"postcode": "6638"
	},
	{
		"town": "booie",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "book book",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "bookaar",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "bookabie",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "bookara",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "booker bay",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "bookham",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "bookram",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "bool lagoon",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "boolading",
		"state": "wa",
		"postcode": "6392"
	},
	{
		"town": "boolambayte",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "boolardy",
		"state": "wa",
		"postcode": "6635"
	},
	{
		"town": "boolarong",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "boolaroo",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "boolarra",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "boolarra south",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "boolboonda",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "boolburra",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "boolcarroll",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "booleroo centre",
		"state": "sa",
		"postcode": "5482"
	},
	{
		"town": "boolgun",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "booligal",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "boolite",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "boomahnoomoonah",
		"state": "vic",
		"postcode": "3728"
	},
	{
		"town": "boomanoomana",
		"state": "nsw",
		"postcode": "2712"
	},
	{
		"town": "boomer bay",
		"state": "tas",
		"postcode": "7177"
	},
	{
		"town": "boomerang beach",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "boomey",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "boomi",
		"state": "nsw",
		"postcode": "2405"
	},
	{
		"town": "boomi creek",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "boomoodeerie",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "boompa",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "boonah",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "boonah",
		"state": "vic",
		"postcode": "3235"
	},
	{
		"town": "boonanarring",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "boonara",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "boonarga",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "boondall",
		"state": "qld",
		"postcode": "4034"
	},
	{
		"town": "boondall heights",
		"state": "qld",
		"postcode": "4034"
	},
	{
		"town": "boondandilla",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "boondooma",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "boonenne",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "boonerdo",
		"state": "sa",
		"postcode": "5633"
	},
	{
		"town": "boonoo boonoo",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "boonooroo",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "boonooroo plains",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "boorabee park",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "booragoon",
		"state": "wa",
		"postcode": "6154"
	},
	{
		"town": "booragoon",
		"state": "wa",
		"postcode": "6954"
	},
	{
		"town": "booragul",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "booral",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "booral",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "booralaming",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "booran road po",
		"state": "vic",
		"postcode": "3163"
	},
	{
		"town": "boorcan",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "boorga",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "boorganna",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "boorhaman",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "boorhaman east",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "boorhaman north",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "boorolong",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "boorolong",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "booroobin",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "boorook",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "boorool",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "booroolite",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "boorooma",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "boorooma",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "booroopki",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "booroorban",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "boorowa",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "boors plain",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "boort",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "boortkoi",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "boortkoi",
		"state": "vic",
		"postcode": "3273"
	},
	{
		"town": "boosey",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "bootawa",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "bootenal",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "boothenba",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "booti booti",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "booubyjan",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "booval",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "booval fair",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "booyal",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "booyong",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "bora ridge",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "borallon",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "boralma",
		"state": "vic",
		"postcode": "3682"
	},
	{
		"town": "borambil",
		"state": "nsw",
		"postcode": "2329"
	},
	{
		"town": "borambula",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "boraning",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "boranup",
		"state": "wa",
		"postcode": "6286"
	},
	{
		"town": "borden",
		"state": "wa",
		"postcode": "6338"
	},
	{
		"town": "border loop",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "border store",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "borderdale",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "bordertown",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "bordertown south",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "boree",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "boree",
		"state": "nsw",
		"postcode": "2864"
	},
	{
		"town": "boree creek",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "boreen",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "boreen point",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "borenore",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "borlands",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "bornholm",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "boro",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "boronia",
		"state": "vic",
		"postcode": "3155"
	},
	{
		"town": "boronia heights",
		"state": "qld",
		"postcode": "4124"
	},
	{
		"town": "boronia park",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "bororen",
		"state": "qld",
		"postcode": "4678"
	},
	{
		"town": "borrika",
		"state": "sa",
		"postcode": "5309"
	},
	{
		"town": "borroloola",
		"state": "nt",
		"postcode": "854"
	},
	{
		"town": "borung",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "boscabel",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "bossley park",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "bostobrick",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "bostocks creek",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "botany",
		"state": "nsw",
		"postcode": "1455"
	},
	{
		"town": "botany",
		"state": "nsw",
		"postcode": "2019"
	},
	{
		"town": "botfields",
		"state": "nsw",
		"postcode": "2876"
	},
	{
		"town": "bothwell",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "botobolar",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "bottle creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bouddi",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "boulder",
		"state": "wa",
		"postcode": "6432"
	},
	{
		"town": "boulder creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "bouldercombe",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "boulia",
		"state": "qld",
		"postcode": "4829"
	},
	{
		"town": "boundain",
		"state": "wa",
		"postcode": "6312"
	},
	{
		"town": "boundary bend",
		"state": "vic",
		"postcode": "3599"
	},
	{
		"town": "bourbah",
		"state": "nsw",
		"postcode": "2828"
	},
	{
		"town": "bourke",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "bourkelands",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "bournda",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "bournewood",
		"state": "nsw",
		"postcode": "2868"
	},
	{
		"town": "bouvard",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "bovell",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "bow",
		"state": "nsw",
		"postcode": "2329"
	},
	{
		"town": "bow bowing",
		"state": "nsw",
		"postcode": "2566"
	},
	{
		"town": "bow bridge",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "bowan park",
		"state": "nsw",
		"postcode": "2864"
	},
	{
		"town": "bowden",
		"state": "sa",
		"postcode": "5007"
	},
	{
		"town": "bowelling",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "bowen",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "bowen",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "bowen bridge",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "bowen hills",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "bowen mountain",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "bowenfels",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "bowenvale",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "bowenville",
		"state": "qld",
		"postcode": "4404"
	},
	{
		"town": "bower",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "bowes",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "boweya",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "boweya north",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "bowgada",
		"state": "wa",
		"postcode": "6623"
	},
	{
		"town": "bowhill",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "bowillia",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "bowler",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "bowling alley point",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "bowman",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "bowman farm",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "bowmans",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "bowmans creek",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "bowmans forest",
		"state": "vic",
		"postcode": "3735"
	},
	{
		"town": "bowna",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "bowning",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "bowral",
		"state": "nsw",
		"postcode": "2576"
	},
	{
		"town": "bowraville",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "bowser",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "box head",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "box hill",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "box hill",
		"state": "vic",
		"postcode": "3128"
	},
	{
		"town": "box hill central",
		"state": "vic",
		"postcode": "3128"
	},
	{
		"town": "box hill north",
		"state": "vic",
		"postcode": "3129"
	},
	{
		"town": "box hill south",
		"state": "vic",
		"postcode": "3128"
	},
	{
		"town": "box ridge",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "boxwood",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "boxwood hill",
		"state": "wa",
		"postcode": "6338"
	},
	{
		"town": "boya",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "boyanup",
		"state": "wa",
		"postcode": "6237"
	},
	{
		"town": "boydtown",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "boyer",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "boykambil",
		"state": "qld",
		"postcode": "4212"
	},
	{
		"town": "boyland",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "boyne island",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "boyne valley",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "boynedale",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "boyneside",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "boynewood",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "boys",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "boyup brook",
		"state": "wa",
		"postcode": "6244"
	},
	{
		"town": "bracalba",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "bracewell",
		"state": "qld",
		"postcode": "4695"
	},
	{
		"town": "bracken ridge",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "brackendale",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "bracknell",
		"state": "tas",
		"postcode": "7302"
	},
	{
		"town": "bradbury",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "bradbury",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "braddon",
		"state": "act",
		"postcode": "2612"
	},
	{
		"town": "bradford",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "bradfordville",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "bradvale",
		"state": "vic",
		"postcode": "3361"
	},
	{
		"town": "brady creek",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "bradys marsh",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "braefield",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "braemar",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "braemar",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "braemar forest",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "braemore",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "braeside",
		"state": "vic",
		"postcode": "3195"
	},
	{
		"town": "brahma lodge",
		"state": "sa",
		"postcode": "5109"
	},
	{
		"town": "braidwood",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "bramfield",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "bramley",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "brampton island",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "bramston beach",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "branch creek",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "branch creek",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "branchview",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "branditt",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "brandon",
		"state": "qld",
		"postcode": "4808"
	},
	{
		"town": "brandy creek",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "brandy creek",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "branga plains",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "branxholm",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "branxholme",
		"state": "vic",
		"postcode": "3302"
	},
	{
		"town": "branxton",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "branyan",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "brassall",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "brassall heights",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "brassi",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "braunstone",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "bray",
		"state": "sa",
		"postcode": "5276"
	},
	{
		"town": "bray park",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "bray park",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "braybrook",
		"state": "vic",
		"postcode": "3019"
	},
	{
		"town": "braybrook north",
		"state": "vic",
		"postcode": "3019"
	},
	{
		"town": "brays creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "brayton",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "breadalbane",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "breadalbane",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "breadalbane",
		"state": "tas",
		"postcode": "7258"
	},
	{
		"town": "break of day",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "breakaway",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "breakaway creek",
		"state": "vic",
		"postcode": "3303"
	},
	{
		"town": "breakfast creek",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "breakfast creek",
		"state": "qld",
		"postcode": "4010"
	},
	{
		"town": "breakfast point",
		"state": "nsw",
		"postcode": "2137"
	},
	{
		"town": "breakwater",
		"state": "vic",
		"postcode": "3219"
	},
	{
		"town": "bream creek",
		"state": "tas",
		"postcode": "7175"
	},
	{
		"town": "breamlea",
		"state": "vic",
		"postcode": "3227"
	},
	{
		"town": "bredbo",
		"state": "nsw",
		"postcode": "2626"
	},
	{
		"town": "breelong",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "breera",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "breeza",
		"state": "nsw",
		"postcode": "2381"
	},
	{
		"town": "bremer",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "bremer bay",
		"state": "wa",
		"postcode": "6338"
	},
	{
		"town": "brenanah",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "brenda",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "brendale",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "brentford square",
		"state": "vic",
		"postcode": "3131"
	},
	{
		"town": "brentwood",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "brentwood",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "brentwood",
		"state": "wa",
		"postcode": "6153"
	},
	{
		"town": "breona",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "breton bay",
		"state": "wa",
		"postcode": "6043"
	},
	{
		"town": "bretti",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "brewarrina",
		"state": "nsw",
		"postcode": "2839"
	},
	{
		"town": "brewongle",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "brewster",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "briagolong",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "briar hill",
		"state": "vic",
		"postcode": "3088"
	},
	{
		"town": "briarbrook",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "bribbaree",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "bribie island",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "bribie island north",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "brickmakers beach",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "bridge creek",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "bridge inn",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "bridgeman downs",
		"state": "qld",
		"postcode": "4035"
	},
	{
		"town": "bridgenorth",
		"state": "tas",
		"postcode": "7277"
	},
	{
		"town": "bridges",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "bridgetown",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "bridgewater",
		"state": "sa",
		"postcode": "5155"
	},
	{
		"town": "bridgewater",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "bridgewater",
		"state": "vic",
		"postcode": "3516"
	},
	{
		"town": "bridgewater north",
		"state": "vic",
		"postcode": "3516"
	},
	{
		"town": "bridgewater on loddon",
		"state": "vic",
		"postcode": "3516"
	},
	{
		"town": "bridgman",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "bridport",
		"state": "tas",
		"postcode": "7262"
	},
	{
		"town": "brierfield",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "brigadoon",
		"state": "wa",
		"postcode": "6069"
	},
	{
		"town": "brigalow",
		"state": "qld",
		"postcode": "4412"
	},
	{
		"town": "briggsvale",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "bright",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "brightly",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "brighton",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "brighton",
		"state": "sa",
		"postcode": "5048"
	},
	{
		"town": "brighton",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "brighton",
		"state": "vic",
		"postcode": "3186"
	},
	{
		"town": "brighton army camp",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "brighton beach",
		"state": "vic",
		"postcode": "3186"
	},
	{
		"town": "brighton east",
		"state": "vic",
		"postcode": "3187"
	},
	{
		"town": "brighton eventide",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "brighton nathan street",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "brighton north",
		"state": "vic",
		"postcode": "3186"
	},
	{
		"town": "brighton road",
		"state": "vic",
		"postcode": "3184"
	},
	{
		"town": "brighton-le-sands",
		"state": "nsw",
		"postcode": "2216"
	},
	{
		"town": "brightview",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "brightwaters",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "brigooda",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "bril bril",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "brim",
		"state": "vic",
		"postcode": "3391"
	},
	{
		"town": "brimbago",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "brimbin",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "brimboal",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "brimin",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "brimpaen",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "brindabella",
		"state": "nsw",
		"postcode": "2611"
	},
	{
		"town": "brinerville",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "bringalbert",
		"state": "vic",
		"postcode": "3319"
	},
	{
		"town": "bringalily",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "bringelly",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "bringenbrong",
		"state": "nsw",
		"postcode": "3707"
	},
	{
		"town": "bringo",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "brinkin",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "brinkley",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "brinkworth",
		"state": "sa",
		"postcode": "5464"
	},
	{
		"town": "brinsmead",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "4001"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9000"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9001"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9002"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9003"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9005"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9007"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9008"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9009"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9010"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9013"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9015"
	},
	{
		"town": "brisbane",
		"state": "qld",
		"postcode": "9020"
	},
	{
		"town": "brisbane adelaide street",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "brisbane airport",
		"state": "qld",
		"postcode": "4007"
	},
	{
		"town": "brisbane exhibition",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "brisbane gpo",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9016"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9017"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9018"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9019"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9021"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9022"
	},
	{
		"town": "brisbane gpo boxes",
		"state": "qld",
		"postcode": "9023"
	},
	{
		"town": "brisbane grove",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "brisbane market",
		"state": "qld",
		"postcode": "4106"
	},
	{
		"town": "brisbane myer centre",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "brisbane roma street",
		"state": "qld",
		"postcode": "4003"
	},
	{
		"town": "brisbane-city",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "brisk bay",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "brit brit",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "brittons swamp",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "brixton",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "broad arrow",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "broadbeach",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "broadbeach waters",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "broadford",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "broadlands",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "broadmarsh",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "broadmeadow",
		"state": "nsw",
		"postcode": "2292"
	},
	{
		"town": "broadmeadows",
		"state": "vic",
		"postcode": "3047"
	},
	{
		"town": "broadmere",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "broadview",
		"state": "sa",
		"postcode": "5083"
	},
	{
		"town": "broadwater",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "broadwater",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "broadwater",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "broadwater",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "broadwater",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "broadway",
		"state": "nsw",
		"postcode": "1401"
	},
	{
		"town": "broadway",
		"state": "nsw",
		"postcode": "2007"
	},
	{
		"town": "broadway nedlands",
		"state": "wa",
		"postcode": "6009"
	},
	{
		"town": "broadwood",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "brobenah",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "brocklehurst",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "brocklesby",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "brockley",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "brockman",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "brodribb river",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "brogans creek",
		"state": "nsw",
		"postcode": "2848"
	},
	{
		"town": "brogo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "broke",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "broken creek",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "broken head",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "broken hill",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "broken hill north",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "broken hill west",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "broken river",
		"state": "qld",
		"postcode": "4757"
	},
	{
		"town": "brolgan",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "brombin",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "bromelton",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "bromley",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "brompton",
		"state": "sa",
		"postcode": "5007"
	},
	{
		"town": "bronte",
		"state": "nsw",
		"postcode": "2024"
	},
	{
		"town": "bronte park",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "brook hall",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "brookdale",
		"state": "nsw",
		"postcode": "2656"
	},
	{
		"town": "brookdale",
		"state": "wa",
		"postcode": "6112"
	},
	{
		"town": "brooker",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "brookfield",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "brookfield",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "brookfield",
		"state": "vic",
		"postcode": "3338"
	},
	{
		"town": "brookhampton",
		"state": "wa",
		"postcode": "6239"
	},
	{
		"town": "brookhill",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "brooklana",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "brooklands",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "brooklands",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "brooklet",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "brooklet",
		"state": "vic",
		"postcode": "3392"
	},
	{
		"town": "brooklyn",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "brooklyn",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "brooklyn",
		"state": "vic",
		"postcode": "3012"
	},
	{
		"town": "brooklyn",
		"state": "vic",
		"postcode": "3025"
	},
	{
		"town": "brooklyn park",
		"state": "sa",
		"postcode": "5032"
	},
	{
		"town": "brooks bay",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "brooksby",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "brookside",
		"state": "vic",
		"postcode": "3740"
	},
	{
		"town": "brookside centre",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "brookstead",
		"state": "qld",
		"postcode": "4364"
	},
	{
		"town": "brookton",
		"state": "wa",
		"postcode": "6306"
	},
	{
		"town": "brookvale",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "brookville",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "brookville",
		"state": "vic",
		"postcode": "3896"
	},
	{
		"town": "brooloo",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "brooman",
		"state": "nsw",
		"postcode": "2538"
	},
	{
		"town": "broome",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "broomehill",
		"state": "wa",
		"postcode": "6318"
	},
	{
		"town": "broomehill east",
		"state": "wa",
		"postcode": "6318"
	},
	{
		"town": "broomehill village",
		"state": "wa",
		"postcode": "6318"
	},
	{
		"town": "broomehill west",
		"state": "wa",
		"postcode": "6318"
	},
	{
		"town": "broomfield",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "brooms head",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "brooweena",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "broughton",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "broughton vale",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "broulee",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "brovinia",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "brown beach",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "brown hill",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "brown hill",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "brown hill creek",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "brown range",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "brownlow",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "brownlow",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "brownlow hill",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "brownmore",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "browns creek",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "browns crossing",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "browns plains",
		"state": "qld",
		"postcode": "4118"
	},
	{
		"town": "browns plains",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "brownsleigh",
		"state": "qld",
		"postcode": "4118"
	},
	{
		"town": "brownsville",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "broxburn",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "bruarong",
		"state": "vic",
		"postcode": "3749"
	},
	{
		"town": "bruce",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "bruce",
		"state": "sa",
		"postcode": "5433"
	},
	{
		"town": "bruce rock",
		"state": "wa",
		"postcode": "6418"
	},
	{
		"town": "brucedale",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "bruces creek",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "brucknell",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "bruie plains",
		"state": "nsw",
		"postcode": "2875"
	},
	{
		"town": "bruinbun",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "brukunga",
		"state": "sa",
		"postcode": "5252"
	},
	{
		"town": "brunchilly",
		"state": "nt",
		"postcode": "861"
	},
	{
		"town": "brundee",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "brunette downs",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "brungle",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "brungle creek",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "brunkerville",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "brunswick",
		"state": "vic",
		"postcode": "3056"
	},
	{
		"town": "brunswick",
		"state": "vic",
		"postcode": "8538"
	},
	{
		"town": "brunswick",
		"state": "wa",
		"postcode": "6224"
	},
	{
		"town": "brunswick east",
		"state": "vic",
		"postcode": "3057"
	},
	{
		"town": "brunswick heads",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "brunswick west",
		"state": "vic",
		"postcode": "3055"
	},
	{
		"town": "brush creek",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "brushgrove",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "brushy creek",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "bruthen",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "bryans gap",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "bryden",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "buangor",
		"state": "vic",
		"postcode": "3375"
	},
	{
		"town": "buaraba",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "buaraba south",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "bucasia",
		"state": "qld",
		"postcode": "4750"
	},
	{
		"town": "bucca",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bucca wauka",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "buccan",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "buccarumbi",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "buccleuch",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "buchan",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "buchan point",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "buchan south",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "buchanan",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "buchanan",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "buchanan",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "bucheen creek",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "buchfelde",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "buckajo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "buckaroo",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "buckenbowra",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "buckenderra",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "buckendoon",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "bucketty",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "buckingham",
		"state": "sa",
		"postcode": "5270"
	},
	{
		"town": "buckingham",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "buckland",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "buckland",
		"state": "vic",
		"postcode": "3740"
	},
	{
		"town": "buckland",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "buckland park",
		"state": "sa",
		"postcode": "5120"
	},
	{
		"town": "buckleboo",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "buckley",
		"state": "vic",
		"postcode": "3240"
	},
	{
		"town": "buckley swamp",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "buckrabanyule",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "buddabaddah",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "budden",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "budderoo",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "buddina",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "buddong",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "buderim",
		"state": "qld",
		"postcode": "4556"
	},
	{
		"town": "budgee",
		"state": "qld",
		"postcode": "4359"
	},
	{
		"town": "budgee budgee",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "budgeree",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "budgeree east",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "budgerum east",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "budgewoi",
		"state": "nsw",
		"postcode": "2262"
	},
	{
		"town": "buff point",
		"state": "nsw",
		"postcode": "2262"
	},
	{
		"town": "buffalo",
		"state": "vic",
		"postcode": "3958"
	},
	{
		"town": "buffalo creek",
		"state": "vic",
		"postcode": "3958"
	},
	{
		"town": "buffalo river",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "bugaldie",
		"state": "nsw",
		"postcode": "2357"
	},
	{
		"town": "bugle hut",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "bugle hut",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "builyan",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "bukali",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "bukalong",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "bukkulla",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "bulahdelah",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "bulart",
		"state": "vic",
		"postcode": "3314"
	},
	{
		"town": "bulby brush",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "buldah",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "bulga",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "bulga",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "bulga forest",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "bulgarra",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "bulgary",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "bulgobac",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "bulgoback",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "bulimba",
		"state": "qld",
		"postcode": "4171"
	},
	{
		"town": "bulingary",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "bull creek",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "bull creek",
		"state": "wa",
		"postcode": "6149"
	},
	{
		"town": "bull plain",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "bull swamp",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "bulla",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "bulla",
		"state": "vic",
		"postcode": "3428"
	},
	{
		"town": "bulla creek",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "bullabul",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "bullabulling",
		"state": "wa",
		"postcode": "6429"
	},
	{
		"town": "bullaburra",
		"state": "nsw",
		"postcode": "2784"
	},
	{
		"town": "bullagreen",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "bullarah",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "bullaring",
		"state": "wa",
		"postcode": "6373"
	},
	{
		"town": "bullarook",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "bullarto",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "bullarto south",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "bullawa creek",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "bullcamp",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "bulldog",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bulleen",
		"state": "vic",
		"postcode": "3105"
	},
	{
		"town": "bulleen south",
		"state": "vic",
		"postcode": "3105"
	},
	{
		"town": "bullengarook",
		"state": "vic",
		"postcode": "3437"
	},
	{
		"town": "bullfinch",
		"state": "wa",
		"postcode": "6484"
	},
	{
		"town": "bulli",
		"state": "nsw",
		"postcode": "2516"
	},
	{
		"town": "bulli creek",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "bulli tops",
		"state": "nsw",
		"postcode": "2516"
	},
	{
		"town": "bulliac",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "bullio",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "bullioh",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "bullock hills",
		"state": "wa",
		"postcode": "6317"
	},
	{
		"town": "bullsbrook",
		"state": "wa",
		"postcode": "6084"
	},
	{
		"town": "bullumwaal",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "bullyard",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "buln buln",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "buln buln east",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "bulong",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "bulwer",
		"state": "qld",
		"postcode": "4025"
	},
	{
		"town": "bulwer island",
		"state": "qld",
		"postcode": "4008"
	},
	{
		"town": "bulyee",
		"state": "wa",
		"postcode": "6306"
	},
	{
		"town": "bulyeroi",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "bumbaldry",
		"state": "nsw",
		"postcode": "2794"
	},
	{
		"town": "bumbang",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "bumberrah",
		"state": "vic",
		"postcode": "3902"
	},
	{
		"town": "bumberry",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "bumbunga",
		"state": "sa",
		"postcode": "5520"
	},
	{
		"town": "bunbartha",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "bunburra",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "bunbury",
		"state": "sa",
		"postcode": "5266"
	},
	{
		"town": "bunbury",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "bunbury",
		"state": "wa",
		"postcode": "6231"
	},
	{
		"town": "bundabah",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "bundaberg",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bundaberg central",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bundaberg east",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bundaberg north",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bundaberg south",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bundaberg west",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "bundaburrah",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "bundagen",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "bundalaguah",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "bundall",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "bundalong",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "bundalong south",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "bundamba",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "bundanoon",
		"state": "nsw",
		"postcode": "2578"
	},
	{
		"town": "bundarbo",
		"state": "nsw",
		"postcode": "2726"
	},
	{
		"town": "bundarra",
		"state": "nsw",
		"postcode": "2359"
	},
	{
		"town": "bundeena",
		"state": "nsw",
		"postcode": "2230"
	},
	{
		"town": "bundella",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "bundemar",
		"state": "nsw",
		"postcode": "2823"
	},
	{
		"town": "bundewallah",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "bundey",
		"state": "sa",
		"postcode": "5320"
	},
	{
		"town": "bundgeam",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "bunding",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "bundook",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "bundoora",
		"state": "vic",
		"postcode": "3083"
	},
	{
		"town": "bundri",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "bundure",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "bung bong",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "bunga",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "bungaba",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "bungabbee",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "bungadoo",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "bungador",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "bungal",
		"state": "vic",
		"postcode": "3334"
	},
	{
		"town": "bungalally",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "bungalora",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "bungalow",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "bungama",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "bungana",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "bungarby",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "bungaree",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "bungaree",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "bungawalbin",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bungeet",
		"state": "vic",
		"postcode": "3726"
	},
	{
		"town": "bungeet west",
		"state": "vic",
		"postcode": "3726"
	},
	{
		"town": "bungendore",
		"state": "nsw",
		"postcode": "2621"
	},
	{
		"town": "bungil",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "bungonia",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "bungowannah",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "bungulla",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "bungulla",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "bungulluping",
		"state": "wa",
		"postcode": "6413"
	},
	{
		"town": "bunguluke",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "bungundarra",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "bungunya",
		"state": "qld",
		"postcode": "4494"
	},
	{
		"town": "bungwahl",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "buniche",
		"state": "wa",
		"postcode": "6353"
	},
	{
		"town": "buninjon lake",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "buninyong",
		"state": "vic",
		"postcode": "3357"
	},
	{
		"town": "bunjil",
		"state": "wa",
		"postcode": "6623"
	},
	{
		"town": "bunjurgen",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "bunkers hill",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "bunnaloo",
		"state": "nsw",
		"postcode": "2731"
	},
	{
		"town": "bunnan",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "buntine",
		"state": "wa",
		"postcode": "6613"
	},
	{
		"town": "bunya",
		"state": "qld",
		"postcode": "4055"
	},
	{
		"town": "bunya creek",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "bunya mountains",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "bunyah",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "bunyan",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "bunyip",
		"state": "vic",
		"postcode": "3815"
	},
	{
		"town": "bunyip north",
		"state": "vic",
		"postcode": "3815"
	},
	{
		"town": "buraja",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "burakin",
		"state": "wa",
		"postcode": "6467"
	},
	{
		"town": "buranda",
		"state": "qld",
		"postcode": "4102"
	},
	{
		"town": "burbank",
		"state": "qld",
		"postcode": "4156"
	},
	{
		"town": "burbong",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "burburgate",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "burcher",
		"state": "nsw",
		"postcode": "2671"
	},
	{
		"town": "burdell",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "burdett",
		"state": "nsw",
		"postcode": "2804"
	},
	{
		"town": "burdett",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "bureen",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "burekup",
		"state": "wa",
		"postcode": "6227"
	},
	{
		"town": "burges",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "burgooney",
		"state": "nsw",
		"postcode": "2672"
	},
	{
		"town": "burgowan",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "burkes bridge",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "burkes flat",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "burketown",
		"state": "qld",
		"postcode": "4830"
	},
	{
		"town": "burleigh centre",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "burleigh heads",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "burleigh town",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "burleigh waters",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "burlong",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "burma road",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "burnbank",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "burncluith",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "burndale",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "burnett creek",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "burnett downs",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "burnett heads",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "burnewang",
		"state": "vic",
		"postcode": "3558"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7915"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7916"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7917"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7918"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7919"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7920"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7921"
	},
	{
		"town": "burnie",
		"state": "tas",
		"postcode": "7922"
	},
	{
		"town": "burnley",
		"state": "vic",
		"postcode": "3121"
	},
	{
		"town": "burns",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "burns",
		"state": "wa",
		"postcode": "6028"
	},
	{
		"town": "burns creek",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "burnsfield",
		"state": "sa",
		"postcode": "5520"
	},
	{
		"town": "burnside",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "burnside",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "burnside",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "burnside",
		"state": "vic",
		"postcode": "3023"
	},
	{
		"town": "burnside",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "burnt bridge",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "burnt creek",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "burnt yards",
		"state": "nsw",
		"postcode": "2792"
	},
	{
		"town": "buronga",
		"state": "nsw",
		"postcode": "2739"
	},
	{
		"town": "burpengary",
		"state": "qld",
		"postcode": "4505"
	},
	{
		"town": "burra",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "burra",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "burra",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "burra creek",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "burra eastern districts",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "burraboi",
		"state": "nsw",
		"postcode": "2732"
	},
	{
		"town": "burrabunnia",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "burracoppin",
		"state": "wa",
		"postcode": "6421"
	},
	{
		"town": "burradoo",
		"state": "nsw",
		"postcode": "2576"
	},
	{
		"town": "burraduc",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "burraga",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "burragate",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "burramine",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "burramine south",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "burrandana",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "burraneer",
		"state": "nsw",
		"postcode": "2230"
	},
	{
		"town": "burrangong",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "burrapine",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "burrawang",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "burrell creek",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "burren junction",
		"state": "nsw",
		"postcode": "2386"
	},
	{
		"town": "burrereo",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "burrier",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "burrill lake",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "burringbar",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "burrinjuck",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "burroin",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "burrong north",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "burroway",
		"state": "nsw",
		"postcode": "2821"
	},
	{
		"town": "burrowye",
		"state": "vic",
		"postcode": "3709"
	},
	{
		"town": "burrum",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "burrum heads",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "burrum river",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "burrum town",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "burrumbeet",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "burrumboot east",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "burrumbuttock",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "burrundulla",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "burrungule",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "burswood",
		"state": "wa",
		"postcode": "6100"
	},
	{
		"town": "burton",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "burton",
		"state": "sa",
		"postcode": "5110"
	},
	{
		"town": "burtville",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "burua",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "burwood",
		"state": "nsw",
		"postcode": "1805"
	},
	{
		"town": "burwood",
		"state": "nsw",
		"postcode": "2134"
	},
	{
		"town": "burwood",
		"state": "vic",
		"postcode": "3125"
	},
	{
		"town": "burwood east",
		"state": "vic",
		"postcode": "3151"
	},
	{
		"town": "burwood heights",
		"state": "nsw",
		"postcode": "2136"
	},
	{
		"town": "burwood heights",
		"state": "qld",
		"postcode": "4161"
	},
	{
		"town": "burwood heights",
		"state": "vic",
		"postcode": "3151"
	},
	{
		"town": "burwood north",
		"state": "nsw",
		"postcode": "2134"
	},
	{
		"town": "busby",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "busbys flat",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "bushfield",
		"state": "vic",
		"postcode": "3281"
	},
	{
		"town": "bushland beach",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "bushy creek",
		"state": "vic",
		"postcode": "3293"
	},
	{
		"town": "bushy park",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "bushy park",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "bushy park",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "busselton",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "butchers ridge",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "bute",
		"state": "sa",
		"postcode": "5560"
	},
	{
		"town": "butler",
		"state": "sa",
		"postcode": "5605"
	},
	{
		"town": "butler",
		"state": "wa",
		"postcode": "6036"
	},
	{
		"town": "butlers gorge",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "buttaba",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "buttai",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "butterwick",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "buxton",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "buxton",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "buxton",
		"state": "vic",
		"postcode": "3711"
	},
	{
		"town": "byabarra",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "byadbo wilderness",
		"state": "nsw",
		"postcode": "2633"
	},
	{
		"town": "byaduk",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "byaduk north",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "byaduk north",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "byamee",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "byangum",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "byawatha",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "bybera",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "byee",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "byellee",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "byfield",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "byford",
		"state": "wa",
		"postcode": "6122"
	},
	{
		"town": "bygalorie",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "bylands",
		"state": "vic",
		"postcode": "3762"
	},
	{
		"town": "bylong",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "byng",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "byrneside",
		"state": "vic",
		"postcode": "3617"
	},
	{
		"town": "byrnestown",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "byrneville",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "byrock",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "byron bay",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "byrrill creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "bywong",
		"state": "nsw",
		"postcode": "2621"
	},
	{
		"town": "cabanandra",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "cabarita",
		"state": "nsw",
		"postcode": "2137"
	},
	{
		"town": "cabarita",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "cabarita beach",
		"state": "nsw",
		"postcode": "2488"
	},
	{
		"town": "cabarlah",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "cabbage tree",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "cabbage tree",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "cabbage tree creek",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "cabbage tree island",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "cabbage tree point",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "cable beach",
		"state": "wa",
		"postcode": "6726"
	},
	{
		"town": "caboolture",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "caboonbah",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "cabramatta",
		"state": "nsw",
		"postcode": "2166"
	},
	{
		"town": "cabramatta west",
		"state": "nsw",
		"postcode": "2166"
	},
	{
		"town": "cabramurra",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "cadell",
		"state": "sa",
		"postcode": "5321"
	},
	{
		"town": "cadello",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "cadgee",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "cadia",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "cadoux",
		"state": "wa",
		"postcode": "6466"
	},
	{
		"town": "caerleon",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "caffey",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "caffreys flat",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "caiguna",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "cainbable",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "cairn curran reservoir",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "cairncross",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "cairns",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "cairns bay",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "cairns central",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "cairns north",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "cairns orchid plaza",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "cal lal",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "calala",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "calamia",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "calamvale",
		"state": "qld",
		"postcode": "4116"
	},
	{
		"town": "calare",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "calarie",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "calavos",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "calca",
		"state": "sa",
		"postcode": "5671"
	},
	{
		"town": "calcarra",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "calder",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "calder park",
		"state": "vic",
		"postcode": "3037"
	},
	{
		"town": "caldermeade",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "calders",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "caldervale",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "calderwood",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "caldwell",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "calen",
		"state": "qld",
		"postcode": "4798"
	},
	{
		"town": "calga",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "calgoa",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "calico creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "califat",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "california gully",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "calimo",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "calingiri",
		"state": "wa",
		"postcode": "6569"
	},
	{
		"town": "calingunee",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "caliph",
		"state": "sa",
		"postcode": "5310"
	},
	{
		"town": "calista",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "calivil",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "caljie",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "callaghan",
		"state": "nsw",
		"postcode": "2308"
	},
	{
		"town": "callaghans creek",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "callaghans creeks",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "callala bay",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "callala beach",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "callandoon",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "callawadda",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "callemondah",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "callide",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "callignee",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "callignee north",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "callington",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "calliope",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "calliope",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "callungra",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "calomba",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "caloola",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "caloote",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "calorafield",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "caloundra",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "caloundra west",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "calperum",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "calrossie",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "caltowie",
		"state": "sa",
		"postcode": "5490"
	},
	{
		"town": "calulu",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "calvert",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "calwalla",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "calwell",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "camballin",
		"state": "wa",
		"postcode": "6728"
	},
	{
		"town": "cambalong",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "cambarville",
		"state": "vic",
		"postcode": "3779"
	},
	{
		"town": "cambellup",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "camberwell",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "camberwell",
		"state": "vic",
		"postcode": "3124"
	},
	{
		"town": "camberwell",
		"state": "vic",
		"postcode": "8626"
	},
	{
		"town": "camberwell",
		"state": "vic",
		"postcode": "8627"
	},
	{
		"town": "camberwell east",
		"state": "vic",
		"postcode": "3126"
	},
	{
		"town": "camberwell north",
		"state": "vic",
		"postcode": "3124"
	},
	{
		"town": "camberwell south",
		"state": "vic",
		"postcode": "3124"
	},
	{
		"town": "camberwell west",
		"state": "vic",
		"postcode": "3124"
	},
	{
		"town": "cambewarra",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "camboon",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "camboon",
		"state": "qld",
		"postcode": "4719"
	},
	{
		"town": "cambooya",
		"state": "qld",
		"postcode": "4358"
	},
	{
		"town": "cambra",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "cambrai",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "cambrian hill",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "cambridge",
		"state": "tas",
		"postcode": "7170"
	},
	{
		"town": "cambridge gardens",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "cambridge park",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "cambroon",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "camdale",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "camden",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "camden head",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "camden park",
		"state": "nsw",
		"postcode": "2568"
	},
	{
		"town": "camden park",
		"state": "sa",
		"postcode": "5038"
	},
	{
		"town": "camden south",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "camellia",
		"state": "nsw",
		"postcode": "2142"
	},
	{
		"town": "camena",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "cameron corner",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "camira",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "camira",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "camira creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "cammeray",
		"state": "nsw",
		"postcode": "2062"
	},
	{
		"town": "camoola",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "camooweal",
		"state": "qld",
		"postcode": "4828"
	},
	{
		"town": "camp corner",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "camp hill",
		"state": "qld",
		"postcode": "4152"
	},
	{
		"town": "camp mountain",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "campania",
		"state": "tas",
		"postcode": "7026"
	},
	{
		"town": "campaspe west",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "campbell",
		"state": "act",
		"postcode": "2612"
	},
	{
		"town": "campbell creek",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "campbell town",
		"state": "tas",
		"postcode": "7210"
	},
	{
		"town": "campbellfield",
		"state": "vic",
		"postcode": "3061"
	},
	{
		"town": "campbells bridge",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "campbells creek",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "campbells forest",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "campbelltown",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "campbelltown",
		"state": "sa",
		"postcode": "5074"
	},
	{
		"town": "campbelltown",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "campbelltown north",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "camperdown",
		"state": "nsw",
		"postcode": "1450"
	},
	{
		"town": "camperdown",
		"state": "nsw",
		"postcode": "2050"
	},
	{
		"town": "camperdown",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "campion",
		"state": "wa",
		"postcode": "6421"
	},
	{
		"town": "campoona",
		"state": "sa",
		"postcode": "5640"
	},
	{
		"town": "campsie",
		"state": "nsw",
		"postcode": "2194"
	},
	{
		"town": "campvale",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "campwin beach",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "cams wharf",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "canada bay",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "canadian",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "canadian bay",
		"state": "vic",
		"postcode": "3930"
	},
	{
		"town": "canadian lead",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "canaga",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "canal creek",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "canary island",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "canary island",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "canbelego",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "canberra",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "canberra",
		"state": "act",
		"postcode": "2601"
	},
	{
		"town": "cancanning",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "candelo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "cane",
		"state": "wa",
		"postcode": "6710"
	},
	{
		"town": "caneland",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "cangai",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "cangara",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "cania",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "caniaba",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "caniambo",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "canley heights",
		"state": "nsw",
		"postcode": "2166"
	},
	{
		"town": "canley vale",
		"state": "nsw",
		"postcode": "2166"
	},
	{
		"town": "cann river",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "canna",
		"state": "wa",
		"postcode": "6627"
	},
	{
		"town": "cannawigara",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "canni creek",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "cannie",
		"state": "vic",
		"postcode": "3540"
	},
	{
		"town": "cannindah",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "canning bridge applecross",
		"state": "wa",
		"postcode": "6153"
	},
	{
		"town": "canning creek",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "canning mills",
		"state": "wa",
		"postcode": "6111"
	},
	{
		"town": "canning vale",
		"state": "wa",
		"postcode": "6155"
	},
	{
		"town": "canning vale",
		"state": "wa",
		"postcode": "6971"
	},
	{
		"town": "canning vale south",
		"state": "wa",
		"postcode": "6155"
	},
	{
		"town": "cannington",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "cannington",
		"state": "wa",
		"postcode": "6980"
	},
	{
		"town": "cannington",
		"state": "wa",
		"postcode": "6987"
	},
	{
		"town": "cannon creek",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "cannon hill",
		"state": "qld",
		"postcode": "4170"
	},
	{
		"town": "cannon valley",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "cannons creek",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "cannonvale",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "cannum",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "canobolas",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "canoelands",
		"state": "nsw",
		"postcode": "2157"
	},
	{
		"town": "canonba",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "canoona",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "canowie",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "canowie belt",
		"state": "sa",
		"postcode": "5420"
	},
	{
		"town": "canowindra",
		"state": "nsw",
		"postcode": "2804"
	},
	{
		"town": "canowindra",
		"state": "qld",
		"postcode": "4209"
	},
	{
		"town": "canteen creek",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "canterbury",
		"state": "nsw",
		"postcode": "2193"
	},
	{
		"town": "canterbury",
		"state": "vic",
		"postcode": "3126"
	},
	{
		"town": "canton beach",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "canunda",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "canungra",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "canyonleigh",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "capalaba",
		"state": "qld",
		"postcode": "4157"
	},
	{
		"town": "capalaba west",
		"state": "qld",
		"postcode": "4157"
	},
	{
		"town": "caparra",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "cape barren island",
		"state": "tas",
		"postcode": "7257"
	},
	{
		"town": "cape borda",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "cape bridgewater",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "cape burney",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "cape clear",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "cape cleveland",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "cape conran",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "cape conway",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "cape douglas",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "cape everard",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "cape gloucester",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "cape hillsborough",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "cape jaffa",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "cape jervis",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "cape moreton",
		"state": "qld",
		"postcode": "4025"
	},
	{
		"town": "cape otway",
		"state": "vic",
		"postcode": "3233"
	},
	{
		"town": "cape paterson",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "cape portland",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "cape range national park",
		"state": "wa",
		"postcode": "6707"
	},
	{
		"town": "cape riche",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "cape schanck",
		"state": "vic",
		"postcode": "3939"
	},
	{
		"town": "cape sorell",
		"state": "tas",
		"postcode": "7468"
	},
	{
		"town": "cape tribulation",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "cape woolamai",
		"state": "vic",
		"postcode": "3925"
	},
	{
		"town": "capeen",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "capel",
		"state": "wa",
		"postcode": "6271"
	},
	{
		"town": "capel river",
		"state": "wa",
		"postcode": "6271"
	},
	{
		"town": "capella",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "capels crossing",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "capertee",
		"state": "nsw",
		"postcode": "2846"
	},
	{
		"town": "capital hill",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "capoompeta",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "capricorn",
		"state": "wa",
		"postcode": "6642"
	},
	{
		"town": "captain creek",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "captains flat",
		"state": "nsw",
		"postcode": "2623"
	},
	{
		"town": "captains mountain",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "caraban",
		"state": "wa",
		"postcode": "6041"
	},
	{
		"town": "carabooda",
		"state": "wa",
		"postcode": "6033"
	},
	{
		"town": "carabost",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "carag carag",
		"state": "vic",
		"postcode": "3623"
	},
	{
		"town": "caragabal",
		"state": "nsw",
		"postcode": "2810"
	},
	{
		"town": "caralue",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "caralulup",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "caramut",
		"state": "vic",
		"postcode": "3274"
	},
	{
		"town": "carani",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "carapooee",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "carapooee west",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "carapook",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "caravan head",
		"state": "nsw",
		"postcode": "2225"
	},
	{
		"town": "caravonica",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "carawa",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "carbarup",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "carbine",
		"state": "wa",
		"postcode": "6429"
	},
	{
		"town": "carboor",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "carbrook",
		"state": "qld",
		"postcode": "4130"
	},
	{
		"town": "carbunup river",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "carcalgong",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "carcoar",
		"state": "nsw",
		"postcode": "2791"
	},
	{
		"town": "carcuma",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "cardiff",
		"state": "nsw",
		"postcode": "2285"
	},
	{
		"town": "cardiff heights",
		"state": "nsw",
		"postcode": "2285"
	},
	{
		"town": "cardiff south",
		"state": "nsw",
		"postcode": "2285"
	},
	{
		"town": "cardigan",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "cardigan village",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "cardinia",
		"state": "vic",
		"postcode": "3978"
	},
	{
		"town": "cardross",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "cardstone",
		"state": "qld",
		"postcode": "4854"
	},
	{
		"town": "cardup",
		"state": "wa",
		"postcode": "6122"
	},
	{
		"town": "cardwell",
		"state": "qld",
		"postcode": "4849"
	},
	{
		"town": "careel bay",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "carew",
		"state": "sa",
		"postcode": "5270"
	},
	{
		"town": "carey bay",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "carey gully",
		"state": "sa",
		"postcode": "5144"
	},
	{
		"town": "carey park",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "cargerie",
		"state": "vic",
		"postcode": "3334"
	},
	{
		"town": "cargo",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "carina",
		"state": "qld",
		"postcode": "4152"
	},
	{
		"town": "carina",
		"state": "vic",
		"postcode": "3512"
	},
	{
		"town": "carina heights",
		"state": "qld",
		"postcode": "4152"
	},
	{
		"town": "carina north",
		"state": "qld",
		"postcode": "4152"
	},
	{
		"town": "carinda",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "carindale",
		"state": "qld",
		"postcode": "4152"
	},
	{
		"town": "carine",
		"state": "wa",
		"postcode": "6020"
	},
	{
		"town": "caringal",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "caringbah",
		"state": "nsw",
		"postcode": "1495"
	},
	{
		"town": "caringbah",
		"state": "nsw",
		"postcode": "2229"
	},
	{
		"town": "carisbrook",
		"state": "vic",
		"postcode": "3464"
	},
	{
		"town": "carlarchy",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "carlingford",
		"state": "nsw",
		"postcode": "2118"
	},
	{
		"town": "carlingford court",
		"state": "nsw",
		"postcode": "2118"
	},
	{
		"town": "carlingford north",
		"state": "nsw",
		"postcode": "2118"
	},
	{
		"town": "carlisle",
		"state": "wa",
		"postcode": "6101"
	},
	{
		"town": "carlisle river",
		"state": "vic",
		"postcode": "3239"
	},
	{
		"town": "carlotta",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "carlsruhe",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "carlsruhe rail",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "carlton",
		"state": "nsw",
		"postcode": "2218"
	},
	{
		"town": "carlton",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "carlton",
		"state": "vic",
		"postcode": "3053"
	},
	{
		"town": "carlton",
		"state": "vic",
		"postcode": "8507"
	},
	{
		"town": "carlton north",
		"state": "vic",
		"postcode": "3054"
	},
	{
		"town": "carlton river",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "carlton south",
		"state": "vic",
		"postcode": "3053"
	},
	{
		"town": "carlyle",
		"state": "vic",
		"postcode": "3687"
	},
	{
		"town": "carmantown",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "carmel",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "carmichael",
		"state": "vic",
		"postcode": "3957"
	},
	{
		"town": "carmila",
		"state": "qld",
		"postcode": "4739"
	},
	{
		"town": "carmoo",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "carnamah",
		"state": "wa",
		"postcode": "6517"
	},
	{
		"town": "carnarvon",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "carnegie",
		"state": "vic",
		"postcode": "3163"
	},
	{
		"town": "carnes hill",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "carneys creek",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "carngham",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "carnham",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "carnsdale",
		"state": "nsw",
		"postcode": "2660"
	},
	{
		"town": "caroda",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "carole park",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "caroline",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "caroline springs",
		"state": "vic",
		"postcode": "3023"
	},
	{
		"town": "caron",
		"state": "wa",
		"postcode": "6618"
	},
	{
		"town": "carool",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "caroona",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "carpendale",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "carpendeit",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "carpenter rocks",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "carpolac",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "carrabin",
		"state": "wa",
		"postcode": "6423"
	},
	{
		"town": "carrabolla",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "carrai",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "carrajung",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "carrajung south",
		"state": "vic",
		"postcode": "3874"
	},
	{
		"town": "carramar",
		"state": "nsw",
		"postcode": "2163"
	},
	{
		"town": "carramar",
		"state": "wa",
		"postcode": "6031"
	},
	{
		"town": "carranballac",
		"state": "vic",
		"postcode": "3361"
	},
	{
		"town": "carrara",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "carrathool",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "carrawabbity",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "carrick",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "carrick",
		"state": "tas",
		"postcode": "7291"
	},
	{
		"town": "carrickalinga",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "carrieton",
		"state": "sa",
		"postcode": "5432"
	},
	{
		"town": "carrington",
		"state": "nsw",
		"postcode": "2294"
	},
	{
		"town": "carrington",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "carrington",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "carrington",
		"state": "qld",
		"postcode": "4883"
	},
	{
		"town": "carrington falls",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "carroll",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "carroll gap",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "carrolls creek",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "carron",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "carrowbrook",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "carrs creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "carrs island",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "carrs peninsular",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "carrs plains",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "carrum",
		"state": "vic",
		"postcode": "3197"
	},
	{
		"town": "carrum downs",
		"state": "vic",
		"postcode": "3201"
	},
	{
		"town": "carseldine",
		"state": "qld",
		"postcode": "4034"
	},
	{
		"town": "carss park",
		"state": "nsw",
		"postcode": "2221"
	},
	{
		"town": "carters ridge",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "cartwright",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "cartwrights hill",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "carwarp",
		"state": "vic",
		"postcode": "3494"
	},
	{
		"town": "carwell",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "cascade",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "cascade",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "cascades",
		"state": "tas",
		"postcode": "7004"
	},
	{
		"town": "casey",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "casey",
		"state": "tas",
		"postcode": "7151"
	},
	{
		"town": "cashens",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "cashmere",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "cashmore",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "cashs crossing",
		"state": "qld",
		"postcode": "4035"
	},
	{
		"town": "casino",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "casino west",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "cassidys bridge",
		"state": "vic",
		"postcode": "3279"
	},
	{
		"town": "cassilis",
		"state": "nsw",
		"postcode": "2329"
	},
	{
		"town": "cassilis",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "cassini",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "castambul",
		"state": "sa",
		"postcode": "5076"
	},
	{
		"town": "castaways beach",
		"state": "qld",
		"postcode": "4567"
	},
	{
		"town": "castella",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "casterton",
		"state": "vic",
		"postcode": "3311"
	},
	{
		"town": "castle cove",
		"state": "nsw",
		"postcode": "2069"
	},
	{
		"town": "castle creek",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "castle creek",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "castle creek",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "castle donnington",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "castle doyle",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "castle forbes bay",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "castle hill",
		"state": "nsw",
		"postcode": "1765"
	},
	{
		"town": "castle hill",
		"state": "nsw",
		"postcode": "2154"
	},
	{
		"town": "castle hill",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "castle rock",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "castleburn",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "castlecrag",
		"state": "nsw",
		"postcode": "2068"
	},
	{
		"town": "castlefield",
		"state": "vic",
		"postcode": "3188"
	},
	{
		"town": "castlemaine",
		"state": "vic",
		"postcode": "3450"
	},
	{
		"town": "castlereagh",
		"state": "nsw",
		"postcode": "2749"
	},
	{
		"town": "castletown",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "casuarina",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "casuarina",
		"state": "nt",
		"postcode": "811"
	},
	{
		"town": "casuarina",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "casula",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "casula mall",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "cataby",
		"state": "wa",
		"postcode": "6507"
	},
	{
		"town": "catagunya",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "catalina",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "catamaran",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "catani",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "cathcart",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "cathcart",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "catherine field",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "catherine hill bay",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "cathkin",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "cathundral",
		"state": "nsw",
		"postcode": "2823"
	},
	{
		"town": "cations",
		"state": "vic",
		"postcode": "3808"
	},
	{
		"town": "cattai",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "catterick",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "cattle creek",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "cattle creek",
		"state": "qld",
		"postcode": "4407"
	},
	{
		"town": "cattle creek",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "catumnal",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "caulfield",
		"state": "vic",
		"postcode": "3162"
	},
	{
		"town": "caulfield east",
		"state": "vic",
		"postcode": "3145"
	},
	{
		"town": "caulfield junction",
		"state": "vic",
		"postcode": "3161"
	},
	{
		"town": "caulfield north",
		"state": "vic",
		"postcode": "3161"
	},
	{
		"town": "caulfield south",
		"state": "vic",
		"postcode": "3162"
	},
	{
		"town": "causeway",
		"state": "act",
		"postcode": "2604"
	},
	{
		"town": "causeway lake",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "cavan",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "cavan",
		"state": "sa",
		"postcode": "5094"
	},
	{
		"town": "caveat",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "cavenagh",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "cavendish",
		"state": "vic",
		"postcode": "3314"
	},
	{
		"town": "caversham",
		"state": "wa",
		"postcode": "6055"
	},
	{
		"town": "caves beach",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "caveside",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "caveton",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "cawarral",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "cawdor",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "cawdor",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "cawongla",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "cecil hills",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "cecil park",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "cecil plains",
		"state": "qld",
		"postcode": "4407"
	},
	{
		"town": "cedar brush creek",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "cedar creek",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "cedar creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "cedar creek",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "cedar creek",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "cedar grove",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "cedar party",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "cedar pocket",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "cedar point",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "cedar vale",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "cedarton",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "ceduna",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "cells river",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "cement mills",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "centenary heights",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "centenary heights",
		"state": "qld",
		"postcode": "4869"
	},
	{
		"town": "centenary park",
		"state": "qld",
		"postcode": "4869"
	},
	{
		"town": "centennial park",
		"state": "nsw",
		"postcode": "2021"
	},
	{
		"town": "centennial park",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "central bucca",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "central castra",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "central colo",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "central gippsland hospital",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "central macdonald",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "central mangrove",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "central park",
		"state": "vic",
		"postcode": "3145"
	},
	{
		"town": "central plaza",
		"state": "qld",
		"postcode": "4001"
	},
	{
		"town": "central queensland university",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "central tilba",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "centreville",
		"state": "vic",
		"postcode": "3910"
	},
	{
		"town": "ceratodus",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "ceres",
		"state": "nsw",
		"postcode": "2821"
	},
	{
		"town": "ceres",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "cervantes",
		"state": "wa",
		"postcode": "6511"
	},
	{
		"town": "cessnock",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "cessnock west",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "cethana",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "chadoora",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "chadstone",
		"state": "vic",
		"postcode": "3148"
	},
	{
		"town": "chadstone centre",
		"state": "vic",
		"postcode": "3148"
	},
	{
		"town": "chadwick",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "chaffey",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "chahpingah",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "chain of lagoons",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "chain valley bay",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "chakola",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "chaldron",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "challambra",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "chambers flat",
		"state": "qld",
		"postcode": "4133"
	},
	{
		"town": "chambigne",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "chances plains",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "chandada",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "chandler",
		"state": "qld",
		"postcode": "4155"
	},
	{
		"town": "chandlers creek",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "chandlers hill",
		"state": "sa",
		"postcode": "5159"
	},
	{
		"town": "chapel flat",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "chapel hill",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "chapel street north",
		"state": "vic",
		"postcode": "3141"
	},
	{
		"town": "chapman",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "chapman bore",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "chapman hill",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "chapman valley",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "chapple vale",
		"state": "vic",
		"postcode": "3239"
	},
	{
		"town": "charam",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "charbon",
		"state": "nsw",
		"postcode": "2848"
	},
	{
		"town": "charing cross",
		"state": "nsw",
		"postcode": "2024"
	},
	{
		"town": "charity creek",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "charleroi",
		"state": "vic",
		"postcode": "3695"
	},
	{
		"town": "charles sturt university",
		"state": "nsw",
		"postcode": "2678"
	},
	{
		"town": "charles sturt university",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "charleston",
		"state": "sa",
		"postcode": "5244"
	},
	{
		"town": "charlestown",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "charlestown",
		"state": "qld",
		"postcode": "4608"
	},
	{
		"town": "charleville",
		"state": "qld",
		"postcode": "4470"
	},
	{
		"town": "charleys forest",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "charlotte cove",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "charlottes pass",
		"state": "nsw",
		"postcode": "2624"
	},
	{
		"town": "charlton",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "charlton",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "charlton",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "charlwood",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "charman",
		"state": "vic",
		"postcode": "3194"
	},
	{
		"town": "charmhaven",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "charnwood",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "charra",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "charters towers",
		"state": "qld",
		"postcode": "4820"
	},
	{
		"town": "chartwell",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "chasm creek",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "chatham",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "chatham",
		"state": "vic",
		"postcode": "3279"
	},
	{
		"town": "chatham valley",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "chatsbury",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "1502"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "1504"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "1505"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "1507"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "1511"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "2057"
	},
	{
		"town": "chatswood",
		"state": "nsw",
		"postcode": "2067"
	},
	{
		"town": "chatswood hills",
		"state": "qld",
		"postcode": "4127"
	},
	{
		"town": "chatswood west",
		"state": "nsw",
		"postcode": "2067"
	},
	{
		"town": "chatsworth",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "chatsworth",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "chatsworth",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "cheepie",
		"state": "qld",
		"postcode": "4475"
	},
	{
		"town": "cheesemans creek",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "chelmer",
		"state": "qld",
		"postcode": "4068"
	},
	{
		"town": "chelmsford",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "chelmsford",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "chelona",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "chelsea",
		"state": "vic",
		"postcode": "3196"
	},
	{
		"town": "chelsea heights",
		"state": "vic",
		"postcode": "3196"
	},
	{
		"town": "cheltenham",
		"state": "nsw",
		"postcode": "2119"
	},
	{
		"town": "cheltenham",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "cheltenham",
		"state": "sa",
		"postcode": "5014"
	},
	{
		"town": "cheltenham",
		"state": "vic",
		"postcode": "3192"
	},
	{
		"town": "cheltenham east",
		"state": "vic",
		"postcode": "3192"
	},
	{
		"town": "cheltenham north",
		"state": "vic",
		"postcode": "3192"
	},
	{
		"town": "chepstowe",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "cherbourg",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "chermside",
		"state": "qld",
		"postcode": "4032"
	},
	{
		"town": "chermside centre",
		"state": "qld",
		"postcode": "4032"
	},
	{
		"town": "chermside south",
		"state": "qld",
		"postcode": "4032"
	},
	{
		"town": "chermside west",
		"state": "qld",
		"postcode": "4032"
	},
	{
		"town": "cherokee",
		"state": "vic",
		"postcode": "3434"
	},
	{
		"town": "cherrilong",
		"state": "vic",
		"postcode": "3874"
	},
	{
		"town": "cherry creek",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "cherry gardens",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "cherry tree hill",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "cherry tree pool",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "cherrybrook",
		"state": "nsw",
		"postcode": "2126"
	},
	{
		"town": "cherrypool",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "cherryville",
		"state": "sa",
		"postcode": "5134"
	},
	{
		"town": "cherwell",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "cheshunt",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "cheshunt south",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "chesney vale",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "chester hill",
		"state": "nsw",
		"postcode": "2162"
	},
	{
		"town": "chesterfield",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "chetwynd",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "chevallum",
		"state": "qld",
		"postcode": "4555"
	},
	{
		"town": "cheviot",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "chevron island",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "chewton",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "chewton bushlands",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "chichester",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "chichester",
		"state": "wa",
		"postcode": "6754"
	},
	{
		"town": "chidlow",
		"state": "wa",
		"postcode": "6556"
	},
	{
		"town": "chifley",
		"state": "act",
		"postcode": "2606"
	},
	{
		"town": "chifley",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "chigwell",
		"state": "tas",
		"postcode": "7011"
	},
	{
		"town": "chilcotts creek",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "chilcotts grass",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "childers",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "childers",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "chillagoe",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "chillingham",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "chillingollah",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "chiltern",
		"state": "vic",
		"postcode": "3683"
	},
	{
		"town": "chiltern valley",
		"state": "vic",
		"postcode": "3683"
	},
	{
		"town": "chinamen wells",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "chinbingina",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "chinchilla",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "chinderah",
		"state": "nsw",
		"postcode": "2487"
	},
	{
		"town": "chinghee creek",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "chinkapook",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "chinnock",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "chinocup",
		"state": "wa",
		"postcode": "6317"
	},
	{
		"town": "chintin",
		"state": "vic",
		"postcode": "3756"
	},
	{
		"town": "chippendale",
		"state": "nsw",
		"postcode": "2008"
	},
	{
		"town": "chipping norton",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "chirn park",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "chirnside park",
		"state": "vic",
		"postcode": "3116"
	},
	{
		"town": "chirrup",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "chisholm",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "chisholm centre",
		"state": "nsw",
		"postcode": "2153"
	},
	{
		"town": "chiswick",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "chittaway bay",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "chittaway point",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "chittering",
		"state": "wa",
		"postcode": "6084"
	},
	{
		"town": "chittinup",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "chocolyn",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "chorkerup",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "chorregon",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "chowan creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "chowerup",
		"state": "wa",
		"postcode": "6244"
	},
	{
		"town": "christie downs",
		"state": "sa",
		"postcode": "5164"
	},
	{
		"town": "christies",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "christies beach",
		"state": "sa",
		"postcode": "5165"
	},
	{
		"town": "christies beach north",
		"state": "sa",
		"postcode": "5165"
	},
	{
		"town": "christmas creek",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "christmas hills",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "christmas hills",
		"state": "vic",
		"postcode": "3775"
	},
	{
		"town": "christmas island",
		"state": "wa",
		"postcode": "6798"
	},
	{
		"town": "christmastown",
		"state": "vic",
		"postcode": "3683"
	},
	{
		"town": "chrome",
		"state": "vic",
		"postcode": "3302"
	},
	{
		"town": "chudleigh",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "chullora",
		"state": "nsw",
		"postcode": "2190"
	},
	{
		"town": "chum creek",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "church point",
		"state": "nsw",
		"postcode": "2105"
	},
	{
		"town": "churchable",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "churchill",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "churchill",
		"state": "vic",
		"postcode": "3842"
	},
	{
		"town": "churchill island",
		"state": "vic",
		"postcode": "3925"
	},
	{
		"town": "churchlands",
		"state": "wa",
		"postcode": "6018"
	},
	{
		"town": "chute",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "chuwar",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "cinnabar",
		"state": "qld",
		"postcode": "4600"
	},
	{
		"town": "circle valley",
		"state": "wa",
		"postcode": "6445"
	},
	{
		"town": "city beach",
		"state": "wa",
		"postcode": "6015"
	},
	{
		"town": "city delivery centre",
		"state": "wa",
		"postcode": "6000"
	},
	{
		"town": "city west campus",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "civic square",
		"state": "act",
		"postcode": "2608"
	},
	{
		"town": "clackline",
		"state": "wa",
		"postcode": "6564"
	},
	{
		"town": "clagiraba",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "clairview",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "clandulla",
		"state": "nsw",
		"postcode": "2848"
	},
	{
		"town": "clapham",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "clare",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "clare",
		"state": "sa",
		"postcode": "5453"
	},
	{
		"town": "claredale",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "claremont",
		"state": "tas",
		"postcode": "7011"
	},
	{
		"town": "claremont",
		"state": "vic",
		"postcode": "3732"
	},
	{
		"town": "claremont",
		"state": "wa",
		"postcode": "6010"
	},
	{
		"town": "claremont",
		"state": "wa",
		"postcode": "6910"
	},
	{
		"town": "claremont meadows",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "claremont north",
		"state": "wa",
		"postcode": "6010"
	},
	{
		"town": "clarence",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "clarence gardens",
		"state": "sa",
		"postcode": "5039"
	},
	{
		"town": "clarence park",
		"state": "sa",
		"postcode": "5034"
	},
	{
		"town": "clarence point",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "clarence town",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "clarendon",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "clarendon",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "clarendon",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "clarendon",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "clarendon",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "clarendon vale",
		"state": "tas",
		"postcode": "7019"
	},
	{
		"town": "clarenza",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "claretown",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "clareval",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "clareville",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "clarinda",
		"state": "vic",
		"postcode": "3169"
	},
	{
		"town": "clarke creek",
		"state": "qld",
		"postcode": "4705"
	},
	{
		"town": "clarkefield",
		"state": "vic",
		"postcode": "3430"
	},
	{
		"town": "clarkes hill",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "clarkson",
		"state": "wa",
		"postcode": "6030"
	},
	{
		"town": "claude road",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "claverton",
		"state": "qld",
		"postcode": "4471"
	},
	{
		"town": "clay wells",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "claybank",
		"state": "vic",
		"postcode": "3902"
	},
	{
		"town": "clayfield",
		"state": "qld",
		"postcode": "4011"
	},
	{
		"town": "claymore",
		"state": "nsw",
		"postcode": "2559"
	},
	{
		"town": "claypans",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "clayton",
		"state": "sa",
		"postcode": "5256"
	},
	{
		"town": "clayton",
		"state": "vic",
		"postcode": "3168"
	},
	{
		"town": "clayton south",
		"state": "vic",
		"postcode": "3169"
	},
	{
		"town": "clear creek",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "clear island waters",
		"state": "qld",
		"postcode": "4226"
	},
	{
		"town": "clear lake",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "clear mountain",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "clearfield",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "clearview",
		"state": "sa",
		"postcode": "5085"
	},
	{
		"town": "cleary",
		"state": "wa",
		"postcode": "6476"
	},
	{
		"town": "cleland",
		"state": "sa",
		"postcode": "5152"
	},
	{
		"town": "clematis",
		"state": "vic",
		"postcode": "3782"
	},
	{
		"town": "clements gap",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "clemton park",
		"state": "nsw",
		"postcode": "2206"
	},
	{
		"town": "clergate",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "clermont",
		"state": "qld",
		"postcode": "4721"
	},
	{
		"town": "cleve",
		"state": "sa",
		"postcode": "5640"
	},
	{
		"town": "cleveland",
		"state": "qld",
		"postcode": "4163"
	},
	{
		"town": "cleveland",
		"state": "tas",
		"postcode": "7211"
	},
	{
		"town": "clifden",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "clifford",
		"state": "qld",
		"postcode": "4427"
	},
	{
		"town": "clifford gardens",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "cliftleigh",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "clifton",
		"state": "nsw",
		"postcode": "2515"
	},
	{
		"town": "clifton",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "clifton beach",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "clifton beach",
		"state": "tas",
		"postcode": "7020"
	},
	{
		"town": "clifton creek",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "clifton gardens",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "clifton grove",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "clifton hill",
		"state": "qld",
		"postcode": "4105"
	},
	{
		"town": "clifton hill",
		"state": "vic",
		"postcode": "3068"
	},
	{
		"town": "clifton springs",
		"state": "vic",
		"postcode": "3222"
	},
	{
		"town": "clifton vale",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "clifton waters",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "clinton",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "clinton",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "clinton centre",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "clintonvale",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "cloisters square",
		"state": "wa",
		"postcode": "6850"
	},
	{
		"town": "clonbinane",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "cloncurry",
		"state": "qld",
		"postcode": "4824"
	},
	{
		"town": "clontarf",
		"state": "nsw",
		"postcode": "2093"
	},
	{
		"town": "clontarf",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "clontarf",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "clontarf beach",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "closeburn",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "clothiers creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "clouds creek",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "cloudy bay",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "clovass",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "clovelly",
		"state": "nsw",
		"postcode": "2031"
	},
	{
		"town": "clovelly park",
		"state": "sa",
		"postcode": "5042"
	},
	{
		"town": "clovelly west",
		"state": "nsw",
		"postcode": "2031"
	},
	{
		"town": "clover flat",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "clover park",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "cloverdale",
		"state": "wa",
		"postcode": "6105"
	},
	{
		"town": "cloverdale",
		"state": "wa",
		"postcode": "6985"
	},
	{
		"town": "cloverlea",
		"state": "vic",
		"postcode": "3822"
	},
	{
		"town": "cloyna",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "cluan",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "club terrace",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "cluden",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "clumber",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "clump point",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "clunes",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "clunes",
		"state": "vic",
		"postcode": "3370"
	},
	{
		"town": "clybucca",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "clyde",
		"state": "nsw",
		"postcode": "2142"
	},
	{
		"town": "clyde",
		"state": "vic",
		"postcode": "3978"
	},
	{
		"town": "clyde north",
		"state": "vic",
		"postcode": "3978"
	},
	{
		"town": "clydebank",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "clydesdale",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "clydesdale",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "coads tank",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "coal creek",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "coal point",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "coalbank",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "coalcliff",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "coaldale",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "coalfalls",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "coalmines reserve",
		"state": "tas",
		"postcode": "7186"
	},
	{
		"town": "coalstoun lakes",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "coalville",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "coasters retreat",
		"state": "nsw",
		"postcode": "2108"
	},
	{
		"town": "coatesville",
		"state": "vic",
		"postcode": "3165"
	},
	{
		"town": "cobains",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "cobaki",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "cobaki lakes",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "cobar",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "cobar park",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "cobargo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "cobark",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "cobaw",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "cobbadah",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "cobbannah",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "cobbitty",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "cobbora",
		"state": "nsw",
		"postcode": "2844"
	},
	{
		"town": "cobbs hill",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "cobden",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "cobdogla",
		"state": "sa",
		"postcode": "5346"
	},
	{
		"town": "cobraball",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "cobram",
		"state": "vic",
		"postcode": "3643"
	},
	{
		"town": "cobram",
		"state": "vic",
		"postcode": "3644"
	},
	{
		"town": "cobram east",
		"state": "vic",
		"postcode": "3644"
	},
	{
		"town": "cobrico",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "cobungra",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "coburg",
		"state": "vic",
		"postcode": "3058"
	},
	{
		"town": "coburg north",
		"state": "vic",
		"postcode": "3058"
	},
	{
		"town": "cocamba",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "cocata",
		"state": "sa",
		"postcode": "5654"
	},
	{
		"town": "cochranes creek",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "cockaleechie",
		"state": "sa",
		"postcode": "5631"
	},
	{
		"town": "cockatoo",
		"state": "qld",
		"postcode": "4419"
	},
	{
		"town": "cockatoo",
		"state": "vic",
		"postcode": "3781"
	},
	{
		"town": "cockatoo island",
		"state": "wa",
		"postcode": "6731"
	},
	{
		"town": "cockatoo valley",
		"state": "sa",
		"postcode": "5351"
	},
	{
		"town": "cockburn",
		"state": "sa",
		"postcode": "5440"
	},
	{
		"town": "cocklebiddy",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "coconut grove",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "coconut island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "cocoroc",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "codjatotine",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "codrington",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "codrington",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "coen",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "coes creek",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "coffee camp",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "coffin bay",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "coffs harbour",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "coffs harbour jetty",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "coffs harbour plaza",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "coggan",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "coghills creek",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "cogra bay",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "cohuna",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "coila",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "coimadai",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "cokum",
		"state": "vic",
		"postcode": "3542"
	},
	{
		"town": "colac",
		"state": "vic",
		"postcode": "3250"
	},
	{
		"town": "colac colac",
		"state": "vic",
		"postcode": "3707"
	},
	{
		"town": "colac east",
		"state": "vic",
		"postcode": "3250"
	},
	{
		"town": "colac west",
		"state": "vic",
		"postcode": "3250"
	},
	{
		"town": "colbinabbin",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "colbinabbin west",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "colbrook",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "cold harbour",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "coldstream",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "coldstream",
		"state": "vic",
		"postcode": "3770"
	},
	{
		"town": "coleambally",
		"state": "nsw",
		"postcode": "2707"
	},
	{
		"town": "colebatch",
		"state": "sa",
		"postcode": "5266"
	},
	{
		"town": "colebee",
		"state": "nsw",
		"postcode": "2761"
	},
	{
		"town": "colebrook",
		"state": "tas",
		"postcode": "7027"
	},
	{
		"town": "coledale",
		"state": "nsw",
		"postcode": "2515"
	},
	{
		"town": "coleraine",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "coles",
		"state": "sa",
		"postcode": "5272"
	},
	{
		"town": "coles bay",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "coleyville",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "coliban estate",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "coliban reservoir",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "colignan",
		"state": "vic",
		"postcode": "3494"
	},
	{
		"town": "colinroobie",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "colinton",
		"state": "nsw",
		"postcode": "2626"
	},
	{
		"town": "colinton",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "collarenebri",
		"state": "nsw",
		"postcode": "2833"
	},
	{
		"town": "collaroy",
		"state": "nsw",
		"postcode": "2097"
	},
	{
		"town": "collaroy",
		"state": "qld",
		"postcode": "4707"
	},
	{
		"town": "collaroy beach",
		"state": "nsw",
		"postcode": "2097"
	},
	{
		"town": "collaroy plateau",
		"state": "nsw",
		"postcode": "2097"
	},
	{
		"town": "collaroy plateau west",
		"state": "nsw",
		"postcode": "2097"
	},
	{
		"town": "collector",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "college grove",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "college park",
		"state": "sa",
		"postcode": "5069"
	},
	{
		"town": "college view",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "collendina",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "collie",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "collie",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "collie burn",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "collie cardiff",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "collingullie",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "collingwood",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "collingwood",
		"state": "vic",
		"postcode": "3066"
	},
	{
		"town": "collingwood heights",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "collingwood north",
		"state": "vic",
		"postcode": "3066"
	},
	{
		"town": "collingwood park",
		"state": "qld",
		"postcode": "4301"
	},
	{
		"town": "collingwood park",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "collins creek",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "collins siding",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "collins siding",
		"state": "wa",
		"postcode": "6260"
	},
	{
		"town": "collins street east",
		"state": "vic",
		"postcode": "8003"
	},
	{
		"town": "collins street west",
		"state": "vic",
		"postcode": "8007"
	},
	{
		"town": "collinsvale",
		"state": "tas",
		"postcode": "7012"
	},
	{
		"town": "collinsville",
		"state": "qld",
		"postcode": "4804"
	},
	{
		"town": "collinsville",
		"state": "sa",
		"postcode": "5418"
	},
	{
		"town": "collinswood",
		"state": "sa",
		"postcode": "5081"
	},
	{
		"town": "colliver",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "collombatti",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "collum collum",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "colly blue",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "colmslie",
		"state": "qld",
		"postcode": "4170"
	},
	{
		"town": "colo",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "colo",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "colo heights",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "colo vale",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "colonel light gardens",
		"state": "sa",
		"postcode": "5041"
	},
	{
		"town": "colosseum",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "colquhoun",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "colston park",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "colton",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "columboola",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "colyton",
		"state": "nsw",
		"postcode": "2760"
	},
	{
		"town": "comara",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "comaum",
		"state": "sa",
		"postcode": "5277"
	},
	{
		"town": "combaning",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "combara",
		"state": "nsw",
		"postcode": "2829"
	},
	{
		"town": "combienbar",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "combo",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "comboyne",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "come by chance",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "comet",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "comet hill",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "commissioners creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "commissioners waters",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "commodine",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "como",
		"state": "nsw",
		"postcode": "2226"
	},
	{
		"town": "como",
		"state": "qld",
		"postcode": "4571"
	},
	{
		"town": "como",
		"state": "wa",
		"postcode": "6152"
	},
	{
		"town": "como",
		"state": "wa",
		"postcode": "6952"
	},
	{
		"town": "como west",
		"state": "nsw",
		"postcode": "2226"
	},
	{
		"town": "comobella",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "compton",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "conara",
		"state": "tas",
		"postcode": "7211"
	},
	{
		"town": "conargo",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "concongella",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "concord",
		"state": "nsw",
		"postcode": "2137"
	},
	{
		"town": "concord repatriation hospital",
		"state": "nsw",
		"postcode": "2139"
	},
	{
		"town": "concord west",
		"state": "nsw",
		"postcode": "1821"
	},
	{
		"town": "concord west",
		"state": "nsw",
		"postcode": "2138"
	},
	{
		"town": "concordia",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "condah",
		"state": "vic",
		"postcode": "3303"
	},
	{
		"town": "condah swamp",
		"state": "vic",
		"postcode": "3303"
	},
	{
		"town": "condamine",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "condamine farms",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "condamine plains",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "condell park",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "conder",
		"state": "act",
		"postcode": "2906"
	},
	{
		"town": "condingup",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "condobolin",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "condon",
		"state": "qld",
		"postcode": "4815"
	},
	{
		"town": "condong",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "condowie",
		"state": "sa",
		"postcode": "5464"
	},
	{
		"town": "coneac",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "congarinni",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "congelin",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "congewai",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "congo",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "congupna",
		"state": "vic",
		"postcode": "3633"
	},
	{
		"town": "conimbia",
		"state": "nsw",
		"postcode": "2829"
	},
	{
		"town": "coningham",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "coningsby",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "coniston",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "conjola",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "conmurra",
		"state": "sa",
		"postcode": "5272"
	},
	{
		"town": "connangorach",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "connells point",
		"state": "nsw",
		"postcode": "2221"
	},
	{
		"town": "connellys marsh",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "connewarre",
		"state": "vic",
		"postcode": "3227"
	},
	{
		"town": "connewirricoo",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "connolly",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "connors plain",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "conoble",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "conondale",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "contine",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "conway",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "conway beach",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "cooba",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "coober pedy",
		"state": "sa",
		"postcode": "5723"
	},
	{
		"town": "coobool",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "coobowie",
		"state": "sa",
		"postcode": "5583"
	},
	{
		"town": "coochiemudlo island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "coochin",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "coochin creek",
		"state": "qld",
		"postcode": "4519"
	},
	{
		"town": "coocooboonah",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "coodanup",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "cooee",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "cooee bay",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "cooeeimbardi",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "coogee",
		"state": "nsw",
		"postcode": "2034"
	},
	{
		"town": "coogee",
		"state": "wa",
		"postcode": "6166"
	},
	{
		"town": "coojar",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "cook",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "cook",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "cookamidgera",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "cookardinia",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "cooke plains",
		"state": "sa",
		"postcode": "5261"
	},
	{
		"town": "cookernup",
		"state": "wa",
		"postcode": "6220"
	},
	{
		"town": "cookinburra",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "cooks gap",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "cooks hill",
		"state": "nsw",
		"postcode": "2300"
	},
	{
		"town": "cooks myalls",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "cooktown",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "coolabah",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "coolabine",
		"state": "qld",
		"postcode": "4574"
	},
	{
		"town": "coolabunia",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "coolac",
		"state": "nsw",
		"postcode": "2727"
	},
	{
		"town": "cooladar hill",
		"state": "wa",
		"postcode": "6638"
	},
	{
		"town": "cooladdi",
		"state": "qld",
		"postcode": "4479"
	},
	{
		"town": "coolagolite",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "coolah",
		"state": "nsw",
		"postcode": "2843"
	},
	{
		"town": "coolamon",
		"state": "nsw",
		"postcode": "2701"
	},
	{
		"town": "coolana",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "coolaness",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "coolangatta",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "coolangatta",
		"state": "qld",
		"postcode": "4225"
	},
	{
		"town": "coolangubra",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "coolaroo",
		"state": "vic",
		"postcode": "3048"
	},
	{
		"town": "coolatai",
		"state": "nsw",
		"postcode": "2402"
	},
	{
		"town": "coolbellup",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "coolbinia",
		"state": "wa",
		"postcode": "6050"
	},
	{
		"town": "coolcalalaya",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "coolcha",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "cooleys creek",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "coolgardie",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "coolgardie",
		"state": "wa",
		"postcode": "6429"
	},
	{
		"town": "coolillie",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "coolmunda",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "coolongolook",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "cooloolabin",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "cooloongup",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "coolringdon",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "cooltong",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "coolum beach",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "coolumbooka",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "coolup",
		"state": "wa",
		"postcode": "6214"
	},
	{
		"town": "cooma",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "cooma",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "cooma north",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "coomalbidgup",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "coomandook",
		"state": "sa",
		"postcode": "5261"
	},
	{
		"town": "coomba",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "coombabah",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "coombadjha",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "coombell",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "coomberdale",
		"state": "wa",
		"postcode": "6512"
	},
	{
		"town": "coomboona",
		"state": "vic",
		"postcode": "3629"
	},
	{
		"town": "coomera",
		"state": "qld",
		"postcode": "4209"
	},
	{
		"town": "coominglah",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "coominglah forest",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "coominya",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "coomoo",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "coomoo coomoo",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "coomoora",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "coomooroo",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "coomrith",
		"state": "qld",
		"postcode": "4423"
	},
	{
		"town": "coonabarabran",
		"state": "nsw",
		"postcode": "2357"
	},
	{
		"town": "coonabidgee",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "coonalpyn",
		"state": "sa",
		"postcode": "5265"
	},
	{
		"town": "coonamble",
		"state": "nsw",
		"postcode": "2829"
	},
	{
		"town": "coonambula",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "coonamia",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "coonanga",
		"state": "vic",
		"postcode": "3641"
	},
	{
		"town": "coonarr",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "coonawarra",
		"state": "sa",
		"postcode": "5263"
	},
	{
		"town": "coondle",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "coondoo",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "coonerang",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "coongbar",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "coongulla",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "coongulmerang",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "coonong",
		"state": "nsw",
		"postcode": "2645"
	},
	{
		"town": "coonooer bridge",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "coonooer west",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "cooperabung",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "coopernook",
		"state": "nsw",
		"postcode": "2426"
	},
	{
		"town": "coopers creek",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "coopers creek",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "coopers gully",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "coopers plains",
		"state": "qld",
		"postcode": "4108"
	},
	{
		"town": "coopers shoot",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "cooplacurripa",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "coorabell",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "coorabie",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "coorada",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "cooramook",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "cooran",
		"state": "qld",
		"postcode": "4569"
	},
	{
		"town": "cooranbong",
		"state": "nsw",
		"postcode": "2265"
	},
	{
		"town": "cooranga north",
		"state": "qld",
		"postcode": "4408"
	},
	{
		"town": "cooriemungle",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "cooroibah",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "coorong",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "coorooman",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "coorow",
		"state": "wa",
		"postcode": "6515"
	},
	{
		"town": "cooroy",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "cooroy mountain",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "coorparoo",
		"state": "qld",
		"postcode": "4151"
	},
	{
		"town": "cootamundra",
		"state": "nsw",
		"postcode": "2590"
	},
	{
		"town": "cootharaba",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "cootra",
		"state": "sa",
		"postcode": "5650"
	},
	{
		"town": "cootralantra",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "coowonga",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "cooya beach",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "cooyal",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "cooyar",
		"state": "qld",
		"postcode": "4402"
	},
	{
		"town": "copacabana",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "cope",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "cope cope",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "copeland",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "copeton",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "copeville",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "copi hollow",
		"state": "nsw",
		"postcode": "2879"
	},
	{
		"town": "copley",
		"state": "sa",
		"postcode": "5732"
	},
	{
		"town": "copley",
		"state": "wa",
		"postcode": "6562"
	},
	{
		"town": "copmanhurst",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "coppabella",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "coppabella",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "copperhannia",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "copping",
		"state": "tas",
		"postcode": "7174"
	},
	{
		"town": "cora lynn",
		"state": "vic",
		"postcode": "3814"
	},
	{
		"town": "corack",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "corack east",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "corackerup",
		"state": "wa",
		"postcode": "6336"
	},
	{
		"town": "coragulac",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "coraki",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "coral bank",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "coral bay",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "coral cove",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "coralville",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "coramba",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "corang",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "corangula",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "corbie hill",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "cordalba",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "cordeaux",
		"state": "nsw",
		"postcode": "2526"
	},
	{
		"town": "cordeaux heights",
		"state": "nsw",
		"postcode": "2526"
	},
	{
		"town": "cordelia",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "cordelia",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "cordering",
		"state": "wa",
		"postcode": "6393"
	},
	{
		"town": "cordillo downs",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "coree",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "coree south",
		"state": "nsw",
		"postcode": "2716"
	},
	{
		"town": "coreen",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "corella",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "corfield",
		"state": "qld",
		"postcode": "4733"
	},
	{
		"town": "corinda",
		"state": "qld",
		"postcode": "4075"
	},
	{
		"town": "corindhap",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "corindi beach",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "corinella",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "corinella",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "coringa",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "corinna",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "corinthia",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "corio",
		"state": "vic",
		"postcode": "3214"
	},
	{
		"town": "corlette",
		"state": "nsw",
		"postcode": "2315"
	},
	{
		"town": "cornalla",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "corndale",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "corndale",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "corndale",
		"state": "vic",
		"postcode": "3311"
	},
	{
		"town": "cornelia creek",
		"state": "vic",
		"postcode": "3622"
	},
	{
		"town": "cornelian bay",
		"state": "tas",
		"postcode": "7008"
	},
	{
		"town": "cornella",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "cornella east",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "corner inlet",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "corney town",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "cornishtown",
		"state": "vic",
		"postcode": "3683"
	},
	{
		"town": "cornubia",
		"state": "qld",
		"postcode": "4130"
	},
	{
		"town": "cornwall",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "cornwallis",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "corny point",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "corobimilla",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "coromandel east",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "coromandel valley",
		"state": "sa",
		"postcode": "5051"
	},
	{
		"town": "coromby",
		"state": "vic",
		"postcode": "3390"
	},
	{
		"town": "coronet bay",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "corop",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "corop west",
		"state": "vic",
		"postcode": "3558"
	},
	{
		"town": "cororooke",
		"state": "vic",
		"postcode": "3254"
	},
	{
		"town": "corowa",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "corra linn",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "corrigin",
		"state": "wa",
		"postcode": "6375"
	},
	{
		"town": "corrimal",
		"state": "nsw",
		"postcode": "2518"
	},
	{
		"town": "corrimal east",
		"state": "nsw",
		"postcode": "2518"
	},
	{
		"town": "corringle",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "corroboree flat",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "corrowong",
		"state": "nsw",
		"postcode": "2633"
	},
	{
		"town": "corryong",
		"state": "vic",
		"postcode": "3707"
	},
	{
		"town": "cortlinye",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "corunna",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "corunnun",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "cosgrove",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "cosgrove south",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "cosmo newbery",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "costerfield",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "cothams",
		"state": "vic",
		"postcode": "3756"
	},
	{
		"town": "cotswold",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "cotswold hills",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "cottage point",
		"state": "nsw",
		"postcode": "2084"
	},
	{
		"town": "cottawalla",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "cottee",
		"state": "nsw",
		"postcode": "2701"
	},
	{
		"town": "cottesloe",
		"state": "wa",
		"postcode": "6011"
	},
	{
		"town": "cottesloe",
		"state": "wa",
		"postcode": "6911"
	},
	{
		"town": "cottles bridge",
		"state": "vic",
		"postcode": "3099"
	},
	{
		"town": "cotton tree",
		"state": "qld",
		"postcode": "4558"
	},
	{
		"town": "cottonvale",
		"state": "qld",
		"postcode": "4375"
	},
	{
		"town": "couangalt",
		"state": "vic",
		"postcode": "3437"
	},
	{
		"town": "couch beach",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "cougal",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "coulson",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "coulta",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "countegany",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "courabyra",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "couradda",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "courajago",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "couridjah",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "coursing park",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "courtenay",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "coutts crossing",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "coverty",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "cow bay",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "cow flat",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "cowabbie",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "cowalla",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "cowan",
		"state": "nsw",
		"postcode": "2081"
	},
	{
		"town": "cowan cowan",
		"state": "qld",
		"postcode": "4025"
	},
	{
		"town": "cowandilla",
		"state": "sa",
		"postcode": "5033"
	},
	{
		"town": "cowangie",
		"state": "vic",
		"postcode": "3506"
	},
	{
		"town": "cowaramup",
		"state": "wa",
		"postcode": "6284"
	},
	{
		"town": "cowcowing",
		"state": "wa",
		"postcode": "6485"
	},
	{
		"town": "cowell",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "cowes",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "cowirra",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "cowley",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "cowleys creek",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "cowper",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "cowra",
		"state": "nsw",
		"postcode": "2794"
	},
	{
		"town": "cowrie point",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "cowwarr",
		"state": "vic",
		"postcode": "3857"
	},
	{
		"town": "cox peninsula",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "coxs creek",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "coxs crown",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "crabbes creek",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "craboon",
		"state": "nsw",
		"postcode": "2844"
	},
	{
		"town": "crabtree",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "crace",
		"state": "act",
		"postcode": "2911"
	},
	{
		"town": "crackenback",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "cracow",
		"state": "qld",
		"postcode": "4719"
	},
	{
		"town": "cradle mountain",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "cradoc",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "cradock",
		"state": "sa",
		"postcode": "5432"
	},
	{
		"town": "crafers",
		"state": "sa",
		"postcode": "5152"
	},
	{
		"town": "crafers west",
		"state": "sa",
		"postcode": "5152"
	},
	{
		"town": "craigburn farm",
		"state": "sa",
		"postcode": "5051"
	},
	{
		"town": "craigie",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "craigie",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "craigie",
		"state": "wa",
		"postcode": "6025"
	},
	{
		"town": "craigieburn",
		"state": "vic",
		"postcode": "3064"
	},
	{
		"town": "craiglie",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "craigmore",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "craignish",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "craigslea",
		"state": "qld",
		"postcode": "4032"
	},
	{
		"town": "cramenton",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "cranbourne",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "cranbourne east",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "cranbourne north",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "cranbourne south",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "cranbourne west",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "cranbrook",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "cranbrook",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "cranbrook",
		"state": "wa",
		"postcode": "6321"
	},
	{
		"town": "cranbury",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "cranebrook",
		"state": "nsw",
		"postcode": "2749"
	},
	{
		"town": "crangan bay",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "cranley",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "craven",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "craven plateau",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "cravensville",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "crawford",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "crawford river",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "crawley",
		"state": "wa",
		"postcode": "6009"
	},
	{
		"town": "crawney",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "crediton",
		"state": "qld",
		"postcode": "4757"
	},
	{
		"town": "creek junction",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "creek view",
		"state": "vic",
		"postcode": "3558"
	},
	{
		"town": "creewah",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "creighton",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "creightons creek",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "cremorne",
		"state": "nsw",
		"postcode": "1648"
	},
	{
		"town": "cremorne",
		"state": "nsw",
		"postcode": "2090"
	},
	{
		"town": "cremorne",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "cremorne",
		"state": "tas",
		"postcode": "7024"
	},
	{
		"town": "cremorne",
		"state": "vic",
		"postcode": "3121"
	},
	{
		"town": "cremorne junction",
		"state": "nsw",
		"postcode": "2090"
	},
	{
		"town": "cremorne point",
		"state": "nsw",
		"postcode": "2090"
	},
	{
		"town": "crescent",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "crescent head",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "cressbrook",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "cresswell downs",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "cressy",
		"state": "tas",
		"postcode": "7302"
	},
	{
		"town": "cressy",
		"state": "vic",
		"postcode": "3322"
	},
	{
		"town": "crestmead",
		"state": "qld",
		"postcode": "4132"
	},
	{
		"town": "crestwood",
		"state": "nsw",
		"postcode": "2153"
	},
	{
		"town": "creswick",
		"state": "vic",
		"postcode": "3363"
	},
	{
		"town": "creswick north",
		"state": "vic",
		"postcode": "3363"
	},
	{
		"town": "crib point",
		"state": "vic",
		"postcode": "3919"
	},
	{
		"town": "crimea",
		"state": "vic",
		"postcode": "3161"
	},
	{
		"town": "cringila",
		"state": "nsw",
		"postcode": "2502"
	},
	{
		"town": "croftby",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "crohamhurst",
		"state": "qld",
		"postcode": "4519"
	},
	{
		"town": "croker island",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "croki",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "cromer",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "cromer",
		"state": "sa",
		"postcode": "5235"
	},
	{
		"town": "cromer",
		"state": "vic",
		"postcode": "3193"
	},
	{
		"town": "cromer heights",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "cronin island",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "cronins",
		"state": "vic",
		"postcode": "3705"
	},
	{
		"town": "cronulla",
		"state": "nsw",
		"postcode": "2230"
	},
	{
		"town": "crooble",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "crooked corner",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "crooked river",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "crookhaven",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "crookwell",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "croom",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "croppa creek",
		"state": "nsw",
		"postcode": "2411"
	},
	{
		"town": "cross roads",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "cross roads",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "cross roads",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "crossdale",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "crosslands",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "crossley",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "crossmaglen",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "crossman",
		"state": "wa",
		"postcode": "6390"
	},
	{
		"town": "crossover",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "croudace bay",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "crow mountain",
		"state": "nsw",
		"postcode": "2346"
	},
	{
		"town": "crowdy head",
		"state": "nsw",
		"postcode": "2427"
	},
	{
		"town": "crowlands",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "crowley vale",
		"state": "qld",
		"postcode": "4342"
	},
	{
		"town": "crownthorpe",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "crows nest",
		"state": "nsw",
		"postcode": "1585"
	},
	{
		"town": "crows nest",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "crows nest",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "crowther",
		"state": "nsw",
		"postcode": "2803"
	},
	{
		"town": "crowther island",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "croxton east",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "croydon",
		"state": "nsw",
		"postcode": "2132"
	},
	{
		"town": "croydon",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "croydon",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "croydon",
		"state": "vic",
		"postcode": "3136"
	},
	{
		"town": "croydon hills",
		"state": "vic",
		"postcode": "3136"
	},
	{
		"town": "croydon north",
		"state": "vic",
		"postcode": "3136"
	},
	{
		"town": "croydon park",
		"state": "nsw",
		"postcode": "2133"
	},
	{
		"town": "croydon park",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "croydon park south",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "croydon south",
		"state": "vic",
		"postcode": "3136"
	},
	{
		"town": "crudine",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "crusoe",
		"state": "vic",
		"postcode": "3555"
	},
	{
		"town": "crymelon",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "cryna",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "cryon",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "crystal brook",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "crystal brook",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "crystal creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "crystal creek",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "crystal springs",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "cuballing",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "cubba",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "cuckoo",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "cudal",
		"state": "nsw",
		"postcode": "2864"
	},
	{
		"town": "cudgee",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "cudgegong",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "cudgel",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "cudgen",
		"state": "nsw",
		"postcode": "2487"
	},
	{
		"town": "cudgera creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "cudgewa",
		"state": "vic",
		"postcode": "3705"
	},
	{
		"town": "cudlee creek",
		"state": "sa",
		"postcode": "5232"
	},
	{
		"town": "cudmirrah",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "cue",
		"state": "wa",
		"postcode": "6640"
	},
	{
		"town": "culbin",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "culburra",
		"state": "sa",
		"postcode": "5261"
	},
	{
		"town": "culburra beach",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "culcairn",
		"state": "nsw",
		"postcode": "2660"
	},
	{
		"town": "culfearn",
		"state": "vic",
		"postcode": "3580"
	},
	{
		"town": "culgoa",
		"state": "vic",
		"postcode": "3530"
	},
	{
		"town": "culham",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "culla",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "cullacabardee",
		"state": "wa",
		"postcode": "6067"
	},
	{
		"town": "cullalla",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "cullarin",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "cullen",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "cullen bay",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "cullen bullen",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "cullenbone",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "cullenswood",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "cullinane",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "cullinga",
		"state": "nsw",
		"postcode": "2588"
	},
	{
		"town": "culloden",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "cullulleraine",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "cullya",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "culmaran creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "cumbalum",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "cumbandry",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "cumberland park",
		"state": "sa",
		"postcode": "5041"
	},
	{
		"town": "cumberland park",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "cumberland valley",
		"state": "vic",
		"postcode": "3779"
	},
	{
		"town": "cumbijowa",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "cumbo",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "cumboogle",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "cumborah",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "cummeragunga",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "cummins",
		"state": "sa",
		"postcode": "5631"
	},
	{
		"town": "cumnock",
		"state": "nsw",
		"postcode": "2867"
	},
	{
		"town": "cundare north",
		"state": "vic",
		"postcode": "3251"
	},
	{
		"town": "cunderdin",
		"state": "wa",
		"postcode": "6407"
	},
	{
		"town": "cundinup",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "cundle flat",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "cundletown",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "cundumbul",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "cungena",
		"state": "sa",
		"postcode": "5660"
	},
	{
		"town": "cungulla",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "cunjardine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "cunjurong",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "cunliffe",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "cunnamulla",
		"state": "qld",
		"postcode": "4490"
	},
	{
		"town": "cunningar",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "cunningham",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "cunningham",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "cunninyeuk",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "cunyarie",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "cuprona",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "curban",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "curdie vale",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "curdies river",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "curl curl",
		"state": "nsw",
		"postcode": "2096"
	},
	{
		"town": "curlewis",
		"state": "nsw",
		"postcode": "2381"
	},
	{
		"town": "curlewis",
		"state": "vic",
		"postcode": "3222"
	},
	{
		"town": "curlwaa",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "curra",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "curra creek",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "currabubula",
		"state": "nsw",
		"postcode": "2342"
	},
	{
		"town": "curragh",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "currajong",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "currambine",
		"state": "wa",
		"postcode": "6028"
	},
	{
		"town": "curramore",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "curramore",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "curramulka",
		"state": "sa",
		"postcode": "5580"
	},
	{
		"town": "currans hill",
		"state": "nsw",
		"postcode": "2567"
	},
	{
		"town": "currarong",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "currawananna",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "currawang",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "currawarna",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "currawong beach",
		"state": "nsw",
		"postcode": "2108"
	},
	{
		"town": "currency creek",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "curricabark",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "currie",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "currigee",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "currimundi",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "currins",
		"state": "vic",
		"postcode": "3641"
	},
	{
		"town": "currowan",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "currumbin",
		"state": "qld",
		"postcode": "4223"
	},
	{
		"town": "currumbin valley",
		"state": "qld",
		"postcode": "4223"
	},
	{
		"town": "currumbin waters",
		"state": "qld",
		"postcode": "4223"
	},
	{
		"town": "curtin",
		"state": "act",
		"postcode": "2605"
	},
	{
		"town": "curtis island",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "curyo",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "cushnie",
		"state": "qld",
		"postcode": "4608"
	},
	{
		"town": "custon",
		"state": "sa",
		"postcode": "5270"
	},
	{
		"town": "cuthbert",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "cuttabri",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "cuttagee",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "cuttlefish bay",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "cygnet",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "cygnet river",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "cynthia",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "cypress gardens",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "cypress gardens",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "d'aguilar",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "d'estrees bay",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "daadenning creek",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "daandine",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "dabee",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "daceyville",
		"state": "nsw",
		"postcode": "2032"
	},
	{
		"town": "dadswells bridge",
		"state": "vic",
		"postcode": "3385"
	},
	{
		"town": "daggar hills",
		"state": "wa",
		"postcode": "6638"
	},
	{
		"town": "daglish",
		"state": "wa",
		"postcode": "6008"
	},
	{
		"town": "dagun",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "dahlen",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "daintree",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "dairy flat",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "dairy plains",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "dairyville",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "daisy hill",
		"state": "qld",
		"postcode": "4127"
	},
	{
		"town": "daisy hill",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "dajarra",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "dakabin",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "dakenba",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "dalbeg",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "dalby",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "dalcross",
		"state": "vic",
		"postcode": "3388"
	},
	{
		"town": "daldee",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "dales creek",
		"state": "vic",
		"postcode": "3341"
	},
	{
		"town": "daleys point",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "dalga",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "dalgety",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "daliak",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "dalkeith",
		"state": "wa",
		"postcode": "6009"
	},
	{
		"town": "dalkey",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "dallarnil",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "dallas",
		"state": "vic",
		"postcode": "3047"
	},
	{
		"town": "dalmallee",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "dalman",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "dalmeny",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "dalmore",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "dalmorton",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "dalrymple heights",
		"state": "qld",
		"postcode": "4757"
	},
	{
		"town": "dalswinton",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "dalton",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "daltons bridge",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "dalveen",
		"state": "qld",
		"postcode": "4374"
	},
	{
		"town": "dalwallinu",
		"state": "wa",
		"postcode": "6609"
	},
	{
		"town": "dalwogan",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "dalwood",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "dalwood",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "daly river",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "daly waters",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "dalyellup",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "dalysford",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "dalyston",
		"state": "vic",
		"postcode": "3992"
	},
	{
		"town": "dalyup",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "damascus",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "damboring",
		"state": "wa",
		"postcode": "6606"
	},
	{
		"town": "dampier",
		"state": "wa",
		"postcode": "6713"
	},
	{
		"town": "dampier peninsula",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "danbulla",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "danbury park",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "dandaloo",
		"state": "nsw",
		"postcode": "2823"
	},
	{
		"town": "dandaragan",
		"state": "wa",
		"postcode": "6507"
	},
	{
		"town": "dandenong",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "dandenong",
		"state": "vic",
		"postcode": "8785"
	},
	{
		"town": "dandenong east",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "dandenong north",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "dandenong south",
		"state": "vic",
		"postcode": "3164"
	},
	{
		"town": "dandenong south",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "dandongadale",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "dangar",
		"state": "nsw",
		"postcode": "2309"
	},
	{
		"town": "dangar island",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "dangarfield",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "dangarsleigh",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "dangin",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "dangore",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "dapto",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "darbalara",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "darby",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "darbys falls",
		"state": "nsw",
		"postcode": "2793"
	},
	{
		"town": "darch",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "dardadine",
		"state": "wa",
		"postcode": "6392"
	},
	{
		"town": "dardanup",
		"state": "wa",
		"postcode": "6236"
	},
	{
		"town": "dareton",
		"state": "nsw",
		"postcode": "2717"
	},
	{
		"town": "dargalong",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "dargan",
		"state": "nsw",
		"postcode": "2786"
	},
	{
		"town": "dargo",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "dark corner",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "darkan",
		"state": "wa",
		"postcode": "6392"
	},
	{
		"town": "darkbonee",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "darke peak",
		"state": "sa",
		"postcode": "5642"
	},
	{
		"town": "darkes forest",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "darkwood",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "darley",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "darlimurla",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "darling",
		"state": "vic",
		"postcode": "3145"
	},
	{
		"town": "darling downs",
		"state": "wa",
		"postcode": "6122"
	},
	{
		"town": "darling harbour",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "darling heights",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "darling island",
		"state": "nsw",
		"postcode": "2009"
	},
	{
		"town": "darling point",
		"state": "nsw",
		"postcode": "2027"
	},
	{
		"town": "darling south",
		"state": "vic",
		"postcode": "3143"
	},
	{
		"town": "darling south",
		"state": "vic",
		"postcode": "3145"
	},
	{
		"town": "darlinghurst",
		"state": "nsw",
		"postcode": "1300"
	},
	{
		"town": "darlinghurst",
		"state": "nsw",
		"postcode": "2010"
	},
	{
		"town": "darlington",
		"state": "nsw",
		"postcode": "2008"
	},
	{
		"town": "darlington",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "darlington",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "darlington",
		"state": "sa",
		"postcode": "5047"
	},
	{
		"town": "darlington",
		"state": "vic",
		"postcode": "3271"
	},
	{
		"town": "darlington",
		"state": "wa",
		"postcode": "6070"
	},
	{
		"town": "darlington point",
		"state": "nsw",
		"postcode": "2706"
	},
	{
		"town": "darlow",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "darnick",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "darnley island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "darnum",
		"state": "vic",
		"postcode": "3822"
	},
	{
		"town": "daroobalgie",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "darra",
		"state": "qld",
		"postcode": "4076"
	},
	{
		"town": "darradup",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "darraweit guim",
		"state": "vic",
		"postcode": "3756"
	},
	{
		"town": "darriman",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "dart dart",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "dartbrook",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "dartmoor",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "dartmouth",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "dartnall",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "darts creek",
		"state": "qld",
		"postcode": "4695"
	},
	{
		"town": "daruka",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "darwin",
		"state": "nt",
		"postcode": "800"
	},
	{
		"town": "darwin",
		"state": "nt",
		"postcode": "801"
	},
	{
		"town": "darwin river",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "darwwank",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "dashville",
		"state": "vic",
		"postcode": "3763"
	},
	{
		"town": "dattuk",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "dauan",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "davenport",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "daveys bay",
		"state": "vic",
		"postcode": "3930"
	},
	{
		"town": "daveyston",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "davidson",
		"state": "nsw",
		"postcode": "2085"
	},
	{
		"town": "davis",
		"state": "tas",
		"postcode": "7151"
	},
	{
		"town": "davis creek",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "davistown",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "davoren park",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "davoren park north",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "davoren park south",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "daw park",
		"state": "sa",
		"postcode": "5041"
	},
	{
		"town": "dawes point",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "dawesley",
		"state": "sa",
		"postcode": "5252"
	},
	{
		"town": "dawesville",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "dawson",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "dawson",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "dayboro",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "daydream island",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "daylesford",
		"state": "vic",
		"postcode": "3460"
	},
	{
		"town": "daymar",
		"state": "qld",
		"postcode": "4497"
	},
	{
		"town": "daysdale",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "daytrap",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "de grey",
		"state": "wa",
		"postcode": "6722"
	},
	{
		"town": "de mole river",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "deagon",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "deakin",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "deakin",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "deakin university",
		"state": "vic",
		"postcode": "3217"
	},
	{
		"town": "deakin west",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "deal island locked bag",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "dean",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "dean park",
		"state": "nsw",
		"postcode": "2761"
	},
	{
		"town": "deanmill",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "deans marsh",
		"state": "vic",
		"postcode": "3235"
	},
	{
		"town": "deauville",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "deception bay",
		"state": "qld",
		"postcode": "4508"
	},
	{
		"town": "dedari",
		"state": "wa",
		"postcode": "6429"
	},
	{
		"town": "deddick valley",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "deddington",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "dederang",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "dee lagoon",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "dee why",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "dee why beach",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "deep bay",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "deep creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "deep creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "deep creek",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "deep creek",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "deep lead",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "deepdale",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "deepdene",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "deepwater",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "deepwater",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "deepwater",
		"state": "sa",
		"postcode": "5266"
	},
	{
		"town": "deer park",
		"state": "vic",
		"postcode": "3023"
	},
	{
		"town": "deer park east",
		"state": "vic",
		"postcode": "3022"
	},
	{
		"town": "deer park north",
		"state": "vic",
		"postcode": "3023"
	},
	{
		"town": "deer vale",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "deeragun",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "deeral",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "degilbo",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "delacombe",
		"state": "vic",
		"postcode": "3356"
	},
	{
		"town": "delahey",
		"state": "vic",
		"postcode": "3037"
	},
	{
		"town": "delamere",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "delan",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "delaneys creek",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "delatite",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "delburn",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "delegate",
		"state": "nsw",
		"postcode": "2633"
	},
	{
		"town": "delegate river east",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "delissaville",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "dellicknora",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "delmont",
		"state": "tas",
		"postcode": "7302"
	},
	{
		"town": "deloraine",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "delroy gardens",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "delta",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "delungra",
		"state": "nsw",
		"postcode": "2403"
	},
	{
		"town": "delvine",
		"state": "vic",
		"postcode": "3864"
	},
	{
		"town": "demondrille",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "denbarker",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "dendy",
		"state": "vic",
		"postcode": "3186"
	},
	{
		"town": "denham",
		"state": "wa",
		"postcode": "6537"
	},
	{
		"town": "denham court",
		"state": "nsw",
		"postcode": "2565"
	},
	{
		"town": "denhams beach",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "denial bay",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "denicull creek",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "deniliquin",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "denison",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "denistone",
		"state": "nsw",
		"postcode": "2114"
	},
	{
		"town": "denistone east",
		"state": "nsw",
		"postcode": "2112"
	},
	{
		"town": "denistone west",
		"state": "nsw",
		"postcode": "2114"
	},
	{
		"town": "denman",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "denmark",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "dennes point",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "dennington",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "denver",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "depot hill",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "deptford",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "derby",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "derby",
		"state": "vic",
		"postcode": "3516"
	},
	{
		"town": "derby",
		"state": "wa",
		"postcode": "6728"
	},
	{
		"town": "dereel",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "dergholm",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "derhams hill",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "dering",
		"state": "vic",
		"postcode": "3489"
	},
	{
		"town": "dernancourt",
		"state": "sa",
		"postcode": "5075"
	},
	{
		"town": "derri derra",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "derrimut",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "derrinal",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "derrinallum",
		"state": "vic",
		"postcode": "3325"
	},
	{
		"town": "derriwong",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "derrymore",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "derwent bridge",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "derwent park",
		"state": "tas",
		"postcode": "7009"
	},
	{
		"town": "detention river",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "detpa",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "deua",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "deua river valley",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "deuchar",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "devenish",
		"state": "vic",
		"postcode": "3726"
	},
	{
		"town": "devereux creek",
		"state": "qld",
		"postcode": "4753"
	},
	{
		"town": "devils gate",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "devils hole",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "deviot",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "devlins pound",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "devon hills",
		"state": "tas",
		"postcode": "7300"
	},
	{
		"town": "devon meadows",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "devon north",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "devon park",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "devoncourt station",
		"state": "qld",
		"postcode": "4824"
	},
	{
		"town": "devonport",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "dewars pool",
		"state": "wa",
		"postcode": "6567"
	},
	{
		"town": "dewhurst",
		"state": "vic",
		"postcode": "3808"
	},
	{
		"town": "dewitt",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "dharruk",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "dhuragoon",
		"state": "nsw",
		"postcode": "2733"
	},
	{
		"town": "dhurringile",
		"state": "vic",
		"postcode": "3610"
	},
	{
		"town": "diamantina lakes",
		"state": "qld",
		"postcode": "4735"
	},
	{
		"town": "diamond bay",
		"state": "nsw",
		"postcode": "2030"
	},
	{
		"town": "diamond beach",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "diamond creek",
		"state": "vic",
		"postcode": "3089"
	},
	{
		"town": "diamond gully",
		"state": "vic",
		"postcode": "3450"
	},
	{
		"town": "diamond head",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "diamond head",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "diamond hill",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "diamond valley",
		"state": "qld",
		"postcode": "4553"
	},
	{
		"town": "dianas basin",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "dianella",
		"state": "wa",
		"postcode": "6059"
	},
	{
		"town": "dicks hill",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "dickson",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "dicky beach",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "dickygundi",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "didcot",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "diddillibah",
		"state": "qld",
		"postcode": "4559"
	},
	{
		"town": "diddleum plains",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "diehard",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "digby",
		"state": "vic",
		"postcode": "3309"
	},
	{
		"town": "diggers camp",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "diggers rest",
		"state": "vic",
		"postcode": "3427"
	},
	{
		"town": "diggora",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "diggora west",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "diglum",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "dignams creek",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "dilkoon",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "dillon bay",
		"state": "wa",
		"postcode": "6338"
	},
	{
		"town": "dilpurra",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "dilston",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "dimboola",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "dimbulah",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "dinant",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "dindiloa",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "dingabledinga",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "dingadee",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "dingee",
		"state": "vic",
		"postcode": "3571"
	},
	{
		"town": "dingley village",
		"state": "vic",
		"postcode": "3172"
	},
	{
		"town": "dingo",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "dingo beach",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "dingo forest",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "dingwall",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "dinmore",
		"state": "qld",
		"postcode": "4303"
	},
	{
		"town": "dinner plain",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "dinninup",
		"state": "wa",
		"postcode": "6244"
	},
	{
		"town": "dinoga",
		"state": "nsw",
		"postcode": "2404"
	},
	{
		"town": "dinyarrak",
		"state": "vic",
		"postcode": "3415"
	},
	{
		"town": "direk",
		"state": "sa",
		"postcode": "5110"
	},
	{
		"town": "dirnaseer",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "dirnbir",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "dirranbandi",
		"state": "qld",
		"postcode": "4486"
	},
	{
		"town": "dirty creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "dismal swamp",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "dittmer",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "diwan",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "dixalea",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "dixie",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "dixons creek",
		"state": "vic",
		"postcode": "3775"
	},
	{
		"town": "dixvale",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "djuan",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "djuan",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "djugun",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "dobie",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "dobies bight",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "dobinsons",
		"state": "vic",
		"postcode": "3705"
	},
	{
		"town": "doboy",
		"state": "qld",
		"postcode": "4174"
	},
	{
		"town": "dobroyd point",
		"state": "nsw",
		"postcode": "2045"
	},
	{
		"town": "docker",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "docker river",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "dockers plains",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "docklands",
		"state": "vic",
		"postcode": "3008"
	},
	{
		"town": "doctor george mountain",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "doctors creek",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "doctors flat",
		"state": "vic",
		"postcode": "3895"
	},
	{
		"town": "doctors rocks",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "dodges ferry",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "dodsworth",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "dog rocks",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "dog swamp",
		"state": "wa",
		"postcode": "6060"
	},
	{
		"town": "dog trap crossing",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "dohles rocks",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "dolans bay",
		"state": "nsw",
		"postcode": "2229"
	},
	{
		"town": "dollar",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "dolls point",
		"state": "nsw",
		"postcode": "2219"
	},
	{
		"town": "dolphin heads",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "dolphin point",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "dolphin sands",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "domain road po",
		"state": "vic",
		"postcode": "3141"
	},
	{
		"town": "domville",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "don",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "don valley",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "donald",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "donald creek",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "doncaster",
		"state": "vic",
		"postcode": "3108"
	},
	{
		"town": "doncaster east",
		"state": "vic",
		"postcode": "3109"
	},
	{
		"town": "doncaster heights",
		"state": "vic",
		"postcode": "3109"
	},
	{
		"town": "dondingalong",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "dongara",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "dongolocking",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "donnelly river",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "donnellyville",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "donnybrook",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "donnybrook",
		"state": "vic",
		"postcode": "3064"
	},
	{
		"town": "donnybrook",
		"state": "wa",
		"postcode": "6239"
	},
	{
		"town": "donovans",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "donovans forest",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "donovans lane",
		"state": "vic",
		"postcode": "3286"
	},
	{
		"town": "donvale",
		"state": "vic",
		"postcode": "3111"
	},
	{
		"town": "dooboobetic",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "doodlakine",
		"state": "wa",
		"postcode": "6411"
	},
	{
		"town": "dooen",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "dookaling",
		"state": "wa",
		"postcode": "6575"
	},
	{
		"town": "dookie",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "dookie college",
		"state": "vic",
		"postcode": "3647"
	},
	{
		"town": "doolandella",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "doolbi",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "doomadgee",
		"state": "qld",
		"postcode": "4830"
	},
	{
		"town": "doomben",
		"state": "qld",
		"postcode": "4007"
	},
	{
		"town": "doon ayre",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "doon doon",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "doonan",
		"state": "qld",
		"postcode": "4562"
	},
	{
		"town": "doongin",
		"state": "wa",
		"postcode": "6409"
	},
	{
		"town": "doongul",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "doonside",
		"state": "nsw",
		"postcode": "2767"
	},
	{
		"town": "dooralong",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "dopewarra",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "dora creek",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "doreen",
		"state": "vic",
		"postcode": "3754"
	},
	{
		"town": "dorodong",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "dorre island",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "dorrigo",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "dorrigo north",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "dorrington",
		"state": "qld",
		"postcode": "4060"
	},
	{
		"town": "dorroughby",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "dorset vale",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "double bay",
		"state": "nsw",
		"postcode": "1360"
	},
	{
		"town": "double bay",
		"state": "nsw",
		"postcode": "2028"
	},
	{
		"town": "double creek",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "doubleview",
		"state": "wa",
		"postcode": "6018"
	},
	{
		"town": "doubtful creek",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "doughboy",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "douglas",
		"state": "qld",
		"postcode": "4354"
	},
	{
		"town": "douglas",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "douglas",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "douglas park",
		"state": "nsw",
		"postcode": "2569"
	},
	{
		"town": "douglas river",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "dover",
		"state": "tas",
		"postcode": "7117"
	},
	{
		"town": "dover gardens",
		"state": "sa",
		"postcode": "5048"
	},
	{
		"town": "dover heights",
		"state": "nsw",
		"postcode": "2030"
	},
	{
		"town": "doveton",
		"state": "vic",
		"postcode": "3177"
	},
	{
		"town": "dowerin",
		"state": "wa",
		"postcode": "6461"
	},
	{
		"town": "dowling",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "dowlingville",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "down river",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "downer",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "downlands",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "downside",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "dows creek",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "dowsing point",
		"state": "tas",
		"postcode": "7010"
	},
	{
		"town": "doyalson",
		"state": "nsw",
		"postcode": "2262"
	},
	{
		"town": "doyles creek",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "doyles river",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "drake",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "draper",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "drayton",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "drayton north",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "dreeite",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "dreeite south",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "drewvale",
		"state": "qld",
		"postcode": "4116"
	},
	{
		"town": "driffield",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "drik drik",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "drildool",
		"state": "nsw",
		"postcode": "2386"
	},
	{
		"town": "drillham",
		"state": "qld",
		"postcode": "4424"
	},
	{
		"town": "drillham south",
		"state": "qld",
		"postcode": "4424"
	},
	{
		"town": "drinan",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "dripstone",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "driver",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "dromana",
		"state": "vic",
		"postcode": "3936"
	},
	{
		"town": "dromana west",
		"state": "vic",
		"postcode": "3938"
	},
	{
		"town": "dromedary",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "dromedary",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "dropmore",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "drouin",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "drouin east",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "drouin south",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "drouin west",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "drumanure",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "drumborg",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "drumcondra",
		"state": "vic",
		"postcode": "3215"
	},
	{
		"town": "drummartin",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "drummond",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "drummond cove",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "drummond north",
		"state": "vic",
		"postcode": "3446"
	},
	{
		"town": "drummoyne",
		"state": "nsw",
		"postcode": "1470"
	},
	{
		"town": "drummoyne",
		"state": "nsw",
		"postcode": "2047"
	},
	{
		"town": "drung",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "dry creek",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "dry creek",
		"state": "sa",
		"postcode": "5094"
	},
	{
		"town": "dry diggings",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "dry plain",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "dryandra",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "drysdale",
		"state": "vic",
		"postcode": "3222"
	},
	{
		"town": "duaringa",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "dubbo",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "dubbo east",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "dubbo grove",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "dubbo west",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "dublin",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "duchembegarra north",
		"state": "vic",
		"postcode": "3409"
	},
	{
		"town": "duchess",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "duck creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "duckenfield",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "duckinwilla",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "duckmaloi",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "dudinin",
		"state": "wa",
		"postcode": "6363"
	},
	{
		"town": "dudley",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "dudley",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "dudley park",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "dudley park",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "duffholme",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "duffy",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "duffys forest",
		"state": "nsw",
		"postcode": "2084"
	},
	{
		"town": "dugandan",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "dugays bridge",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "duingal",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "dukin",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "dulacca",
		"state": "qld",
		"postcode": "4425"
	},
	{
		"town": "dulcot",
		"state": "tas",
		"postcode": "7025"
	},
	{
		"town": "dulguigan",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "dulong",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "dululu",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "dulverton",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "dulwich",
		"state": "sa",
		"postcode": "5065"
	},
	{
		"town": "dulwich hill",
		"state": "nsw",
		"postcode": "2203"
	},
	{
		"town": "dulyalbin",
		"state": "wa",
		"postcode": "6425"
	},
	{
		"town": "dum dum",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "dumaresq",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "dumaresq island",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "dumbalk",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "dumbalk east",
		"state": "vic",
		"postcode": "3957"
	},
	{
		"town": "dumbarton",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "dumbleton",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "dumbleyung",
		"state": "wa",
		"postcode": "6350"
	},
	{
		"town": "dumbudgery",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "dumgree",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "dumosa",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "dumpy creek",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "dunach",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "dunalley",
		"state": "tas",
		"postcode": "7177"
	},
	{
		"town": "dunbible",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "dunbogan",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "dunbulbalane",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "duncan",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "duncraig",
		"state": "wa",
		"postcode": "6023"
	},
	{
		"town": "dundarrah",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "dundas",
		"state": "nsw",
		"postcode": "2117"
	},
	{
		"town": "dundas",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "dundas",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "dundas valley",
		"state": "nsw",
		"postcode": "2117"
	},
	{
		"town": "dundathu",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "dundee",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "dundee beach",
		"state": "nt",
		"postcode": "840"
	},
	{
		"town": "dundee downs",
		"state": "nt",
		"postcode": "840"
	},
	{
		"town": "dundee forest",
		"state": "nt",
		"postcode": "840"
	},
	{
		"town": "dundonnell",
		"state": "vic",
		"postcode": "3271"
	},
	{
		"town": "dundowran",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "dundowran beach",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "dundula",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "dundurrabin",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "dunearn",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "dunedoo",
		"state": "nsw",
		"postcode": "2844"
	},
	{
		"town": "dungarubba",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "dungay",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "dungeree",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "dungog",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "dungowan",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "dunk island",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "dunkeld",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "dunkeld",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "dunkirk",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "dunlop",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "dunluce",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "dunmarra",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "dunmora",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "dunmore",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "dunmore",
		"state": "qld",
		"postcode": "4407"
	},
	{
		"town": "dunmore",
		"state": "vic",
		"postcode": "3287"
	},
	{
		"town": "dunmunkle east",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "dunnrock",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "dunnstown",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "dunolly",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "dunolly",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "dunoon",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "dunorlan",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "dunrobin",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "duns creek",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "dunsborough",
		"state": "wa",
		"postcode": "6281"
	},
	{
		"town": "duntroon",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "dunville loop",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "dunwich",
		"state": "qld",
		"postcode": "4183"
	},
	{
		"town": "dunworthy",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "durack",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "durack",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "durah",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "dural",
		"state": "nsw",
		"postcode": "2158"
	},
	{
		"town": "dural",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "duramana",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "duranbah",
		"state": "nsw",
		"postcode": "2487"
	},
	{
		"town": "duranillin",
		"state": "wa",
		"postcode": "6393"
	},
	{
		"town": "durdidwarrah",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "durham downs",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "durham lead",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "durham ox",
		"state": "vic",
		"postcode": "3576"
	},
	{
		"town": "duri",
		"state": "nsw",
		"postcode": "2344"
	},
	{
		"town": "duroby",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "duroby creek",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "durong",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "durong south",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "durran durra",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "durras",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "durras north",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "durren durren",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "dusodie",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "dutson",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "dutson downs",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "dutton",
		"state": "sa",
		"postcode": "5356"
	},
	{
		"town": "dutton park",
		"state": "qld",
		"postcode": "4102"
	},
	{
		"town": "dutton way",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "duval",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "duverney",
		"state": "vic",
		"postcode": "3323"
	},
	{
		"town": "dwarda",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "dwellingup",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "dyers crossing",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "dykehead",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "dynnyrne",
		"state": "tas",
		"postcode": "7005"
	},
	{
		"town": "dyraaba",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "dyraaba central",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "dyraaba creek",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "dyrring",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "dysart",
		"state": "qld",
		"postcode": "4745"
	},
	{
		"town": "dysart",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "dysart",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "eagle bay",
		"state": "wa",
		"postcode": "6281"
	},
	{
		"town": "eagle farm",
		"state": "qld",
		"postcode": "4009"
	},
	{
		"town": "eagle heights",
		"state": "qld",
		"postcode": "4271"
	},
	{
		"town": "eagle junction",
		"state": "qld",
		"postcode": "4011"
	},
	{
		"town": "eagle on the hill",
		"state": "sa",
		"postcode": "5150"
	},
	{
		"town": "eagle point",
		"state": "vic",
		"postcode": "3878"
	},
	{
		"town": "eagle vale",
		"state": "nsw",
		"postcode": "2558"
	},
	{
		"town": "eagleby",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "eaglefield",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "eaglehawk",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "eaglehawk neck",
		"state": "tas",
		"postcode": "7179"
	},
	{
		"town": "eaglehawk north",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "eaglemont",
		"state": "vic",
		"postcode": "3084"
	},
	{
		"town": "eagleton",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "earlston",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "earlville",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "earlwood",
		"state": "nsw",
		"postcode": "2206"
	},
	{
		"town": "east albury",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "east armidale",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "east augusta",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "east bairnsdale",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "east ballina",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "east barron",
		"state": "qld",
		"postcode": "4883"
	},
	{
		"town": "east bendigo",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "east bowes",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "east boyd town",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "east brisbane",
		"state": "qld",
		"postcode": "4169"
	},
	{
		"town": "east bunbury",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "east cam",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "east cannington",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "east carnarvon",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "east chapman",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "east damboring",
		"state": "wa",
		"postcode": "6608"
	},
	{
		"town": "east deep creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "east devonport",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "east end",
		"state": "qld",
		"postcode": "4695"
	},
	{
		"town": "east fremantle",
		"state": "wa",
		"postcode": "6158"
	},
	{
		"town": "east geelong",
		"state": "vic",
		"postcode": "3219"
	},
	{
		"town": "east gosford",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "east gresford",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "east haldon",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "east hills",
		"state": "nsw",
		"postcode": "2213"
	},
	{
		"town": "east ipswich",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "east jindabyne",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "east kangaloon",
		"state": "nsw",
		"postcode": "2576"
	},
	{
		"town": "east kempsey",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "east kurrajong",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "east launceston",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "east lindfield",
		"state": "nsw",
		"postcode": "2070"
	},
	{
		"town": "east lismore",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "east lynne",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "east lyons river",
		"state": "wa",
		"postcode": "6705"
	},
	{
		"town": "east mackay",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "east maitland",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "east melbourne",
		"state": "vic",
		"postcode": "3002"
	},
	{
		"town": "east melbourne",
		"state": "vic",
		"postcode": "8002"
	},
	{
		"town": "east moonta",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "east nanango",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "east perth",
		"state": "wa",
		"postcode": "6004"
	},
	{
		"town": "east perth",
		"state": "wa",
		"postcode": "6892"
	},
	{
		"town": "east perth",
		"state": "wa",
		"postcode": "6893"
	},
	{
		"town": "east point",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "east popanyinning",
		"state": "wa",
		"postcode": "6309"
	},
	{
		"town": "east ridgley",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "east rockingham",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "east ryde",
		"state": "nsw",
		"postcode": "2113"
	},
	{
		"town": "east sale raaf",
		"state": "vic",
		"postcode": "3852"
	},
	{
		"town": "east seaham",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "east sydney",
		"state": "nsw",
		"postcode": "2010"
	},
	{
		"town": "east tamworth",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "east toowoomba",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "east victoria park",
		"state": "wa",
		"postcode": "6101"
	},
	{
		"town": "east victoria park",
		"state": "wa",
		"postcode": "6981"
	},
	{
		"town": "east wagga wagga",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "east wangaratta",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "east warburton",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "east wardell",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "east yeoburn",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "eastbrook",
		"state": "wa",
		"postcode": "6260"
	},
	{
		"town": "eastern creek",
		"state": "nsw",
		"postcode": "2766"
	},
	{
		"town": "eastern heights",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "eastern suburbs pc",
		"state": "nsw",
		"postcode": "2005"
	},
	{
		"town": "eastern view",
		"state": "vic",
		"postcode": "3231"
	},
	{
		"town": "eastgardens",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "eastlake",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "eastlakes",
		"state": "nsw",
		"postcode": "2018"
	},
	{
		"town": "eastmoor",
		"state": "vic",
		"postcode": "3165"
	},
	{
		"town": "eastville",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "eastwood",
		"state": "nsw",
		"postcode": "2122"
	},
	{
		"town": "eastwood",
		"state": "sa",
		"postcode": "5063"
	},
	{
		"town": "eaton",
		"state": "wa",
		"postcode": "6232"
	},
	{
		"town": "eatons hill",
		"state": "qld",
		"postcode": "4037"
	},
	{
		"town": "eatonsville",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "ebbw vale",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "ebden",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "ebenezer",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "ebenezer",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "ebenezer",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "eberys",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "ebor",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "eccleston",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "echuca",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "echuca east",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "echuca south",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "echuca village",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "echuca west",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "echunga",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "ecklin south",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "edderton",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "eddington",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "eddystone",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "eddystone point",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "eden",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "eden creek",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "eden hill",
		"state": "wa",
		"postcode": "6054"
	},
	{
		"town": "eden hills",
		"state": "sa",
		"postcode": "5050"
	},
	{
		"town": "eden park",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "eden valley",
		"state": "sa",
		"postcode": "5235"
	},
	{
		"town": "edenhope",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "edens landing",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "edensor park",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "edenville",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "edgcumbe beach",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "edge hill",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "edgecliff",
		"state": "nsw",
		"postcode": "2027"
	},
	{
		"town": "edgecombe",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "edgeroi",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "edgewater",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "edgeworth",
		"state": "nsw",
		"postcode": "2285"
	},
	{
		"town": "edi",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "edi upper",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "edillilie",
		"state": "sa",
		"postcode": "5630"
	},
	{
		"town": "edinburgh",
		"state": "sa",
		"postcode": "5111"
	},
	{
		"town": "edith",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "edith creek",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "edith river",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "edithburgh",
		"state": "sa",
		"postcode": "5583"
	},
	{
		"town": "edithvale",
		"state": "vic",
		"postcode": "3196"
	},
	{
		"town": "edmondson park",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "edmonton",
		"state": "qld",
		"postcode": "4869"
	},
	{
		"town": "edrom",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "edward river",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "edwards find",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "edwardstown",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "edwardstown",
		"state": "sa",
		"postcode": "5039"
	},
	{
		"town": "eenaweena",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "eerwah vale",
		"state": "qld",
		"postcode": "4562"
	},
	{
		"town": "eganstown",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "egg lagoon",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "eggs and bacon bay",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "eglinton",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "eglinton",
		"state": "wa",
		"postcode": "6034"
	},
	{
		"town": "egypt",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "eidsvold",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "eidsvold east",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "eidsvold west",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "eight mile creek",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "eight mile plains",
		"state": "qld",
		"postcode": "4113"
	},
	{
		"town": "eighteen mile",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "eighty mile beach",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "eilandonan",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "eildon",
		"state": "vic",
		"postcode": "3713"
	},
	{
		"town": "eildon hill",
		"state": "qld",
		"postcode": "4030"
	},
	{
		"town": "eimeo",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "einasleigh",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "ejanding",
		"state": "wa",
		"postcode": "6464"
	},
	{
		"town": "ekibin",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "el arish",
		"state": "qld",
		"postcode": "4855"
	},
	{
		"town": "elaine",
		"state": "vic",
		"postcode": "3334"
	},
	{
		"town": "elaman creek",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "elands",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "elanora",
		"state": "qld",
		"postcode": "4221"
	},
	{
		"town": "elanora heights",
		"state": "nsw",
		"postcode": "2101"
	},
	{
		"town": "elberton",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "elbow valley",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "elderslie",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "elderslie",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "elderslie",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "eldon",
		"state": "tas",
		"postcode": "7027"
	},
	{
		"town": "eldorado",
		"state": "vic",
		"postcode": "3746"
	},
	{
		"town": "electra",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "electrona",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "eleebana",
		"state": "nsw",
		"postcode": "2282"
	},
	{
		"town": "elermore vale",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "elevated plains",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "elgin",
		"state": "wa",
		"postcode": "6237"
	},
	{
		"town": "elgin vale",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "eli waters",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "elimbah",
		"state": "qld",
		"postcode": "4516"
	},
	{
		"town": "elingamite",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "elingamite north",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "elizabeth",
		"state": "sa",
		"postcode": "5112"
	},
	{
		"town": "elizabeth bay",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "elizabeth beach",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "elizabeth downs",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "elizabeth east",
		"state": "sa",
		"postcode": "5112"
	},
	{
		"town": "elizabeth grove",
		"state": "sa",
		"postcode": "5112"
	},
	{
		"town": "elizabeth north",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "elizabeth park",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "elizabeth south",
		"state": "sa",
		"postcode": "5112"
	},
	{
		"town": "elizabeth street po",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "elizabeth town",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "elizabeth vale",
		"state": "sa",
		"postcode": "5112"
	},
	{
		"town": "elizabeth west",
		"state": "sa",
		"postcode": "5113"
	},
	{
		"town": "ellalong",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "ellam",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "elland",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "ellangowan",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "ellangowan",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "ellaswood",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "elleker",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "ellen grove",
		"state": "qld",
		"postcode": "4078"
	},
	{
		"town": "ellenborough",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "ellenbrook",
		"state": "wa",
		"postcode": "6069"
	},
	{
		"town": "ellendale",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "ellendale",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "ellerside",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "ellerslie",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "ellerslie",
		"state": "tas",
		"postcode": "7211"
	},
	{
		"town": "ellerslie",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "ellerston",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "ellesmere",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "elliminyt",
		"state": "vic",
		"postcode": "3250"
	},
	{
		"town": "ellinbank",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "elliott",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "elliott",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "elliott",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "elliott heads",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "ellis beach",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "ellis lane",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "elliston",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "elmhurst",
		"state": "vic",
		"postcode": "3469"
	},
	{
		"town": "elmore",
		"state": "vic",
		"postcode": "3558"
	},
	{
		"town": "elong elong",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "elphin",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "elphinstone",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "elphinstone",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "elphinstone",
		"state": "vic",
		"postcode": "3448"
	},
	{
		"town": "elrington",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "elsey station",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "elsmore",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "elsternwick",
		"state": "vic",
		"postcode": "3185"
	},
	{
		"town": "eltham",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "eltham",
		"state": "vic",
		"postcode": "3095"
	},
	{
		"town": "eltham north",
		"state": "vic",
		"postcode": "3095"
	},
	{
		"town": "elvina bay",
		"state": "nsw",
		"postcode": "2105"
	},
	{
		"town": "elwick",
		"state": "tas",
		"postcode": "7010"
	},
	{
		"town": "elwood",
		"state": "vic",
		"postcode": "3184"
	},
	{
		"town": "embleton",
		"state": "wa",
		"postcode": "6062"
	},
	{
		"town": "emerald",
		"state": "qld",
		"postcode": "4720"
	},
	{
		"town": "emerald",
		"state": "vic",
		"postcode": "3782"
	},
	{
		"town": "emerald beach",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "emerald hill",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "emerton",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "emita",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "emmaville",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "empire bay",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "empire vale",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "emu",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "emu bay",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "emu bridge",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "emu creek",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "emu creek",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "emu downs",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "emu flat",
		"state": "vic",
		"postcode": "3522"
	},
	{
		"town": "emu heights",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "emu heights",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "emu hill",
		"state": "wa",
		"postcode": "6369"
	},
	{
		"town": "emu park",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "emu plains",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "emu point",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "emu vale",
		"state": "qld",
		"postcode": "4371"
	},
	{
		"town": "encounter bay",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "endeavour hills",
		"state": "vic",
		"postcode": "3802"
	},
	{
		"town": "eneabba",
		"state": "wa",
		"postcode": "6518"
	},
	{
		"town": "enfield",
		"state": "nsw",
		"postcode": "2136"
	},
	{
		"town": "enfield",
		"state": "sa",
		"postcode": "5085"
	},
	{
		"town": "enfield",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "enfield plaza",
		"state": "sa",
		"postcode": "5085"
	},
	{
		"town": "enfield south",
		"state": "nsw",
		"postcode": "2133"
	},
	{
		"town": "engadine",
		"state": "nsw",
		"postcode": "2233"
	},
	{
		"town": "england creek",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "englefield",
		"state": "vic",
		"postcode": "3407"
	},
	{
		"town": "english town",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "englorie park",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "enmore",
		"state": "nsw",
		"postcode": "2042"
	},
	{
		"town": "enmore",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "enmore",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "enngonia",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "ennuin",
		"state": "wa",
		"postcode": "6484"
	},
	{
		"town": "enoggera",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "ensay",
		"state": "vic",
		"postcode": "3895"
	},
	{
		"town": "ensay north",
		"state": "vic",
		"postcode": "3895"
	},
	{
		"town": "environa",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "eppalock",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "epping",
		"state": "nsw",
		"postcode": "1710"
	},
	{
		"town": "epping",
		"state": "nsw",
		"postcode": "2121"
	},
	{
		"town": "epping",
		"state": "tas",
		"postcode": "7257"
	},
	{
		"town": "epping",
		"state": "vic",
		"postcode": "3076"
	},
	{
		"town": "epping forest",
		"state": "tas",
		"postcode": "7211"
	},
	{
		"town": "epsom",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "epsom",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "eradu",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "eradu south",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "erakala",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "eraring",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "ercildoune",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "eremerang",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "erica",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "erigolia",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "erikin",
		"state": "wa",
		"postcode": "6386"
	},
	{
		"town": "erina",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "erina fair",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "erina heights",
		"state": "nsw",
		"postcode": "2260"
	},
	{
		"town": "erinbank",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "erindale",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "erindale centre",
		"state": "act",
		"postcode": "2903"
	},
	{
		"town": "erinunderra",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "erith",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "erlando beach",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "erldunda",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "ermington",
		"state": "nsw",
		"postcode": "1700"
	},
	{
		"town": "ermington",
		"state": "nsw",
		"postcode": "2115"
	},
	{
		"town": "ernabella",
		"state": "sa",
		"postcode": "872"
	},
	{
		"town": "ernest",
		"state": "qld",
		"postcode": "4214"
	},
	{
		"town": "ernestina",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "erobin",
		"state": "qld",
		"postcode": "4160"
	},
	{
		"town": "eromanga",
		"state": "qld",
		"postcode": "4480"
	},
	{
		"town": "erowal bay",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "erriba",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "errowanbang",
		"state": "nsw",
		"postcode": "2791"
	},
	{
		"town": "erskine",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "erskine",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "erskine park",
		"state": "nsw",
		"postcode": "2759"
	},
	{
		"town": "erskineville",
		"state": "nsw",
		"postcode": "2043"
	},
	{
		"town": "erub",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "erudgere",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "eschol",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "eschol park",
		"state": "nsw",
		"postcode": "2558"
	},
	{
		"town": "esk",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "eskdale",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "eskdale",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "esmond",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "esperance",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "essendon",
		"state": "vic",
		"postcode": "3040"
	},
	{
		"town": "essendon north",
		"state": "vic",
		"postcode": "3041"
	},
	{
		"town": "essendon west",
		"state": "vic",
		"postcode": "3040"
	},
	{
		"town": "essington",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "estella",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "ethelton",
		"state": "sa",
		"postcode": "5015"
	},
	{
		"town": "etmilyn",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "etna creek",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "eton",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "eton north",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "ettalong",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "ettalong beach",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "ettamogah",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "ettrick",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "ettrick",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "euabalong",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "euabalong west",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "eubenangee",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "euberta",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "euchareena",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "eucla",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "eucumbene",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "eudlo",
		"state": "qld",
		"postcode": "4554"
	},
	{
		"town": "eudunda",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "eugenana",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "eugowra",
		"state": "nsw",
		"postcode": "2806"
	},
	{
		"town": "eukey",
		"state": "qld",
		"postcode": "4380"
	},
	{
		"town": "eulah creek",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "euleilah",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "eulo",
		"state": "qld",
		"postcode": "4491"
	},
	{
		"town": "eulomogo",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "eumemmerring",
		"state": "vic",
		"postcode": "3177"
	},
	{
		"town": "eumundi",
		"state": "qld",
		"postcode": "4562"
	},
	{
		"town": "eumungerie",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "eungai creek",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "eungai rail",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "eungella",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "eungella",
		"state": "qld",
		"postcode": "4757"
	},
	{
		"town": "eungella dam",
		"state": "qld",
		"postcode": "4757"
	},
	{
		"town": "eungella hinterland",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "eunonoreenya",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "eurack",
		"state": "vic",
		"postcode": "3251"
	},
	{
		"town": "eurambeen",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "euramo",
		"state": "qld",
		"postcode": "4854"
	},
	{
		"town": "eurardy",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "eureka",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "eureka",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "eureka",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "eurelia",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "eurimbula",
		"state": "nsw",
		"postcode": "2867"
	},
	{
		"town": "eurimbula",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "euriowie",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "euroa",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "eurobin",
		"state": "vic",
		"postcode": "3739"
	},
	{
		"town": "eurobin falls",
		"state": "vic",
		"postcode": "3740"
	},
	{
		"town": "eurobodalla",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "euroka",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "eurong",
		"state": "qld",
		"postcode": "4581"
	},
	{
		"town": "eurongilly",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "eurunderee",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "euston",
		"state": "nsw",
		"postcode": "2737"
	},
	{
		"town": "evandale",
		"state": "sa",
		"postcode": "5069"
	},
	{
		"town": "evandale",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "evans head",
		"state": "nsw",
		"postcode": "2473"
	},
	{
		"town": "evans landing",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "evans plains",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "evansford",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "evanslea",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "evanston",
		"state": "sa",
		"postcode": "5116"
	},
	{
		"town": "evanston",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "evanston gardens",
		"state": "sa",
		"postcode": "5116"
	},
	{
		"town": "evanston park",
		"state": "sa",
		"postcode": "5116"
	},
	{
		"town": "evanston south",
		"state": "sa",
		"postcode": "5116"
	},
	{
		"town": "evatt",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "eveleigh",
		"state": "nsw",
		"postcode": "1430"
	},
	{
		"town": "eveleigh",
		"state": "nsw",
		"postcode": "2015"
	},
	{
		"town": "evelyn",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "evelyn central",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "everard central",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "everard park",
		"state": "sa",
		"postcode": "5035"
	},
	{
		"town": "everton",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "everton hills",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "everton park",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "everton upper",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "eviron",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "ewingar",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "ewingsdale",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "ewington",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "exeter",
		"state": "nsw",
		"postcode": "2579"
	},
	{
		"town": "exeter",
		"state": "sa",
		"postcode": "5019"
	},
	{
		"town": "exeter",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "exford",
		"state": "vic",
		"postcode": "3338"
	},
	{
		"town": "exmouth",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "exmouth",
		"state": "wa",
		"postcode": "6707"
	},
	{
		"town": "exmouth gulf",
		"state": "wa",
		"postcode": "6707"
	},
	{
		"town": "export park",
		"state": "sa",
		"postcode": "5950"
	},
	{
		"town": "exton",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "eynesbury",
		"state": "vic",
		"postcode": "3338"
	},
	{
		"town": "ezards mill",
		"state": "vic",
		"postcode": "3896"
	},
	{
		"town": "fadden",
		"state": "act",
		"postcode": "2904"
	},
	{
		"town": "failford",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "fairbairn civil aerodrome",
		"state": "act",
		"postcode": "2609"
	},
	{
		"town": "fairbairn raaf",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "fairbank",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "fairbridge",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "fairdale",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "fairfield",
		"state": "nsw",
		"postcode": "1860"
	},
	{
		"town": "fairfield",
		"state": "nsw",
		"postcode": "2165"
	},
	{
		"town": "fairfield",
		"state": "qld",
		"postcode": "4103"
	},
	{
		"town": "fairfield",
		"state": "vic",
		"postcode": "3078"
	},
	{
		"town": "fairfield east",
		"state": "nsw",
		"postcode": "2165"
	},
	{
		"town": "fairfield gardens",
		"state": "qld",
		"postcode": "4103"
	},
	{
		"town": "fairfield heights",
		"state": "nsw",
		"postcode": "2165"
	},
	{
		"town": "fairfield west",
		"state": "nsw",
		"postcode": "2165"
	},
	{
		"town": "fairhaven",
		"state": "vic",
		"postcode": "3231"
	},
	{
		"town": "fairholme",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "fairhope",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "fairley",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "fairlight",
		"state": "nsw",
		"postcode": "2094"
	},
	{
		"town": "fairney view",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "fairview",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "fairview park",
		"state": "sa",
		"postcode": "5126"
	},
	{
		"town": "fairy bower",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "fairy dell",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "fairy dell",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "fairy hill",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "fairy meadow",
		"state": "nsw",
		"postcode": "2519"
	},
	{
		"town": "fairymead",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "faithfull",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "falbrook",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "falcon",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "falconer",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "falls creek",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "falls creek",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "falmouth",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "fannie bay",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "far meadow",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "faraday",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "farina",
		"state": "sa",
		"postcode": "5733"
	},
	{
		"town": "farleigh",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "farley",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "farmborough heights",
		"state": "nsw",
		"postcode": "2526"
	},
	{
		"town": "farnborough",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "farnham",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "farnsfield",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "farrants hill",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "farrars creek",
		"state": "qld",
		"postcode": "4481"
	},
	{
		"town": "farrell flat",
		"state": "sa",
		"postcode": "5416"
	},
	{
		"town": "farrer",
		"state": "act",
		"postcode": "2607"
	},
	{
		"town": "farringdon",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "fassifern",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "fassifern",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "fassifern valley",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "faulconbridge",
		"state": "nsw",
		"postcode": "2776"
	},
	{
		"town": "faulkland",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "fawcett",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "fawcetts basin",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "fawkner",
		"state": "vic",
		"postcode": "3060"
	},
	{
		"town": "fawkner east",
		"state": "vic",
		"postcode": "3060"
	},
	{
		"town": "fawkner north",
		"state": "vic",
		"postcode": "3060"
	},
	{
		"town": "federal",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "federal",
		"state": "qld",
		"postcode": "4568"
	},
	{
		"town": "feilton",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "felixstow",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "felton",
		"state": "qld",
		"postcode": "4358"
	},
	{
		"town": "felton east",
		"state": "qld",
		"postcode": "4358"
	},
	{
		"town": "felton south",
		"state": "qld",
		"postcode": "4358"
	},
	{
		"town": "fennell bay",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "fentonbury",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "fentons creek",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "ferguson",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "ferguson",
		"state": "wa",
		"postcode": "6236"
	},
	{
		"town": "fern bay",
		"state": "nsw",
		"postcode": "2295"
	},
	{
		"town": "fern gully",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "fern hill",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "fern tree",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "fernances",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "fernbank",
		"state": "vic",
		"postcode": "3864"
	},
	{
		"town": "fernbank creek",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "fernbrook",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "ferndale",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "ferndale",
		"state": "wa",
		"postcode": "6148"
	},
	{
		"town": "ferney",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "fernhill",
		"state": "nsw",
		"postcode": "2519"
	},
	{
		"town": "fernihurst",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "fernlees",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "fernleigh",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "fernmount",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "fernside",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "ferntree gully",
		"state": "vic",
		"postcode": "3156"
	},
	{
		"town": "fernvale",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "fernvale",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "fernvale",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "ferny creek",
		"state": "vic",
		"postcode": "3786"
	},
	{
		"town": "ferny glen",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "ferny grove",
		"state": "qld",
		"postcode": "4055"
	},
	{
		"town": "ferny hills",
		"state": "qld",
		"postcode": "4055"
	},
	{
		"town": "ferodale",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "ferryden park",
		"state": "sa",
		"postcode": "5010"
	},
	{
		"town": "ficks crossing",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "fiddletown",
		"state": "nsw",
		"postcode": "2159"
	},
	{
		"town": "fidges",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "field",
		"state": "sa",
		"postcode": "5265"
	},
	{
		"town": "fiery flat",
		"state": "vic",
		"postcode": "3520"
	},
	{
		"town": "fifield",
		"state": "nsw",
		"postcode": "2875"
	},
	{
		"town": "fifteen mile",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "fig tree pocket",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "figtree",
		"state": "nsw",
		"postcode": "2525"
	},
	{
		"town": "finch hatton",
		"state": "qld",
		"postcode": "4756"
	},
	{
		"town": "findon",
		"state": "sa",
		"postcode": "5023"
	},
	{
		"town": "fine flower",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "fingal",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "fingal",
		"state": "vic",
		"postcode": "3939"
	},
	{
		"town": "fingal bay",
		"state": "nsw",
		"postcode": "2315"
	},
	{
		"town": "fingal head",
		"state": "nsw",
		"postcode": "2487"
	},
	{
		"town": "finger post",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "finke",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "finley",
		"state": "nsw",
		"postcode": "2713"
	},
	{
		"town": "finnie",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "finniss",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "finucane",
		"state": "wa",
		"postcode": "6722"
	},
	{
		"town": "finucane island",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "firefly",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "firle",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "firthside",
		"state": "tas",
		"postcode": "7050"
	},
	{
		"town": "fish creek",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "fish point",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "fish river",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "fisher",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "fisher",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "fisher river",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "fisherman bay",
		"state": "sa",
		"postcode": "5522"
	},
	{
		"town": "fishermans bay",
		"state": "nsw",
		"postcode": "2316"
	},
	{
		"town": "fishermans bend",
		"state": "vic",
		"postcode": "3207"
	},
	{
		"town": "fishermans paradise",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "fishermans reach",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "fishers hill",
		"state": "nsw",
		"postcode": "2421"
	},
	{
		"town": "fishery falls",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "fishing point",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "fiskville",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "fitzgerald",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "fitzgerald",
		"state": "wa",
		"postcode": "6337"
	},
	{
		"town": "fitzgerald river",
		"state": "wa",
		"postcode": "6338"
	},
	{
		"town": "fitzgeralds mount",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "fitzgeralds valley",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "fitzgibbon",
		"state": "qld",
		"postcode": "4018"
	},
	{
		"town": "fitzroy",
		"state": "sa",
		"postcode": "5082"
	},
	{
		"town": "fitzroy",
		"state": "vic",
		"postcode": "3065"
	},
	{
		"town": "fitzroy",
		"state": "vic",
		"postcode": "8557"
	},
	{
		"town": "fitzroy crossing",
		"state": "wa",
		"postcode": "6765"
	},
	{
		"town": "fitzroy falls",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "fitzroy north",
		"state": "vic",
		"postcode": "3068"
	},
	{
		"town": "five dock",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "five mile",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "five ways",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "flaggy creek",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "flaggy rock",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "flagstaff",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "flagstaff gully",
		"state": "tas",
		"postcode": "7015"
	},
	{
		"town": "flagstaff hill",
		"state": "sa",
		"postcode": "5159"
	},
	{
		"town": "flagstone creek",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "flametree",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "flamingo beach",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "flat rocks",
		"state": "wa",
		"postcode": "6318"
	},
	{
		"town": "flat tops",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "flaxley",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "flaxton",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "flemington",
		"state": "vic",
		"postcode": "3031"
	},
	{
		"town": "fletcher",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "fletcher creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "flinders",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "flinders",
		"state": "vic",
		"postcode": "3929"
	},
	{
		"town": "flinders bay",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "flinders chase",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "flinders island",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "flinders lane",
		"state": "vic",
		"postcode": "8009"
	},
	{
		"town": "flinders naval depot",
		"state": "vic",
		"postcode": "3920"
	},
	{
		"town": "flinders park",
		"state": "sa",
		"postcode": "5025"
	},
	{
		"town": "flinders university",
		"state": "sa",
		"postcode": "5042"
	},
	{
		"town": "flinders view",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "flora hill",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "floradin",
		"state": "vic",
		"postcode": "3640"
	},
	{
		"town": "floraville",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "floreat",
		"state": "wa",
		"postcode": "6014"
	},
	{
		"town": "floreat forum",
		"state": "wa",
		"postcode": "6014"
	},
	{
		"town": "florentine",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "florey",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "florida gardens",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "flowerdale",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "flowerdale",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "flowerdale",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "flowerdale",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "flowerpot",
		"state": "tas",
		"postcode": "7163"
	},
	{
		"town": "flowery gully",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "fly creek",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "flyers creek",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "flying fish point",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "flying fox",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "flynn",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "flynn",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "flynn",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "flynns beach",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "flynns creek",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "fontys pool",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "footscray",
		"state": "vic",
		"postcode": "3011"
	},
	{
		"town": "footscray west",
		"state": "vic",
		"postcode": "3012"
	},
	{
		"town": "forbes",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "forbes",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "forbes creek",
		"state": "nsw",
		"postcode": "2621"
	},
	{
		"town": "forbes river",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "forbesdale",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "forcett",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "forde",
		"state": "act",
		"postcode": "2914"
	},
	{
		"town": "fordington",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "fords",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "fords bridge",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "fordsdale",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "fordwich",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "foreshores",
		"state": "qld",
		"postcode": "4678"
	},
	{
		"town": "forest",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "forest creek",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "forest glade",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "forest glen",
		"state": "nsw",
		"postcode": "2157"
	},
	{
		"town": "forest glen",
		"state": "qld",
		"postcode": "4556"
	},
	{
		"town": "forest grove",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "forest grove",
		"state": "wa",
		"postcode": "6286"
	},
	{
		"town": "forest hill",
		"state": "nsw",
		"postcode": "2651"
	},
	{
		"town": "forest hill",
		"state": "qld",
		"postcode": "4342"
	},
	{
		"town": "forest hill",
		"state": "vic",
		"postcode": "3131"
	},
	{
		"town": "forest hill",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "forest lake",
		"state": "qld",
		"postcode": "4078"
	},
	{
		"town": "forest lodge",
		"state": "nsw",
		"postcode": "2037"
	},
	{
		"town": "forest range",
		"state": "sa",
		"postcode": "5139"
	},
	{
		"town": "forest reefs",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "forest ridge",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "forest south",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "forestdale",
		"state": "qld",
		"postcode": "4118"
	},
	{
		"town": "forester",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "forestville",
		"state": "nsw",
		"postcode": "2087"
	},
	{
		"town": "forestville",
		"state": "sa",
		"postcode": "5035"
	},
	{
		"town": "forge creek",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "formartin",
		"state": "qld",
		"postcode": "4404"
	},
	{
		"town": "forrest",
		"state": "act",
		"postcode": "2603"
	},
	{
		"town": "forrest",
		"state": "vic",
		"postcode": "3236"
	},
	{
		"town": "forrest",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "forrest beach",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "forrest beach",
		"state": "wa",
		"postcode": "6271"
	},
	{
		"town": "forrestania",
		"state": "wa",
		"postcode": "6359"
	},
	{
		"town": "forrestdale",
		"state": "wa",
		"postcode": "6112"
	},
	{
		"town": "forresters beach",
		"state": "nsw",
		"postcode": "2260"
	},
	{
		"town": "forrestfield",
		"state": "wa",
		"postcode": "6058"
	},
	{
		"town": "forreston",
		"state": "sa",
		"postcode": "5233"
	},
	{
		"town": "forsayth",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "forster",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "forster",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "forster keys",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "forster shopping village",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "fort direction",
		"state": "tas",
		"postcode": "7022"
	},
	{
		"town": "fortescue",
		"state": "tas",
		"postcode": "7182"
	},
	{
		"town": "fortescue",
		"state": "wa",
		"postcode": "6716"
	},
	{
		"town": "fortescue bay",
		"state": "tas",
		"postcode": "7182"
	},
	{
		"town": "forth",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "forthside",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "fortis creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "fortitude valley",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "foster",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "foster north",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "fosters valley",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "fosterton",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "fosterville",
		"state": "vic",
		"postcode": "3557"
	},
	{
		"town": "foul bay",
		"state": "sa",
		"postcode": "5577"
	},
	{
		"town": "foulden",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "fountain gate",
		"state": "vic",
		"postcode": "3805"
	},
	{
		"town": "fountain valley",
		"state": "sa",
		"postcode": "5159"
	},
	{
		"town": "fountaindale",
		"state": "nsw",
		"postcode": "2258"
	},
	{
		"town": "four corners",
		"state": "nsw",
		"postcode": "2716"
	},
	{
		"town": "four mile beach",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "four mile creek",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "four mile creek",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "four winds",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "fourteen mile plain",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "fourteen mile road",
		"state": "vic",
		"postcode": "3814"
	},
	{
		"town": "fowlers bay",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "fox",
		"state": "sa",
		"postcode": "5272"
	},
	{
		"town": "fox valley",
		"state": "nsw",
		"postcode": "2076"
	},
	{
		"town": "foxdale",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "foxground",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "foxhow",
		"state": "vic",
		"postcode": "3323"
	},
	{
		"town": "framlingham",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "framlingham east",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "frances",
		"state": "sa",
		"postcode": "5262"
	},
	{
		"town": "frankford",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "frankland",
		"state": "wa",
		"postcode": "6396"
	},
	{
		"town": "franklin",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "franklin",
		"state": "tas",
		"postcode": "7113"
	},
	{
		"town": "franklin village",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "franklinford",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "franklyn",
		"state": "sa",
		"postcode": "5421"
	},
	{
		"town": "frankston",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "frankston east",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "frankston heights",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "frankston north",
		"state": "vic",
		"postcode": "3200"
	},
	{
		"town": "frankston south",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "frankton",
		"state": "sa",
		"postcode": "5356"
	},
	{
		"town": "frankton",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "fraser",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "fraser island",
		"state": "qld",
		"postcode": "4581"
	},
	{
		"town": "fraser range",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "frazer park",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "frazers creek",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "frazerview",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "fredericksfield",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "frederickton",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "freeburgh",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "freeling",
		"state": "sa",
		"postcode": "5372"
	},
	{
		"town": "freemans reach",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "freemans waterhole",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "freemantle",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "freestone",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "freestone creek",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "fregon",
		"state": "sa",
		"postcode": "872"
	},
	{
		"town": "fremantle",
		"state": "wa",
		"postcode": "6160"
	},
	{
		"town": "fremantle",
		"state": "wa",
		"postcode": "6959"
	},
	{
		"town": "fremantle",
		"state": "wa",
		"postcode": "6962"
	},
	{
		"town": "french island",
		"state": "vic",
		"postcode": "3921"
	},
	{
		"town": "french park",
		"state": "nsw",
		"postcode": "2655"
	},
	{
		"town": "frenches creek",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "frenchman bay",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "frenchmans",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "frenchs forest",
		"state": "nsw",
		"postcode": "1639"
	},
	{
		"town": "frenchs forest",
		"state": "nsw",
		"postcode": "1640"
	},
	{
		"town": "frenchs forest",
		"state": "nsw",
		"postcode": "2086"
	},
	{
		"town": "frenchs forest",
		"state": "qld",
		"postcode": "4502"
	},
	{
		"town": "frenchs forest east",
		"state": "nsw",
		"postcode": "2086"
	},
	{
		"town": "frenchville",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "freshwater",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "freshwater creek",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "freshwater point",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "frewville",
		"state": "sa",
		"postcode": "5063"
	},
	{
		"town": "freycinet",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "friendly beaches",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "frizells",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "frodsley",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "frog rock",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "frogmore",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "frogs hollow",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "fruitgrove",
		"state": "qld",
		"postcode": "4113"
	},
	{
		"town": "fryerstown",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "frying pan",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "fulham",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "fulham",
		"state": "sa",
		"postcode": "5024"
	},
	{
		"town": "fulham",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "fulham gardens",
		"state": "sa",
		"postcode": "5024"
	},
	{
		"town": "fullarton",
		"state": "sa",
		"postcode": "5063"
	},
	{
		"town": "fullerton",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "fullerton cove",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "fumina",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "fumina south",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "furnell",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "furner",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "furnissdale",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "furracabad",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "furzes",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "fyans creek",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "fyansford",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "fyshwick",
		"state": "act",
		"postcode": "2609"
	},
	{
		"town": "gabalong",
		"state": "wa",
		"postcode": "6574"
	},
	{
		"town": "gabbadah",
		"state": "wa",
		"postcode": "6042"
	},
	{
		"town": "gabbin",
		"state": "wa",
		"postcode": "6476"
	},
	{
		"town": "gabo island",
		"state": "vic",
		"postcode": "3892"
	},
	{
		"town": "gadara",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "gaeta",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "gaffneys creek",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "gagebrook",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "gailes",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "gainsborough",
		"state": "vic",
		"postcode": "3822"
	},
	{
		"town": "gainsford",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "gairdner",
		"state": "wa",
		"postcode": "6337"
	},
	{
		"town": "gairloch",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "galambine",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "galaquil",
		"state": "vic",
		"postcode": "3395"
	},
	{
		"town": "galaquil rail",
		"state": "vic",
		"postcode": "3395"
	},
	{
		"town": "galga",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "galiwinku",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "galloways hill",
		"state": "qld",
		"postcode": "4171"
	},
	{
		"town": "galong",
		"state": "nsw",
		"postcode": "2585"
	},
	{
		"town": "galore",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "galston",
		"state": "nsw",
		"postcode": "2159"
	},
	{
		"town": "gama",
		"state": "vic",
		"postcode": "3487"
	},
	{
		"town": "gan gan",
		"state": "nsw",
		"postcode": "2315"
	},
	{
		"town": "ganbenang",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "gangara",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "gangat",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "ganmain",
		"state": "nsw",
		"postcode": "2702"
	},
	{
		"town": "gannawarra",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "gap ridge",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "gapsted",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "gapuwiyak",
		"state": "nt",
		"postcode": "880"
	},
	{
		"town": "garah",
		"state": "nsw",
		"postcode": "2405"
	},
	{
		"town": "garangula",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "garbutt",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "garbutt east",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "garden city",
		"state": "vic",
		"postcode": "3207"
	},
	{
		"town": "garden island",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "garden island",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "garden island creek",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "garden suburb",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "gardenvale",
		"state": "vic",
		"postcode": "3185"
	},
	{
		"town": "gardenvale west",
		"state": "vic",
		"postcode": "3185"
	},
	{
		"town": "gardiner",
		"state": "vic",
		"postcode": "3146"
	},
	{
		"town": "gardners bay",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "garema",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "garfield",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "garfield",
		"state": "vic",
		"postcode": "3814"
	},
	{
		"town": "garfield north",
		"state": "vic",
		"postcode": "3814"
	},
	{
		"town": "gargett",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "garibaldi",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "garie",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "garland",
		"state": "nsw",
		"postcode": "2797"
	},
	{
		"town": "garland valley",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "garra",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "garradunga",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "garran",
		"state": "act",
		"postcode": "2605"
	},
	{
		"town": "garthowen",
		"state": "nsw",
		"postcode": "2345"
	},
	{
		"town": "garthowen",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "garup",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "garvoc",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "gascoyne junction",
		"state": "wa",
		"postcode": "6705"
	},
	{
		"town": "gascoyne river",
		"state": "wa",
		"postcode": "6705"
	},
	{
		"town": "gateshead",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "gateway island",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "gatton",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "gatton college",
		"state": "qld",
		"postcode": "4345"
	},
	{
		"town": "gatum",
		"state": "vic",
		"postcode": "3407"
	},
	{
		"town": "gaven",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "gawler",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "gawler",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "gawler belt",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "gawler east",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "gawler river",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "gawler south",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "gawler west",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "gayndah",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "gaythorne",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "gazette",
		"state": "vic",
		"postcode": "3289"
	},
	{
		"town": "gearys flat",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "geebung",
		"state": "qld",
		"postcode": "4034"
	},
	{
		"town": "geehi",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "geelong",
		"state": "vic",
		"postcode": "3220"
	},
	{
		"town": "geelong west",
		"state": "vic",
		"postcode": "3218"
	},
	{
		"town": "geeveston",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "geham",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "geilston bay",
		"state": "tas",
		"postcode": "7015"
	},
	{
		"town": "gelantipy",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "gellibrand",
		"state": "vic",
		"postcode": "3239"
	},
	{
		"town": "gellibrand lower",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "gelliondale",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "gelorup",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "gelston park",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "gemalla",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "gembrook",
		"state": "vic",
		"postcode": "3783"
	},
	{
		"town": "gemfields",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "gemmells",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "gemmells hill",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "gemville",
		"state": "nsw",
		"postcode": "2836"
	},
	{
		"town": "genaven",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "geneva",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "genoa",
		"state": "vic",
		"postcode": "3891"
	},
	{
		"town": "geographe",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "geogrup",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "george town",
		"state": "tas",
		"postcode": "7253"
	},
	{
		"town": "georges creek",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "georges creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "georges creek",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "georges hall",
		"state": "nsw",
		"postcode": "2198"
	},
	{
		"town": "georges heights",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "georges plains",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "georgetown",
		"state": "nsw",
		"postcode": "2298"
	},
	{
		"town": "georgetown",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "georgetown",
		"state": "sa",
		"postcode": "5472"
	},
	{
		"town": "georgica",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "georgina",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "gepps cross",
		"state": "sa",
		"postcode": "5094"
	},
	{
		"town": "geraldton",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "geraldton",
		"state": "wa",
		"postcode": "6531"
	},
	{
		"town": "gerang gerung",
		"state": "vic",
		"postcode": "3418"
	},
	{
		"town": "gerangamete",
		"state": "vic",
		"postcode": "3243"
	},
	{
		"town": "geranium",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "geranium plains",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "gerard",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "german creek",
		"state": "qld",
		"postcode": "4746"
	},
	{
		"town": "german creek",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "germania",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "germantown",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "gerogery",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "gerringong",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "gerroa",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "geurie",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "gheerulla",
		"state": "qld",
		"postcode": "4574"
	},
	{
		"town": "gherang",
		"state": "vic",
		"postcode": "3240"
	},
	{
		"town": "gheringhap",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "ghin ghin",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "ghinghinda",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "ghinni ghi",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "ghinni ghinni",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "ghoolendaadi",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "ghooli",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "ghost hill",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "giants creek",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "gibberagee",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "gibraltar range",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "gibson",
		"state": "wa",
		"postcode": "6448"
	},
	{
		"town": "gidgegannup",
		"state": "wa",
		"postcode": "6083"
	},
	{
		"town": "gidginbung",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "gidley",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "giffard",
		"state": "vic",
		"postcode": "3850"
	},
	{
		"town": "giffard west",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "gifford hill",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "gigoomgan",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "gilberton",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "gilberton",
		"state": "sa",
		"postcode": "5081"
	},
	{
		"town": "gilberton",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "gilderoy",
		"state": "vic",
		"postcode": "3797"
	},
	{
		"town": "gildora",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "gilead",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "giles corner",
		"state": "sa",
		"postcode": "5411"
	},
	{
		"town": "gilfillan",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "gilgai",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "gilgandra",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "gilgering",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "gilgooma",
		"state": "nsw",
		"postcode": "2829"
	},
	{
		"town": "gilgunnia",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "gillenbah",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "gilles plains",
		"state": "sa",
		"postcode": "5086"
	},
	{
		"town": "gilletts ridge",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "gillieston",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "gillieston heights",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "gillingall",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "gillingarra",
		"state": "wa",
		"postcode": "6510"
	},
	{
		"town": "gillman",
		"state": "sa",
		"postcode": "5013"
	},
	{
		"town": "gilmandyke",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "gilmore",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "gilmore",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "gilston",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "gilwell park",
		"state": "vic",
		"postcode": "3783"
	},
	{
		"town": "gin gin",
		"state": "nsw",
		"postcode": "2823"
	},
	{
		"town": "gin gin",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "gindie",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "gindoran",
		"state": "qld",
		"postcode": "4676"
	},
	{
		"town": "gingerah",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "ginghi",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "gingin",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "ginginup",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "gingkin",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "ginninderra village",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "ginoondan",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "gipsy point",
		"state": "vic",
		"postcode": "3891"
	},
	{
		"town": "giralang",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "girards hill",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "girgarre",
		"state": "vic",
		"postcode": "3624"
	},
	{
		"town": "girgarre east",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "girilambone",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "giro",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "girral",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "girralong",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "girraween",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "girrawheen",
		"state": "wa",
		"postcode": "6064"
	},
	{
		"town": "giru",
		"state": "qld",
		"postcode": "4809"
	},
	{
		"town": "girvan",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "gisborne",
		"state": "vic",
		"postcode": "3437"
	},
	{
		"town": "gisborne south",
		"state": "vic",
		"postcode": "3437"
	},
	{
		"town": "givelda",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "gladesville",
		"state": "nsw",
		"postcode": "1675"
	},
	{
		"town": "gladesville",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "gladfield",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "gladfield",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "gladstone",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "gladstone",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "gladstone",
		"state": "sa",
		"postcode": "5473"
	},
	{
		"town": "gladstone",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "gladstone park",
		"state": "vic",
		"postcode": "3043"
	},
	{
		"town": "gladstone south",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "gladysdale",
		"state": "vic",
		"postcode": "3797"
	},
	{
		"town": "glamorgan vale",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "glan devon",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "glance creek",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "glandore",
		"state": "sa",
		"postcode": "5037"
	},
	{
		"town": "glanmire",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "glanmire",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "glanville",
		"state": "sa",
		"postcode": "5015"
	},
	{
		"town": "glass house mountains",
		"state": "qld",
		"postcode": "4518"
	},
	{
		"town": "glastonbury",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "glaziers bay",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "glebe",
		"state": "nsw",
		"postcode": "2037"
	},
	{
		"town": "glebe",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "glebe point",
		"state": "nsw",
		"postcode": "2037"
	},
	{
		"town": "gledhow",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "gleeson hill",
		"state": "sa",
		"postcode": "5520"
	},
	{
		"town": "glen alice",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "glen allen",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "glen alpine",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "glen alvie",
		"state": "vic",
		"postcode": "3979"
	},
	{
		"town": "glen aplin",
		"state": "qld",
		"postcode": "4381"
	},
	{
		"town": "glen ayr",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "glen boughton",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "glen cairn",
		"state": "qld",
		"postcode": "4342"
	},
	{
		"town": "glen creek",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "glen davis",
		"state": "nsw",
		"postcode": "2846"
	},
	{
		"town": "glen dhu",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "glen echo",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "glen eden",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "glen elgin",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "glen esk",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "glen falloch",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "glen fernaigh",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "glen forbes",
		"state": "vic",
		"postcode": "3990"
	},
	{
		"town": "glen forrest",
		"state": "wa",
		"postcode": "6071"
	},
	{
		"town": "glen huntly",
		"state": "vic",
		"postcode": "3163"
	},
	{
		"town": "glen huon",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "glen innes",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "glen iris",
		"state": "vic",
		"postcode": "3146"
	},
	{
		"town": "glen iris",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "glen isla",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "glen kedron",
		"state": "qld",
		"postcode": "4031"
	},
	{
		"town": "glen martin",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "glen mervyn",
		"state": "wa",
		"postcode": "6239"
	},
	{
		"town": "glen nevis",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "glen oak",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "glen osmond",
		"state": "sa",
		"postcode": "5064"
	},
	{
		"town": "glen park",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "glen valley",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "glen ward",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "glen warning",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "glen waverley",
		"state": "vic",
		"postcode": "3150"
	},
	{
		"town": "glen william",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "glen wills",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "glenaire",
		"state": "vic",
		"postcode": "3238"
	},
	{
		"town": "glenaladale",
		"state": "vic",
		"postcode": "3864"
	},
	{
		"town": "glenalbyn",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "glenalta",
		"state": "sa",
		"postcode": "5052"
	},
	{
		"town": "glenarbon",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "glenaroua",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "glenarvon",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "glenaubyn",
		"state": "qld",
		"postcode": "4424"
	},
	{
		"town": "glenbar",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "glenbawn",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "glenbrae",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "glenbrook",
		"state": "nsw",
		"postcode": "2773"
	},
	{
		"town": "glenburn",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "glenburnie",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "glencairn",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "glencoe",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "glencoe",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "glencoe",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "glencoe west",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "glendale",
		"state": "nsw",
		"postcode": "2285"
	},
	{
		"town": "glendalough",
		"state": "wa",
		"postcode": "6016"
	},
	{
		"town": "glendambo",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "glendaruel",
		"state": "vic",
		"postcode": "3363"
	},
	{
		"town": "glenden",
		"state": "qld",
		"postcode": "4743"
	},
	{
		"town": "glendenning",
		"state": "nsw",
		"postcode": "2761"
	},
	{
		"town": "glendevie",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "glendon",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "glendonbrook",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "glendonnell",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "glendore",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "glendorf",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "gleneagle",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "glenelg",
		"state": "sa",
		"postcode": "5045"
	},
	{
		"town": "glenelg east",
		"state": "sa",
		"postcode": "5045"
	},
	{
		"town": "glenelg jetty road",
		"state": "sa",
		"postcode": "5045"
	},
	{
		"town": "glenelg north",
		"state": "sa",
		"postcode": "5045"
	},
	{
		"town": "glenelg south",
		"state": "sa",
		"postcode": "5045"
	},
	{
		"town": "glenella",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "glenerin",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "glenfern",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "glenferrie south",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "glenfield",
		"state": "nsw",
		"postcode": "2167"
	},
	{
		"town": "glenfield",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "glenfield park",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "glenforest",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "glenfyne",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "glengala",
		"state": "vic",
		"postcode": "3020"
	},
	{
		"town": "glengarrie",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "glengarry",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "glengarry",
		"state": "vic",
		"postcode": "3854"
	},
	{
		"town": "glengarry",
		"state": "wa",
		"postcode": "6023"
	},
	{
		"town": "glengarry north",
		"state": "vic",
		"postcode": "3854"
	},
	{
		"town": "glengarry west",
		"state": "vic",
		"postcode": "3854"
	},
	{
		"town": "glengower",
		"state": "vic",
		"postcode": "3370"
	},
	{
		"town": "glengowrie",
		"state": "sa",
		"postcode": "5044"
	},
	{
		"town": "glenhaughton",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "glenhaven",
		"state": "nsw",
		"postcode": "2156"
	},
	{
		"town": "glenhaven",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "glenhope",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "gleniffer",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "glenisla",
		"state": "vic",
		"postcode": "3314"
	},
	{
		"town": "glenleigh",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "glenlofty",
		"state": "vic",
		"postcode": "3469"
	},
	{
		"town": "glenloth",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "glenloth east",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "glenluce",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "glenlusk",
		"state": "tas",
		"postcode": "7012"
	},
	{
		"town": "glenlynn",
		"state": "wa",
		"postcode": "6256"
	},
	{
		"town": "glenlyon",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "glenmaggie",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "glenmona",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "glenmoral",
		"state": "qld",
		"postcode": "4719"
	},
	{
		"town": "glenmore",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "glenmore",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "glenmore park",
		"state": "nsw",
		"postcode": "2745"
	},
	{
		"town": "glenmorgan",
		"state": "qld",
		"postcode": "4423"
	},
	{
		"town": "glennie heights",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "glennies creek",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "glenning valley",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "glenora",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "glenoran",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "glenorchy",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "glenorchy",
		"state": "tas",
		"postcode": "7010"
	},
	{
		"town": "glenorchy",
		"state": "vic",
		"postcode": "3385"
	},
	{
		"town": "glenorchy",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "glenore grove",
		"state": "qld",
		"postcode": "4342"
	},
	{
		"town": "glenorie",
		"state": "nsw",
		"postcode": "2157"
	},
	{
		"town": "glenormiston north",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "glenormiston south",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "glenpatrick",
		"state": "vic",
		"postcode": "3469"
	},
	{
		"town": "glenquarie",
		"state": "nsw",
		"postcode": "2564"
	},
	{
		"town": "glenquarry",
		"state": "nsw",
		"postcode": "2576"
	},
	{
		"town": "glenrae",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "glenreagh",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "glenridding",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "glenrock",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "glenroi",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "glenrowan",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "glenrowan west",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "glenroy",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "glenroy",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "glenroy",
		"state": "sa",
		"postcode": "5277"
	},
	{
		"town": "glenroy",
		"state": "vic",
		"postcode": "3046"
	},
	{
		"town": "glenshee",
		"state": "vic",
		"postcode": "3469"
	},
	{
		"town": "glenside",
		"state": "sa",
		"postcode": "5065"
	},
	{
		"town": "glenthompson",
		"state": "vic",
		"postcode": "3293"
	},
	{
		"town": "glenthorne",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "glentromie",
		"state": "wa",
		"postcode": "6509"
	},
	{
		"town": "glenugie",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "glenunga",
		"state": "sa",
		"postcode": "5064"
	},
	{
		"town": "glenvale",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "glenvale",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "glenvale park",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "glenview",
		"state": "qld",
		"postcode": "4553"
	},
	{
		"town": "glenwood",
		"state": "nsw",
		"postcode": "2768"
	},
	{
		"town": "glenwood",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "glenworth valley",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "globe derby park",
		"state": "sa",
		"postcode": "5110"
	},
	{
		"town": "glomar beach",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "glossodia",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "glossop",
		"state": "sa",
		"postcode": "5344"
	},
	{
		"town": "gloucester",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "glynde",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "glynde plaza",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "gnangara",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "gnarabup",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "gnarwarre",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "gnotuk",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "gnowangerup",
		"state": "wa",
		"postcode": "6335"
	},
	{
		"town": "gnowellen",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "goba creek",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "gobbagombalin",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "gobur",
		"state": "vic",
		"postcode": "3719"
	},
	{
		"town": "gocup",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "goddards",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "godfreys creek",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "godwin beach",
		"state": "qld",
		"postcode": "4511"
	},
	{
		"town": "gogango",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "gogeldrie",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "gol gol",
		"state": "nsw",
		"postcode": "2738"
	},
	{
		"town": "golconda",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "golden bay",
		"state": "wa",
		"postcode": "6174"
	},
	{
		"town": "golden beach",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "golden beach",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "golden creek",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "golden fleece",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "golden grove",
		"state": "nsw",
		"postcode": "2008"
	},
	{
		"town": "golden grove",
		"state": "sa",
		"postcode": "5125"
	},
	{
		"town": "golden grove village",
		"state": "sa",
		"postcode": "5125"
	},
	{
		"town": "golden gully",
		"state": "vic",
		"postcode": "3555"
	},
	{
		"town": "golden heights",
		"state": "sa",
		"postcode": "5322"
	},
	{
		"town": "golden hill",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "golden point",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "golden point",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "golden point",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "golden ridge",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "golden square",
		"state": "vic",
		"postcode": "3555"
	},
	{
		"town": "golden valley",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "goldie",
		"state": "vic",
		"postcode": "3435"
	},
	{
		"town": "goldsborough",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "goldsworthy",
		"state": "wa",
		"postcode": "6723"
	},
	{
		"town": "gollan",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "golspie",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "golton south",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "gomersal",
		"state": "sa",
		"postcode": "5352"
	},
	{
		"town": "gong gong",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "gongolgon",
		"state": "nsw",
		"postcode": "2839"
	},
	{
		"town": "gonn crossing",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "goobang",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "goobarragandra",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "gooburrum",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "good hope",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "good hope landing",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "good night",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "goodar",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "goodger",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "goodlands",
		"state": "wa",
		"postcode": "6468"
	},
	{
		"town": "goodna",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "goodna east",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "goodnight",
		"state": "nsw",
		"postcode": "2736"
	},
	{
		"town": "goodooga",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "goodwood",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "goodwood",
		"state": "sa",
		"postcode": "5034"
	},
	{
		"town": "goodwood",
		"state": "tas",
		"postcode": "7010"
	},
	{
		"town": "goodwood island",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "googa creek",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "googong",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "goolgowi",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "goolhi",
		"state": "nsw",
		"postcode": "2379"
	},
	{
		"town": "goolma",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "goolmangar",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "gooloogong",
		"state": "nsw",
		"postcode": "2805"
	},
	{
		"town": "goolwa",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "goolwa beach",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "goolwa north",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "goolwa south",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "goomalibee",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "goomalling",
		"state": "wa",
		"postcode": "6460"
	},
	{
		"town": "goomally",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "goomarin",
		"state": "wa",
		"postcode": "6415"
	},
	{
		"town": "goombargana",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "goomboorian",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "goombungee",
		"state": "qld",
		"postcode": "4354"
	},
	{
		"town": "goomburra",
		"state": "qld",
		"postcode": "4362"
	},
	{
		"town": "goomeri",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "goomeribong",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "goon nure",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "goondah",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "goondi",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "goondiwindi",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "goonellabah",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "goonengerry",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "goongarrie",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "goongerah",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "goonoo goonoo",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "goonumbla",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "gooram",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "gooram gong",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "gooramadda",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "goorambat",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "goorangoola",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "goorganga creek",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "goorganga plains",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "goornong",
		"state": "vic",
		"postcode": "3557"
	},
	{
		"town": "gooroc",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "gooroolba",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "gooseberry hill",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "gootchie",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "goovigen",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "goowarra",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "gorae",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "gorae west",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "goranba",
		"state": "qld",
		"postcode": "4421"
	},
	{
		"town": "gordon",
		"state": "act",
		"postcode": "2906"
	},
	{
		"town": "gordon",
		"state": "nsw",
		"postcode": "2072"
	},
	{
		"town": "gordon",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "gordon",
		"state": "vic",
		"postcode": "3345"
	},
	{
		"town": "gordon park",
		"state": "qld",
		"postcode": "4031"
	},
	{
		"town": "gordonbrook",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "gordonvale",
		"state": "qld",
		"postcode": "4865"
	},
	{
		"town": "gordonville",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "gore",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "gore hill",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "gorge rock",
		"state": "wa",
		"postcode": "6375"
	},
	{
		"town": "gormandale",
		"state": "vic",
		"postcode": "3873"
	},
	{
		"town": "gormans hill",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "gormanston",
		"state": "tas",
		"postcode": "7466"
	},
	{
		"town": "gorokan",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "goroke",
		"state": "vic",
		"postcode": "3412"
	},
	{
		"town": "gorrie",
		"state": "wa",
		"postcode": "6556"
	},
	{
		"town": "goschen",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "gosford",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "gosford south",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "gosford west",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "gosforth",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "goshen",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "gosnells",
		"state": "wa",
		"postcode": "6110"
	},
	{
		"town": "gosnells",
		"state": "wa",
		"postcode": "6990"
	},
	{
		"town": "gosse",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "gostwyck",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "goughs bay",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "goulbourn island",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "goulburn",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "goulburn north",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "goulburn weir",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "gould creek",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "goulds country",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "gouldsville",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "gove",
		"state": "nt",
		"postcode": "880"
	},
	{
		"town": "gowan",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "gowanbrae",
		"state": "vic",
		"postcode": "3043"
	},
	{
		"town": "gowanford",
		"state": "vic",
		"postcode": "3544"
	},
	{
		"town": "gowangardie",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "gowar east",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "gower",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "gowrie",
		"state": "act",
		"postcode": "2904"
	},
	{
		"town": "gowrie",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "gowrie",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "gowrie",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "gowrie junction",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "gowrie mountain",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "gowrie park",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "goyder",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "goyura",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "grabben gullen",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "grace plains",
		"state": "sa",
		"postcode": "5502"
	},
	{
		"town": "gracemere",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "gracetown",
		"state": "wa",
		"postcode": "6284"
	},
	{
		"town": "graceville",
		"state": "qld",
		"postcode": "4075"
	},
	{
		"town": "graceville east",
		"state": "qld",
		"postcode": "4075"
	},
	{
		"town": "grafton",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "grafton west",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "gragin",
		"state": "nsw",
		"postcode": "2403"
	},
	{
		"town": "grahams creek",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "grahamstown",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "grahamvale",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "graman",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "grand ridge",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "grandchester",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "grange",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "grange",
		"state": "sa",
		"postcode": "5022"
	},
	{
		"town": "grangeburn",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "granite flat",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "granite flat",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "granite rock",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "grantham",
		"state": "qld",
		"postcode": "4347"
	},
	{
		"town": "granton",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "grants beach",
		"state": "nsw",
		"postcode": "2445"
	},
	{
		"town": "grants patch",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "grantville",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "granville",
		"state": "nsw",
		"postcode": "1830"
	},
	{
		"town": "granville",
		"state": "nsw",
		"postcode": "1831"
	},
	{
		"town": "granville",
		"state": "nsw",
		"postcode": "2142"
	},
	{
		"town": "granville",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "granville",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "granville harbour",
		"state": "tas",
		"postcode": "7469"
	},
	{
		"town": "granya",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "grape tree",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "grasmere",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "grass flat",
		"state": "vic",
		"postcode": "3409"
	},
	{
		"town": "grass patch",
		"state": "wa",
		"postcode": "6446"
	},
	{
		"town": "grass valley",
		"state": "wa",
		"postcode": "6403"
	},
	{
		"town": "grassdale",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "grassdale",
		"state": "vic",
		"postcode": "3302"
	},
	{
		"town": "grassmere",
		"state": "vic",
		"postcode": "3281"
	},
	{
		"town": "grasstree",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "grasstree beach",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "grasstree hill",
		"state": "tas",
		"postcode": "7017"
	},
	{
		"town": "grassy",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "grassy flat",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "grassy head",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "grassy spur",
		"state": "vic",
		"postcode": "3957"
	},
	{
		"town": "grattai",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "gravelly beach",
		"state": "tas",
		"postcode": "7276"
	},
	{
		"town": "gravesend",
		"state": "nsw",
		"postcode": "2401"
	},
	{
		"town": "grawin",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "grawlin",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "gray",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "gray",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "grays gate",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "grays point",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "graytown",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "gre gre",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "gre gre north",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "gre gre south",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "great bay",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "great keppel island",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "great mackerel beach",
		"state": "nsw",
		"postcode": "2108"
	},
	{
		"town": "great marlow",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "great northern",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "great sandy strait",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "great southern",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "great western",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "gredgwin",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "green cape",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "green creek",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "green fields",
		"state": "sa",
		"postcode": "5107"
	},
	{
		"town": "green forest",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "green gully",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "green gully",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "green head",
		"state": "wa",
		"postcode": "6514"
	},
	{
		"town": "green hills",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "green hills",
		"state": "nsw",
		"postcode": "2730"
	},
	{
		"town": "green island",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "green lake",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "green pigeon",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "green point",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "green point",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "green point",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "green range",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "green valley",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "greenacre",
		"state": "nsw",
		"postcode": "2190"
	},
	{
		"town": "greenacres",
		"state": "sa",
		"postcode": "5086"
	},
	{
		"town": "greenbank",
		"state": "qld",
		"postcode": "4124"
	},
	{
		"town": "greenbanks",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "greenbushes",
		"state": "wa",
		"postcode": "6254"
	},
	{
		"town": "greendale",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "greendale",
		"state": "nsw",
		"postcode": "2745"
	},
	{
		"town": "greendale",
		"state": "vic",
		"postcode": "3341"
	},
	{
		"town": "greenethorpe",
		"state": "nsw",
		"postcode": "2809"
	},
	{
		"town": "greenfield park",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "greenfields",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "greenhill",
		"state": "sa",
		"postcode": "5140"
	},
	{
		"town": "greenhill",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "greenhills",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "greenhills",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "greenhills",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "greenhills",
		"state": "wa",
		"postcode": "6380"
	},
	{
		"town": "greenlake",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "greenland dam",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "greenlands",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "greenlands",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "greenlands",
		"state": "qld",
		"postcode": "4380"
	},
	{
		"town": "greenmantle",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "greenmount",
		"state": "qld",
		"postcode": "4225"
	},
	{
		"town": "greenmount",
		"state": "qld",
		"postcode": "4359"
	},
	{
		"town": "greenmount",
		"state": "qld",
		"postcode": "4751"
	},
	{
		"town": "greenmount",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "greenmount",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "greenmount east",
		"state": "qld",
		"postcode": "4359"
	},
	{
		"town": "greenock",
		"state": "sa",
		"postcode": "5360"
	},
	{
		"town": "greenough",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "greenridge",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "greens beach",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "greens creek",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "greensborough",
		"state": "vic",
		"postcode": "3088"
	},
	{
		"town": "greenslopes",
		"state": "qld",
		"postcode": "4120"
	},
	{
		"town": "greenup",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "greenvale",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "greenvale",
		"state": "vic",
		"postcode": "3059"
	},
	{
		"town": "greenview",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "greenwald",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "greenway",
		"state": "act",
		"postcode": "2900"
	},
	{
		"town": "greenways",
		"state": "sa",
		"postcode": "5272"
	},
	{
		"town": "greenwell point",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "greenwich",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "greenwich park",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "greenwith",
		"state": "sa",
		"postcode": "5125"
	},
	{
		"town": "greenwood",
		"state": "wa",
		"postcode": "6024"
	},
	{
		"town": "greenwood",
		"state": "wa",
		"postcode": "6924"
	},
	{
		"town": "greenwood village",
		"state": "qld",
		"postcode": "4301"
	},
	{
		"town": "greenwoods valley",
		"state": "wa",
		"postcode": "6405"
	},
	{
		"town": "greg greg",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "gregadoo",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "greghamstown",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "gregors creek",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "gregory",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "gregory downs",
		"state": "qld",
		"postcode": "4830"
	},
	{
		"town": "gregory river",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "gregory river",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "greigs flat",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "grenfell",
		"state": "nsw",
		"postcode": "2810"
	},
	{
		"town": "grenville",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "gresford",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "gresham",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "greta",
		"state": "nsw",
		"postcode": "2334"
	},
	{
		"town": "greta",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "greta south",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "greta west",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "gretna",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "grevillia",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "grey river",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "greycliffe",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "greys plain",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "greystanes",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "greythorn",
		"state": "vic",
		"postcode": "3104"
	},
	{
		"town": "griffin",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "griffith",
		"state": "act",
		"postcode": "2603"
	},
	{
		"town": "griffith",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "griffith east",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "griffith university",
		"state": "qld",
		"postcode": "4111"
	},
	{
		"town": "grimwade",
		"state": "wa",
		"postcode": "6253"
	},
	{
		"town": "grindelwald",
		"state": "tas",
		"postcode": "7277"
	},
	{
		"town": "gringegalgona",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "gritjurk",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "grogan",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "grong grong",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "groomsville",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "groper creek reserve",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "grose vale",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "grose wold",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "grosmont",
		"state": "qld",
		"postcode": "4419"
	},
	{
		"town": "grosses plain",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "grosvenor",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "grosvenor place",
		"state": "nsw",
		"postcode": "1216"
	},
	{
		"town": "grosvenor place",
		"state": "nsw",
		"postcode": "1217"
	},
	{
		"town": "grosvenor place",
		"state": "nsw",
		"postcode": "1218"
	},
	{
		"town": "grosvenor place",
		"state": "nsw",
		"postcode": "1219"
	},
	{
		"town": "grosvenor place",
		"state": "nsw",
		"postcode": "1220"
	},
	{
		"town": "grove",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "grovedale",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "grovely",
		"state": "qld",
		"postcode": "4054"
	},
	{
		"town": "growee",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "grubben",
		"state": "nsw",
		"postcode": "2658"
	},
	{
		"town": "gruyere",
		"state": "vic",
		"postcode": "3770"
	},
	{
		"town": "guanaba",
		"state": "qld",
		"postcode": "4210"
	},
	{
		"town": "gubbata",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "guerilla bay",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "guilderton",
		"state": "wa",
		"postcode": "6041"
	},
	{
		"town": "guildford",
		"state": "nsw",
		"postcode": "2161"
	},
	{
		"town": "guildford",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "guildford",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "guildford",
		"state": "wa",
		"postcode": "6055"
	},
	{
		"town": "guildford",
		"state": "wa",
		"postcode": "6935"
	},
	{
		"town": "guildford west",
		"state": "nsw",
		"postcode": "2161"
	},
	{
		"town": "gulargambone",
		"state": "nsw",
		"postcode": "2828"
	},
	{
		"town": "gulf creek",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "gulgamree",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "gulgong",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "gulligan",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "gulliver",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "gulmarrad",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "gulnare",
		"state": "sa",
		"postcode": "5471"
	},
	{
		"town": "gulpa",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "guluguba",
		"state": "qld",
		"postcode": "4418"
	},
	{
		"town": "gum creek",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "gum flat",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "gum scrub",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "gumble",
		"state": "nsw",
		"postcode": "2865"
	},
	{
		"town": "gumdale",
		"state": "qld",
		"postcode": "4154"
	},
	{
		"town": "gumeracha",
		"state": "sa",
		"postcode": "5233"
	},
	{
		"town": "gumlu",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "gumly gumly",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "gumma",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "gunalda",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "gunbar",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "gunbower",
		"state": "vic",
		"postcode": "3566"
	},
	{
		"town": "gundagai",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "gundamulda",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "gundaroo",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "gundary",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "gunderbooka",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "gunderman",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "gundiah",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "gundillion",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "gundowring",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "gundurimba",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "gundy",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "gungahlin",
		"state": "act",
		"postcode": "2912"
	},
	{
		"town": "gungal",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "gungaloon",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "gunn",
		"state": "nt",
		"postcode": "832"
	},
	{
		"town": "gunn point",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "gunnedah",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "gunnembene",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "gunning",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "gunning gap",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "gunningbland",
		"state": "nsw",
		"postcode": "2876"
	},
	{
		"town": "gunningrah",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "gunns gully",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "gunns plains",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "gunpowder",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "gununa",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "gunyah",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "gunyah",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "gunyarra",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "gunyidi",
		"state": "wa",
		"postcode": "6513"
	},
	{
		"town": "gurgeena",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "gurley",
		"state": "nsw",
		"postcode": "2398"
	},
	{
		"town": "gurnang",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "gurra gurra",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "gurranang",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "gurrundah",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "gurulmundi",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "gutha",
		"state": "wa",
		"postcode": "6623"
	},
	{
		"town": "guthalungra",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "guthega",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "guthridge",
		"state": "vic",
		"postcode": "3850"
	},
	{
		"town": "guyong",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "guyra",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "guys forest",
		"state": "vic",
		"postcode": "3709"
	},
	{
		"town": "guys hill",
		"state": "vic",
		"postcode": "3807"
	},
	{
		"town": "gwabegar",
		"state": "nsw",
		"postcode": "2356"
	},
	{
		"town": "gwalia",
		"state": "wa",
		"postcode": "6438"
	},
	{
		"town": "gwambegwine",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "gwambygine",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "gwandalan",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "gwelup",
		"state": "wa",
		"postcode": "6018"
	},
	{
		"town": "gwindinup",
		"state": "wa",
		"postcode": "6237"
	},
	{
		"town": "gwynneville",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "gymbowen",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "gymea",
		"state": "nsw",
		"postcode": "2227"
	},
	{
		"town": "gymea bay",
		"state": "nsw",
		"postcode": "2227"
	},
	{
		"town": "gympie",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "haasts bluff",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "habana",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "haberfield",
		"state": "nsw",
		"postcode": "2045"
	},
	{
		"town": "hackett",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "hacketts gully",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "hackham",
		"state": "sa",
		"postcode": "5163"
	},
	{
		"town": "hackham west",
		"state": "sa",
		"postcode": "5163"
	},
	{
		"town": "hackney",
		"state": "sa",
		"postcode": "5069"
	},
	{
		"town": "hacks ferry",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "haddon",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "haden",
		"state": "qld",
		"postcode": "4353"
	},
	{
		"town": "hadfield",
		"state": "vic",
		"postcode": "3046"
	},
	{
		"town": "hadley",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "hadspen",
		"state": "tas",
		"postcode": "7290"
	},
	{
		"town": "hagley",
		"state": "tas",
		"postcode": "7292"
	},
	{
		"town": "hahndorf",
		"state": "sa",
		"postcode": "5245"
	},
	{
		"town": "haig",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "haigslea",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "hail creek",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "haines",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "halbury",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "halekulani",
		"state": "nsw",
		"postcode": "2262"
	},
	{
		"town": "half moon bay",
		"state": "vic",
		"postcode": "3193"
	},
	{
		"town": "half tide beach",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "halfway creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "halfway creek",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "haliday bay",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "halidon",
		"state": "sa",
		"postcode": "5309"
	},
	{
		"town": "halifax",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "halifax street",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "hall",
		"state": "act",
		"postcode": "2618"
	},
	{
		"town": "hallam",
		"state": "vic",
		"postcode": "3803"
	},
	{
		"town": "halleluja hills",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "hallett",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "hallett cove",
		"state": "sa",
		"postcode": "5158"
	},
	{
		"town": "halliday bay",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "hallidays point",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "hallora",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "halloran",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "halls creek",
		"state": "nsw",
		"postcode": "2346"
	},
	{
		"town": "halls creek",
		"state": "wa",
		"postcode": "6770"
	},
	{
		"town": "halls gap",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "halls head",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "hallston",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "hallsville",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "halton",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "haly creek",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "hambidge",
		"state": "sa",
		"postcode": "5633"
	},
	{
		"town": "hambidge",
		"state": "sa",
		"postcode": "5642"
	},
	{
		"town": "hambledon hill",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "hamel",
		"state": "wa",
		"postcode": "6215"
	},
	{
		"town": "hamelin bay",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "hamelin pool",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "hamersley",
		"state": "wa",
		"postcode": "6022"
	},
	{
		"town": "hamersley range",
		"state": "wa",
		"postcode": "6716"
	},
	{
		"town": "hamilton",
		"state": "nsw",
		"postcode": "2303"
	},
	{
		"town": "hamilton",
		"state": "qld",
		"postcode": "4007"
	},
	{
		"town": "hamilton",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "hamilton",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "hamilton",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "hamilton central",
		"state": "qld",
		"postcode": "4007"
	},
	{
		"town": "hamilton creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "hamilton east",
		"state": "nsw",
		"postcode": "2303"
	},
	{
		"town": "hamilton heights",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "hamilton hill",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "hamilton hill",
		"state": "wa",
		"postcode": "6963"
	},
	{
		"town": "hamilton island",
		"state": "qld",
		"postcode": "4803"
	},
	{
		"town": "hamilton north",
		"state": "nsw",
		"postcode": "2292"
	},
	{
		"town": "hamilton north",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "hamilton plains",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "hamilton south",
		"state": "nsw",
		"postcode": "2303"
	},
	{
		"town": "hamilton valley",
		"state": "nsw",
		"postcode": "2641"
	},
	{
		"town": "hamley",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "hamley bridge",
		"state": "sa",
		"postcode": "5401"
	},
	{
		"town": "hamlyn heights",
		"state": "vic",
		"postcode": "3215"
	},
	{
		"town": "hamlyn terrace",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "hammond",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "hammond",
		"state": "vic",
		"postcode": "3610"
	},
	{
		"town": "hammondville",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "hampden",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "hampden",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "hampden hall",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "hampshire",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "hampstead gardens",
		"state": "sa",
		"postcode": "5086"
	},
	{
		"town": "hampton",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "hampton",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "hampton",
		"state": "vic",
		"postcode": "3188"
	},
	{
		"town": "hampton east",
		"state": "vic",
		"postcode": "3188"
	},
	{
		"town": "hampton north",
		"state": "vic",
		"postcode": "3188"
	},
	{
		"town": "hampton park",
		"state": "vic",
		"postcode": "3976"
	},
	{
		"town": "hanging rock",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "hanging rock",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "hannaford",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "hannam vale",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "hannans",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "hannans",
		"state": "wa",
		"postcode": "6433"
	},
	{
		"town": "hansborough",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "hanson",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "hansons south",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "hansonville",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "hanwood",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "happy valley",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "happy valley",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "happy valley",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "happy valley",
		"state": "sa",
		"postcode": "5159"
	},
	{
		"town": "happy valley",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "happy valley",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "harbord",
		"state": "nsw",
		"postcode": "2096"
	},
	{
		"town": "harbord west",
		"state": "nsw",
		"postcode": "2096"
	},
	{
		"town": "harcourt",
		"state": "vic",
		"postcode": "3453"
	},
	{
		"town": "harcourt north",
		"state": "vic",
		"postcode": "3453"
	},
	{
		"town": "harden",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "hardwicke bay",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "hardy",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "hardys bay",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "harefield",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "harewood",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "harford",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "hargrave park",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "hargraves",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "harkaway",
		"state": "vic",
		"postcode": "3806"
	},
	{
		"town": "harlaxton",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "harlin",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "harman",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "harmers haven",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "harolds cross",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "harparary",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "harper creek",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "harpers hill",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "harrami",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "harriet",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "harriet river",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "harrietville",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "harrington",
		"state": "nsw",
		"postcode": "2427"
	},
	{
		"town": "harrington park",
		"state": "nsw",
		"postcode": "2567"
	},
	{
		"town": "harris park",
		"state": "nsw",
		"postcode": "2150"
	},
	{
		"town": "harrisfield",
		"state": "vic",
		"postcode": "3174"
	},
	{
		"town": "harrismith",
		"state": "wa",
		"postcode": "6361"
	},
	{
		"town": "harrison",
		"state": "act",
		"postcode": "2914"
	},
	{
		"town": "harristown",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "harrisville",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "harrogate",
		"state": "sa",
		"postcode": "5244"
	},
	{
		"town": "harrow",
		"state": "vic",
		"postcode": "3317"
	},
	{
		"town": "harrys creek",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "harston",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "hart",
		"state": "sa",
		"postcode": "5464"
	},
	{
		"town": "hartley",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "hartley",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "hartley vale",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "hartwell",
		"state": "vic",
		"postcode": "3124"
	},
	{
		"town": "hartwood",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "hartys plains",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "harvey",
		"state": "wa",
		"postcode": "6220"
	},
	{
		"town": "harwood",
		"state": "nsw",
		"postcode": "2465"
	},
	{
		"town": "haslam",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "hassall grove",
		"state": "nsw",
		"postcode": "2761"
	},
	{
		"town": "hastings",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "hastings",
		"state": "vic",
		"postcode": "3915"
	},
	{
		"town": "hastings",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "hastings point",
		"state": "nsw",
		"postcode": "2489"
	},
	{
		"town": "hat head",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "hatfield",
		"state": "nsw",
		"postcode": "2715"
	},
	{
		"town": "hatherleigh",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "hattah",
		"state": "vic",
		"postcode": "3501"
	},
	{
		"town": "hatton vale",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "havelock",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "haven",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "havenview",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "havilah",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "havilah",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "hawker",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "hawker",
		"state": "sa",
		"postcode": "5434"
	},
	{
		"town": "hawkesbury heights",
		"state": "nsw",
		"postcode": "2777"
	},
	{
		"town": "hawkesdale",
		"state": "vic",
		"postcode": "3287"
	},
	{
		"town": "hawkhurst",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "hawkins creek",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "hawkinston",
		"state": "vic",
		"postcode": "3578"
	},
	{
		"town": "hawks nest",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "hawksburn",
		"state": "vic",
		"postcode": "3142"
	},
	{
		"town": "hawkwood",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "hawley beach",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "hawthorn",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "hawthorn",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "hawthorn",
		"state": "vic",
		"postcode": "8622"
	},
	{
		"town": "hawthorn east",
		"state": "vic",
		"postcode": "3123"
	},
	{
		"town": "hawthorn north",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "hawthorn west",
		"state": "vic",
		"postcode": "3122"
	},
	{
		"town": "hawthorndene",
		"state": "sa",
		"postcode": "5051"
	},
	{
		"town": "hawthorne",
		"state": "qld",
		"postcode": "4171"
	},
	{
		"town": "hay",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "hay flat",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "hay point",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "hay south",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "hayanmi",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "hayborough",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "haydens bog",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "hayes",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "hayes creek",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "hayes gap",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "hayman island",
		"state": "qld",
		"postcode": "4801"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "1208"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "1236"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "1237"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "1238"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "1239"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "1240"
	},
	{
		"town": "haymarket",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "haysdale",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "hazel glen",
		"state": "vic",
		"postcode": "3754"
	},
	{
		"town": "hazel park",
		"state": "vic",
		"postcode": "3966"
	},
	{
		"town": "hazelbrook",
		"state": "nsw",
		"postcode": "2779"
	},
	{
		"town": "hazeldene",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "hazelgrove",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "hazelmere",
		"state": "wa",
		"postcode": "6055"
	},
	{
		"town": "hazelvale",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "hazelwood",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "hazelwood north",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "hazelwood park",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "hazelwood south",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "hazledean",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "headington hill",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "healesville",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "healesville main street",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "healesville post shop",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "healy",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "hearson",
		"state": "wa",
		"postcode": "6715"
	},
	{
		"town": "heath field",
		"state": "vic",
		"postcode": "3311"
	},
	{
		"town": "heath hill",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "heathcote",
		"state": "nsw",
		"postcode": "2233"
	},
	{
		"town": "heathcote",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "heathcote junction",
		"state": "vic",
		"postcode": "3758"
	},
	{
		"town": "heathcote south",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "heather hill",
		"state": "vic",
		"postcode": "3172"
	},
	{
		"town": "heatherbrae",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "heatherdale",
		"state": "vic",
		"postcode": "3132"
	},
	{
		"town": "heatherton",
		"state": "vic",
		"postcode": "3202"
	},
	{
		"town": "heathfield",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "heathmere",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "heathmont",
		"state": "vic",
		"postcode": "3135"
	},
	{
		"town": "heathpool",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "heathridge",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "heathvale",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "heathwood",
		"state": "qld",
		"postcode": "4110"
	},
	{
		"town": "heatley",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "hebden",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "hebel",
		"state": "qld",
		"postcode": "4486"
	},
	{
		"town": "hebersham",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "heckenberg",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "hectorville",
		"state": "sa",
		"postcode": "5073"
	},
	{
		"town": "heddon greta",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "hedley",
		"state": "vic",
		"postcode": "3967"
	},
	{
		"town": "heidelberg",
		"state": "vic",
		"postcode": "3084"
	},
	{
		"town": "heidelberg heights",
		"state": "vic",
		"postcode": "3081"
	},
	{
		"town": "heidelberg rgh",
		"state": "vic",
		"postcode": "3081"
	},
	{
		"town": "heidelberg west",
		"state": "vic",
		"postcode": "3081"
	},
	{
		"town": "heifer station",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "heka",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "helen springs",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "helena valley",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "helens plains",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "helensburgh",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "helensvale",
		"state": "qld",
		"postcode": "4212"
	},
	{
		"town": "helenvale",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "helidon",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "helidon spa",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "hellyer",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "hemmant",
		"state": "qld",
		"postcode": "4174"
	},
	{
		"town": "henderson",
		"state": "wa",
		"postcode": "6166"
	},
	{
		"town": "hendersyde",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "hendon",
		"state": "sa",
		"postcode": "5014"
	},
	{
		"town": "hendra",
		"state": "qld",
		"postcode": "4011"
	},
	{
		"town": "henley",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "henley beach",
		"state": "sa",
		"postcode": "5022"
	},
	{
		"town": "henley beach south",
		"state": "sa",
		"postcode": "5022"
	},
	{
		"town": "henley brook",
		"state": "wa",
		"postcode": "6055"
	},
	{
		"town": "henlow",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "henrietta",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "hensley park",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "henty",
		"state": "nsw",
		"postcode": "2658"
	},
	{
		"town": "henty",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "hepburn",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "hepburn springs",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "herbert",
		"state": "nt",
		"postcode": "836"
	},
	{
		"town": "herberton",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "herdsman",
		"state": "wa",
		"postcode": "6017"
	},
	{
		"town": "hereford hall",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "heritage park",
		"state": "qld",
		"postcode": "4118"
	},
	{
		"town": "hermannsburg",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "hermidale",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "hermit park",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "hernani",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "herne hill",
		"state": "vic",
		"postcode": "3218"
	},
	{
		"town": "herne hill",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "hernes oak",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "heron island",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "herons creek",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "herrick",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "herron",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "herston",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "hervey bay",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "hesket",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "hesse",
		"state": "vic",
		"postcode": "3321"
	},
	{
		"town": "hester",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "hester brook",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "hetherington",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "hewett",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "hexham",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "hexham",
		"state": "vic",
		"postcode": "3273"
	},
	{
		"town": "heybridge",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "heyfield",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "heyington",
		"state": "vic",
		"postcode": "3142"
	},
	{
		"town": "heytesbury lower",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "heywood",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "hiamdale",
		"state": "vic",
		"postcode": "3847"
	},
	{
		"town": "hiawatha",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "hickeys creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "hicksborough",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "hidden valley",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "hidden valley",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "hideaway bay",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "higgins",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "higginsville",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "high camp",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "high range",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "high wycombe",
		"state": "wa",
		"postcode": "6057"
	},
	{
		"town": "highbury",
		"state": "sa",
		"postcode": "5089"
	},
	{
		"town": "highbury",
		"state": "wa",
		"postcode": "6313"
	},
	{
		"town": "highclere",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "highcroft",
		"state": "tas",
		"postcode": "7183"
	},
	{
		"town": "higher macdonald",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "highett",
		"state": "vic",
		"postcode": "3190"
	},
	{
		"town": "highfields",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "highfields",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "highgate",
		"state": "sa",
		"postcode": "5063"
	},
	{
		"town": "highgate",
		"state": "wa",
		"postcode": "6003"
	},
	{
		"town": "highgate hill",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "highland valley",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "highlands",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "highpoint city",
		"state": "vic",
		"postcode": "3032"
	},
	{
		"town": "highton",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "highvale",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "highworth",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "hilgay",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "hilisvale",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "hill end",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "hill end",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "hill end",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "hill plain",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "hill top",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "hillarys",
		"state": "wa",
		"postcode": "6025"
	},
	{
		"town": "hillarys",
		"state": "wa",
		"postcode": "6923"
	},
	{
		"town": "hillbank",
		"state": "sa",
		"postcode": "5112"
	},
	{
		"town": "hillcrest",
		"state": "qld",
		"postcode": "4118"
	},
	{
		"town": "hillcrest",
		"state": "sa",
		"postcode": "5086"
	},
	{
		"town": "hillcrest",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "hillcrest",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "hillcrest heights",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "hilldale",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "hillfoot",
		"state": "vic",
		"postcode": "3705"
	},
	{
		"town": "hillgrove",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "hillgrove",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "hillier",
		"state": "sa",
		"postcode": "5116"
	},
	{
		"town": "hillman",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "hillman river",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "hillsborough",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "hillsborough",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "hillsdale",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "hillside",
		"state": "nsw",
		"postcode": "2157"
	},
	{
		"town": "hillside",
		"state": "vic",
		"postcode": "3037"
	},
	{
		"town": "hillside",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "hillston",
		"state": "nsw",
		"postcode": "2675"
	},
	{
		"town": "hilltop",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "hilltown",
		"state": "sa",
		"postcode": "5455"
	},
	{
		"town": "hillview",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "hillville",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "hillvue",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "hillwood",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "hilton",
		"state": "sa",
		"postcode": "5033"
	},
	{
		"town": "hilton",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "hinchinbrook",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "hincks",
		"state": "sa",
		"postcode": "5603"
	},
	{
		"town": "hindleton",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "hindmarsh",
		"state": "sa",
		"postcode": "5007"
	},
	{
		"town": "hindmarsh",
		"state": "wa",
		"postcode": "6462"
	},
	{
		"town": "hindmarsh island",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "hindmarsh tiers",
		"state": "sa",
		"postcode": "5202"
	},
	{
		"town": "hindmarsh valley",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "hines hill",
		"state": "wa",
		"postcode": "6413"
	},
	{
		"town": "hinnomunjie",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "hinton",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "hirstglen",
		"state": "qld",
		"postcode": "4359"
	},
	{
		"town": "hithergreen",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "hithfield",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "hivesville",
		"state": "qld",
		"postcode": "4612"
	},
	{
		"town": "hmas albatross",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "hmas cerberus",
		"state": "vic",
		"postcode": "3920"
	},
	{
		"town": "hmas coonawarra",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "hmas creswell",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "hmas harman",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "hmas kuttabul",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "hmas nirimba",
		"state": "nsw",
		"postcode": "2764"
	},
	{
		"town": "hmas penguin",
		"state": "nsw",
		"postcode": "2091"
	},
	{
		"town": "hmas platypus",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "hmas rushcutters",
		"state": "nsw",
		"postcode": "2027"
	},
	{
		"town": "hmas waterhen",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "hmas watson",
		"state": "nsw",
		"postcode": "2030"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7001"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7800"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7802"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7803"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7804"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7805"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7806"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7807"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7808"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7809"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7810"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7811"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7812"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7813"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7814"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7823"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7824"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7827"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7828"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7829"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7845"
	},
	{
		"town": "hobart",
		"state": "tas",
		"postcode": "7850"
	},
	{
		"town": "hobart airport",
		"state": "tas",
		"postcode": "7001"
	},
	{
		"town": "hobartville",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "hobbys yards",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "hocking",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "hoddle",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "hoddles creek",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "hoddys well",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "hodgleigh",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "hodgson vale",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "hoffman",
		"state": "wa",
		"postcode": "6220"
	},
	{
		"town": "hogarth range",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "holbrook",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "holden hill",
		"state": "sa",
		"postcode": "5088"
	},
	{
		"town": "holder",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "holder",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "holder siding",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "holey plain",
		"state": "vic",
		"postcode": "3847"
	},
	{
		"town": "holgate",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "holland park",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "holland park east",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "holland park west",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "hollands landing",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "holleton",
		"state": "wa",
		"postcode": "6369"
	},
	{
		"town": "holleton",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "hollisdale",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "hollow tree",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "holloways beach",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "hollydeen",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "hollywell",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "holmesglen",
		"state": "vic",
		"postcode": "3148"
	},
	{
		"town": "holmesville",
		"state": "nsw",
		"postcode": "2286"
	},
	{
		"town": "holmview",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "holroyd",
		"state": "nsw",
		"postcode": "2142"
	},
	{
		"town": "holsworthy",
		"state": "nsw",
		"postcode": "2173"
	},
	{
		"town": "holt",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "holt rock",
		"state": "wa",
		"postcode": "6355"
	},
	{
		"town": "holts flat",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "holts hill",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "holwell",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "holyoake",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "home hill",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "home island cocos (keeling) islands",
		"state": "wa",
		"postcode": "6799"
	},
	{
		"town": "home rule",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "homebush",
		"state": "nsw",
		"postcode": "2140"
	},
	{
		"town": "homebush",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "homebush bay",
		"state": "nsw",
		"postcode": "2127"
	},
	{
		"town": "homebush south",
		"state": "nsw",
		"postcode": "2140"
	},
	{
		"town": "homebush west",
		"state": "nsw",
		"postcode": "2140"
	},
	{
		"town": "homecroft",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "homeleigh",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "homerton",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "homestead",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "homewood",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "honeywood",
		"state": "tas",
		"postcode": "7017"
	},
	{
		"town": "honiton",
		"state": "sa",
		"postcode": "5576"
	},
	{
		"town": "hoods",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "hook island",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "hookswood",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "hoopers bridge",
		"state": "vic",
		"postcode": "3464"
	},
	{
		"town": "hope forest",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "hope gap",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "hope island",
		"state": "qld",
		"postcode": "4212"
	},
	{
		"town": "hope vale",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "hope valley",
		"state": "sa",
		"postcode": "5090"
	},
	{
		"town": "hope valley",
		"state": "wa",
		"postcode": "6165"
	},
	{
		"town": "hopefield",
		"state": "vic",
		"postcode": "3390"
	},
	{
		"town": "hopeland",
		"state": "wa",
		"postcode": "6125"
	},
	{
		"town": "hopelands",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "hopetoun",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "hopetoun",
		"state": "wa",
		"postcode": "6348"
	},
	{
		"town": "hopetoun gardens",
		"state": "vic",
		"postcode": "3185"
	},
	{
		"town": "hopetoun park",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "hopevale",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "hopkins creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "hopkins point",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "hopkins view",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "hoppers crossing",
		"state": "vic",
		"postcode": "3029"
	},
	{
		"town": "hordern vale",
		"state": "vic",
		"postcode": "3238"
	},
	{
		"town": "horfield",
		"state": "vic",
		"postcode": "3567"
	},
	{
		"town": "horn island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "hornet bank",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "horningsea park",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "hornsby",
		"state": "nsw",
		"postcode": "1630"
	},
	{
		"town": "hornsby",
		"state": "nsw",
		"postcode": "2077"
	},
	{
		"town": "hornsby heights",
		"state": "nsw",
		"postcode": "2077"
	},
	{
		"town": "hornsby northgate",
		"state": "nsw",
		"postcode": "1635"
	},
	{
		"town": "horrocks",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "horse camp",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "horse creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "horseshoe bay",
		"state": "qld",
		"postcode": "4819"
	},
	{
		"town": "horseshoe bend",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "horseshoe creek",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "horsfal",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "horsfield bay",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "horsham",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "horsham",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "horsham",
		"state": "vic",
		"postcode": "3402"
	},
	{
		"town": "horsham west",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "horsley",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "horsley park",
		"state": "nsw",
		"postcode": "2164"
	},
	{
		"town": "horsleys",
		"state": "vic",
		"postcode": "3950"
	},
	{
		"town": "horton",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "horton valley",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "hoskin corner",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "hoskinstown",
		"state": "nsw",
		"postcode": "2621"
	},
	{
		"town": "hotham heights",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "hotham hill",
		"state": "vic",
		"postcode": "3051"
	},
	{
		"town": "hotspur",
		"state": "vic",
		"postcode": "3303"
	},
	{
		"town": "houghton",
		"state": "sa",
		"postcode": "5131"
	},
	{
		"town": "housells",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "houston",
		"state": "vic",
		"postcode": "3128"
	},
	{
		"town": "hove",
		"state": "sa",
		"postcode": "5048"
	},
	{
		"town": "hovea",
		"state": "wa",
		"postcode": "6071"
	},
	{
		"town": "hovells creek",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "howard",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "howard springs",
		"state": "nt",
		"postcode": "835"
	},
	{
		"town": "howards",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "howatharra",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "howden",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "howell",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "howes creek",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "howes valley",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "howick",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "howick hill",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "howlong",
		"state": "nsw",
		"postcode": "2643"
	},
	{
		"town": "howmans gap",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "howqua",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "howqua hills",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "howqua inlet",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "howrah",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "howth",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "hoxton park",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "hoya",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "hoyleton",
		"state": "sa",
		"postcode": "5453"
	},
	{
		"town": "huberts corner",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "huddlestone",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "hudson",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "hughenden",
		"state": "qld",
		"postcode": "4821"
	},
	{
		"town": "hughes",
		"state": "act",
		"postcode": "2605"
	},
	{
		"town": "hughes creek",
		"state": "vic",
		"postcode": "3664"
	},
	{
		"town": "hughesdale",
		"state": "vic",
		"postcode": "3166"
	},
	{
		"town": "hulongine",
		"state": "wa",
		"postcode": "6460"
	},
	{
		"town": "humbug scrub",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "hume",
		"state": "act",
		"postcode": "2620"
	},
	{
		"town": "hume weir",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "humevale",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "humphery",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "humpty doo",
		"state": "nt",
		"postcode": "836"
	},
	{
		"town": "humpybong",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "humula",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "hunchy",
		"state": "qld",
		"postcode": "4555"
	},
	{
		"town": "hungerford",
		"state": "qld",
		"postcode": "4493"
	},
	{
		"town": "hungerford",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "hunter",
		"state": "vic",
		"postcode": "3558"
	},
	{
		"town": "hunter island",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "hunters hill",
		"state": "nsw",
		"postcode": "2110"
	},
	{
		"town": "hunters hill west",
		"state": "nsw",
		"postcode": "2110"
	},
	{
		"town": "hunterston",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "hunterview",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "huntfield heights",
		"state": "sa",
		"postcode": "5163"
	},
	{
		"town": "hunting ground",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "huntingdale",
		"state": "vic",
		"postcode": "3166"
	},
	{
		"town": "huntingdale",
		"state": "wa",
		"postcode": "6110"
	},
	{
		"town": "huntingdon",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "huntingfield",
		"state": "tas",
		"postcode": "7055"
	},
	{
		"town": "huntingwood",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "huntley",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "huntleys point",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "huntly",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "huntly north",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "huon",
		"state": "vic",
		"postcode": "3695"
	},
	{
		"town": "huon creek",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "huonbrook",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "huonville",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "hurdle flat",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "hurlstone park",
		"state": "nsw",
		"postcode": "2193"
	},
	{
		"town": "hurstbridge",
		"state": "vic",
		"postcode": "3099"
	},
	{
		"town": "hurstville",
		"state": "nsw",
		"postcode": "1493"
	},
	{
		"town": "hurstville",
		"state": "nsw",
		"postcode": "2220"
	},
	{
		"town": "hurstville grove",
		"state": "nsw",
		"postcode": "2220"
	},
	{
		"town": "hurstville westfield",
		"state": "nsw",
		"postcode": "2220"
	},
	{
		"town": "huskisson",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "hutt",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "hutt street",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "huxley",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "hyams beach",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "hyde park",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "hyde park",
		"state": "sa",
		"postcode": "5061"
	},
	{
		"town": "hyde park castletown",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "hyden",
		"state": "wa",
		"postcode": "6359"
	},
	{
		"town": "hydes creek",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "hyem",
		"state": "vic",
		"postcode": "3733"
	},
	{
		"town": "hyland park",
		"state": "nsw",
		"postcode": "2448"
	},
	{
		"town": "hynam",
		"state": "sa",
		"postcode": "5262"
	},
	{
		"town": "hyndmans creek",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "iama",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "icy creek",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "ida bay",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "idalia",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "ideraway",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "iguana creek",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "ilarwill",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "ilbilbie",
		"state": "qld",
		"postcode": "4738"
	},
	{
		"town": "ilbogan",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "ilford",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "ilfracombe",
		"state": "qld",
		"postcode": "4727"
	},
	{
		"town": "ilfraville",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "ilkley",
		"state": "qld",
		"postcode": "4554"
	},
	{
		"town": "illabarook",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "illabo",
		"state": "nsw",
		"postcode": "2590"
	},
	{
		"town": "illalong creek",
		"state": "nsw",
		"postcode": "2584"
	},
	{
		"town": "illawarra",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "illawarra",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "illawong",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "illinbah",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "illowa",
		"state": "vic",
		"postcode": "3282"
	},
	{
		"town": "iluka",
		"state": "nsw",
		"postcode": "2466"
	},
	{
		"town": "iluka",
		"state": "wa",
		"postcode": "6028"
	},
	{
		"town": "image flat",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "imampa",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "imbil",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "inala",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "inala east",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "inala heights",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "inala west",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "indee",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "indented head",
		"state": "vic",
		"postcode": "3223"
	},
	{
		"town": "indi",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "indigo",
		"state": "vic",
		"postcode": "3683"
	},
	{
		"town": "indigo upper",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "indigo valley",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "indooroopilly",
		"state": "qld",
		"postcode": "4068"
	},
	{
		"town": "indooroopilly centre",
		"state": "qld",
		"postcode": "4068"
	},
	{
		"town": "indulkana",
		"state": "sa",
		"postcode": "872"
	},
	{
		"town": "ingebirah",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "inggarda",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "ingham",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "ingle farm",
		"state": "sa",
		"postcode": "5098"
	},
	{
		"town": "ingleburn",
		"state": "nsw",
		"postcode": "1890"
	},
	{
		"town": "ingleburn",
		"state": "nsw",
		"postcode": "2565"
	},
	{
		"town": "ingleburn milpo",
		"state": "nsw",
		"postcode": "2174"
	},
	{
		"town": "inglehope",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "ingleside",
		"state": "nsw",
		"postcode": "2101"
	},
	{
		"town": "ingleside",
		"state": "qld",
		"postcode": "4228"
	},
	{
		"town": "inglewood",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "inglewood",
		"state": "sa",
		"postcode": "5133"
	},
	{
		"town": "inglewood",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "inglewood",
		"state": "wa",
		"postcode": "6052"
	},
	{
		"town": "ingliston",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "ingoldsby",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "injinoo",
		"state": "qld",
		"postcode": "4876"
	},
	{
		"town": "injune",
		"state": "qld",
		"postcode": "4454"
	},
	{
		"town": "inkerman",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "inkerman",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "inkpen",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "inman valley",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "innaloo",
		"state": "wa",
		"postcode": "6018"
	},
	{
		"town": "innaloo",
		"state": "wa",
		"postcode": "6918"
	},
	{
		"town": "innamincka",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "innawanga",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "innes",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "innes park",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "innes view",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "inneston",
		"state": "sa",
		"postcode": "5577"
	},
	{
		"town": "innisfail",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "innisplain",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "innot hot springs",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "inskip point",
		"state": "qld",
		"postcode": "4581"
	},
	{
		"town": "interlaken",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "inverbrackie",
		"state": "sa",
		"postcode": "5244"
	},
	{
		"town": "inverell",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "inveresk",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "invergordon",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "invergordon",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "invergordon south",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "invergowrie",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "inverlaw",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "inverleigh",
		"state": "vic",
		"postcode": "3321"
	},
	{
		"town": "inverloch",
		"state": "vic",
		"postcode": "3996"
	},
	{
		"town": "invermay",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "invermay",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "invermay park",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "inverness",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "iona",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "iona",
		"state": "vic",
		"postcode": "3815"
	},
	{
		"town": "ipswich",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "iraak",
		"state": "vic",
		"postcode": "3494"
	},
	{
		"town": "iredale",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "irishtown",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "irishtown",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "irishtown",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "iron baron",
		"state": "sa",
		"postcode": "5600"
	},
	{
		"town": "iron knob",
		"state": "sa",
		"postcode": "5601"
	},
	{
		"town": "ironbank",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "ironbark",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "ironbark",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "ironbark",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "ironbarks",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "irongate",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "ironmungy",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "ironpot",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "ironpot",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "ironside",
		"state": "qld",
		"postcode": "4067"
	},
	{
		"town": "irrewarra",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "irrewillipe",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "irrewillipe east",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "irvinebank",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "irvingdale",
		"state": "qld",
		"postcode": "4404"
	},
	{
		"town": "irvington",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "irwin",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "irymple",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "irymple",
		"state": "vic",
		"postcode": "3498"
	},
	{
		"town": "isaacs",
		"state": "act",
		"postcode": "2607"
	},
	{
		"town": "isabella",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "isabella plains",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "isis central",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "isis central mill",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "isis river",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "isisford",
		"state": "qld",
		"postcode": "4731"
	},
	{
		"town": "isla",
		"state": "qld",
		"postcode": "4719"
	},
	{
		"town": "island beach",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "island plantation",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "isle of capri",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "islington",
		"state": "nsw",
		"postcode": "2296"
	},
	{
		"town": "isseka",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "ithaca",
		"state": "qld",
		"postcode": "4059"
	},
	{
		"town": "ivanhoe",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "ivanhoe",
		"state": "vic",
		"postcode": "3079"
	},
	{
		"town": "ivanhoe",
		"state": "vic",
		"postcode": "8576"
	},
	{
		"town": "ivanhoe east",
		"state": "vic",
		"postcode": "3079"
	},
	{
		"town": "ivanhoe north",
		"state": "vic",
		"postcode": "3079"
	},
	{
		"town": "iveragh",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "ivory creek",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "jabiru",
		"state": "nt",
		"postcode": "886"
	},
	{
		"town": "jabuk",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "jacana",
		"state": "vic",
		"postcode": "3047"
	},
	{
		"town": "jack river",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "jackadgery",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "jackalass",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "jackass flat",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "jackeys marsh",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "jacks corner",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "jacks creek",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "jackson",
		"state": "qld",
		"postcode": "4426"
	},
	{
		"town": "jacksons flat",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "jacksons track",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "jacky bulbin flat",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "jacob creek",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "jacobs well",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "jacobs well",
		"state": "wa",
		"postcode": "6304"
	},
	{
		"town": "jacup",
		"state": "wa",
		"postcode": "6337"
	},
	{
		"town": "jaggan",
		"state": "qld",
		"postcode": "4885"
	},
	{
		"town": "jagumba",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "jagungal wilderness",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "jalbarragup",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "jallakin",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "jallukur",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "jallumba",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "jam jerrup",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "jamberoo",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "jambin",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "jamboree heights",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "james cook university",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "james creek",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "james well",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "jamestown",
		"state": "sa",
		"postcode": "5491"
	},
	{
		"town": "jamieson",
		"state": "sa",
		"postcode": "5640"
	},
	{
		"town": "jamieson",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "jamison centre",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "jamisontown",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "jan juc",
		"state": "vic",
		"postcode": "3228"
	},
	{
		"town": "jancourt",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "jancourt east",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "jandabup",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "jandakot",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "jandowae",
		"state": "qld",
		"postcode": "4410"
	},
	{
		"town": "jane brook",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "janiember east",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "jannali",
		"state": "nsw",
		"postcode": "2226"
	},
	{
		"town": "japoonvale",
		"state": "qld",
		"postcode": "4856"
	},
	{
		"town": "jardee",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "jardine",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "jarklin",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "jarrah glen",
		"state": "wa",
		"postcode": "6398"
	},
	{
		"town": "jarrahdale",
		"state": "wa",
		"postcode": "6124"
	},
	{
		"town": "jarrahmond",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "jarrahwood",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "jarvis creek",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "jaspers brush",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "jaunter",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "jay creek",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "jeeralang",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "jeeralang junction",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "jeetho",
		"state": "vic",
		"postcode": "3945"
	},
	{
		"town": "jeffcott",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "jeffcott north",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "jeffries",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "jelcobine",
		"state": "wa",
		"postcode": "6306"
	},
	{
		"town": "jellat jellat",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "jellinbah",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "jemalong",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "jembaicumbene",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "jennacubbine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "jennapullin",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "jenolan",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "jenolan caves",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "jensen",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "jeogla",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "jeparit",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "jerangle",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "jerdacuttup",
		"state": "wa",
		"postcode": "6346"
	},
	{
		"town": "jeremadra",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "jeremy",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "jericho",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "jericho",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "jericho",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "jerilderie",
		"state": "nsw",
		"postcode": "2716"
	},
	{
		"town": "jerrabattculla",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "jerrabomberra",
		"state": "nsw",
		"postcode": "2619"
	},
	{
		"town": "jerramungup",
		"state": "wa",
		"postcode": "6337"
	},
	{
		"town": "jerrara",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "jerrawa",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "jerrawangala",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "jerro",
		"state": "vic",
		"postcode": "3399"
	},
	{
		"town": "jerrong",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "jerrys plains",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "jerseyville",
		"state": "nsw",
		"postcode": "2431"
	},
	{
		"town": "jeruk",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "jerusalem",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "jervis bay",
		"state": "act",
		"postcode": "2540"
	},
	{
		"town": "jervis island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "jervois",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "jesmond",
		"state": "nsw",
		"postcode": "2299"
	},
	{
		"town": "jetsonville",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "jewells",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "jews lagoon",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "jibberding",
		"state": "wa",
		"postcode": "6612"
	},
	{
		"town": "jiggi",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "jil jil",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "jilliby",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "jilpanger",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "jim and jack creek",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "jimaringle",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "jimboomba",
		"state": "qld",
		"postcode": "4280"
	},
	{
		"town": "jimbour",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "jimcumbilly",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "jimenbuen",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "jimna",
		"state": "qld",
		"postcode": "4515"
	},
	{
		"town": "jindabyne",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "jindalee",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "jindalee",
		"state": "wa",
		"postcode": "6036"
	},
	{
		"town": "jinden",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "jindera",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "jindivick",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "jindong",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "jingalup",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "jingellic",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "jingera",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "jingili",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "jitarning",
		"state": "wa",
		"postcode": "6365"
	},
	{
		"town": "joadja",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "jobs gully",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "joel joel",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "joel south",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "johanna",
		"state": "vic",
		"postcode": "3238"
	},
	{
		"town": "john bull creek",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "johnburg",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "johns river",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "johnsons",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "johnsons creek",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "johnsons creek",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "johnsons hill",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "johnsonville",
		"state": "vic",
		"postcode": "3902"
	},
	{
		"town": "johnstones hill",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "johnstown",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "jolimont",
		"state": "vic",
		"postcode": "3002"
	},
	{
		"town": "jolimont",
		"state": "wa",
		"postcode": "6014"
	},
	{
		"town": "jollys lookout",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "jondaryan",
		"state": "qld",
		"postcode": "4403"
	},
	{
		"town": "jones bridge",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "jones creek",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "jones gully",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "jones hill",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "jones island",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "joondalup",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "joondanna",
		"state": "wa",
		"postcode": "6060"
	},
	{
		"town": "josephville",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "joskeleigh",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "joslin",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "joyces creek",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "joyner",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "jubilee",
		"state": "qld",
		"postcode": "4065"
	},
	{
		"town": "jubilee",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "jubilee",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "jubilee heights",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "jubilee pocket",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "judbury",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "judds creek",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "jugiong",
		"state": "nsw",
		"postcode": "2726"
	},
	{
		"town": "julago",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "julatten",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "julia",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "julia creek",
		"state": "qld",
		"postcode": "4823"
	},
	{
		"town": "julimar",
		"state": "wa",
		"postcode": "6567"
	},
	{
		"town": "jumbuk",
		"state": "vic",
		"postcode": "3869"
	},
	{
		"town": "jumbunna",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "juna downs",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "junabee",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "junction hill",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "junction point",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "junction view",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "junction village",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "jundah",
		"state": "qld",
		"postcode": "4736"
	},
	{
		"town": "junee",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "junee reefs",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "jung",
		"state": "vic",
		"postcode": "3399"
	},
	{
		"town": "jungaburra",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "junortoun",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "jurendine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "jurien bay",
		"state": "wa",
		"postcode": "6516"
	},
	{
		"town": "kaarimba",
		"state": "vic",
		"postcode": "3635"
	},
	{
		"town": "kaban",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "kabra",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "kadina",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "kadina",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "kadnook",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "kagaru",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "kahibah",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "kaimkillenbun",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "kain",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "kains flat",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "kainton",
		"state": "sa",
		"postcode": "5552"
	},
	{
		"town": "kairi",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "kalamia",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "kalamunda",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "kalamunda",
		"state": "wa",
		"postcode": "6926"
	},
	{
		"town": "kalanbi",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "kalang",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "kalang",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "kalangadoo",
		"state": "sa",
		"postcode": "5278"
	},
	{
		"town": "kalannie",
		"state": "wa",
		"postcode": "6468"
	},
	{
		"town": "kalapa",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "kalarka",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "kalaru",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "kalbar",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "kalbarri",
		"state": "wa",
		"postcode": "6536"
	},
	{
		"town": "kalbarri national park",
		"state": "wa",
		"postcode": "6536"
	},
	{
		"town": "kalbeeba",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "kaleen",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "kaleentha",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "kalgan",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "kalgoorlie",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "kalgoorlie",
		"state": "wa",
		"postcode": "6433"
	},
	{
		"town": "kalgup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "kalimna",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "kalimna west",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "kalinga",
		"state": "qld",
		"postcode": "4030"
	},
	{
		"town": "kalka",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "kalkallo",
		"state": "vic",
		"postcode": "3064"
	},
	{
		"town": "kalkaringi",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "kalkee",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "kalkie",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "kalkite",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "kallady",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "kallangur",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "kallaroo",
		"state": "wa",
		"postcode": "6025"
	},
	{
		"town": "kallista",
		"state": "vic",
		"postcode": "3791"
	},
	{
		"town": "kallora",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "kalma",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "kaloorup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "kalorama",
		"state": "vic",
		"postcode": "3766"
	},
	{
		"town": "kalpienung",
		"state": "vic",
		"postcode": "3529"
	},
	{
		"town": "kalpowar",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "kaltukatjara",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "kalumburu",
		"state": "wa",
		"postcode": "6740"
	},
	{
		"town": "kalunga",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "kalyan",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "kamarah",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "kamarooka",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "kamarooka north",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "kambah",
		"state": "act",
		"postcode": "2902"
	},
	{
		"town": "kambalda",
		"state": "wa",
		"postcode": "6442"
	},
	{
		"town": "kambalda west",
		"state": "wa",
		"postcode": "6444"
	},
	{
		"town": "kameruka",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "kamerunga",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "kamona",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "kanagulk",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "kanahooka",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "kanangra",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "kananook",
		"state": "vic",
		"postcode": "3198"
	},
	{
		"town": "kanawalla",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "kancoona",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "kancoona south",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "kandanga",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "kandos",
		"state": "nsw",
		"postcode": "2848"
	},
	{
		"town": "kaneira",
		"state": "vic",
		"postcode": "3530"
	},
	{
		"town": "kangaloon",
		"state": "nsw",
		"postcode": "2576"
	},
	{
		"town": "kangara",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "kangara",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "kangarilla",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "kangaroo creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "kangaroo flat",
		"state": "nsw",
		"postcode": "2846"
	},
	{
		"town": "kangaroo flat",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "kangaroo flat",
		"state": "vic",
		"postcode": "3555"
	},
	{
		"town": "kangaroo ground",
		"state": "vic",
		"postcode": "3097"
	},
	{
		"town": "kangaroo gully",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "kangaroo hills",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "kangaroo inn",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "kangaroo lake",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "kangaroo point",
		"state": "nsw",
		"postcode": "2224"
	},
	{
		"town": "kangaroo point",
		"state": "qld",
		"postcode": "4169"
	},
	{
		"town": "kangaroo valley",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "kangawall",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "kangy angy",
		"state": "nsw",
		"postcode": "2258"
	},
	{
		"town": "kanigan",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "kanimbla",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "kanimbla",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "kaniva",
		"state": "vic",
		"postcode": "3419"
	},
	{
		"town": "kanmantoo",
		"state": "sa",
		"postcode": "5252"
	},
	{
		"town": "kanni",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "kanowna",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "kanumbra",
		"state": "vic",
		"postcode": "3719"
	},
	{
		"town": "kanwal",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "kanya",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "kanyaka",
		"state": "sa",
		"postcode": "5434"
	},
	{
		"town": "kanyapella",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "kaoota",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "kapaldo",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "kapooka",
		"state": "nsw",
		"postcode": "2661"
	},
	{
		"town": "kappawanta",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "kappinie",
		"state": "sa",
		"postcode": "5632"
	},
	{
		"town": "kapunda",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "kaputar",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "karaak flat",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "karabar",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "karabeal",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "karakin",
		"state": "wa",
		"postcode": "6044"
	},
	{
		"town": "karalee",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "karalee",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "karama",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "karana downs",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "karangi",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "karanja",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "karara",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "karatta",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "karawara",
		"state": "wa",
		"postcode": "6152"
	},
	{
		"town": "karawatha",
		"state": "qld",
		"postcode": "4117"
	},
	{
		"town": "kardella",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "kardella south",
		"state": "vic",
		"postcode": "3950"
	},
	{
		"town": "kardinya",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "kareela",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "kariah",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "karijini",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "karingal",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "karingal centre",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "kariong",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "karkarooc",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "karkoo",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "karlgarin",
		"state": "wa",
		"postcode": "6358"
	},
	{
		"town": "karloning",
		"state": "wa",
		"postcode": "6479"
	},
	{
		"town": "karloo",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "karn",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "karnak",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "karnup",
		"state": "wa",
		"postcode": "6176"
	},
	{
		"town": "karonie",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "karoola",
		"state": "tas",
		"postcode": "7267"
	},
	{
		"town": "karoonda",
		"state": "sa",
		"postcode": "5307"
	},
	{
		"town": "karrabin",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "karragarra island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "karragullen",
		"state": "wa",
		"postcode": "6111"
	},
	{
		"town": "karrakatta",
		"state": "wa",
		"postcode": "6010"
	},
	{
		"town": "karrakup",
		"state": "wa",
		"postcode": "6122"
	},
	{
		"town": "karramomus",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "karranadgin",
		"state": "wa",
		"postcode": "6460"
	},
	{
		"town": "karrara",
		"state": "sa",
		"postcode": "5158"
	},
	{
		"town": "karratha",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "karratha town centre",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "karridale",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "karrinyup",
		"state": "wa",
		"postcode": "6018"
	},
	{
		"town": "karrinyup",
		"state": "wa",
		"postcode": "6921"
	},
	{
		"town": "kars springs",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "karte",
		"state": "sa",
		"postcode": "5307"
	},
	{
		"town": "karuah",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "karumba",
		"state": "qld",
		"postcode": "4891"
	},
	{
		"town": "karyrie",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "katamatite",
		"state": "vic",
		"postcode": "3649"
	},
	{
		"town": "katamatite east",
		"state": "vic",
		"postcode": "3649"
	},
	{
		"town": "katandra",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "katandra north",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "katandra west",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "katanning",
		"state": "wa",
		"postcode": "6317"
	},
	{
		"town": "katarapko",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "katherine",
		"state": "nt",
		"postcode": "850"
	},
	{
		"town": "katherine",
		"state": "nt",
		"postcode": "851"
	},
	{
		"town": "katherine",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "katoomba",
		"state": "nsw",
		"postcode": "2780"
	},
	{
		"town": "katrine",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "katunga",
		"state": "vic",
		"postcode": "3640"
	},
	{
		"town": "katyil",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "kauring",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "kawana",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "kawana island",
		"state": "qld",
		"postcode": "4557"
	},
	{
		"town": "kawana waters",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "kawarren",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "kawl kawl",
		"state": "qld",
		"postcode": "4612"
	},
	{
		"town": "kawungan",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "kayena",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "kayuga",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "keajura",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "kealba",
		"state": "vic",
		"postcode": "3021"
	},
	{
		"town": "kealy",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "kearneys spring",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "kearns",
		"state": "nsw",
		"postcode": "2558"
	},
	{
		"town": "kearsley",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "kedron",
		"state": "qld",
		"postcode": "4031"
	},
	{
		"town": "kedron upper",
		"state": "qld",
		"postcode": "4055"
	},
	{
		"town": "keebah",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "keebra park",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "keely",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "keepit",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "keera",
		"state": "nsw",
		"postcode": "2404"
	},
	{
		"town": "keerrong",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "keilira",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "keilor",
		"state": "vic",
		"postcode": "3036"
	},
	{
		"town": "keilor downs",
		"state": "vic",
		"postcode": "3038"
	},
	{
		"town": "keilor east",
		"state": "vic",
		"postcode": "3033"
	},
	{
		"town": "keilor lodge",
		"state": "vic",
		"postcode": "3038"
	},
	{
		"town": "keilor north",
		"state": "vic",
		"postcode": "3037"
	},
	{
		"town": "keilor park",
		"state": "vic",
		"postcode": "3042"
	},
	{
		"town": "keinbah",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "keiraville",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "keith",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "keith hall",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "kelgoola",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "kellalac",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "kellatier",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "kellerberrin",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "kellevie",
		"state": "tas",
		"postcode": "7176"
	},
	{
		"town": "kelly",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "kellys plains",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "kellyville",
		"state": "nsw",
		"postcode": "2155"
	},
	{
		"town": "kelmscott",
		"state": "wa",
		"postcode": "6111"
	},
	{
		"town": "kelmscott",
		"state": "wa",
		"postcode": "6991"
	},
	{
		"town": "kelsey creek",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "kelso",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "kelso",
		"state": "qld",
		"postcode": "4815"
	},
	{
		"town": "kelso",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "kelvin",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "kelvin grove",
		"state": "qld",
		"postcode": "4059"
	},
	{
		"town": "kelvin grove",
		"state": "tas",
		"postcode": "7211"
	},
	{
		"town": "kelvin view",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "kembla grange",
		"state": "nsw",
		"postcode": "2526"
	},
	{
		"town": "kemblawarra",
		"state": "nsw",
		"postcode": "2505"
	},
	{
		"town": "kemmis",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "kemp beach",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "kemps creek",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "kempsey",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "kempsey msc",
		"state": "nsw",
		"postcode": "2442"
	},
	{
		"town": "kempton",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "kempton",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "kendall",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "kendenup",
		"state": "wa",
		"postcode": "6323"
	},
	{
		"town": "kendle",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "kenebri",
		"state": "nsw",
		"postcode": "2396"
	},
	{
		"town": "kenilworth",
		"state": "qld",
		"postcode": "4574"
	},
	{
		"town": "kenley",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "kenmare",
		"state": "vic",
		"postcode": "3395"
	},
	{
		"town": "kenmore",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "kenmore",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "kenmore east",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "kenmore hills",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "kennaicle creek",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "kennedy",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "kennedy range",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "kennedys creek",
		"state": "vic",
		"postcode": "3239"
	},
	{
		"town": "kennett river",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "kennington",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "kenny",
		"state": "act",
		"postcode": "2911"
	},
	{
		"town": "kensington",
		"state": "nsw",
		"postcode": "1465"
	},
	{
		"town": "kensington",
		"state": "nsw",
		"postcode": "2033"
	},
	{
		"town": "kensington",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "kensington",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "kensington",
		"state": "vic",
		"postcode": "3031"
	},
	{
		"town": "kensington",
		"state": "wa",
		"postcode": "6151"
	},
	{
		"town": "kensington gardens",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "kensington grove",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "kensington park",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "kent town",
		"state": "sa",
		"postcode": "5067"
	},
	{
		"town": "kent town",
		"state": "sa",
		"postcode": "5071"
	},
	{
		"town": "kentbruck",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "kentdale",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "kenthurst",
		"state": "nsw",
		"postcode": "2156"
	},
	{
		"town": "kentish",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "kentlyn",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "kenton valley",
		"state": "sa",
		"postcode": "5233"
	},
	{
		"town": "kents lagoon",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "kents pocket",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "kentucky",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "kentucky south",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "kentville",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "kenwick",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "kenyu",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "keon park",
		"state": "vic",
		"postcode": "3073"
	},
	{
		"town": "kepa",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "keperra",
		"state": "qld",
		"postcode": "4054"
	},
	{
		"town": "kepnock",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "keppel sands",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "keppoch",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "kerang",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "kerang east",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "kerewong",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "kergunyah",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "kernot",
		"state": "vic",
		"postcode": "3979"
	},
	{
		"town": "kerrabee",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "kerrie",
		"state": "vic",
		"postcode": "3434"
	},
	{
		"town": "kerrigundi",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "kerrimuir",
		"state": "vic",
		"postcode": "3129"
	},
	{
		"town": "kerrisdale",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "kerrs creek",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "kerry",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "kerrydale",
		"state": "qld",
		"postcode": "4226"
	},
	{
		"town": "kersbrook",
		"state": "sa",
		"postcode": "5231"
	},
	{
		"town": "keswick",
		"state": "sa",
		"postcode": "5035"
	},
	{
		"town": "keswick terminal",
		"state": "sa",
		"postcode": "5035"
	},
	{
		"town": "ketelghay",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "kettering",
		"state": "tas",
		"postcode": "7155"
	},
	{
		"town": "kevington",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "kew",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "kew",
		"state": "vic",
		"postcode": "3101"
	},
	{
		"town": "kew east",
		"state": "vic",
		"postcode": "3102"
	},
	{
		"town": "kewarra beach",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "kewdale",
		"state": "wa",
		"postcode": "6105"
	},
	{
		"town": "kewell",
		"state": "vic",
		"postcode": "3390"
	},
	{
		"town": "keybarbin",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "keyneton",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "keysborough",
		"state": "vic",
		"postcode": "3173"
	},
	{
		"town": "keysbrook",
		"state": "wa",
		"postcode": "6126"
	},
	{
		"town": "keysland",
		"state": "qld",
		"postcode": "4612"
	},
	{
		"town": "khancoban",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "kholo",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "ki ki",
		"state": "sa",
		"postcode": "5261"
	},
	{
		"town": "kia ora",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "kia ora",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "kia ora",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "kiacatoo",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "kiah",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "kialla",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "kialla",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "kialla east",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "kialla park",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "kialla west",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "kiama",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "kiama downs",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "kiama heights",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "kiamba",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "kiandra",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "kianga",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "kianga",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "kiara",
		"state": "wa",
		"postcode": "6054"
	},
	{
		"town": "kiata",
		"state": "vic",
		"postcode": "3418"
	},
	{
		"town": "kickabil",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "kidaman creek",
		"state": "qld",
		"postcode": "4574"
	},
	{
		"town": "kidds gully",
		"state": "vic",
		"postcode": "3460"
	},
	{
		"town": "kidman park",
		"state": "sa",
		"postcode": "5025"
	},
	{
		"town": "kidston",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "kielpa",
		"state": "sa",
		"postcode": "5642"
	},
	{
		"town": "kiels mountain",
		"state": "qld",
		"postcode": "4559"
	},
	{
		"town": "kielvale",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "kiewa",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "kikiamah",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "kikoira",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "kilaben bay",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "kilburn",
		"state": "sa",
		"postcode": "5084"
	},
	{
		"town": "kilburn north",
		"state": "sa",
		"postcode": "5084"
	},
	{
		"town": "kilcoy",
		"state": "qld",
		"postcode": "4515"
	},
	{
		"town": "kilcunda",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "kilfeera",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "kilgin",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "kilgra",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "kilkenny",
		"state": "sa",
		"postcode": "5009"
	},
	{
		"town": "kilkivan",
		"state": "qld",
		"postcode": "4600"
	},
	{
		"town": "killabakh",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "killaloe",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "killara",
		"state": "nsw",
		"postcode": "2071"
	},
	{
		"town": "killara",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "killarney",
		"state": "qld",
		"postcode": "4373"
	},
	{
		"town": "killarney",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "killarney heights",
		"state": "nsw",
		"postcode": "2087"
	},
	{
		"town": "killarney vale",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "killawarra",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "killawarra",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "killcare",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "killcare heights",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "killiecrankie",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "killimicat",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "killingworth",
		"state": "nsw",
		"postcode": "2278"
	},
	{
		"town": "killingworth",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "killongbutta",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "killora",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "kilmany",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "kilmore",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "kilmore east",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "kilsyth",
		"state": "vic",
		"postcode": "3137"
	},
	{
		"town": "kilsyth south",
		"state": "vic",
		"postcode": "3137"
	},
	{
		"town": "kimba",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "kimberley",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "kimberley park",
		"state": "qld",
		"postcode": "4128"
	},
	{
		"town": "kimbolton",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "kimbriki",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "kimovale",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "kin kin",
		"state": "qld",
		"postcode": "4571"
	},
	{
		"town": "kin kora",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "kinalung",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "kinbombi",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "kinchant dam",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "kinchela",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "kincora",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "kincumber",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "kincumber south",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "kindee",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "kindervale",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "kindon",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "kindred",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "king ash bay",
		"state": "nt",
		"postcode": "854"
	},
	{
		"town": "king island",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "king parrot creek",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "king river",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "king scrub",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "king valley",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "kingaroy",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "kingfisher bay",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "kinglake",
		"state": "vic",
		"postcode": "3763"
	},
	{
		"town": "kinglake central",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "kinglake west",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "kingoonya",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "kingower",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "kings beach",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "kings creek",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "kings creek",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "kings cross",
		"state": "nsw",
		"postcode": "1340"
	},
	{
		"town": "kings cross",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "kings langley",
		"state": "nsw",
		"postcode": "2147"
	},
	{
		"town": "kings meadows",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "kings park",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "kings park",
		"state": "sa",
		"postcode": "5034"
	},
	{
		"town": "kings park",
		"state": "vic",
		"postcode": "3021"
	},
	{
		"town": "kings park",
		"state": "wa",
		"postcode": "6005"
	},
	{
		"town": "kings plains",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "kings plains",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "kings point",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "kingsbury",
		"state": "vic",
		"postcode": "3083"
	},
	{
		"town": "kingscliff",
		"state": "nsw",
		"postcode": "2487"
	},
	{
		"town": "kingscote",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "kingsdale",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "kingsdene",
		"state": "nsw",
		"postcode": "2118"
	},
	{
		"town": "kingsford",
		"state": "nsw",
		"postcode": "2032"
	},
	{
		"town": "kingsford",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "kingsford",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "kingsgate",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "kingsgrove",
		"state": "nsw",
		"postcode": "1480"
	},
	{
		"town": "kingsgrove",
		"state": "nsw",
		"postcode": "2208"
	},
	{
		"town": "kingsholme",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "kingsley",
		"state": "wa",
		"postcode": "6026"
	},
	{
		"town": "kingsthorpe",
		"state": "qld",
		"postcode": "4400"
	},
	{
		"town": "kingston",
		"state": "act",
		"postcode": "2604"
	},
	{
		"town": "kingston",
		"state": "qld",
		"postcode": "4114"
	},
	{
		"town": "kingston",
		"state": "tas",
		"postcode": "7050"
	},
	{
		"town": "kingston",
		"state": "tas",
		"postcode": "7051"
	},
	{
		"town": "kingston",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "kingston",
		"state": "wa",
		"postcode": "6256"
	},
	{
		"town": "kingston beach",
		"state": "tas",
		"postcode": "7050"
	},
	{
		"town": "kingston park",
		"state": "sa",
		"postcode": "5049"
	},
	{
		"town": "kingston se",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "kingston-on-murray",
		"state": "sa",
		"postcode": "5331"
	},
	{
		"town": "kingstown",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "kingsvale",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "kingsville",
		"state": "vic",
		"postcode": "3012"
	},
	{
		"town": "kingsville west",
		"state": "vic",
		"postcode": "3012"
	},
	{
		"town": "kingsway",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "kingsway west",
		"state": "nsw",
		"postcode": "2208"
	},
	{
		"town": "kingswood",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "kingswood",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "kingswood",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "kingswood",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "kinka beach",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "kinkuna",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "kinleymore",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "kinlyside",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "kinnabulla",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "kinross",
		"state": "wa",
		"postcode": "6028"
	},
	{
		"town": "kintore",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "kinyapanial",
		"state": "vic",
		"postcode": "3520"
	},
	{
		"town": "kioloa",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "kioma",
		"state": "qld",
		"postcode": "4498"
	},
	{
		"town": "kiora",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "kippa-ring",
		"state": "qld",
		"postcode": "4021"
	},
	{
		"town": "kippax",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "kippax centre",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "kippaxs",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "kippenduff",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "kirkcaldy",
		"state": "sa",
		"postcode": "5022"
	},
	{
		"town": "kirkconnell",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "kirkham",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "kirkstall",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "kirkwood",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "kirra",
		"state": "qld",
		"postcode": "4225"
	},
	{
		"town": "kirrawee",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "kirribilli",
		"state": "nsw",
		"postcode": "2061"
	},
	{
		"town": "kirton point",
		"state": "sa",
		"postcode": "5606"
	},
	{
		"town": "kirup",
		"state": "wa",
		"postcode": "6251"
	},
	{
		"town": "kirwan",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "kirwans bridge",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "kitchener",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "kithbrook",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "kitoba",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "kiwarrak",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "kiwirrkurra",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "kleinton",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "klemzig",
		"state": "sa",
		"postcode": "5087"
	},
	{
		"town": "klori",
		"state": "nsw",
		"postcode": "2346"
	},
	{
		"town": "knapp creek",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "knebsworth",
		"state": "vic",
		"postcode": "3286"
	},
	{
		"town": "knight",
		"state": "vic",
		"postcode": "3360"
	},
	{
		"town": "knights hill",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "knockrow",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "knorrit flat",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "knotts siding",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "knowsley",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "knox city centre",
		"state": "vic",
		"postcode": "3152"
	},
	{
		"town": "knox park",
		"state": "vic",
		"postcode": "3180"
	},
	{
		"town": "knoxfield",
		"state": "vic",
		"postcode": "3180"
	},
	{
		"town": "knuckeys lagoon",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "koah",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "koallah",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "kobble creek",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "kobyboyn",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "kockibitoo",
		"state": "nsw",
		"postcode": "2702"
	},
	{
		"town": "kodj kodjin",
		"state": "wa",
		"postcode": "6488"
	},
	{
		"town": "koetong",
		"state": "vic",
		"postcode": "3704"
	},
	{
		"town": "kogan",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "kogarah",
		"state": "nsw",
		"postcode": "1485"
	},
	{
		"town": "kogarah",
		"state": "nsw",
		"postcode": "1487"
	},
	{
		"town": "kogarah",
		"state": "nsw",
		"postcode": "2217"
	},
	{
		"town": "kogarah bay",
		"state": "nsw",
		"postcode": "2217"
	},
	{
		"town": "kohinoor",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "koimbo",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "kojaneerup",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "kojarena",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "kojonup",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "kokotungo",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "kolodong",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "kolonga",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "koloona",
		"state": "nsw",
		"postcode": "2403"
	},
	{
		"town": "kolora",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "komungla",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "kondinin",
		"state": "wa",
		"postcode": "6367"
	},
	{
		"town": "kondut",
		"state": "wa",
		"postcode": "6605"
	},
	{
		"town": "kongal",
		"state": "sa",
		"postcode": "5270"
	},
	{
		"town": "kongolia",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "kongorong",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "kongwak",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "konnongorring",
		"state": "wa",
		"postcode": "6603"
	},
	{
		"town": "konongwootong",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "koo wee rup",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "koo wee rup north",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "kooba",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "kooem",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "koojan",
		"state": "wa",
		"postcode": "6510"
	},
	{
		"town": "koojedda",
		"state": "wa",
		"postcode": "6562"
	},
	{
		"town": "kookabookra",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "kookaburra",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "kookynie",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "koolan island",
		"state": "wa",
		"postcode": "6733"
	},
	{
		"town": "koolanooka",
		"state": "wa",
		"postcode": "6623"
	},
	{
		"town": "koolewong",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "kooljerrenup",
		"state": "wa",
		"postcode": "6214"
	},
	{
		"town": "koolkhan",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "kooloonong",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "koolunga",
		"state": "sa",
		"postcode": "5464"
	},
	{
		"town": "koolyanobbing",
		"state": "wa",
		"postcode": "6427"
	},
	{
		"town": "koolywurtie",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "koomberkine",
		"state": "wa",
		"postcode": "6461"
	},
	{
		"town": "koomeela",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "koonawarra",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "koonda",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "koondoola",
		"state": "wa",
		"postcode": "6064"
	},
	{
		"town": "koondrook",
		"state": "vic",
		"postcode": "3580"
	},
	{
		"town": "koongal",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "koongamia",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "koongawa",
		"state": "sa",
		"postcode": "5650"
	},
	{
		"town": "koonibba",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "koonoomoo",
		"state": "vic",
		"postcode": "3644"
	},
	{
		"town": "koonorigan",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "koonunga",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "koonwarra",
		"state": "vic",
		"postcode": "3954"
	},
	{
		"town": "koonya",
		"state": "tas",
		"postcode": "7187"
	},
	{
		"town": "kooragang",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "koorainghat",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "kooralbyn",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "koorawatha",
		"state": "nsw",
		"postcode": "2807"
	},
	{
		"town": "koorda",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "kooreh",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "kooreh south",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "koorilla",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "koorine",
		"state": "sa",
		"postcode": "5279"
	},
	{
		"town": "kooringal",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "kooringal",
		"state": "qld",
		"postcode": "4025"
	},
	{
		"town": "koorkab",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "koorlong",
		"state": "vic",
		"postcode": "3501"
	},
	{
		"town": "koornalla",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "kooroocheang",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "koorooman",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "kooroona",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "kooroongarra",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "kooroowi",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "kootingal",
		"state": "nsw",
		"postcode": "2352"
	},
	{
		"town": "kooyong",
		"state": "vic",
		"postcode": "3144"
	},
	{
		"town": "koppio",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "koraleigh",
		"state": "nsw",
		"postcode": "2735"
	},
	{
		"town": "korbel",
		"state": "wa",
		"postcode": "6415"
	},
	{
		"town": "koriella",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "koroit",
		"state": "vic",
		"postcode": "3282"
	},
	{
		"town": "korong vale",
		"state": "vic",
		"postcode": "3520"
	},
	{
		"town": "koroop",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "korora",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "korrak korrak",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "korrelocking",
		"state": "wa",
		"postcode": "6485"
	},
	{
		"town": "korrine",
		"state": "vic",
		"postcode": "3979"
	},
	{
		"town": "korumburra",
		"state": "vic",
		"postcode": "3950"
	},
	{
		"town": "korumburra south",
		"state": "vic",
		"postcode": "3950"
	},
	{
		"town": "korunye",
		"state": "sa",
		"postcode": "5502"
	},
	{
		"town": "korweinguboora",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "kosciuszko",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "kotara",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "kotara east",
		"state": "nsw",
		"postcode": "2305"
	},
	{
		"town": "kotara fair",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "kotara south",
		"state": "nsw",
		"postcode": "2289"
	},
	{
		"town": "kotta",
		"state": "vic",
		"postcode": "3565"
	},
	{
		"town": "kotupna",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "koumala",
		"state": "qld",
		"postcode": "4738"
	},
	{
		"town": "kow swamp",
		"state": "vic",
		"postcode": "3567"
	},
	{
		"town": "kowanyama",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "kowbi",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "kowen forest",
		"state": "act",
		"postcode": "2620"
	},
	{
		"town": "kowguran",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "kowrowa",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "koyuga",
		"state": "vic",
		"postcode": "3622"
	},
	{
		"town": "koyuga south",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "krambach",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "krawarree",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "kremnos",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "kringin",
		"state": "sa",
		"postcode": "5304"
	},
	{
		"town": "kronkup",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "krowera",
		"state": "vic",
		"postcode": "3945"
	},
	{
		"town": "kubbine",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "kubin village",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "kubura",
		"state": "nsw",
		"postcode": "2655"
	},
	{
		"town": "kudardup",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "kudla",
		"state": "sa",
		"postcode": "5115"
	},
	{
		"town": "kuitpo",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "kuitpo colony",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "kukerin",
		"state": "wa",
		"postcode": "6352"
	},
	{
		"town": "kulangoor",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "kularin",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "kulgera",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "kulgun",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "kulikup",
		"state": "wa",
		"postcode": "6244"
	},
	{
		"town": "kulin",
		"state": "wa",
		"postcode": "6365"
	},
	{
		"town": "kulja",
		"state": "wa",
		"postcode": "6470"
	},
	{
		"town": "kulkami",
		"state": "sa",
		"postcode": "5307"
	},
	{
		"town": "kullogum",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "kulnura",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "kulpara",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "kulpi",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "kuluin",
		"state": "qld",
		"postcode": "4558"
	},
	{
		"town": "kulwin",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "kulwin",
		"state": "vic",
		"postcode": "3490"
	},
	{
		"town": "kulyaling",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "kumarina",
		"state": "wa",
		"postcode": "6642"
	},
	{
		"town": "kumarl",
		"state": "wa",
		"postcode": "6445"
	},
	{
		"town": "kumbia",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "kunama",
		"state": "nsw",
		"postcode": "2730"
	},
	{
		"town": "kunanalling",
		"state": "wa",
		"postcode": "6429"
	},
	{
		"town": "kunat",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "kunda park",
		"state": "qld",
		"postcode": "4556"
	},
	{
		"town": "kundabung",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "kundibakh",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "kundle kundle",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "kungala",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "kunghur",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "kunghur creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "kunioon",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "kununoppin",
		"state": "wa",
		"postcode": "6489"
	},
	{
		"town": "kununurra",
		"state": "wa",
		"postcode": "6743"
	},
	{
		"town": "kunwarara",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "kunyung",
		"state": "vic",
		"postcode": "3930"
	},
	{
		"town": "kupunn",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "kuraby",
		"state": "qld",
		"postcode": "4112"
	},
	{
		"town": "kuranda",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "kurdgweechee",
		"state": "vic",
		"postcode": "3395"
	},
	{
		"town": "kureelpa",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "kuringup",
		"state": "wa",
		"postcode": "6317"
	},
	{
		"town": "kurmond",
		"state": "nsw",
		"postcode": "2757"
	},
	{
		"town": "kurnalpi",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "kurnbrunin",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "kurnell",
		"state": "nsw",
		"postcode": "2231"
	},
	{
		"town": "kurraca",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "kurraca west",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "kurrajong",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "kurrajong heights",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "kurrajong hills",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "kurralta park",
		"state": "sa",
		"postcode": "5037"
	},
	{
		"town": "kurrenkutten",
		"state": "wa",
		"postcode": "6376"
	},
	{
		"town": "kurri kurri",
		"state": "nsw",
		"postcode": "2327"
	},
	{
		"town": "kurrimine beach",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "kurrowah",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "kurting",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "kurumbul",
		"state": "qld",
		"postcode": "4388"
	},
	{
		"town": "kurunjang",
		"state": "vic",
		"postcode": "3337"
	},
	{
		"town": "kurwongbah",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "kuttabul",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "kweda",
		"state": "wa",
		"postcode": "6306"
	},
	{
		"town": "kwelkan",
		"state": "wa",
		"postcode": "6415"
	},
	{
		"town": "kwinana",
		"state": "wa",
		"postcode": "6966"
	},
	{
		"town": "kwinana beach",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "kwinana town centre",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "kwobrup",
		"state": "wa",
		"postcode": "6317"
	},
	{
		"town": "kwolyin",
		"state": "wa",
		"postcode": "6385"
	},
	{
		"town": "ky valley",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "ky west",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "kyabram",
		"state": "vic",
		"postcode": "3619"
	},
	{
		"town": "kyabram",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "kyalite",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "kyancutta",
		"state": "sa",
		"postcode": "5651"
	},
	{
		"town": "kybeyan",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "kybong",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "kybunga",
		"state": "sa",
		"postcode": "5453"
	},
	{
		"town": "kybybolite",
		"state": "sa",
		"postcode": "5262"
	},
	{
		"town": "kyeamba",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "kyeema",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "kyeemagh",
		"state": "nsw",
		"postcode": "2216"
	},
	{
		"town": "kyle bay",
		"state": "nsw",
		"postcode": "2221"
	},
	{
		"town": "kyneton",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "kyneton south",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "kynnumboon",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "kynuna",
		"state": "qld",
		"postcode": "4823"
	},
	{
		"town": "kyogle",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "kywong",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "la perouse",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "la trobe university",
		"state": "vic",
		"postcode": "3086"
	},
	{
		"town": "laanecoorie",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "laang",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "labertouche",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "labrador",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "laburnum",
		"state": "vic",
		"postcode": "3130"
	},
	{
		"town": "laceby",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "laceys creek",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "lachlan",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "lackrana",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "lacmalac",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "lade vale",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "lady barron",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "ladys pass",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "ladysmith",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "laen",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "laen east",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "laen north",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "laffer",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "laffing waters",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "laggan",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "lagoon grass",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "lagoon pocket",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "lagrange",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "laguna",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "laguna quays",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "lah",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "laharum",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "laheys creek",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "laidley",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "laidley creek west",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "laidley heights",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "laidley north",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "laidley south",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "lajamanu",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "lake albert",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "lake bathurst",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "lake bennett",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "lake biddy",
		"state": "wa",
		"postcode": "6355"
	},
	{
		"town": "lake boga",
		"state": "vic",
		"postcode": "3584"
	},
	{
		"town": "lake bolac",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "lake brewster",
		"state": "nsw",
		"postcode": "2675"
	},
	{
		"town": "lake brown",
		"state": "wa",
		"postcode": "6479"
	},
	{
		"town": "lake buloke",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "lake bunga",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "lake burrendong",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "lake camm",
		"state": "wa",
		"postcode": "6355"
	},
	{
		"town": "lake cargelligo",
		"state": "nsw",
		"postcode": "2672"
	},
	{
		"town": "lake cathie",
		"state": "nsw",
		"postcode": "2445"
	},
	{
		"town": "lake charm",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "lake clarendon",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "lake clifton",
		"state": "wa",
		"postcode": "6215"
	},
	{
		"town": "lake condah",
		"state": "vic",
		"postcode": "3303"
	},
	{
		"town": "lake conjola",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "lake cooper",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "lake cootharaba",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "lake cowal",
		"state": "nsw",
		"postcode": "2671"
	},
	{
		"town": "lake crescent",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "lake deborah",
		"state": "wa",
		"postcode": "6484"
	},
	{
		"town": "lake eildon",
		"state": "vic",
		"postcode": "3713"
	},
	{
		"town": "lake fyans",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "lake gardens",
		"state": "vic",
		"postcode": "3355"
	},
	{
		"town": "lake george",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "lake gillear",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "lake goldsmith",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "lake grace",
		"state": "wa",
		"postcode": "6353"
	},
	{
		"town": "lake haven",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "lake heights",
		"state": "nsw",
		"postcode": "2502"
	},
	{
		"town": "lake hiawatha",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "lake hindmarsh",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "lake illawarra",
		"state": "nsw",
		"postcode": "2528"
	},
	{
		"town": "lake innes",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "lake kangaroo",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "lake karnak",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "lake king",
		"state": "wa",
		"postcode": "6356"
	},
	{
		"town": "lake leake",
		"state": "tas",
		"postcode": "7210"
	},
	{
		"town": "lake lonsdale",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "lake macdonald",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "lake mackenzie",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "lake magenta",
		"state": "wa",
		"postcode": "6355"
	},
	{
		"town": "lake manchester",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "lake margaret",
		"state": "tas",
		"postcode": "7467"
	},
	{
		"town": "lake margarette",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "lake marmal",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "lake mary",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "lake meran",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "lake mokoan",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "lake monduran",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "lake moodemere",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "lake moogerah",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "lake morris",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "lake mundi",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "lake munmorah",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "lake placid",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "lake plains",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "lake powell",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "lake proserpine",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "lake rowan",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "lake st clair",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "lake tinaroo",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "lake toolbrunup",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "lake tyers",
		"state": "vic",
		"postcode": "3887"
	},
	{
		"town": "lake tyers beach",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "lake tyers camp park",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "lake tyrrell",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "lake view",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "lake wallace",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "lake wellington",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "lake wells",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "lake wendouree",
		"state": "vic",
		"postcode": "3355"
	},
	{
		"town": "lake wyangan",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "lakeland",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "lakelands",
		"state": "nsw",
		"postcode": "2282"
	},
	{
		"town": "lakelands",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "lakemba",
		"state": "nsw",
		"postcode": "2195"
	},
	{
		"town": "lakes creek",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "lakes entrance",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "lakeside",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "lakeside estate",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "lakesland",
		"state": "nsw",
		"postcode": "2572"
	},
	{
		"town": "lakewood",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "lakewood",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "lal lal",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "lalalty",
		"state": "nsw",
		"postcode": "3644"
	},
	{
		"town": "lalbert",
		"state": "vic",
		"postcode": "3542"
	},
	{
		"town": "lalbert road",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "lalla",
		"state": "tas",
		"postcode": "7267"
	},
	{
		"town": "lalor",
		"state": "vic",
		"postcode": "3075"
	},
	{
		"town": "lalor park",
		"state": "nsw",
		"postcode": "2147"
	},
	{
		"town": "lalor plaza",
		"state": "vic",
		"postcode": "3075"
	},
	{
		"town": "lamb island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "lambells lagoon",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "lambs valley",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "lambs valley",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "lambton",
		"state": "nsw",
		"postcode": "2299"
	},
	{
		"town": "lameroo",
		"state": "sa",
		"postcode": "5302"
	},
	{
		"town": "lamington",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "lamington",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "lamington national park",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "lammermoor",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "lammermoor beach",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "lamplough",
		"state": "vic",
		"postcode": "3467"
	},
	{
		"town": "lancaster",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "lance creek",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "lancefield",
		"state": "vic",
		"postcode": "3435"
	},
	{
		"town": "lancefield junction",
		"state": "vic",
		"postcode": "3430"
	},
	{
		"town": "lancelin",
		"state": "wa",
		"postcode": "6044"
	},
	{
		"town": "landers shoot",
		"state": "qld",
		"postcode": "4555"
	},
	{
		"town": "landervale",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "landsborough",
		"state": "qld",
		"postcode": "4550"
	},
	{
		"town": "landsborough",
		"state": "vic",
		"postcode": "3384"
	},
	{
		"town": "landsborough west",
		"state": "vic",
		"postcode": "3384"
	},
	{
		"town": "landsdale",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "lane cove",
		"state": "nsw",
		"postcode": "1595"
	},
	{
		"town": "lane cove",
		"state": "nsw",
		"postcode": "1597"
	},
	{
		"town": "lane cove",
		"state": "nsw",
		"postcode": "2066"
	},
	{
		"town": "lanena",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "lang lang",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "lang lang east",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "langdons hill",
		"state": "vic",
		"postcode": "3363"
	},
	{
		"town": "lange",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "langford",
		"state": "wa",
		"postcode": "6147"
	},
	{
		"town": "langhorne creek",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "langi kal kal",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "langi logan",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "langkoop",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "langley",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "langley",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "langley vale",
		"state": "nsw",
		"postcode": "2426"
	},
	{
		"town": "langsborough",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "langshaw",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "langview",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "langville",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "langwarrin",
		"state": "vic",
		"postcode": "3910"
	},
	{
		"town": "lanitza",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "lankeys creek",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "lannercost",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "lansdale",
		"state": "nsw",
		"postcode": "2873"
	},
	{
		"town": "lansdowne",
		"state": "nsw",
		"postcode": "2163"
	},
	{
		"town": "lansdowne",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "lansdowne",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "lansvale",
		"state": "nsw",
		"postcode": "2166"
	},
	{
		"town": "lapoinya",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "lapstone",
		"state": "nsw",
		"postcode": "2773"
	},
	{
		"town": "lara",
		"state": "vic",
		"postcode": "3212"
	},
	{
		"town": "larapinta",
		"state": "qld",
		"postcode": "4110"
	},
	{
		"town": "laravale",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "larbert",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "lardner",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "largs",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "largs bay",
		"state": "sa",
		"postcode": "5016"
	},
	{
		"town": "largs north",
		"state": "sa",
		"postcode": "5016"
	},
	{
		"town": "lark hill",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "larnook",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "larpent",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "larrakeyah",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "larralea",
		"state": "vic",
		"postcode": "3325"
	},
	{
		"town": "larras lee",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "larrimah",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "lascelles",
		"state": "vic",
		"postcode": "3487"
	},
	{
		"town": "latham",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "latham",
		"state": "wa",
		"postcode": "6616"
	},
	{
		"town": "lathlain",
		"state": "wa",
		"postcode": "6100"
	},
	{
		"town": "latimer",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "latrobe",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "lattens bend",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "lauderdale",
		"state": "tas",
		"postcode": "7021"
	},
	{
		"town": "laughtondale",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7900"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7901"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7902"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7903"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7904"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7905"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7906"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7907"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7908"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7909"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7910"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7911"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7912"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7913"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7914"
	},
	{
		"town": "launceston",
		"state": "tas",
		"postcode": "7923"
	},
	{
		"town": "launching place",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "laura",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "laura",
		"state": "sa",
		"postcode": "5480"
	},
	{
		"town": "laura bay",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "laurel hill",
		"state": "nsw",
		"postcode": "2649"
	},
	{
		"town": "laurieton",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "lauriston",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "lavadia",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "lavarack barracks",
		"state": "qld",
		"postcode": "4813"
	},
	{
		"town": "lavelle",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "lavender bay",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "lavers hill",
		"state": "vic",
		"postcode": "3238"
	},
	{
		"town": "laverton",
		"state": "vic",
		"postcode": "3028"
	},
	{
		"town": "laverton",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "laverton north",
		"state": "vic",
		"postcode": "3026"
	},
	{
		"town": "laverton raaf",
		"state": "vic",
		"postcode": "3027"
	},
	{
		"town": "lavington",
		"state": "nsw",
		"postcode": "2641"
	},
	{
		"town": "law courts",
		"state": "vic",
		"postcode": "8010"
	},
	{
		"town": "lawes",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "lawgi dawes",
		"state": "qld",
		"postcode": "4716"
	},
	{
		"town": "lawitta",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "lawler",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "lawlers",
		"state": "wa",
		"postcode": "6437"
	},
	{
		"town": "lawloit",
		"state": "vic",
		"postcode": "3418"
	},
	{
		"town": "lawnton",
		"state": "qld",
		"postcode": "4501"
	},
	{
		"town": "lawrence",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "lawrence",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "lawson",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "lawson",
		"state": "nsw",
		"postcode": "2783"
	},
	{
		"town": "le roy",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "leabrook",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "leadville",
		"state": "nsw",
		"postcode": "2844"
	},
	{
		"town": "leafdale",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "leaghur",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "leanyer",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "learmonth",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "learmonth",
		"state": "wa",
		"postcode": "6707"
	},
	{
		"town": "leasingham",
		"state": "sa",
		"postcode": "5452"
	},
	{
		"town": "leawarra",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "leawood gardens",
		"state": "sa",
		"postcode": "5150"
	},
	{
		"town": "lebrina",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "leconfield",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "leda",
		"state": "wa",
		"postcode": "6170"
	},
	{
		"town": "ledcourt",
		"state": "vic",
		"postcode": "3385"
	},
	{
		"town": "ledge point",
		"state": "wa",
		"postcode": "6043"
	},
	{
		"town": "lee creek",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "lee point",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "leebrooke",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "leechs gully",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "leederville",
		"state": "wa",
		"postcode": "6007"
	},
	{
		"town": "leederville",
		"state": "wa",
		"postcode": "6900"
	},
	{
		"town": "leederville",
		"state": "wa",
		"postcode": "6902"
	},
	{
		"town": "leederville",
		"state": "wa",
		"postcode": "6903"
	},
	{
		"town": "leeka",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "leeman",
		"state": "wa",
		"postcode": "6514"
	},
	{
		"town": "leeming",
		"state": "wa",
		"postcode": "6149"
	},
	{
		"town": "leeor",
		"state": "vic",
		"postcode": "3420"
	},
	{
		"town": "leeton",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "leets vale",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "leeuwin",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "leeville",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "lefevres corner",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "lefroy",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "lefthand branch",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "legana",
		"state": "tas",
		"postcode": "7277"
	},
	{
		"town": "legerwood",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "legges camp",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "legume",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "legunia",
		"state": "tas",
		"postcode": "7263"
	},
	{
		"town": "leichardt",
		"state": "vic",
		"postcode": "3516"
	},
	{
		"town": "leichhardt",
		"state": "nsw",
		"postcode": "2040"
	},
	{
		"town": "leichhardt",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "leigh",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "leigh creek",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "leigh creek",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "leighton",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "leighwood",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "leinster",
		"state": "wa",
		"postcode": "6437"
	},
	{
		"town": "leitchville",
		"state": "vic",
		"postcode": "3567"
	},
	{
		"town": "leith",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "lemana junction",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "lemington",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "lemnos",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "lemon springs",
		"state": "vic",
		"postcode": "3419"
	},
	{
		"town": "lemon tree",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "lemon tree passage",
		"state": "nsw",
		"postcode": "2319"
	},
	{
		"town": "lemont",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "lemonthyme",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "lemontree",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "lenaghan",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "lenah valley",
		"state": "tas",
		"postcode": "7008"
	},
	{
		"town": "leneva",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "lennard brook",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "lennox head",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "lenswood",
		"state": "sa",
		"postcode": "5240"
	},
	{
		"town": "leonards hill",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "leonay",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "leongatha",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "leongatha north",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "leonora",
		"state": "wa",
		"postcode": "6438"
	},
	{
		"town": "leopold",
		"state": "vic",
		"postcode": "3224"
	},
	{
		"town": "leppington",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "lerderderg",
		"state": "vic",
		"postcode": "3341"
	},
	{
		"town": "lerida",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "leschenault",
		"state": "wa",
		"postcode": "6233"
	},
	{
		"town": "leslie manor",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "leslie vale",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "lesmurdie",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "letchworth",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "lethbridge",
		"state": "vic",
		"postcode": "3332"
	},
	{
		"town": "lethbridge park",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "lethebrook",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "letts beach",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "leumeah",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "leura",
		"state": "nsw",
		"postcode": "2780"
	},
	{
		"town": "levendale",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "levenstrath",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "lewinsbrook",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "lewis ponds",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "lewisham",
		"state": "nsw",
		"postcode": "2049"
	},
	{
		"town": "lewisham",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "lewiston",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "lexia",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "lexton",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "leyburn",
		"state": "qld",
		"postcode": "4365"
	},
	{
		"town": "leycester",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "leydens hill",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "liapootah",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "liberty grove",
		"state": "nsw",
		"postcode": "2138"
	},
	{
		"town": "licola",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "licola north",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "lidcombe",
		"state": "nsw",
		"postcode": "1825"
	},
	{
		"town": "lidcombe",
		"state": "nsw",
		"postcode": "1826"
	},
	{
		"town": "lidcombe",
		"state": "nsw",
		"postcode": "2141"
	},
	{
		"town": "lidcombe north",
		"state": "nsw",
		"postcode": "2141"
	},
	{
		"town": "liddell",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "lidsdale",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "liena",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "lietinna",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "liffey",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "light pass",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "lighthouse beach",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "lightning ridge",
		"state": "nsw",
		"postcode": "2834"
	},
	{
		"town": "lileah",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "lilli pilli",
		"state": "nsw",
		"postcode": "2229"
	},
	{
		"town": "lilli pilli",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "lillian rock",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "lillico",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "lillico",
		"state": "vic",
		"postcode": "3820"
	},
	{
		"town": "lillicur",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "lillimur",
		"state": "vic",
		"postcode": "3415"
	},
	{
		"town": "lillimur south",
		"state": "vic",
		"postcode": "3419"
	},
	{
		"town": "lilliput",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "lilydale",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "lilydale",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "lilydale",
		"state": "tas",
		"postcode": "7268"
	},
	{
		"town": "lilydale",
		"state": "vic",
		"postcode": "3140"
	},
	{
		"town": "lilyfield",
		"state": "nsw",
		"postcode": "2040"
	},
	{
		"town": "lilyvale",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "lima",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "lima east",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "lima south",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "limbri",
		"state": "nsw",
		"postcode": "2352"
	},
	{
		"town": "lime lake",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "limeburners creek",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "limeburners creek",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "limekilns",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "limerick",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "limestone",
		"state": "nsw",
		"postcode": "2361"
	},
	{
		"town": "limestone",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "limestone",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "limestone creek",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "limestone ridges",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "limevale",
		"state": "qld",
		"postcode": "4384"
	},
	{
		"town": "limonite",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "limpinwood",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "linburn",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "lincoln",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "linda",
		"state": "tas",
		"postcode": "7466"
	},
	{
		"town": "lindeman island",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "linden",
		"state": "nsw",
		"postcode": "2778"
	},
	{
		"town": "linden park",
		"state": "sa",
		"postcode": "5065"
	},
	{
		"town": "lindendale",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "lindenow",
		"state": "vic",
		"postcode": "3865"
	},
	{
		"town": "lindenow south",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "lindesay",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "lindesay creek",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "lindesay view",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "lindfield",
		"state": "nsw",
		"postcode": "2070"
	},
	{
		"town": "lindfield west",
		"state": "nsw",
		"postcode": "2070"
	},
	{
		"town": "lindifferon",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "lindisfarne",
		"state": "tas",
		"postcode": "7015"
	},
	{
		"town": "lindsay",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "lindum",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "linga",
		"state": "vic",
		"postcode": "3509"
	},
	{
		"town": "linley point",
		"state": "nsw",
		"postcode": "2066"
	},
	{
		"town": "linthorpe",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "linton",
		"state": "vic",
		"postcode": "3360"
	},
	{
		"town": "linton grange",
		"state": "vic",
		"postcode": "3754"
	},
	{
		"town": "linville",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "linwood",
		"state": "sa",
		"postcode": "5410"
	},
	{
		"town": "lionsville",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "liparoo",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "lipson",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "lisarow",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "lisle",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "lismore",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "lismore",
		"state": "vic",
		"postcode": "3324"
	},
	{
		"town": "lismore heights",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "liston",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "litchfield",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "lithgow",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "littabella",
		"state": "qld",
		"postcode": "4673"
	},
	{
		"town": "little bay",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "little billabong",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "little cove",
		"state": "qld",
		"postcode": "4567"
	},
	{
		"town": "little grove",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "little hampton",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "little hartley",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "little jacks creek",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "little mountain",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "little mulgrave",
		"state": "qld",
		"postcode": "4865"
	},
	{
		"town": "little pelican",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "little plain",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "little river",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "little river",
		"state": "vic",
		"postcode": "3211"
	},
	{
		"town": "little snowy creek",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "little swanport",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "little topar",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "little tuan",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "little wobby",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "littlehampton",
		"state": "sa",
		"postcode": "5250"
	},
	{
		"town": "littlemore",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "liverpool",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "liverpool south",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "liverpool westfield",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "livingstone",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "livingstone",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "livingstone",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "livingstone valley",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "llanarth",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "llandaff",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "llandilo",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "llanelly",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "llangothlin",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "llanherne",
		"state": "tas",
		"postcode": "7170"
	},
	{
		"town": "llewellyn",
		"state": "tas",
		"postcode": "7213"
	},
	{
		"town": "llowalong",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "lloyd",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "lloyd crossing",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "loadstone",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "loamside",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "lobethal",
		"state": "sa",
		"postcode": "5241"
	},
	{
		"town": "loccota",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "loch",
		"state": "vic",
		"postcode": "3945"
	},
	{
		"town": "loch sport",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "loch valley",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "lochend",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "lochiel",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "lochiel",
		"state": "sa",
		"postcode": "5510"
	},
	{
		"town": "lochiel bridge",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "lochinvar",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "lock",
		"state": "sa",
		"postcode": "5633"
	},
	{
		"town": "lockhart",
		"state": "nsw",
		"postcode": "2656"
	},
	{
		"town": "lockhart river",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "lockington",
		"state": "vic",
		"postcode": "3563"
	},
	{
		"town": "lockleys",
		"state": "sa",
		"postcode": "5032"
	},
	{
		"town": "lockridge",
		"state": "wa",
		"postcode": "6054"
	},
	{
		"town": "lockrose",
		"state": "qld",
		"postcode": "4342"
	},
	{
		"town": "locksley",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "locksley",
		"state": "vic",
		"postcode": "3665"
	},
	{
		"town": "lockwood",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "lockwood south",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "lockyer",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "lockyer",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "lockyer siding",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "lockyer waters",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "loddon vale",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "loftus",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "loftville",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "logan",
		"state": "vic",
		"postcode": "3475"
	},
	{
		"town": "logan central",
		"state": "qld",
		"postcode": "4114"
	},
	{
		"town": "logan reserve",
		"state": "qld",
		"postcode": "4133"
	},
	{
		"town": "logan village",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "logandale",
		"state": "qld",
		"postcode": "4129"
	},
	{
		"town": "loganholme",
		"state": "qld",
		"postcode": "4129"
	},
	{
		"town": "loganlea",
		"state": "qld",
		"postcode": "4131"
	},
	{
		"town": "logans crossing",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "logie brae",
		"state": "nsw",
		"postcode": "2713"
	},
	{
		"town": "logie brae",
		"state": "nsw",
		"postcode": "2716"
	},
	{
		"town": "loira",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "lol gray",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "lollara",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lombadina mission",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "londonderry",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "londonderry raaf",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "londrigan",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "lone pine",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "lone pine",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "lonesome creek",
		"state": "qld",
		"postcode": "4719"
	},
	{
		"town": "long beach",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "long creek",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "long flat",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "long flat",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "long flat",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "long forest",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "long gully",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "long island",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "long island",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "long jetty",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "long plain",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "long plain",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "long plains",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "long plains",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "long pocket",
		"state": "qld",
		"postcode": "4068"
	},
	{
		"town": "long pocket",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "long point",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "long point",
		"state": "nsw",
		"postcode": "2564"
	},
	{
		"town": "long point",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "long reach",
		"state": "tas",
		"postcode": "7253"
	},
	{
		"town": "long reef",
		"state": "nsw",
		"postcode": "2097"
	},
	{
		"town": "longarm",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "longerenong",
		"state": "vic",
		"postcode": "3399"
	},
	{
		"town": "longford",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "longford",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "longlea",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "longley",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "longreach",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "longueville",
		"state": "nsw",
		"postcode": "2066"
	},
	{
		"town": "longwarry",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "longwarry east",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "longwarry north",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "longwarry south",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "longwood",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "longwood",
		"state": "vic",
		"postcode": "3665"
	},
	{
		"town": "lonnavale",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lonsdale",
		"state": "sa",
		"postcode": "5160"
	},
	{
		"town": "loomberah",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "loongana",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "loongana",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "loorana",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "lord howe island",
		"state": "nsw",
		"postcode": "2898"
	},
	{
		"town": "lords hill",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "loreto hill",
		"state": "qld",
		"postcode": "4120"
	},
	{
		"town": "lorinna",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "lorn",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "lorne",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "lorne",
		"state": "vic",
		"postcode": "3232"
	},
	{
		"town": "lostock",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "lota",
		"state": "qld",
		"postcode": "4179"
	},
	{
		"town": "lottah",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "lotus creek",
		"state": "qld",
		"postcode": "4705"
	},
	{
		"town": "louisa creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "louisa creek",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "louisville",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "louth",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "louth bay",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "louth park",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "lovedale",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "loveday",
		"state": "sa",
		"postcode": "5345"
	},
	{
		"town": "lovely banks",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "lovely banks",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "lovett bay",
		"state": "nsw",
		"postcode": "2105"
	},
	{
		"town": "low head",
		"state": "tas",
		"postcode": "7253"
	},
	{
		"town": "lowaldie",
		"state": "sa",
		"postcode": "5307"
	},
	{
		"town": "lowan",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "lowan vale",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "lowanna",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "lowbank",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "lowden",
		"state": "wa",
		"postcode": "6240"
	},
	{
		"town": "lowdina",
		"state": "tas",
		"postcode": "7026"
	},
	{
		"town": "lower acacia creek",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "lower bago",
		"state": "nsw",
		"postcode": "2730"
	},
	{
		"town": "lower barrington",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "lower beechmont",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "lower belford",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "lower beulah",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "lower boro",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "lower bowman",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "lower broughton",
		"state": "sa",
		"postcode": "5522"
	},
	{
		"town": "lower bucca",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "lower chittering",
		"state": "wa",
		"postcode": "6084"
	},
	{
		"town": "lower coldstream",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "lower crawford",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "lower creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "lower cressbrook",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "lower hawkesbury",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "lower hermitage",
		"state": "sa",
		"postcode": "5131"
	},
	{
		"town": "lower homebush",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "lower inman valley",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "lower kalgan",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "lower king",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "lower lewis ponds",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "lower light",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "lower longley",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lower macdonald",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "lower mangrove",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "lower marshes",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "lower mitcham",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "lower moira",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "lower mookebawa",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "lower norton",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "lower pappinbarra",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "lower plenty",
		"state": "vic",
		"postcode": "3093"
	},
	{
		"town": "lower portland",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "lower sandy bay",
		"state": "tas",
		"postcode": "7005"
	},
	{
		"town": "lower snug",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "lower southgate",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "lower tenthill",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "lower towamba",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "lower turners marsh",
		"state": "tas",
		"postcode": "7267"
	},
	{
		"town": "lower wattle grove",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lower wilmot",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "lower wonga",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "lowes",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "lowesdale",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "lowmead",
		"state": "qld",
		"postcode": "4676"
	},
	{
		"town": "lowood",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "lowther",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "loxford",
		"state": "nsw",
		"postcode": "2326"
	},
	{
		"town": "loxton",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "loxton north",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "loy yang",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "loyetea",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "lubeck",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "lucas heights",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "lucaston",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lucinda",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "lucindale",
		"state": "sa",
		"postcode": "5272"
	},
	{
		"town": "lucknow",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "lucknow",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "lucky bay",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "lucyvale",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "luddenham",
		"state": "nsw",
		"postcode": "2745"
	},
	{
		"town": "ludlow",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "ludmilla",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "lue",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "lugarno",
		"state": "nsw",
		"postcode": "2210"
	},
	{
		"town": "lughrata",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "luina",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "lulworth",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "lumeah",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "lunawanna",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "lundavra",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "lune river",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lurg",
		"state": "vic",
		"postcode": "3672"
	},
	{
		"town": "lurnea",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "luscombe",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "luskintyre",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "lutana",
		"state": "tas",
		"postcode": "7009"
	},
	{
		"town": "lutwyche",
		"state": "qld",
		"postcode": "4030"
	},
	{
		"town": "lyal",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "lyalls mill",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "lyetta",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "lygon street north",
		"state": "vic",
		"postcode": "3057"
	},
	{
		"town": "lymington",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "lymwood",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "lynam",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "lynchford",
		"state": "tas",
		"postcode": "7467"
	},
	{
		"town": "lynchs creek",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "lyndale",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "lyndale",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "lyndhurst",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "lyndhurst",
		"state": "nsw",
		"postcode": "2797"
	},
	{
		"town": "lyndhurst",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "lyndhurst",
		"state": "vic",
		"postcode": "3975"
	},
	{
		"town": "lyndoch",
		"state": "sa",
		"postcode": "5351"
	},
	{
		"town": "lyndon",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "lyneham",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "lynette",
		"state": "vic",
		"postcode": "3705"
	},
	{
		"town": "lynford",
		"state": "qld",
		"postcode": "4342"
	},
	{
		"town": "lynton",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "lynwood",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "lynwood",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "lynwood",
		"state": "wa",
		"postcode": "6147"
	},
	{
		"town": "lyons",
		"state": "act",
		"postcode": "2606"
	},
	{
		"town": "lyons",
		"state": "qld",
		"postcode": "4124"
	},
	{
		"town": "lyons",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "lyonville",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "lyra",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "lyrup",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "lysterfield",
		"state": "vic",
		"postcode": "3156"
	},
	{
		"town": "lysterfield south",
		"state": "vic",
		"postcode": "3156"
	},
	{
		"town": "lytton",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "ma ma creek",
		"state": "qld",
		"postcode": "4347"
	},
	{
		"town": "maaroom",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "maatsuyker island",
		"state": "tas",
		"postcode": "7001"
	},
	{
		"town": "mabins well",
		"state": "nsw",
		"postcode": "2716"
	},
	{
		"town": "mabuiag",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "mabuiag island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "macalister",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "macarthur",
		"state": "act",
		"postcode": "2904"
	},
	{
		"town": "macarthur",
		"state": "vic",
		"postcode": "3286"
	},
	{
		"town": "macarthur square",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "macclesfield",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "macclesfield",
		"state": "vic",
		"postcode": "3782"
	},
	{
		"town": "macdonald park",
		"state": "sa",
		"postcode": "5121"
	},
	{
		"town": "macdonalds creek",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "macdonaldtown",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "macedon",
		"state": "vic",
		"postcode": "3440"
	},
	{
		"town": "macfarlane",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "macgillivray",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "macgregor",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "macgregor",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "machans beach",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "machine creek",
		"state": "qld",
		"postcode": "4695"
	},
	{
		"town": "mackay",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackay caneland",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackay east",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackay harbour",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackay north",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackay south",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackay west",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mackenzie",
		"state": "qld",
		"postcode": "4156"
	},
	{
		"town": "mackenzie",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "mackenzie river",
		"state": "qld",
		"postcode": "4705"
	},
	{
		"town": "mackinnon",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "mackintosh",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "macknade",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "macks creek",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "macksville",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "maclagan",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "maclean",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "maclean",
		"state": "qld",
		"postcode": "4280"
	},
	{
		"town": "macleay island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "macleod",
		"state": "vic",
		"postcode": "3085"
	},
	{
		"town": "macleod",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "macleod west",
		"state": "vic",
		"postcode": "3085"
	},
	{
		"town": "macmasters beach",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "macorna",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "macorna north",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "macquarie",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "macquarie",
		"state": "tas",
		"postcode": "7151"
	},
	{
		"town": "macquarie centre",
		"state": "nsw",
		"postcode": "2113"
	},
	{
		"town": "macquarie fields",
		"state": "nsw",
		"postcode": "2564"
	},
	{
		"town": "macquarie hills",
		"state": "nsw",
		"postcode": "2285"
	},
	{
		"town": "macquarie island",
		"state": "tas",
		"postcode": "7151"
	},
	{
		"town": "macquarie links",
		"state": "nsw",
		"postcode": "2564"
	},
	{
		"town": "macquarie park",
		"state": "nsw",
		"postcode": "2113"
	},
	{
		"town": "macquarie pass",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "macquarie plains",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "macquarie settlement",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "macquarie university",
		"state": "nsw",
		"postcode": "2109"
	},
	{
		"town": "macrossan",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "macs cove",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "madalya",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "maddens plains",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "maddingley",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "maddington",
		"state": "wa",
		"postcode": "6109"
	},
	{
		"town": "maddington",
		"state": "wa",
		"postcode": "6989"
	},
	{
		"town": "madeley",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "madgwick",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "madora",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "madowla park",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "madura",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "mafeking",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "maffra",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "maffra",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "maffra west upper",
		"state": "vic",
		"postcode": "3859"
	},
	{
		"town": "magarey",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "maggea",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "magill",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "magill north",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "magill south",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "magnetic island",
		"state": "qld",
		"postcode": "4819"
	},
	{
		"town": "magnolia",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "magometon",
		"state": "nsw",
		"postcode": "2829"
	},
	{
		"town": "magpie",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "magra",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "mahogany creek",
		"state": "wa",
		"postcode": "6072"
	},
	{
		"town": "mahomets flats",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "maianbar",
		"state": "nsw",
		"postcode": "2230"
	},
	{
		"town": "maida vale",
		"state": "wa",
		"postcode": "6057"
	},
	{
		"town": "maidavale",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "maiden gully",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "maidenhead",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "maidenwell",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "maidstone",
		"state": "vic",
		"postcode": "3012"
	},
	{
		"town": "mailer flat",
		"state": "vic",
		"postcode": "3275"
	},
	{
		"town": "mailors flat",
		"state": "vic",
		"postcode": "3275"
	},
	{
		"town": "maimuru",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "main arm",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "main beach",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "main creek",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "main lead",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "main ridge",
		"state": "vic",
		"postcode": "3928"
	},
	{
		"town": "maindample",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "maison dieu",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "maitland",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "maitland",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "maitland bar",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "maitland north",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "maitland vale",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "major line",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "major plains",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "majorca",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "majors creek",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "majors creek",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "makin",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "malabaine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "malabar",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "malabugilmah",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "malaga",
		"state": "wa",
		"postcode": "6090"
	},
	{
		"town": "malaga",
		"state": "wa",
		"postcode": "6944"
	},
	{
		"town": "malak",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "malakoff",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "malanda",
		"state": "qld",
		"postcode": "4885"
	},
	{
		"town": "malarga",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "malbina",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "maldon",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "malebelling",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "malebo",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "maleny",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "malinong",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "mallabula",
		"state": "nsw",
		"postcode": "2319"
	},
	{
		"town": "mallacoota",
		"state": "vic",
		"postcode": "3892"
	},
	{
		"town": "mallala",
		"state": "sa",
		"postcode": "5502"
	},
	{
		"town": "mallan",
		"state": "nsw",
		"postcode": "3586"
	},
	{
		"town": "mallanganee",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "mallowa",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "mallum creek",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "malmalling",
		"state": "wa",
		"postcode": "6556"
	},
	{
		"town": "malmoe",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "malmsbury",
		"state": "vic",
		"postcode": "3446"
	},
	{
		"town": "malones",
		"state": "vic",
		"postcode": "3282"
	},
	{
		"town": "maloneys beach",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "malpas",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "maltee",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "malua bay",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "malvern",
		"state": "sa",
		"postcode": "5061"
	},
	{
		"town": "malvern",
		"state": "vic",
		"postcode": "3144"
	},
	{
		"town": "malvern east",
		"state": "vic",
		"postcode": "3145"
	},
	{
		"town": "malvern east",
		"state": "vic",
		"postcode": "3148"
	},
	{
		"town": "malvern north",
		"state": "vic",
		"postcode": "3144"
	},
	{
		"town": "malyalling",
		"state": "wa",
		"postcode": "6370"
	},
	{
		"town": "mambourin",
		"state": "vic",
		"postcode": "3024"
	},
	{
		"town": "mambray creek",
		"state": "sa",
		"postcode": "5495"
	},
	{
		"town": "manahan",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "manangatang",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "manapouri",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "manar",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "manar",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "manara",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "manbulloo",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "manchester square",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "mandagery",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "mandalay",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "mandalong",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "mandemar",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "mandogalup",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "mandurah",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "mandurah east",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "mandurah north",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "mandurama",
		"state": "nsw",
		"postcode": "2792"
	},
	{
		"town": "mandurang",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "mandurang south",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "manera heights",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "maneroo",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "mangalo",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "mangalore",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "mangalore",
		"state": "vic",
		"postcode": "3663"
	},
	{
		"town": "mangana",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "mangerton",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "mango hill",
		"state": "qld",
		"postcode": "4509"
	},
	{
		"town": "mangoola",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "mangoplah",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "mangowine",
		"state": "wa",
		"postcode": "6479"
	},
	{
		"town": "mangrove creek",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "mangrove mountain",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "manifold heights",
		"state": "vic",
		"postcode": "3218"
	},
	{
		"town": "manildra",
		"state": "nsw",
		"postcode": "2865"
	},
	{
		"town": "manilla",
		"state": "nsw",
		"postcode": "2346"
	},
	{
		"town": "maningrida",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "manjimup",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "manly",
		"state": "nsw",
		"postcode": "1655"
	},
	{
		"town": "manly",
		"state": "nsw",
		"postcode": "2095"
	},
	{
		"town": "manly",
		"state": "qld",
		"postcode": "4179"
	},
	{
		"town": "manly east",
		"state": "nsw",
		"postcode": "2095"
	},
	{
		"town": "manly vale",
		"state": "nsw",
		"postcode": "2093"
	},
	{
		"town": "manly west",
		"state": "qld",
		"postcode": "4179"
	},
	{
		"town": "manmanning",
		"state": "wa",
		"postcode": "6465"
	},
	{
		"town": "manna hill",
		"state": "sa",
		"postcode": "5440"
	},
	{
		"town": "mannanarie",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "mannerim",
		"state": "vic",
		"postcode": "3222"
	},
	{
		"town": "mannering park",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "mannibadar",
		"state": "vic",
		"postcode": "3360"
	},
	{
		"town": "manning",
		"state": "wa",
		"postcode": "6152"
	},
	{
		"town": "manning point",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "manningham",
		"state": "sa",
		"postcode": "5086"
	},
	{
		"town": "manns beach",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "mannuem",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "mannum",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "mannus",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "manobalai",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "manoora",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "manoora",
		"state": "sa",
		"postcode": "5414"
	},
	{
		"town": "manorina",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "mansfield",
		"state": "qld",
		"postcode": "4122"
	},
	{
		"town": "mansfield",
		"state": "vic",
		"postcode": "3722"
	},
	{
		"town": "mansfield",
		"state": "vic",
		"postcode": "3724"
	},
	{
		"town": "mansfield park",
		"state": "sa",
		"postcode": "5012"
	},
	{
		"town": "manton",
		"state": "sa",
		"postcode": "837"
	},
	{
		"town": "mantung",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "manuka",
		"state": "act",
		"postcode": "2603"
	},
	{
		"town": "manumbar",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "manunda",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "many peaks",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "manyana",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "manypeaks",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "manyung",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "mapleton",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "mapoon",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "maragle",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "marama",
		"state": "sa",
		"postcode": "5307"
	},
	{
		"town": "marananga",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "maranboy",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "marangaroo",
		"state": "wa",
		"postcode": "6064"
	},
	{
		"town": "maranoa heights",
		"state": "tas",
		"postcode": "7050"
	},
	{
		"town": "maranup",
		"state": "wa",
		"postcode": "6256"
	},
	{
		"town": "marawaylee",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "maraylya",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "marayong",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "marbellup",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "marble bar",
		"state": "wa",
		"postcode": "6760"
	},
	{
		"town": "marburg",
		"state": "qld",
		"postcode": "4346"
	},
	{
		"town": "march",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "marchagee",
		"state": "wa",
		"postcode": "6515"
	},
	{
		"town": "marcollat",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "marcoola",
		"state": "qld",
		"postcode": "4564"
	},
	{
		"town": "marcus beach",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "marcus hill",
		"state": "vic",
		"postcode": "3222"
	},
	{
		"town": "mardan",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "mardella",
		"state": "wa",
		"postcode": "6125"
	},
	{
		"town": "marden",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "mardi",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "mardie",
		"state": "wa",
		"postcode": "6718"
	},
	{
		"town": "mareeba",
		"state": "qld",
		"postcode": "4880"
	},
	{
		"town": "marengo",
		"state": "vic",
		"postcode": "3233"
	},
	{
		"town": "margaret river",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "margate",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "margate",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "margate beach",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "maria island",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "marian",
		"state": "qld",
		"postcode": "4753"
	},
	{
		"town": "maribyrnong",
		"state": "vic",
		"postcode": "3032"
	},
	{
		"town": "mariginiup",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "marinna",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "marino",
		"state": "sa",
		"postcode": "5049"
	},
	{
		"town": "marion",
		"state": "sa",
		"postcode": "5043"
	},
	{
		"town": "marion bay",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "marion bay",
		"state": "tas",
		"postcode": "7175"
	},
	{
		"town": "marionvale",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "marks point",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "markwell",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "markwood",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "marla",
		"state": "sa",
		"postcode": "5724"
	},
	{
		"town": "marlbed",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "marlborough",
		"state": "qld",
		"postcode": "4705"
	},
	{
		"town": "marlee",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "marleston",
		"state": "sa",
		"postcode": "5033"
	},
	{
		"town": "marlo",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "marlo merrican",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "marlow",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "marlow lagoon",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "marlowe",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "marmion",
		"state": "wa",
		"postcode": "6020"
	},
	{
		"town": "marmong point",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "marmor",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "marne",
		"state": "wa",
		"postcode": "6608"
	},
	{
		"town": "marnoo",
		"state": "vic",
		"postcode": "3387"
	},
	{
		"town": "marodian",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "marola",
		"state": "sa",
		"postcode": "5464"
	},
	{
		"town": "marom creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "marong",
		"state": "vic",
		"postcode": "3515"
	},
	{
		"town": "maroochy river",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "maroochydore",
		"state": "qld",
		"postcode": "4558"
	},
	{
		"town": "maroochydore south",
		"state": "qld",
		"postcode": "4558"
	},
	{
		"town": "maroon",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "maroon dam",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "maroona",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "maroondan",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "maroota",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "maroubra",
		"state": "nsw",
		"postcode": "2035"
	},
	{
		"town": "maroubra junction",
		"state": "nsw",
		"postcode": "2035"
	},
	{
		"town": "maroubra south",
		"state": "nsw",
		"postcode": "2035"
	},
	{
		"town": "marp",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "marrabel",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "marradong",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "marrangaroo",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "marrar",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "marrara",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "marrawah",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "marraweeney",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "marree",
		"state": "sa",
		"postcode": "5733"
	},
	{
		"town": "marrickville",
		"state": "nsw",
		"postcode": "1475"
	},
	{
		"town": "marrickville",
		"state": "nsw",
		"postcode": "1476"
	},
	{
		"town": "marrickville",
		"state": "nsw",
		"postcode": "2204"
	},
	{
		"town": "marrickville metro",
		"state": "nsw",
		"postcode": "2204"
	},
	{
		"town": "marrickville south",
		"state": "nsw",
		"postcode": "2204"
	},
	{
		"town": "marrinup",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "marryatville",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "marsden",
		"state": "qld",
		"postcode": "4132"
	},
	{
		"town": "marsden park",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "marsden postal depot",
		"state": "qld",
		"postcode": "4132"
	},
	{
		"town": "marsfield",
		"state": "nsw",
		"postcode": "2122"
	},
	{
		"town": "marshall",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "marshall mount",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "marshdale",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "marshlands",
		"state": "qld",
		"postcode": "4611"
	},
	{
		"town": "marthaguy",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "martin",
		"state": "wa",
		"postcode": "6110"
	},
	{
		"town": "martindale",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "martins creek",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "martins creek",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "martinsville",
		"state": "nsw",
		"postcode": "2265"
	},
	{
		"town": "martynvale",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "marulan",
		"state": "nsw",
		"postcode": "2579"
	},
	{
		"town": "marulan south",
		"state": "nsw",
		"postcode": "2579"
	},
	{
		"town": "marungi",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "marvel loch",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "mary kathleen",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "maryborough",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "maryborough",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "maryborough west",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "marybrook",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "maryfarms",
		"state": "qld",
		"postcode": "4880"
	},
	{
		"town": "maryknoll",
		"state": "vic",
		"postcode": "3812"
	},
	{
		"town": "maryland",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "marylands",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "marys creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "marys mount",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "marysville",
		"state": "vic",
		"postcode": "3779"
	},
	{
		"town": "maryvale",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "maryvale",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "maryvale",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "maryvale",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "maryville",
		"state": "nsw",
		"postcode": "2293"
	},
	{
		"town": "mascot",
		"state": "nsw",
		"postcode": "1460"
	},
	{
		"town": "mascot",
		"state": "nsw",
		"postcode": "2020"
	},
	{
		"town": "masig",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "maslin beach",
		"state": "sa",
		"postcode": "5170"
	},
	{
		"town": "masons hill",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "massey",
		"state": "vic",
		"postcode": "3482"
	},
	{
		"town": "massey bay",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "mataranka",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "matcham",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "mater hill",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "mater hospital",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "matheson",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "mathiesons",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "mathinna",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "mathoura",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "matlock",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "matong",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "matraville",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "matta flat",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "maude",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "maude",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "mauds landing",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "maudsland",
		"state": "qld",
		"postcode": "4210"
	},
	{
		"town": "maudville",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "maules creek",
		"state": "nsw",
		"postcode": "2382"
	},
	{
		"town": "mawbanna",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "mawson",
		"state": "act",
		"postcode": "2607"
	},
	{
		"town": "mawson",
		"state": "tas",
		"postcode": "7151"
	},
	{
		"town": "mawson",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "mawson lakes",
		"state": "sa",
		"postcode": "5095"
	},
	{
		"town": "maxwell",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "maxwelton",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "may downs",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "maya",
		"state": "wa",
		"postcode": "6614"
	},
	{
		"town": "mayanup",
		"state": "wa",
		"postcode": "6244"
	},
	{
		"town": "mayberry",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "maybole",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "maydena",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "mayers flat",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "mayfield",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "mayfield",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "mayfield",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "mayfield",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "mayfield",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "mayfield east",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "mayfield north",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "mayfield west",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "mayflower",
		"state": "vic",
		"postcode": "3869"
	},
	{
		"town": "maylands",
		"state": "sa",
		"postcode": "5069"
	},
	{
		"town": "maylands",
		"state": "wa",
		"postcode": "6051"
	},
	{
		"town": "maylands",
		"state": "wa",
		"postcode": "6931"
	},
	{
		"town": "maynards plains",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "mayne",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "mayreef",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "mayrung",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "mays hill",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "mayvale",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "mcalinden",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "mcalister",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "mcbeath",
		"state": "wa",
		"postcode": "6770"
	},
	{
		"town": "mccallum",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "mccartins",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "mccoys bridge",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "mccracken",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "mccrae",
		"state": "vic",
		"postcode": "3938"
	},
	{
		"town": "mccullys gap",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "mcdevitt",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "mcdougalls hill",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "mcdowall",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "mcevoys",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "mcewens beach",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mcgraths hill",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "mcharg creek",
		"state": "sa",
		"postcode": "5157"
	},
	{
		"town": "mcilwraith",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "mcintosh creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "mcintyre",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "mckail",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "mckay creek",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "mckees hill",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "mckellar",
		"state": "act",
		"postcode": "2617"
	},
	{
		"town": "mckenzie creek",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "mckenzie hill",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "mckinlay",
		"state": "qld",
		"postcode": "4823"
	},
	{
		"town": "mckinnon",
		"state": "vic",
		"postcode": "3204"
	},
	{
		"town": "mckinnons",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "mclaren flat",
		"state": "sa",
		"postcode": "5171"
	},
	{
		"town": "mclaren vale",
		"state": "sa",
		"postcode": "5171"
	},
	{
		"town": "mcleans ridges",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "mcleods shoot",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "mcloughlins beach",
		"state": "vic",
		"postcode": "3874"
	},
	{
		"town": "mcmahons creek",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "mcmahons point",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "mcmahons reef",
		"state": "nsw",
		"postcode": "2585"
	},
	{
		"town": "mcmillans",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "mcminns lagoon",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "mcnaughtons",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "mcphersons crossing",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "mctaggarts",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "mead",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "meadow creek",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "meadow flat",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "meadow heights",
		"state": "vic",
		"postcode": "3048"
	},
	{
		"town": "meadow springs",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "meadowbank",
		"state": "nsw",
		"postcode": "2114"
	},
	{
		"town": "meadowbanks",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "meadowbrook",
		"state": "qld",
		"postcode": "4131"
	},
	{
		"town": "meadows",
		"state": "sa",
		"postcode": "5201"
	},
	{
		"town": "meadowvale",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "meandarra",
		"state": "qld",
		"postcode": "4422"
	},
	{
		"town": "meander",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "meatian",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "mebbin",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "mebul",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "meckering",
		"state": "wa",
		"postcode": "6405"
	},
	{
		"town": "medina",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "medindie",
		"state": "sa",
		"postcode": "5081"
	},
	{
		"town": "medindie gardens",
		"state": "sa",
		"postcode": "5081"
	},
	{
		"town": "medlow bath",
		"state": "nsw",
		"postcode": "2780"
	},
	{
		"town": "medlyn",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "medowie",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "medway",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "meeandah",
		"state": "qld",
		"postcode": "4008"
	},
	{
		"town": "meekatharra",
		"state": "wa",
		"postcode": "6642"
	},
	{
		"town": "meelon",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "meenaar",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "meeniyan",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "meereek",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "meering west",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "meering west",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "meerlieu",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "meermaul",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "meerschaum vale",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "megalong",
		"state": "nsw",
		"postcode": "2785"
	},
	{
		"town": "megan",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "meikleville hill",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "melba",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "melbergen",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "3000"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "3001"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "3004"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8045"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8051"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8060"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8061"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8066"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8069"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8070"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8071"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8100"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8101"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8102"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8103"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8107"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8108"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8111"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8120"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8205"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8383"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8386"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8388"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8390"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8393"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8394"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8396"
	},
	{
		"town": "melbourne",
		"state": "vic",
		"postcode": "8399"
	},
	{
		"town": "melbourne airport",
		"state": "vic",
		"postcode": "3045"
	},
	{
		"town": "melbourne university",
		"state": "vic",
		"postcode": "3052"
	},
	{
		"town": "meldale",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "melinga",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "mella",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "mellis",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "mellong",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "mellool",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "melrose",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "melrose",
		"state": "sa",
		"postcode": "5483"
	},
	{
		"town": "melrose",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "melrose park",
		"state": "nsw",
		"postcode": "2114"
	},
	{
		"town": "melrose park",
		"state": "sa",
		"postcode": "5039"
	},
	{
		"town": "melton",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "melton",
		"state": "vic",
		"postcode": "3337"
	},
	{
		"town": "melton mowbray",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "melton south",
		"state": "vic",
		"postcode": "3338"
	},
	{
		"town": "melton west",
		"state": "vic",
		"postcode": "3337"
	},
	{
		"town": "melville",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "melville",
		"state": "wa",
		"postcode": "6156"
	},
	{
		"town": "melville",
		"state": "wa",
		"postcode": "6956"
	},
	{
		"town": "melville forest",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "melwood",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "memagong",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "memana",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "memerambi",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "mena creek",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mena park",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "menah",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "menai",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "menai central",
		"state": "nsw",
		"postcode": "2234"
	},
	{
		"town": "menangle",
		"state": "nsw",
		"postcode": "2568"
	},
	{
		"town": "menangle park",
		"state": "nsw",
		"postcode": "2563"
	},
	{
		"town": "mendooran",
		"state": "nsw",
		"postcode": "2842"
	},
	{
		"town": "mengha",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "menindee",
		"state": "nsw",
		"postcode": "2879"
	},
	{
		"town": "meningie",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "meningie east",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "meningie west",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "menora",
		"state": "wa",
		"postcode": "6050"
	},
	{
		"town": "mentmore",
		"state": "qld",
		"postcode": "4798"
	},
	{
		"town": "mentone",
		"state": "vic",
		"postcode": "3194"
	},
	{
		"town": "mentone east",
		"state": "vic",
		"postcode": "3194"
	},
	{
		"town": "menzies",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "menzies",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "menzies",
		"state": "wa",
		"postcode": "6436"
	},
	{
		"town": "menzies creek",
		"state": "vic",
		"postcode": "3159"
	},
	{
		"town": "mepunga",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "mepunga east",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "mepunga west",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "merah north",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "meran downs",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "merbein",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "merbein south",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "merbein west",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "mercunda",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "meredith",
		"state": "vic",
		"postcode": "3333"
	},
	{
		"town": "merewether",
		"state": "nsw",
		"postcode": "2291"
	},
	{
		"town": "merewether heights",
		"state": "nsw",
		"postcode": "2291"
	},
	{
		"town": "merghiny",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "meribah",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "meridan plains",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "meridian point",
		"state": "qld",
		"postcode": "4159"
	},
	{
		"town": "merimbula",
		"state": "nsw",
		"postcode": "2548"
	},
	{
		"town": "merinda",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "meringa",
		"state": "qld",
		"postcode": "4865"
	},
	{
		"town": "meringandan",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "meringo",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "meringur",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "merino",
		"state": "vic",
		"postcode": "3310"
	},
	{
		"town": "merivale",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "merkanooka",
		"state": "wa",
		"postcode": "6625"
	},
	{
		"town": "merlwood",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "merlynston",
		"state": "vic",
		"postcode": "3058"
	},
	{
		"town": "mermaid beach",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "mermaid keys",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "mermaid waters",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "mernda",
		"state": "vic",
		"postcode": "3754"
	},
	{
		"town": "meroo",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "meroo meadow",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "merotherie",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "merredin",
		"state": "wa",
		"postcode": "6415"
	},
	{
		"town": "merri view",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "merriang",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "merriang south",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "merriangaah",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "merricks",
		"state": "vic",
		"postcode": "3916"
	},
	{
		"town": "merricks beach",
		"state": "vic",
		"postcode": "3926"
	},
	{
		"town": "merricks north",
		"state": "vic",
		"postcode": "3926"
	},
	{
		"town": "merricumbene",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "merrigal",
		"state": "nsw",
		"postcode": "2827"
	},
	{
		"town": "merrigum",
		"state": "vic",
		"postcode": "3618"
	},
	{
		"town": "merrijig",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "merrilla",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "merrimac",
		"state": "qld",
		"postcode": "4226"
	},
	{
		"town": "merrimans creek",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "merrimu",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "merrinee",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "merriton",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "merritts creek",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "merrivale",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "merriville",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "merriwa",
		"state": "nsw",
		"postcode": "2329"
	},
	{
		"town": "merriwa",
		"state": "wa",
		"postcode": "6030"
	},
	{
		"town": "merriwagga",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "merrygoen",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "merrylands",
		"state": "nsw",
		"postcode": "2160"
	},
	{
		"town": "mersey forest",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "merseylea",
		"state": "tas",
		"postcode": "7305"
	},
	{
		"town": "merton",
		"state": "vic",
		"postcode": "3715"
	},
	{
		"town": "merton vale",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "merty merty",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "meru",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "merungle hill",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "meryla",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "metcalfe",
		"state": "vic",
		"postcode": "3448"
	},
	{
		"town": "metcalfe east",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "metford",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "methul",
		"state": "nsw",
		"postcode": "2701"
	},
	{
		"town": "metricup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "mettler",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "metung",
		"state": "vic",
		"postcode": "3904"
	},
	{
		"town": "metz",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "meunna",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "mewburn park",
		"state": "vic",
		"postcode": "3859"
	},
	{
		"town": "mia mia",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "mia mia",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "miakite",
		"state": "vic",
		"postcode": "3302"
	},
	{
		"town": "miallo",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "miami",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "miami keys",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "miamoon",
		"state": "wa",
		"postcode": "6612"
	},
	{
		"town": "miandetta",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "miandetta",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "miara",
		"state": "qld",
		"postcode": "4673"
	},
	{
		"town": "mica creek",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "micalo island",
		"state": "nsw",
		"postcode": "2464"
	},
	{
		"town": "michelago",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "mickibri",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "mickleham",
		"state": "vic",
		"postcode": "3064"
	},
	{
		"town": "mid north coast msc",
		"state": "nsw",
		"postcode": "2442"
	},
	{
		"town": "mid valley",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "middle arm",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "middle beach",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "middle brook",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "middle brother",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "middle camberwell",
		"state": "vic",
		"postcode": "3124"
	},
	{
		"town": "middle camp",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "middle cove",
		"state": "nsw",
		"postcode": "2068"
	},
	{
		"town": "middle creek",
		"state": "vic",
		"postcode": "3375"
	},
	{
		"town": "middle dural",
		"state": "nsw",
		"postcode": "2158"
	},
	{
		"town": "middle falbrook",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "middle park",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "middle park",
		"state": "vic",
		"postcode": "3206"
	},
	{
		"town": "middle pocket",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "middle point",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "middle ridge",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "middle river",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "middle swan",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "middlemount",
		"state": "qld",
		"postcode": "4746"
	},
	{
		"town": "middlesex",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "middlesex",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "middleton",
		"state": "qld",
		"postcode": "4735"
	},
	{
		"town": "middleton",
		"state": "sa",
		"postcode": "5213"
	},
	{
		"town": "middleton",
		"state": "tas",
		"postcode": "7163"
	},
	{
		"town": "middleton beach",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "middlingbank",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "midge point",
		"state": "qld",
		"postcode": "4799"
	},
	{
		"town": "midgee",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "midginbil",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "midland",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "midvale",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "midway",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "midway point",
		"state": "tas",
		"postcode": "7171"
	},
	{
		"town": "miena",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "miepoll",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "miga lake",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "mil lel",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mila",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "milabena",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "milang",
		"state": "sa",
		"postcode": "5256"
	},
	{
		"town": "milawa",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "milbong",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "milbrodale",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "milbrulong",
		"state": "nsw",
		"postcode": "2656"
	},
	{
		"town": "milby",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "mildura",
		"state": "vic",
		"postcode": "3500"
	},
	{
		"town": "mildura",
		"state": "vic",
		"postcode": "3502"
	},
	{
		"town": "mildura centre plaza",
		"state": "vic",
		"postcode": "3501"
	},
	{
		"town": "mildura east",
		"state": "vic",
		"postcode": "3500"
	},
	{
		"town": "mildura south",
		"state": "vic",
		"postcode": "3501"
	},
	{
		"town": "mildura west",
		"state": "vic",
		"postcode": "3500"
	},
	{
		"town": "mile bridge",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "mile end",
		"state": "sa",
		"postcode": "5031"
	},
	{
		"town": "mile end south",
		"state": "sa",
		"postcode": "5031"
	},
	{
		"town": "milendella",
		"state": "sa",
		"postcode": "5237"
	},
	{
		"town": "miles",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "miles end",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "milford",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "milguy",
		"state": "nsw",
		"postcode": "2399"
	},
	{
		"town": "miling",
		"state": "wa",
		"postcode": "6575"
	},
	{
		"town": "milingimbi",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "milkers flat",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "mill park",
		"state": "vic",
		"postcode": "3082"
	},
	{
		"town": "millaa millaa",
		"state": "qld",
		"postcode": "4886"
	},
	{
		"town": "millah murrah",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "millaroo",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "millars well",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "millbank",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "millbank",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "millbrook",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "millbrook",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "millendon",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "miller",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "millers forest",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "millers point",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "millfield",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "millgrove",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "millicent",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "millie",
		"state": "nsw",
		"postcode": "2397"
	},
	{
		"town": "millingandi",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "millmerran",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "millmerran downs",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "millmerran woods",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "millner",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "milloo",
		"state": "vic",
		"postcode": "3572"
	},
	{
		"town": "millstream",
		"state": "wa",
		"postcode": "6716"
	},
	{
		"town": "millsville",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "millswood",
		"state": "sa",
		"postcode": "5034"
	},
	{
		"town": "millswyn",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "millthorpe",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "milltown",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "millwood",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "millwood",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "millwood",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "milman",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "milndale",
		"state": "vic",
		"postcode": "3990"
	},
	{
		"town": "milnes bridge",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "milo",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "milora",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "milpara",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "milparinka",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "milperra",
		"state": "nsw",
		"postcode": "2214"
	},
	{
		"town": "milroy",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "milroy",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "milsons passage",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "milsons point",
		"state": "nsw",
		"postcode": "1565"
	},
	{
		"town": "milsons point",
		"state": "nsw",
		"postcode": "2061"
	},
	{
		"town": "milton",
		"state": "nsw",
		"postcode": "2538"
	},
	{
		"town": "milton",
		"state": "qld",
		"postcode": "4064"
	},
	{
		"town": "milvale",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "milvale",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "mimili",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "mimosa",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "mimosa",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "minbrie",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "minburra",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "mincha",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "mincha west",
		"state": "vic",
		"postcode": "3567"
	},
	{
		"town": "minchinbury",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "mindaribba",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "mindarie",
		"state": "sa",
		"postcode": "5309"
	},
	{
		"town": "mindarie",
		"state": "wa",
		"postcode": "6030"
	},
	{
		"town": "mindarra",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "minden",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "miners rest",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mingary",
		"state": "sa",
		"postcode": "5440"
	},
	{
		"town": "mingay",
		"state": "nsw",
		"postcode": "2727"
	},
	{
		"town": "mingay",
		"state": "vic",
		"postcode": "3324"
	},
	{
		"town": "mingbool",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mingela",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "mingenew",
		"state": "wa",
		"postcode": "6522"
	},
	{
		"town": "mingo",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "mingoola",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "minhamite",
		"state": "vic",
		"postcode": "3287"
	},
	{
		"town": "minilya",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "minimay",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "mininera",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "minjah",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "minjary",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "minjilang",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "minlaton",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "minmi",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "minmindie",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "minnamurra",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "minnenooka",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "minnie downs",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "minnie water",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "minnipa",
		"state": "sa",
		"postcode": "5654"
	},
	{
		"town": "minnivale",
		"state": "wa",
		"postcode": "6462"
	},
	{
		"town": "minore",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "mintabie",
		"state": "sa",
		"postcode": "5724"
	},
	{
		"town": "mintaro",
		"state": "sa",
		"postcode": "5415"
	},
	{
		"town": "minto",
		"state": "nsw",
		"postcode": "2566"
	},
	{
		"town": "minto",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "minto heights",
		"state": "nsw",
		"postcode": "2566"
	},
	{
		"town": "minvalara",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "minyama",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "minyip",
		"state": "vic",
		"postcode": "3392"
	},
	{
		"town": "minyirr",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "mira mar",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "miralie",
		"state": "vic",
		"postcode": "3596"
	},
	{
		"town": "miram",
		"state": "vic",
		"postcode": "3415"
	},
	{
		"town": "miranda",
		"state": "nsw",
		"postcode": "1490"
	},
	{
		"town": "miranda",
		"state": "nsw",
		"postcode": "2228"
	},
	{
		"town": "miranda",
		"state": "sa",
		"postcode": "5700"
	},
	{
		"town": "mirani",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "mirannie",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "mirboo",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "mirboo east",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "mirboo north",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "mirboo south",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "miriam vale",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "mirimbah",
		"state": "vic",
		"postcode": "3722"
	},
	{
		"town": "miriwinni",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mirrabooka",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "mirrabooka",
		"state": "wa",
		"postcode": "6061"
	},
	{
		"town": "mirrabooka",
		"state": "wa",
		"postcode": "6941"
	},
	{
		"town": "mirranatwa",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "mirrool",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "missabotti",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "missen flat",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "missenden road",
		"state": "nsw",
		"postcode": "2050"
	},
	{
		"town": "missingham",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "mission beach",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "mitalie",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "mitcham",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "mitcham",
		"state": "vic",
		"postcode": "3132"
	},
	{
		"town": "mitcham north",
		"state": "vic",
		"postcode": "3132"
	},
	{
		"town": "mitcham shopping centre",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "mitchell",
		"state": "act",
		"postcode": "2911"
	},
	{
		"town": "mitchell",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "mitchell",
		"state": "nt",
		"postcode": "832"
	},
	{
		"town": "mitchell",
		"state": "qld",
		"postcode": "4465"
	},
	{
		"town": "mitchell park",
		"state": "sa",
		"postcode": "5043"
	},
	{
		"town": "mitchell park",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mitchell park",
		"state": "vic",
		"postcode": "3355"
	},
	{
		"town": "mitchells flat",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "mitchells hill",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "mitchells island",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "mitchellstown",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "mitchellville",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "mitchelton",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "mitiamo",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "mitre",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "mitta junction",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "mitta mitta",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "mittagong",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "mittyack",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "miva",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "moa",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "moama",
		"state": "nsw",
		"postcode": "2731"
	},
	{
		"town": "moana",
		"state": "sa",
		"postcode": "5169"
	},
	{
		"town": "moana park",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "mobilong",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "mobrup",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "mockinya",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "moculta",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "modanville",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "modbury",
		"state": "sa",
		"postcode": "5092"
	},
	{
		"town": "modbury heights",
		"state": "sa",
		"postcode": "5092"
	},
	{
		"town": "modbury north",
		"state": "sa",
		"postcode": "5092"
	},
	{
		"town": "model farms",
		"state": "nsw",
		"postcode": "2153"
	},
	{
		"town": "modella",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "modewarre",
		"state": "vic",
		"postcode": "3240"
	},
	{
		"town": "moe",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "moe south",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "moffat beach",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "moffatdale",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "mogareeka",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "mogendoura",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "moggill",
		"state": "qld",
		"postcode": "4070"
	},
	{
		"town": "moggs creek",
		"state": "vic",
		"postcode": "3231"
	},
	{
		"town": "mogilla",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "moglonemby",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "mogo",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "mogo",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mograni",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "mograni creek",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "mogriguy",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "mogumber",
		"state": "wa",
		"postcode": "6506"
	},
	{
		"town": "moil",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "moina",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "moira",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "mokepilly",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "mokine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "mokoan west",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "molangul",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "mole creek",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "molendinar",
		"state": "qld",
		"postcode": "4214"
	},
	{
		"town": "molesworth",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "molesworth",
		"state": "vic",
		"postcode": "3718"
	},
	{
		"town": "moleville creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "moliagul",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "molka",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "mollerin",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "mollongghip",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "molloy island",
		"state": "wa",
		"postcode": "6290"
	},
	{
		"town": "mollymook",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "mologa",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "molong",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "moltema",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "molyullah",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "mon repos",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "mona vale",
		"state": "nsw",
		"postcode": "1658"
	},
	{
		"town": "mona vale",
		"state": "nsw",
		"postcode": "1660"
	},
	{
		"town": "mona vale",
		"state": "nsw",
		"postcode": "2103"
	},
	{
		"town": "monak",
		"state": "nsw",
		"postcode": "2738"
	},
	{
		"town": "monal",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "monaltrie",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "monarto",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "monarto south",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "monash",
		"state": "act",
		"postcode": "2904"
	},
	{
		"town": "monash",
		"state": "sa",
		"postcode": "5342"
	},
	{
		"town": "monash park",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "monash university",
		"state": "vic",
		"postcode": "3800"
	},
	{
		"town": "monbulk",
		"state": "vic",
		"postcode": "3793"
	},
	{
		"town": "moncrieff",
		"state": "act",
		"postcode": "2914"
	},
	{
		"town": "mondrook",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "monduran",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "mondure",
		"state": "qld",
		"postcode": "4611"
	},
	{
		"town": "monea",
		"state": "vic",
		"postcode": "3664"
	},
	{
		"town": "monegeetta",
		"state": "vic",
		"postcode": "3433"
	},
	{
		"town": "monegeetta north",
		"state": "vic",
		"postcode": "3434"
	},
	{
		"town": "monga",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "mongans bridge",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "mongarlowe",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "mongogarie",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "mongolata",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "monia gap",
		"state": "nsw",
		"postcode": "2675"
	},
	{
		"town": "monivae",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "monkerai",
		"state": "nsw",
		"postcode": "2415"
	},
	{
		"town": "monkey mia",
		"state": "wa",
		"postcode": "6537"
	},
	{
		"town": "monkland",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "monogorilby",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "monomeith",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "mons",
		"state": "qld",
		"postcode": "4556"
	},
	{
		"town": "monsildale",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "mont albert",
		"state": "vic",
		"postcode": "3127"
	},
	{
		"town": "mont albert north",
		"state": "vic",
		"postcode": "3129"
	},
	{
		"town": "montacute",
		"state": "sa",
		"postcode": "5134"
	},
	{
		"town": "montacute",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "montagu",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "montagu bay",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "montana",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "montarra",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "monteagle",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "montecollum",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "montefiores",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "monteith",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "montello",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "monterey",
		"state": "nsw",
		"postcode": "2217"
	},
	{
		"town": "monterey keys",
		"state": "qld",
		"postcode": "4212"
	},
	{
		"town": "montgomery",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "montmorency",
		"state": "vic",
		"postcode": "3094"
	},
	{
		"town": "monto",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "montrose",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "montrose",
		"state": "tas",
		"postcode": "7010"
	},
	{
		"town": "montrose",
		"state": "vic",
		"postcode": "3765"
	},
	{
		"town": "montumana",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "montville",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "monument creek",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "mooball",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "moobi",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "moockra",
		"state": "sa",
		"postcode": "5432"
	},
	{
		"town": "moodiarrup",
		"state": "wa",
		"postcode": "6393"
	},
	{
		"town": "moodinna",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "moodlu",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "moody",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "moogara",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "moogem",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "moogerah",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "mookerawa",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "mookima wybra",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "moolap",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "moolarben",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "moolawatana",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "moolboolaman",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "moolerr",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "mooliabeenee",
		"state": "wa",
		"postcode": "6504"
	},
	{
		"town": "mooloo",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "mooloolaba",
		"state": "qld",
		"postcode": "4557"
	},
	{
		"town": "mooloolah",
		"state": "qld",
		"postcode": "4553"
	},
	{
		"town": "mooloolah valley",
		"state": "qld",
		"postcode": "4553"
	},
	{
		"town": "moolort",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "moombekine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "moombooldool",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "moombra",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "moona plains",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "moonah",
		"state": "tas",
		"postcode": "7009"
	},
	{
		"town": "moonah",
		"state": "tas",
		"postcode": "7892"
	},
	{
		"town": "moonahcullah",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "moonambel",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "moonan brook",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "moonan flat",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "moonbah",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "moonbi",
		"state": "nsw",
		"postcode": "2353"
	},
	{
		"town": "moonbria",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "moondah",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "moondarra",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "moondooner",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "moondyne",
		"state": "wa",
		"postcode": "6567"
	},
	{
		"town": "mooneba",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "moonee beach",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "moonee ponds",
		"state": "vic",
		"postcode": "3039"
	},
	{
		"town": "mooney mooney",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "mooney mooney creek",
		"state": "nsw",
		"postcode": "2083"
	},
	{
		"town": "moonford",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "moongan",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "moonie",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "moonies hill",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "moonlight flat",
		"state": "vic",
		"postcode": "3450"
	},
	{
		"town": "moonlight flat",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "moonmera",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "moonta",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "moonta bay",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "moonta mines",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "moonyoonooka",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "moora",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "moora",
		"state": "wa",
		"postcode": "6510"
	},
	{
		"town": "moorabbin",
		"state": "vic",
		"postcode": "3189"
	},
	{
		"town": "moorabbin airport",
		"state": "vic",
		"postcode": "3194"
	},
	{
		"town": "moorabbin east",
		"state": "vic",
		"postcode": "3189"
	},
	{
		"town": "moorabool",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "moorak",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mooral creek",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "mooralla",
		"state": "vic",
		"postcode": "3314"
	},
	{
		"town": "moorang",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "moorbel",
		"state": "nsw",
		"postcode": "2804"
	},
	{
		"town": "moore",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "moore creek",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "moore park",
		"state": "nsw",
		"postcode": "1363"
	},
	{
		"town": "moore park",
		"state": "nsw",
		"postcode": "2021"
	},
	{
		"town": "moore park",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "moore river national park",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "moorebank",
		"state": "nsw",
		"postcode": "1875"
	},
	{
		"town": "moorebank",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "mooree",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "moores pocket",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "mooreville",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "mooreville road po",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "moorilda",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "moorilim",
		"state": "vic",
		"postcode": "3610"
	},
	{
		"town": "moorina",
		"state": "qld",
		"postcode": "4506"
	},
	{
		"town": "moorina",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "moorine rock",
		"state": "wa",
		"postcode": "6425"
	},
	{
		"town": "moorland",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "moorland",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "moorlands",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "moorleah",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "moormbool west",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "moorngag",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "moorong",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "mooroobool",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "moorooduc",
		"state": "vic",
		"postcode": "3933"
	},
	{
		"town": "moorook",
		"state": "sa",
		"postcode": "5332"
	},
	{
		"town": "moorook south",
		"state": "sa",
		"postcode": "5332"
	},
	{
		"town": "moorooka",
		"state": "qld",
		"postcode": "4105"
	},
	{
		"town": "moorookyle",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "mooroolbark",
		"state": "vic",
		"postcode": "3138"
	},
	{
		"town": "mooroopna",
		"state": "vic",
		"postcode": "3629"
	},
	{
		"town": "mooroopna north",
		"state": "vic",
		"postcode": "3629"
	},
	{
		"town": "mooroopna north west",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "moorundie",
		"state": "sa",
		"postcode": "5357"
	},
	{
		"town": "moorvale",
		"state": "qld",
		"postcode": "4105"
	},
	{
		"town": "moorwatha",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "mootai",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "mootatunga",
		"state": "sa",
		"postcode": "5307"
	},
	{
		"town": "moparrabah",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "moppa",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "moppy",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "moraby",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "morago",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "moranbah",
		"state": "qld",
		"postcode": "4744"
	},
	{
		"town": "moranding",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "morang south",
		"state": "vic",
		"postcode": "3752"
	},
	{
		"town": "morangarell",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "morangup",
		"state": "wa",
		"postcode": "6083"
	},
	{
		"town": "morans crossing",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "morawa",
		"state": "wa",
		"postcode": "6623"
	},
	{
		"town": "morayfield",
		"state": "qld",
		"postcode": "4506"
	},
	{
		"town": "morbinning",
		"state": "wa",
		"postcode": "6304"
	},
	{
		"town": "morchard",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "mordalup",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "mordialloc",
		"state": "vic",
		"postcode": "3195"
	},
	{
		"town": "mordialloc north",
		"state": "vic",
		"postcode": "3195"
	},
	{
		"town": "morea",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "moree",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "moree east",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "moreland",
		"state": "vic",
		"postcode": "3058"
	},
	{
		"town": "moreland west",
		"state": "vic",
		"postcode": "3055"
	},
	{
		"town": "morella",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "moresby",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "moresby",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "morgan",
		"state": "sa",
		"postcode": "5320"
	},
	{
		"town": "morgantown",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "morganville",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "morgiana",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "moriac",
		"state": "vic",
		"postcode": "3240"
	},
	{
		"town": "moriarty",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "morinish",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "morisset",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "morisset park",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "morley",
		"state": "wa",
		"postcode": "6062"
	},
	{
		"town": "morley",
		"state": "wa",
		"postcode": "6943"
	},
	{
		"town": "morning bay",
		"state": "nsw",
		"postcode": "2108"
	},
	{
		"town": "morningside",
		"state": "qld",
		"postcode": "4170"
	},
	{
		"town": "mornington",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "mornington",
		"state": "vic",
		"postcode": "3931"
	},
	{
		"town": "mornington",
		"state": "wa",
		"postcode": "6221"
	},
	{
		"town": "mornington island",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mororo",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "morpeth",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "morphett vale",
		"state": "sa",
		"postcode": "5162"
	},
	{
		"town": "morphettville",
		"state": "sa",
		"postcode": "5043"
	},
	{
		"town": "morrells hill",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "morrisons",
		"state": "vic",
		"postcode": "3334"
	},
	{
		"town": "morrl morrl",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "mortat",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "mortchup",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "mortdale",
		"state": "nsw",
		"postcode": "2223"
	},
	{
		"town": "mortlake",
		"state": "nsw",
		"postcode": "2137"
	},
	{
		"town": "mortlake",
		"state": "vic",
		"postcode": "3272"
	},
	{
		"town": "morton",
		"state": "nsw",
		"postcode": "2538"
	},
	{
		"town": "morton plains",
		"state": "vic",
		"postcode": "3482"
	},
	{
		"town": "morton vale",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "mortons creek",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "morundah",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "moruya",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "moruya heads",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "morven",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "morven",
		"state": "nsw",
		"postcode": "2660"
	},
	{
		"town": "morven",
		"state": "qld",
		"postcode": "4468"
	},
	{
		"town": "morven",
		"state": "vic",
		"postcode": "3302"
	},
	{
		"town": "morwell",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "morwell east",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "morwell river prison",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "morwell upper",
		"state": "vic",
		"postcode": "3840"
	},
	{
		"town": "morwincha",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "moseley",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "mosman",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "mosman park",
		"state": "wa",
		"postcode": "6012"
	},
	{
		"town": "mosman park",
		"state": "wa",
		"postcode": "6912"
	},
	{
		"town": "mosquito creek",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "mosquito creek",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "mosquito hill",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "moss vale",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "mossgiel",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "mossiface",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "mossman",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "mosstank",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "mossy point",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "mothar mountain",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "motley",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "moto",
		"state": "nsw",
		"postcode": "2426"
	},
	{
		"town": "motto farm",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "moulamein",
		"state": "nsw",
		"postcode": "2733"
	},
	{
		"town": "moulden",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "moulyinning",
		"state": "wa",
		"postcode": "6351"
	},
	{
		"town": "mount ada",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "mount adams",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "mount adrah",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "mount alford",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "mount alfred",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "mount alma",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "mount annan",
		"state": "nsw",
		"postcode": "2567"
	},
	{
		"town": "mount aquila",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "mount archer",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "mount arthur",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "mount austin",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "mount barker",
		"state": "sa",
		"postcode": "5251"
	},
	{
		"town": "mount barker",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "mount barney",
		"state": "qld",
		"postcode": "4287"
	},
	{
		"town": "mount barrow",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "mount beauty",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "mount beckworth",
		"state": "vic",
		"postcode": "3363"
	},
	{
		"town": "mount benson",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "mount beppo",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "mount berryman",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "mount best",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "mount binga",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "mount bolton",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mount bruno",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "mount bryan",
		"state": "sa",
		"postcode": "5418"
	},
	{
		"town": "mount bryan east",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "mount buffalo",
		"state": "vic",
		"postcode": "3740"
	},
	{
		"town": "mount buller",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "mount burnett",
		"state": "vic",
		"postcode": "3781"
	},
	{
		"town": "mount burr",
		"state": "sa",
		"postcode": "5279"
	},
	{
		"town": "mount burrell",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "mount bute",
		"state": "vic",
		"postcode": "3324"
	},
	{
		"town": "mount byron",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "mount camel",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "mount cameron",
		"state": "vic",
		"postcode": "3370"
	},
	{
		"town": "mount carbine",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mount caroline",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "mount chalmers",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "mount charles",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "mount charlton",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "mount christian",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "mount claremont",
		"state": "wa",
		"postcode": "6010"
	},
	{
		"town": "mount clarence",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "mount clear",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "mount colah",
		"state": "nsw",
		"postcode": "2079"
	},
	{
		"town": "mount cole creek",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "mount collins",
		"state": "nsw",
		"postcode": "2794"
	},
	{
		"town": "mount compass",
		"state": "sa",
		"postcode": "5210"
	},
	{
		"town": "mount cooke",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "mount coolon",
		"state": "qld",
		"postcode": "4804"
	},
	{
		"town": "mount coolum",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "mount cooper",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "mount cooper",
		"state": "sa",
		"postcode": "5671"
	},
	{
		"town": "mount coot-tha",
		"state": "qld",
		"postcode": "4066"
	},
	{
		"town": "mount cotton",
		"state": "qld",
		"postcode": "4165"
	},
	{
		"town": "mount cottrell",
		"state": "vic",
		"postcode": "3024"
	},
	{
		"town": "mount crawford",
		"state": "sa",
		"postcode": "5351"
	},
	{
		"town": "mount crosby",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "mount crystal",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "mount damper",
		"state": "sa",
		"postcode": "5654"
	},
	{
		"town": "mount dandenong",
		"state": "vic",
		"postcode": "3767"
	},
	{
		"town": "mount darragh",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "mount david",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "mount debateable",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "mount dee",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "mount direction",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "mount doran",
		"state": "vic",
		"postcode": "3334"
	},
	{
		"town": "mount druitt",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "mount druitt village",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "mount drummond",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "mount duneed",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "mount eccles",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "mount eccles south",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "mount eckersley",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "mount edwards",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "mount egerton",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mount eliza",
		"state": "vic",
		"postcode": "3930"
	},
	{
		"town": "mount elliot",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "mount elphinstone",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "mount emlyn",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "mount emu",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "mount enniskillen",
		"state": "qld",
		"postcode": "4472"
	},
	{
		"town": "mount erin",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "mount evelyn",
		"state": "vic",
		"postcode": "3796"
	},
	{
		"town": "mount fairy",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "mount fatigue",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "mount field",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "mount forbes",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "mount foster",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "mount fox",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "mount franklin",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "mount french",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "mount frome",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mount fyans",
		"state": "vic",
		"postcode": "3271"
	},
	{
		"town": "mount gambier",
		"state": "sa",
		"postcode": "5290"
	},
	{
		"town": "mount gambier",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mount gambier east",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mount gambier west",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mount gardiner",
		"state": "qld",
		"postcode": "4705"
	},
	{
		"town": "mount garnet",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "mount george",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "mount george",
		"state": "sa",
		"postcode": "5155"
	},
	{
		"town": "mount gibson",
		"state": "wa",
		"postcode": "6612"
	},
	{
		"town": "mount gipps",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "mount gipps",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "mount glorious",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "mount gravatt",
		"state": "qld",
		"postcode": "4122"
	},
	{
		"town": "mount gravatt east",
		"state": "qld",
		"postcode": "4122"
	},
	{
		"town": "mount hallen",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "mount hampton",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "mount hardey",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "mount harris",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "mount hawthorn",
		"state": "wa",
		"postcode": "6016"
	},
	{
		"town": "mount hawthorn",
		"state": "wa",
		"postcode": "6915"
	},
	{
		"town": "mount helen",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "mount helena",
		"state": "wa",
		"postcode": "6082"
	},
	{
		"town": "mount hicks",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "mount hill",
		"state": "wa",
		"postcode": "6528"
	},
	{
		"town": "mount holland",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "mount hooghly",
		"state": "vic",
		"postcode": "3472"
	},
	{
		"town": "mount hope",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "mount hope",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "mount horeb",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "mount horner",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "mount hotham",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "mount hunter",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "mount hurtle",
		"state": "sa",
		"postcode": "5162"
	},
	{
		"town": "mount hutton",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "mount irvine",
		"state": "nsw",
		"postcode": "2786"
	},
	{
		"town": "mount irving",
		"state": "qld",
		"postcode": "4401"
	},
	{
		"town": "mount isa",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "mount isa east",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "mount jackson",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "mount jagged",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "mount joy",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "mount jukes",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mount julian",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "mount keira",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "mount kembla",
		"state": "nsw",
		"postcode": "2526"
	},
	{
		"town": "mount knowles",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mount kokeby",
		"state": "wa",
		"postcode": "6304"
	},
	{
		"town": "mount kuring-gai",
		"state": "nsw",
		"postcode": "2080"
	},
	{
		"town": "mount kynoch",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "mount lambie",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "mount larcom",
		"state": "qld",
		"postcode": "4695"
	},
	{
		"town": "mount lawless",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "mount lawley",
		"state": "wa",
		"postcode": "6050"
	},
	{
		"town": "mount lawley",
		"state": "wa",
		"postcode": "6929"
	},
	{
		"town": "mount lewis",
		"state": "nsw",
		"postcode": "2190"
	},
	{
		"town": "mount lewis",
		"state": "nsw",
		"postcode": "2200"
	},
	{
		"town": "mount liebig",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "mount lindesay",
		"state": "qld",
		"postcode": "4287"
	},
	{
		"town": "mount lloyd",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "mount lofty",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "mount lofty",
		"state": "sa",
		"postcode": "5152"
	},
	{
		"town": "mount lonarch",
		"state": "vic",
		"postcode": "3468"
	},
	{
		"town": "mount louisa",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "mount low",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "mount luke",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "mount macedon",
		"state": "vic",
		"postcode": "3441"
	},
	{
		"town": "mount madden",
		"state": "wa",
		"postcode": "6356"
	},
	{
		"town": "mount magnet",
		"state": "wa",
		"postcode": "6638"
	},
	{
		"town": "mount magnificent",
		"state": "sa",
		"postcode": "5210"
	},
	{
		"town": "mount margaret",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "mount maria",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "mount marlow",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "mount marrow",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "mount marsden",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "mount marsh",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "mount marshall",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "mount martha",
		"state": "vic",
		"postcode": "3934"
	},
	{
		"town": "mount martin",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "mount mary",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "mount mccutcheon",
		"state": "tas",
		"postcode": "7466"
	},
	{
		"town": "mount mcdonald",
		"state": "nsw",
		"postcode": "2793"
	},
	{
		"town": "mount mceuen",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "mount mcintyre",
		"state": "sa",
		"postcode": "5279"
	},
	{
		"town": "mount mckenzie",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "mount mee",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "mount mellum",
		"state": "qld",
		"postcode": "4550"
	},
	{
		"town": "mount melville",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "mount mercer",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mount mitchell",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "mount mitchell",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mount molar",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "mount molloy",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mount monger",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "mount morgan",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "mount moriac",
		"state": "vic",
		"postcode": "3240"
	},
	{
		"town": "mount moriah",
		"state": "qld",
		"postcode": "4403"
	},
	{
		"town": "mount murchison",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "mount napier",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "mount nasura",
		"state": "wa",
		"postcode": "6112"
	},
	{
		"town": "mount nathan",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "mount nebo",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "mount nelson",
		"state": "tas",
		"postcode": "7007"
	},
	{
		"town": "mount nicholas",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "mount observation",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "mount observation",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "mount olive",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "mount olive",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "mount ommaney",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "mount osmond",
		"state": "sa",
		"postcode": "5064"
	},
	{
		"town": "mount ossa",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "mount ousley",
		"state": "nsw",
		"postcode": "2519"
	},
	{
		"town": "mount palmer",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "mount panorama",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "mount peerless",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "mount pelion",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "mount perry",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "mount pleasant",
		"state": "nsw",
		"postcode": "2519"
	},
	{
		"town": "mount pleasant",
		"state": "nsw",
		"postcode": "2749"
	},
	{
		"town": "mount pleasant",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "mount pleasant",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mount pleasant",
		"state": "sa",
		"postcode": "5235"
	},
	{
		"town": "mount pleasant",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "mount pleasant",
		"state": "wa",
		"postcode": "6153"
	},
	{
		"town": "mount pluto",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "mount pritchard",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "mount prospect",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "mount rae",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "mount rankin",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "mount rascal",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "mount richmond",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "mount rivers",
		"state": "nsw",
		"postcode": "2311"
	},
	{
		"town": "mount riverview",
		"state": "nsw",
		"postcode": "2774"
	},
	{
		"town": "mount rooper",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "mount rouse",
		"state": "vic",
		"postcode": "3289"
	},
	{
		"town": "mount rowan",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "mount royal",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "mount rumney",
		"state": "tas",
		"postcode": "7170"
	},
	{
		"town": "mount russell",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "mount sabine",
		"state": "vic",
		"postcode": "3236"
	},
	{
		"town": "mount saint thomas",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "mount samson",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "mount schank",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "mount scobie",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "mount seymour",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "mount sheila",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "mount slide",
		"state": "vic",
		"postcode": "3763"
	},
	{
		"town": "mount stanley",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "mount steadman",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "mount stirling",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "mount stromlo",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "mount stuart",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "mount stuart",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "mount surprise",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mount surround",
		"state": "qld",
		"postcode": "4809"
	},
	{
		"town": "mount sylvia",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "mount talbot",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "mount tamborine",
		"state": "qld",
		"postcode": "4272"
	},
	{
		"town": "mount tarampa",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "mount tarcoola",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "mount taylor",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "mount templeton",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "mount thompson",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "mount thorley",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "mount tom",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "mount torrens",
		"state": "sa",
		"postcode": "5244"
	},
	{
		"town": "mount tyson",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "mount urah",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "mount vernon",
		"state": "nsw",
		"postcode": "2759"
	},
	{
		"town": "mount vernon",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "mount victoria",
		"state": "nsw",
		"postcode": "2786"
	},
	{
		"town": "mount view",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "mount vincent",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "mount vincent",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mount violet",
		"state": "vic",
		"postcode": "3272"
	},
	{
		"town": "mount walker",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "mount walker",
		"state": "wa",
		"postcode": "6369"
	},
	{
		"town": "mount wallace",
		"state": "vic",
		"postcode": "3342"
	},
	{
		"town": "mount warning",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "mount warren park",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "mount warrigal",
		"state": "nsw",
		"postcode": "2528"
	},
	{
		"town": "mount waverley",
		"state": "vic",
		"postcode": "3149"
	},
	{
		"town": "mount wedge",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "mount werong",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "mount white",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "mount whitestone",
		"state": "qld",
		"postcode": "4347"
	},
	{
		"town": "mount william",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "mount wilson",
		"state": "nsw",
		"postcode": "2786"
	},
	{
		"town": "mountain bay",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "mountain camp",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "mountain creek",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "mountain creek",
		"state": "nsw",
		"postcode": "2660"
	},
	{
		"town": "mountain creek",
		"state": "qld",
		"postcode": "4557"
	},
	{
		"town": "mountain gate",
		"state": "vic",
		"postcode": "3156"
	},
	{
		"town": "mountain river",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "mountain top",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "mountain view",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "mountain view",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "mountain view",
		"state": "vic",
		"postcode": "3988"
	},
	{
		"town": "moura",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "mourilyan",
		"state": "qld",
		"postcode": "4858"
	},
	{
		"town": "mourquong",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "moutajup",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "mowbray",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "mowbray",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "mowbray heights",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "mowbray park",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "moyarra",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "moyhu",
		"state": "vic",
		"postcode": "3732"
	},
	{
		"town": "moyne siding",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "moyne view",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "moyreisk",
		"state": "vic",
		"postcode": "3467"
	},
	{
		"town": "moyston",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "mozart",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "mp creek",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "mt baw baw",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "mt britton",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "muchea",
		"state": "wa",
		"postcode": "6501"
	},
	{
		"town": "muckadilla",
		"state": "qld",
		"postcode": "4461"
	},
	{
		"town": "muckatah",
		"state": "vic",
		"postcode": "3644"
	},
	{
		"town": "muckaty station",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "muckenburra",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "muckleford",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "muckleford south",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "mudamuckla",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "mudgee",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mudgeeraba",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "mudgegonga",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "mudjimba",
		"state": "qld",
		"postcode": "4564"
	},
	{
		"town": "mudlo",
		"state": "qld",
		"postcode": "4600"
	},
	{
		"town": "mugincoble",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "muirlea",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "mukinbudin",
		"state": "wa",
		"postcode": "6479"
	},
	{
		"town": "mulambin",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "mulanggarri",
		"state": "act",
		"postcode": "2914"
	},
	{
		"town": "mulara",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "mulataga",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "mulbring",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "muldiva",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "mulga bore",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "mulga downs",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "mulgildie",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "mulgoa",
		"state": "nsw",
		"postcode": "2745"
	},
	{
		"town": "mulgowie",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "mulgowrie",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "mulgrave",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "mulgrave",
		"state": "vic",
		"postcode": "3170"
	},
	{
		"town": "mulgrave island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "mulgundawa",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "mulguthrie",
		"state": "nsw",
		"postcode": "2877"
	},
	{
		"town": "mulla creek",
		"state": "nsw",
		"postcode": "2352"
	},
	{
		"town": "mullaley",
		"state": "nsw",
		"postcode": "2379"
	},
	{
		"town": "mullaloo",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "mullalyup",
		"state": "wa",
		"postcode": "6252"
	},
	{
		"town": "mullamuddy",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mullaway",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "mullengandra",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "mullengudgery",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "mullewa",
		"state": "wa",
		"postcode": "6630"
	},
	{
		"town": "mullingar",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "mullins",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "mullion creek",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "mulloon",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "mullumbimby",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "mullumbimby creek",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "muluckine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "mulwala",
		"state": "nsw",
		"postcode": "2647"
	},
	{
		"town": "mulyandry",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "mumballup",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "mumbannar",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "mumbil",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "mumblebone plain",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "mumbulla mountain",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "mummel",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "mummulgum",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "munbilla",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "munbura",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "mundabullangana",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "mundaring",
		"state": "wa",
		"postcode": "6073"
	},
	{
		"town": "mundaring weir",
		"state": "wa",
		"postcode": "6073"
	},
	{
		"town": "mundarlo",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "munderoo",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "mundic creek",
		"state": "sa",
		"postcode": "5340"
	},
	{
		"town": "mundijong",
		"state": "wa",
		"postcode": "6123"
	},
	{
		"town": "mundingburra",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "mundiwindi",
		"state": "wa",
		"postcode": "6753"
	},
	{
		"town": "mundongo",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "mundoo",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "mundoo island",
		"state": "sa",
		"postcode": "5214"
	},
	{
		"town": "mundoolun",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "mundoona",
		"state": "vic",
		"postcode": "3635"
	},
	{
		"town": "mundoora",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "mundowran",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "mundrabilla",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "mundubbera",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "mundulla",
		"state": "sa",
		"postcode": "5270"
	},
	{
		"town": "mungabunda",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "mungallala",
		"state": "qld",
		"postcode": "4467"
	},
	{
		"town": "mungar",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "mungay creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "mungery",
		"state": "nsw",
		"postcode": "2869"
	},
	{
		"town": "munghorn",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "mungindi",
		"state": "nsw",
		"postcode": "2406"
	},
	{
		"town": "mungle",
		"state": "nsw",
		"postcode": "2408"
	},
	{
		"town": "munglinup",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "mungungo",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "mungy",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "munna creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "munna point",
		"state": "qld",
		"postcode": "4566"
	},
	{
		"town": "munni",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "munno para",
		"state": "sa",
		"postcode": "5115"
	},
	{
		"town": "munno para downs",
		"state": "sa",
		"postcode": "5115"
	},
	{
		"town": "munno para west",
		"state": "sa",
		"postcode": "5115"
	},
	{
		"town": "munro",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "munruben",
		"state": "qld",
		"postcode": "4125"
	},
	{
		"town": "munster",
		"state": "wa",
		"postcode": "6166"
	},
	{
		"town": "muntadgin",
		"state": "wa",
		"postcode": "6420"
	},
	{
		"town": "muntham",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "munyabla",
		"state": "nsw",
		"postcode": "2658"
	},
	{
		"town": "muradup",
		"state": "wa",
		"postcode": "6394"
	},
	{
		"town": "murarrie",
		"state": "qld",
		"postcode": "4172"
	},
	{
		"town": "murbko",
		"state": "sa",
		"postcode": "5320"
	},
	{
		"town": "murchison",
		"state": "vic",
		"postcode": "3610"
	},
	{
		"town": "murchison",
		"state": "wa",
		"postcode": "6630"
	},
	{
		"town": "murchison east",
		"state": "vic",
		"postcode": "3610"
	},
	{
		"town": "murchison north",
		"state": "vic",
		"postcode": "3610"
	},
	{
		"town": "murdinga",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "murdoch",
		"state": "vic",
		"postcode": "3677"
	},
	{
		"town": "murdoch",
		"state": "wa",
		"postcode": "6150"
	},
	{
		"town": "murdunna",
		"state": "tas",
		"postcode": "7178"
	},
	{
		"town": "muresk",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "murga",
		"state": "nsw",
		"postcode": "2864"
	},
	{
		"town": "murgheboluc",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "murgon",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "muriel",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "murlong",
		"state": "sa",
		"postcode": "5642"
	},
	{
		"town": "murmungee",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "muronbung",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "murphy lake",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "murphys creek",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "murphys creek",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "murputja homelands",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "murra warra",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "murrabit",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "murrabit west",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "murragamba",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "murrah",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "murrami",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "murrawee",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "murrawong",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "murray",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "murray bridge",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "murray bridge",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "murray bridge east",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "murray bridge north",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "murray bridge south",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "murray downs",
		"state": "nsw",
		"postcode": "3585"
	},
	{
		"town": "murray gorge",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "murray island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "murray lock no 9",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "murray town",
		"state": "sa",
		"postcode": "5481"
	},
	{
		"town": "murray upper",
		"state": "qld",
		"postcode": "4854"
	},
	{
		"town": "murraydale",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "murrays bridge",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "murrays flats",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "murrayville",
		"state": "vic",
		"postcode": "3512"
	},
	{
		"town": "murrengenburg",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "murrin bridge",
		"state": "nsw",
		"postcode": "2672"
	},
	{
		"town": "murrin murrin",
		"state": "wa",
		"postcode": "6438"
	},
	{
		"town": "murrindal",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "murrindindi",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "murringo",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "murroon",
		"state": "vic",
		"postcode": "3243"
	},
	{
		"town": "murrulebale",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "murrumba",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "murrumba downs",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "murrumbateman",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "murrumbeena",
		"state": "vic",
		"postcode": "3163"
	},
	{
		"town": "murrumbo",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "murrumbucca",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "murrumburrah",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "murrungower lower",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "murrurundi",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "murtho",
		"state": "sa",
		"postcode": "5340"
	},
	{
		"town": "murtoa",
		"state": "vic",
		"postcode": "3390"
	},
	{
		"town": "murwillumbah",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "murwillumbah south",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "muscle creek",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "musgroves",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "musk",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "musk vale",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "muskerry",
		"state": "vic",
		"postcode": "3557"
	},
	{
		"town": "muskerry east",
		"state": "vic",
		"postcode": "3557"
	},
	{
		"town": "musselboro",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "musselroe bay",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "muston",
		"state": "sa",
		"postcode": "5221"
	},
	{
		"town": "muswellbrook",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "mutarnee",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "mutchilba",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "mutdapilly",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "muttaburra",
		"state": "qld",
		"postcode": "4732"
	},
	{
		"town": "muttama",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "myall",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "myall creek",
		"state": "nsw",
		"postcode": "2403"
	},
	{
		"town": "myall park",
		"state": "nsw",
		"postcode": "2681"
	},
	{
		"town": "myall park",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "myalla",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "myalla",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "myalup",
		"state": "wa",
		"postcode": "6220"
	},
	{
		"town": "myambat",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "myamyn",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "myara",
		"state": "wa",
		"postcode": "6207"
	},
	{
		"town": "myaree",
		"state": "wa",
		"postcode": "6154"
	},
	{
		"town": "myers flat",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "mylestom",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "mylneford",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "mylor",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "myocum",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "myola",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "myola",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "myola",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "myola east",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "mypolonga",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "myponga",
		"state": "sa",
		"postcode": "5202"
	},
	{
		"town": "myponga beach",
		"state": "sa",
		"postcode": "5202"
	},
	{
		"town": "myra vale",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "myrniong",
		"state": "vic",
		"postcode": "3341"
	},
	{
		"town": "myrrhee",
		"state": "vic",
		"postcode": "3732"
	},
	{
		"town": "myrtle bank",
		"state": "sa",
		"postcode": "5064"
	},
	{
		"town": "myrtle bank",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "myrtle creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "myrtle creek",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "myrtle mountain",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "myrtle park",
		"state": "nsw",
		"postcode": "2713"
	},
	{
		"town": "myrtlebank",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "myrtleford",
		"state": "vic",
		"postcode": "3736"
	},
	{
		"town": "myrtleford",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "myrtletown",
		"state": "qld",
		"postcode": "4008"
	},
	{
		"town": "myrtlevale",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "mysia",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "mysterton",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "mystery bay",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "mystic park",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "myuna bay",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "mywee",
		"state": "vic",
		"postcode": "3641"
	},
	{
		"town": "nabageena",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "nabawa",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "nabiac",
		"state": "nsw",
		"postcode": "2312"
	},
	{
		"town": "nabowla",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "nackara",
		"state": "sa",
		"postcode": "5440"
	},
	{
		"town": "nacurrie",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "nadia",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "nagambie",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "nagoorin",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "naidia",
		"state": "sa",
		"postcode": "5354"
	},
	{
		"town": "nailsworth",
		"state": "sa",
		"postcode": "5083"
	},
	{
		"town": "nain",
		"state": "sa",
		"postcode": "5360"
	},
	{
		"town": "nairibin",
		"state": "wa",
		"postcode": "6350"
	},
	{
		"town": "nairne",
		"state": "sa",
		"postcode": "5252"
	},
	{
		"town": "nakara",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "nala",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "nalangil",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "naldera",
		"state": "vic",
		"postcode": "3530"
	},
	{
		"town": "nalinga",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "nalkain",
		"state": "wa",
		"postcode": "6485"
	},
	{
		"town": "nalpa",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "nalya",
		"state": "wa",
		"postcode": "6306"
	},
	{
		"town": "nalyappa",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "namban",
		"state": "wa",
		"postcode": "6512"
	},
	{
		"town": "nambeelup",
		"state": "wa",
		"postcode": "6207"
	},
	{
		"town": "nambour",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "nambour west",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "nambrok",
		"state": "vic",
		"postcode": "3847"
	},
	{
		"town": "nambucca heads",
		"state": "nsw",
		"postcode": "2448"
	},
	{
		"town": "nana glen",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "nanami",
		"state": "nsw",
		"postcode": "2806"
	},
	{
		"town": "nanango",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "nanangroe",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "nanardine",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "nanarup",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "nandaly",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "nanga brook",
		"state": "wa",
		"postcode": "6215"
	},
	{
		"town": "nangana",
		"state": "vic",
		"postcode": "3781"
	},
	{
		"town": "nangari",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "nangeela",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "nangeenan",
		"state": "wa",
		"postcode": "6414"
	},
	{
		"town": "nangiloc",
		"state": "vic",
		"postcode": "3494"
	},
	{
		"town": "nangkita",
		"state": "sa",
		"postcode": "5210"
	},
	{
		"town": "nangram",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "nangus",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "nangwarry",
		"state": "sa",
		"postcode": "5277"
	},
	{
		"town": "nangwee",
		"state": "qld",
		"postcode": "4407"
	},
	{
		"town": "nanima",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "nankin",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "nanneella",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "nannup",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "nanson",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "nantawarra",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "nanum",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "nanutarra",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "napier",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "napoleon reef",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "napoleons",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "napperby",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "nar nar goon",
		"state": "vic",
		"postcode": "3812"
	},
	{
		"town": "nar nar goon north",
		"state": "vic",
		"postcode": "3812"
	},
	{
		"town": "naracoopa",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "naracoorte",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "naradhan",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "naraling",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "narangba",
		"state": "qld",
		"postcode": "4504"
	},
	{
		"town": "narara",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "narbethong",
		"state": "vic",
		"postcode": "3778"
	},
	{
		"town": "nardoo siding",
		"state": "qld",
		"postcode": "4471"
	},
	{
		"town": "nareeb",
		"state": "vic",
		"postcode": "3293"
	},
	{
		"town": "nareen",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "nareewillock",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "narellan",
		"state": "nsw",
		"postcode": "2567"
	},
	{
		"town": "narellan vale",
		"state": "nsw",
		"postcode": "2567"
	},
	{
		"town": "narembeen",
		"state": "wa",
		"postcode": "6369"
	},
	{
		"town": "naremburn",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "nariel valley",
		"state": "vic",
		"postcode": "3705"
	},
	{
		"town": "naring",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "naringal",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "naringal east",
		"state": "vic",
		"postcode": "3277"
	},
	{
		"town": "naringhil south",
		"state": "vic",
		"postcode": "3323"
	},
	{
		"town": "narioka",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "narngulu",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "naroghid",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "narone creek",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "narooma",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "narra tarra",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "narrabarba",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "narrabeen",
		"state": "nsw",
		"postcode": "2101"
	},
	{
		"town": "narrabeen peninsula",
		"state": "nsw",
		"postcode": "2101"
	},
	{
		"town": "narrabri",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "narrabri west",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "narrabundah",
		"state": "act",
		"postcode": "2604"
	},
	{
		"town": "narraburra",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "narracan",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "narragon beach",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "narrakine",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "narraloggan",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "narrambla",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "narrandera",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "narraport",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "narrapumelap south",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "narrawa",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "narrawa",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "narrawallee",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "narraweena",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "narrawong",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "narre warren",
		"state": "vic",
		"postcode": "3805"
	},
	{
		"town": "narre warren east",
		"state": "vic",
		"postcode": "3804"
	},
	{
		"town": "narre warren north",
		"state": "vic",
		"postcode": "3804"
	},
	{
		"town": "narre warren south",
		"state": "vic",
		"postcode": "3805"
	},
	{
		"town": "narridy",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "narrikup",
		"state": "wa",
		"postcode": "6326"
	},
	{
		"town": "narrogin",
		"state": "wa",
		"postcode": "6312"
	},
	{
		"town": "narromine",
		"state": "nsw",
		"postcode": "2821"
	},
	{
		"town": "narrung",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "narrung",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "narwee",
		"state": "nsw",
		"postcode": "2209"
	},
	{
		"town": "nashdale",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "nashua",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "nashville",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "nathalia",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "nathan",
		"state": "qld",
		"postcode": "4111"
	},
	{
		"town": "natimuk",
		"state": "vic",
		"postcode": "3409"
	},
	{
		"town": "national park",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "natone",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "nattai",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "natte yallock",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "natural bridge",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "naturaliste",
		"state": "wa",
		"postcode": "6281"
	},
	{
		"town": "natya",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "naughtons gap",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "naval base",
		"state": "wa",
		"postcode": "6165"
	},
	{
		"town": "navarre",
		"state": "vic",
		"postcode": "3384"
	},
	{
		"town": "navigators",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "nayook",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "nea",
		"state": "nsw",
		"postcode": "2381"
	},
	{
		"town": "neale",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "neales flat",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "nearum",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "neath",
		"state": "nsw",
		"postcode": "2326"
	},
	{
		"town": "nebo",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "nectar brook",
		"state": "sa",
		"postcode": "5495"
	},
	{
		"town": "nedlands",
		"state": "wa",
		"postcode": "6009"
	},
	{
		"town": "nedlands",
		"state": "wa",
		"postcode": "6907"
	},
	{
		"town": "nedlands",
		"state": "wa",
		"postcode": "6909"
	},
	{
		"town": "neds corner",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "needilup",
		"state": "wa",
		"postcode": "6336"
	},
	{
		"town": "needles",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "neerabup",
		"state": "wa",
		"postcode": "6031"
	},
	{
		"town": "neerdie",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "neereman",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "neergabby",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "neerim",
		"state": "vic",
		"postcode": "3831"
	},
	{
		"town": "neerim east",
		"state": "vic",
		"postcode": "3831"
	},
	{
		"town": "neerim junction",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "neerim north",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "neerim south",
		"state": "vic",
		"postcode": "3831"
	},
	{
		"town": "neika",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "neilborough",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "neilrex",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "nelangie",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "nelia",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "nelligen",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "nelly bay",
		"state": "qld",
		"postcode": "4819"
	},
	{
		"town": "nelshaby",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "nelson",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "nelson",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "nelson",
		"state": "vic",
		"postcode": "3292"
	},
	{
		"town": "nelson",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "nelson bay",
		"state": "nsw",
		"postcode": "2315"
	},
	{
		"town": "nelsons plains",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "nelungaloo",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "nembudding",
		"state": "wa",
		"postcode": "6485"
	},
	{
		"town": "nemingha",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "nene",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "nepean",
		"state": "wa",
		"postcode": "6429"
	},
	{
		"town": "nepean bay",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "nerang",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "neranwood",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "nericon",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "neridup",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "nerimbera",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "neringla",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "neringla",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "nerong",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "nerrena",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "nerrena east",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "nerriga",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "nerrigundah",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "nerrin nerrin",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "nerrina",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "nerring",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "netherby",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "netherby",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "nethercote",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "netherdale",
		"state": "qld",
		"postcode": "4756"
	},
	{
		"town": "netley",
		"state": "sa",
		"postcode": "5037"
	},
	{
		"town": "neumgna",
		"state": "qld",
		"postcode": "4614"
	},
	{
		"town": "neurea",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "neurum",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "neutral bay",
		"state": "nsw",
		"postcode": "2089"
	},
	{
		"town": "neutral bay junction",
		"state": "nsw",
		"postcode": "1646"
	},
	{
		"town": "neutral bay junction",
		"state": "nsw",
		"postcode": "2089"
	},
	{
		"town": "nevertire",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "neville",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "nevilton",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "new auckland",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "new beith",
		"state": "qld",
		"postcode": "4124"
	},
	{
		"town": "new berrima",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "new brighton",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "new buildings",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "new chum",
		"state": "qld",
		"postcode": "4303"
	},
	{
		"town": "new farm",
		"state": "qld",
		"postcode": "4005"
	},
	{
		"town": "new gisborne",
		"state": "vic",
		"postcode": "3438"
	},
	{
		"town": "new italy",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "new lambton",
		"state": "nsw",
		"postcode": "2305"
	},
	{
		"town": "new lambton heights",
		"state": "nsw",
		"postcode": "2305"
	},
	{
		"town": "new mapoon",
		"state": "qld",
		"postcode": "4876"
	},
	{
		"town": "new mollyan",
		"state": "nsw",
		"postcode": "2842"
	},
	{
		"town": "new moonta",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "new norcia",
		"state": "wa",
		"postcode": "6509"
	},
	{
		"town": "new norfolk",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "new residence",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "new town",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "new town",
		"state": "tas",
		"postcode": "7008"
	},
	{
		"town": "new valley",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "new well",
		"state": "sa",
		"postcode": "5357"
	},
	{
		"town": "newbold",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "newborough",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "newborough east",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "newbridge",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "newbridge",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "newbury",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "newcarlbeon",
		"state": "wa",
		"postcode": "6475"
	},
	{
		"town": "newcastle",
		"state": "nsw",
		"postcode": "2300"
	},
	{
		"town": "newcastle east",
		"state": "nsw",
		"postcode": "2300"
	},
	{
		"town": "newcastle university",
		"state": "nsw",
		"postcode": "2308"
	},
	{
		"town": "newcastle waters",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "newcastle west",
		"state": "nsw",
		"postcode": "2302"
	},
	{
		"town": "newcomb",
		"state": "vic",
		"postcode": "3219"
	},
	{
		"town": "newdegate",
		"state": "wa",
		"postcode": "6355"
	},
	{
		"town": "newee creek",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "newell",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "newfield",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "newham",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "newhaven",
		"state": "vic",
		"postcode": "3925"
	},
	{
		"town": "newington",
		"state": "nsw",
		"postcode": "1822"
	},
	{
		"town": "newington",
		"state": "nsw",
		"postcode": "2127"
	},
	{
		"town": "newington",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "newland",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "newlands",
		"state": "wa",
		"postcode": "6251"
	},
	{
		"town": "newlands arm",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "newley",
		"state": "nsw",
		"postcode": "2386"
	},
	{
		"town": "newling",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "newlyn",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "newlyn north",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "newman",
		"state": "wa",
		"postcode": "6753"
	},
	{
		"town": "newmarket",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "newmerella",
		"state": "vic",
		"postcode": "3886"
	},
	{
		"town": "newnes",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "newnes junction",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "newnham",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "newport",
		"state": "nsw",
		"postcode": "2106"
	},
	{
		"town": "newport",
		"state": "vic",
		"postcode": "3015"
	},
	{
		"town": "newport beach",
		"state": "nsw",
		"postcode": "2106"
	},
	{
		"town": "newry",
		"state": "vic",
		"postcode": "3859"
	},
	{
		"town": "newrybar",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "newstead",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "newstead",
		"state": "qld",
		"postcode": "4006"
	},
	{
		"town": "newstead",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "newstead",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "newton",
		"state": "sa",
		"postcode": "5074"
	},
	{
		"town": "newton boyd",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "newtown",
		"state": "nsw",
		"postcode": "2042"
	},
	{
		"town": "newtown",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "newtown",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "newtown",
		"state": "vic",
		"postcode": "3220"
	},
	{
		"town": "newtown",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "ngapala",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "ngarkat",
		"state": "sa",
		"postcode": "5302"
	},
	{
		"town": "nguiu",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "ngukurr",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "ngunnawal",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "nhill",
		"state": "vic",
		"postcode": "3418"
	},
	{
		"town": "nhulunbuy",
		"state": "nt",
		"postcode": "880"
	},
	{
		"town": "nhulunbuy",
		"state": "nt",
		"postcode": "881"
	},
	{
		"town": "niagara park",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "niangala",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "nicholls",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "nicholls rivulet",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "nichols point",
		"state": "vic",
		"postcode": "3501"
	},
	{
		"town": "nicholson",
		"state": "vic",
		"postcode": "3882"
	},
	{
		"town": "nickol",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "niddrie",
		"state": "vic",
		"postcode": "3042"
	},
	{
		"town": "niemur",
		"state": "nsw",
		"postcode": "2733"
	},
	{
		"town": "nierinna",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "nietta",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "nightcliff",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "nightcliff",
		"state": "nt",
		"postcode": "814"
	},
	{
		"town": "nigretta",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "nikenbah",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "nildottie",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "nile",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "nilgen",
		"state": "wa",
		"postcode": "6044"
	},
	{
		"town": "nillahcootie",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "nillahcootie dam",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "nillup",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "nilma",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "nilma north",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "nimbin",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "nimmitabel",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "nimmo",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "ninda",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "nindaroo",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "ninderry",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "nindooinbah",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "nine mile",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "nine mile creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "ningaloo",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "ningi",
		"state": "qld",
		"postcode": "4511"
	},
	{
		"town": "ninnes",
		"state": "sa",
		"postcode": "5560"
	},
	{
		"town": "nintingbool",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "ninyeunook",
		"state": "vic",
		"postcode": "3540"
	},
	{
		"town": "nirimba",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "nirranda",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "nirranda east",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "nirranda south",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "noarlunga centre",
		"state": "sa",
		"postcode": "5168"
	},
	{
		"town": "noarlunga downs",
		"state": "sa",
		"postcode": "5168"
	},
	{
		"town": "nobby",
		"state": "qld",
		"postcode": "4360"
	},
	{
		"town": "nobby beach",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "nobbys creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "noble park",
		"state": "vic",
		"postcode": "3174"
	},
	{
		"town": "noble park east",
		"state": "vic",
		"postcode": "3174"
	},
	{
		"town": "noble park north",
		"state": "vic",
		"postcode": "3174"
	},
	{
		"town": "noggabri",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "noggerup",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "nokaning",
		"state": "wa",
		"postcode": "6415"
	},
	{
		"town": "nolba",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "nollamara",
		"state": "wa",
		"postcode": "6061"
	},
	{
		"town": "nomans lake",
		"state": "wa",
		"postcode": "6312"
	},
	{
		"town": "nome",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "nonda",
		"state": "qld",
		"postcode": "4822"
	},
	{
		"town": "nonning",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "noojee",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "nook",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "noombling",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "noona",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "noonamah",
		"state": "nt",
		"postcode": "837"
	},
	{
		"town": "noonbinna",
		"state": "nsw",
		"postcode": "2794"
	},
	{
		"town": "noongaar",
		"state": "wa",
		"postcode": "6424"
	},
	{
		"town": "noongar",
		"state": "wa",
		"postcode": "6428"
	},
	{
		"town": "noora",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "nooramunga",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "noorat",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "noorat east",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "noorinbee",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "noorinbee north",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "noorlah",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "noorong",
		"state": "nsw",
		"postcode": "2732"
	},
	{
		"town": "nooroo",
		"state": "nsw",
		"postcode": "2415"
	},
	{
		"town": "noosa heads",
		"state": "qld",
		"postcode": "4567"
	},
	{
		"town": "noosaville",
		"state": "qld",
		"postcode": "4566"
	},
	{
		"town": "nora creina",
		"state": "sa",
		"postcode": "5276"
	},
	{
		"town": "noradjuha",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "norah head",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "noranda",
		"state": "wa",
		"postcode": "6062"
	},
	{
		"town": "noraville",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "nords wharf",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "norfolk island",
		"state": "nsw",
		"postcode": "2899"
	},
	{
		"town": "norlane",
		"state": "vic",
		"postcode": "3214"
	},
	{
		"town": "norman gardens",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "norman park",
		"state": "qld",
		"postcode": "4170"
	},
	{
		"town": "normanby",
		"state": "qld",
		"postcode": "4059"
	},
	{
		"town": "normanhurst",
		"state": "nsw",
		"postcode": "2076"
	},
	{
		"town": "normanton",
		"state": "qld",
		"postcode": "4890"
	},
	{
		"town": "normanville",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "normanville",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "nornalup",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "norong",
		"state": "vic",
		"postcode": "3682"
	},
	{
		"town": "norong central",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "norseman",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "north adelaide",
		"state": "sa",
		"postcode": "5006"
	},
	{
		"town": "north adelaide melbourne st",
		"state": "sa",
		"postcode": "5006"
	},
	{
		"town": "north albury",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "north aramara",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "north arm",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "north arm",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "north arm cove",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "north avoca",
		"state": "nsw",
		"postcode": "2260"
	},
	{
		"town": "north baandee",
		"state": "wa",
		"postcode": "6412"
	},
	{
		"town": "north balgowlah",
		"state": "nsw",
		"postcode": "2093"
	},
	{
		"town": "north bannister",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "north batemans bay",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "north beach",
		"state": "sa",
		"postcode": "5556"
	},
	{
		"town": "north beach",
		"state": "wa",
		"postcode": "6020"
	},
	{
		"town": "north beach",
		"state": "wa",
		"postcode": "6920"
	},
	{
		"town": "north bendigo",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "north blackwood",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "north boambee valley",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "north bodallin",
		"state": "wa",
		"postcode": "6424"
	},
	{
		"town": "north bondi",
		"state": "nsw",
		"postcode": "2026"
	},
	{
		"town": "north booborowie",
		"state": "sa",
		"postcode": "5417"
	},
	{
		"town": "north booval",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "north boyanup",
		"state": "wa",
		"postcode": "6237"
	},
	{
		"town": "north branch",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "north brighton",
		"state": "sa",
		"postcode": "5048"
	},
	{
		"town": "north brother",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "north bruny",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "north bungunya",
		"state": "qld",
		"postcode": "4494"
	},
	{
		"town": "north cairns",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "north cape",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "north casino",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "north curl curl",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "north dandalup",
		"state": "wa",
		"postcode": "6207"
	},
	{
		"town": "north epping",
		"state": "nsw",
		"postcode": "2121"
	},
	{
		"town": "north eton",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "north fremantle",
		"state": "wa",
		"postcode": "6159"
	},
	{
		"town": "north geelong",
		"state": "vic",
		"postcode": "3215"
	},
	{
		"town": "north gosford",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "north greenbushes",
		"state": "wa",
		"postcode": "6254"
	},
	{
		"town": "north gregory",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "north gregory",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "north haven",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "north haven",
		"state": "sa",
		"postcode": "5018"
	},
	{
		"town": "north hill",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "north hobart",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "north hobart",
		"state": "tas",
		"postcode": "7002"
	},
	{
		"town": "north ipswich",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "north isis",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "north jindong",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "north kellerberrin",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "north lake",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "north lambton",
		"state": "nsw",
		"postcode": "2299"
	},
	{
		"town": "north lilydale",
		"state": "tas",
		"postcode": "7268"
	},
	{
		"town": "north lismore",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "north mackay",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "north maclean",
		"state": "qld",
		"postcode": "4280"
	},
	{
		"town": "north maleny",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "north manly",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "north melbourne",
		"state": "vic",
		"postcode": "3051"
	},
	{
		"town": "north melbourne",
		"state": "vic",
		"postcode": "8500"
	},
	{
		"town": "north moonta",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "north motton",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "north narooma",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "north narrabeen",
		"state": "nsw",
		"postcode": "2101"
	},
	{
		"town": "north parramatta",
		"state": "nsw",
		"postcode": "1750"
	},
	{
		"town": "north parramatta",
		"state": "nsw",
		"postcode": "2151"
	},
	{
		"town": "north perth",
		"state": "wa",
		"postcode": "6006"
	},
	{
		"town": "north perth",
		"state": "wa",
		"postcode": "6906"
	},
	{
		"town": "north pindimar",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "north plantations",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "north plympton",
		"state": "sa",
		"postcode": "5037"
	},
	{
		"town": "north richmond",
		"state": "nsw",
		"postcode": "2754"
	},
	{
		"town": "north road",
		"state": "vic",
		"postcode": "3187"
	},
	{
		"town": "north rockhampton",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "north rocks",
		"state": "nsw",
		"postcode": "2151"
	},
	{
		"town": "north rothbury",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "north ryde",
		"state": "nsw",
		"postcode": "2113"
	},
	{
		"town": "north shields",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "north shore",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "north shore",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "north shore",
		"state": "vic",
		"postcode": "3214"
	},
	{
		"town": "north st ives",
		"state": "nsw",
		"postcode": "2075"
	},
	{
		"town": "north st marys",
		"state": "nsw",
		"postcode": "2760"
	},
	{
		"town": "north star",
		"state": "nsw",
		"postcode": "2408"
	},
	{
		"town": "north strathfield",
		"state": "nsw",
		"postcode": "2137"
	},
	{
		"town": "north sydney",
		"state": "nsw",
		"postcode": "2055"
	},
	{
		"town": "north sydney",
		"state": "nsw",
		"postcode": "2059"
	},
	{
		"town": "north sydney",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "north sydney shoppingworld",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "north talwood",
		"state": "qld",
		"postcode": "4496"
	},
	{
		"town": "north tamborine",
		"state": "qld",
		"postcode": "4272"
	},
	{
		"town": "north tamworth",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "north toowoomba",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "north tumbulgum",
		"state": "nsw",
		"postcode": "2490"
	},
	{
		"town": "north turramurra",
		"state": "nsw",
		"postcode": "2074"
	},
	{
		"town": "north ward",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "north west cape",
		"state": "wa",
		"postcode": "6707"
	},
	{
		"town": "north western suburbs pc",
		"state": "nsw",
		"postcode": "2746"
	},
	{
		"town": "north wonthaggi",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "north yalgogrin",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "north yelta",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "north yeoval",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "north yunderup",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "northam",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "northampton",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "northangera",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "northbridge",
		"state": "nsw",
		"postcode": "1560"
	},
	{
		"town": "northbridge",
		"state": "nsw",
		"postcode": "2063"
	},
	{
		"town": "northbridge",
		"state": "wa",
		"postcode": "6003"
	},
	{
		"town": "northbridge",
		"state": "wa",
		"postcode": "6803"
	},
	{
		"town": "northbridge",
		"state": "wa",
		"postcode": "6865"
	},
	{
		"town": "northcliffe",
		"state": "wa",
		"postcode": "6262"
	},
	{
		"town": "northcote",
		"state": "vic",
		"postcode": "3070"
	},
	{
		"town": "northcote south",
		"state": "vic",
		"postcode": "3070"
	},
	{
		"town": "northdown",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "northern gully",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "northern heights",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "northern rivers msc",
		"state": "nsw",
		"postcode": "2468"
	},
	{
		"town": "northern suburbs pc",
		"state": "nsw",
		"postcode": "2056"
	},
	{
		"town": "northern territory university",
		"state": "nt",
		"postcode": "815"
	},
	{
		"town": "northern territory university",
		"state": "nt",
		"postcode": "909"
	},
	{
		"town": "northfield",
		"state": "sa",
		"postcode": "5085"
	},
	{
		"town": "northgate",
		"state": "qld",
		"postcode": "4013"
	},
	{
		"town": "northgate",
		"state": "sa",
		"postcode": "5085"
	},
	{
		"town": "northlakes",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "northland centre",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "northlands",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "northlands",
		"state": "wa",
		"postcode": "6905"
	},
	{
		"town": "northmead",
		"state": "nsw",
		"postcode": "2152"
	},
	{
		"town": "northwood",
		"state": "nsw",
		"postcode": "2066"
	},
	{
		"town": "northwood",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "norton summit",
		"state": "sa",
		"postcode": "5136"
	},
	{
		"town": "norval",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "norville",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "norway",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "norwell",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "norwich park",
		"state": "qld",
		"postcode": "4745"
	},
	{
		"town": "norwin",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "norwood",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "norwood",
		"state": "sa",
		"postcode": "5067"
	},
	{
		"town": "norwood",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "norwood avenue po",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "norwood hill",
		"state": "vic",
		"postcode": "3450"
	},
	{
		"town": "norwood south",
		"state": "sa",
		"postcode": "5067"
	},
	{
		"town": "notley hills",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "notting hill",
		"state": "vic",
		"postcode": "3168"
	},
	{
		"town": "notts well",
		"state": "sa",
		"postcode": "5357"
	},
	{
		"town": "novar gardens",
		"state": "sa",
		"postcode": "5040"
	},
	{
		"town": "nowa nowa",
		"state": "vic",
		"postcode": "3887"
	},
	{
		"town": "nowendoc",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "nowergup",
		"state": "wa",
		"postcode": "6032"
	},
	{
		"town": "nowhere creek",
		"state": "vic",
		"postcode": "3469"
	},
	{
		"town": "nowhere else",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "nowie",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "nowra",
		"state": "nsw",
		"postcode": "2541"
	},
	{
		"town": "nowra east",
		"state": "nsw",
		"postcode": "2541"
	},
	{
		"town": "nowra naval po",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "nowra north",
		"state": "nsw",
		"postcode": "2541"
	},
	{
		"town": "nt university",
		"state": "nt",
		"postcode": "815"
	},
	{
		"town": "nubba",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "nubeena",
		"state": "tas",
		"postcode": "7184"
	},
	{
		"town": "nubingerie",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "nudgee",
		"state": "qld",
		"postcode": "4014"
	},
	{
		"town": "nudgee beach",
		"state": "qld",
		"postcode": "4014"
	},
	{
		"town": "nug nug",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "nugadong",
		"state": "wa",
		"postcode": "6609"
	},
	{
		"town": "nugara",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "nugent",
		"state": "tas",
		"postcode": "7172"
	},
	{
		"town": "nuggetty",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "nugra",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "nukarni",
		"state": "wa",
		"postcode": "6480"
	},
	{
		"town": "nukinenda",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "nukku",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "nulkaba",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "nulla vale",
		"state": "vic",
		"postcode": "3435"
	},
	{
		"town": "nullagine",
		"state": "wa",
		"postcode": "6758"
	},
	{
		"town": "nullamanna",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "nullan",
		"state": "vic",
		"postcode": "3392"
	},
	{
		"town": "nullawarre",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "nullawarre east",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "nullawil",
		"state": "vic",
		"postcode": "3529"
	},
	{
		"town": "nullica",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "nullo mountain",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "nulsen",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "numbaa",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "number one",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "numbla vale",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "numbugga",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "numbulwar",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "numeralla",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "numinbah",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "numinbah valley",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "numulgi",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "numurkah",
		"state": "vic",
		"postcode": "3636"
	},
	{
		"town": "nunamara",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "nunawading",
		"state": "vic",
		"postcode": "3131"
	},
	{
		"town": "nundah",
		"state": "qld",
		"postcode": "4012"
	},
	{
		"town": "nunderi",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "nundle",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "nundroo",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "nungarin",
		"state": "wa",
		"postcode": "6490"
	},
	{
		"town": "nungatta",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "nungurner",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "nunile",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "nunjikompita",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "nuntin",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "nurcoung",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "nurenmerenmong",
		"state": "nsw",
		"postcode": "2649"
	},
	{
		"town": "nuriootpa",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "nurrabiel",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "nurragi",
		"state": "sa",
		"postcode": "5256"
	},
	{
		"town": "nurran",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "nutfield",
		"state": "vic",
		"postcode": "3099"
	},
	{
		"town": "nutri",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "nyabing",
		"state": "wa",
		"postcode": "6341"
	},
	{
		"town": "nyah",
		"state": "vic",
		"postcode": "3594"
	},
	{
		"town": "nyah west",
		"state": "vic",
		"postcode": "3595"
	},
	{
		"town": "nyallo",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "nyamup",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "nyamville",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "nyapari",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "nyarrin",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "nyerimilang",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "nyllavert",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "nymagee",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "nymboida",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "nyngan",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "nyora",
		"state": "vic",
		"postcode": "3987"
	},
	{
		"town": "nypo",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "nyrang creek",
		"state": "nsw",
		"postcode": "2804"
	},
	{
		"town": "o b flat",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "o'connell",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "o'connell",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "o'connor",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "o'connor",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "o'halloran hill",
		"state": "sa",
		"postcode": "5158"
	},
	{
		"town": "o'malley",
		"state": "act",
		"postcode": "2606"
	},
	{
		"town": "o'reillys",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "o'sullivan beach",
		"state": "sa",
		"postcode": "5166"
	},
	{
		"town": "oak beach",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "oak flats",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "oak park",
		"state": "vic",
		"postcode": "3046"
	},
	{
		"town": "oak valley",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "oak valley",
		"state": "vic",
		"postcode": "3665"
	},
	{
		"town": "oakabella",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "oakajee",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "oakbank",
		"state": "sa",
		"postcode": "5243"
	},
	{
		"town": "oakdale",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "oakdale",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "oakden",
		"state": "sa",
		"postcode": "5086"
	},
	{
		"town": "oakdowns",
		"state": "tas",
		"postcode": "7019"
	},
	{
		"town": "oakenden",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "oakey",
		"state": "qld",
		"postcode": "4401"
	},
	{
		"town": "oakey creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "oakford",
		"state": "wa",
		"postcode": "6121"
	},
	{
		"town": "oakhampton",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "oakhampton heights",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "oakhurst",
		"state": "nsw",
		"postcode": "2761"
	},
	{
		"town": "oakhurst",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "oaklands",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "oaklands junction",
		"state": "vic",
		"postcode": "3063"
	},
	{
		"town": "oaklands park",
		"state": "sa",
		"postcode": "5046"
	},
	{
		"town": "oakleigh",
		"state": "vic",
		"postcode": "3166"
	},
	{
		"town": "oakleigh east",
		"state": "vic",
		"postcode": "3166"
	},
	{
		"town": "oakleigh south",
		"state": "vic",
		"postcode": "3167"
	},
	{
		"town": "oakley",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "oaks",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "oaks estate",
		"state": "act",
		"postcode": "2620"
	},
	{
		"town": "oakvale",
		"state": "vic",
		"postcode": "3540"
	},
	{
		"town": "oakview",
		"state": "qld",
		"postcode": "4600"
	},
	{
		"town": "oakville",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "oakwood",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "oakwood",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "oakwood",
		"state": "tas",
		"postcode": "7182"
	},
	{
		"town": "oakwood park",
		"state": "vic",
		"postcode": "3175"
	},
	{
		"town": "oaky creek",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "oallen",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "oasis gardens",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "oatlands",
		"state": "nsw",
		"postcode": "2117"
	},
	{
		"town": "oatlands",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "oatley",
		"state": "nsw",
		"postcode": "2223"
	},
	{
		"town": "oban",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "oban",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "obanvale",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "oberne",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "oberne creek",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "oberon",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "obi obi",
		"state": "qld",
		"postcode": "4574"
	},
	{
		"town": "obil bil",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "obley",
		"state": "nsw",
		"postcode": "2868"
	},
	{
		"town": "obum obum",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "obx creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "ocallaghans",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "ocean grange",
		"state": "vic",
		"postcode": "3880"
	},
	{
		"town": "ocean grove",
		"state": "vic",
		"postcode": "3226"
	},
	{
		"town": "ocean reef",
		"state": "wa",
		"postcode": "6027"
	},
	{
		"town": "ocean shores",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "ocean view",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "ocean vista",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "ockley",
		"state": "wa",
		"postcode": "6312"
	},
	{
		"town": "oconnell",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "oenpelli",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "officer",
		"state": "vic",
		"postcode": "3809"
	},
	{
		"town": "officer south",
		"state": "vic",
		"postcode": "3809"
	},
	{
		"town": "ogilvie",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "ogmore",
		"state": "qld",
		"postcode": "4706"
	},
	{
		"town": "ogradys ridge",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "ogunbil",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "ohanlons",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "okeden",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "olary",
		"state": "sa",
		"postcode": "5440"
	},
	{
		"town": "old adaminaby",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "old bar",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "old beach",
		"state": "tas",
		"postcode": "7017"
	},
	{
		"town": "old bonalbo",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "old cooranga",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "old erowal bay",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "old grevillia",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "old guildford",
		"state": "nsw",
		"postcode": "2161"
	},
	{
		"town": "old junee",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "old koreelah",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "old mill",
		"state": "nsw",
		"postcode": "2369"
	},
	{
		"town": "old noarlunga",
		"state": "sa",
		"postcode": "5168"
	},
	{
		"town": "old plains",
		"state": "wa",
		"postcode": "6569"
	},
	{
		"town": "old reynella",
		"state": "sa",
		"postcode": "5161"
	},
	{
		"town": "old station",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "old toongabbie",
		"state": "nsw",
		"postcode": "2146"
	},
	{
		"town": "oldbury",
		"state": "wa",
		"postcode": "6121"
	},
	{
		"town": "oldina",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "olinda",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "olinda",
		"state": "vic",
		"postcode": "3788"
	},
	{
		"town": "olivers hill",
		"state": "vic",
		"postcode": "3199"
	},
	{
		"town": "olympic dam",
		"state": "sa",
		"postcode": "5725"
	},
	{
		"town": "omadale",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "oman ama",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "ombersley",
		"state": "vic",
		"postcode": "3241"
	},
	{
		"town": "omeo",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "omeo valley",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "ondit",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "one mile",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "one mile beach",
		"state": "nsw",
		"postcode": "2315"
	},
	{
		"town": "one tree",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "one tree hill",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "one tree hill",
		"state": "vic",
		"postcode": "3786"
	},
	{
		"town": "ongerup",
		"state": "wa",
		"postcode": "6336"
	},
	{
		"town": "onkaparinga hills",
		"state": "sa",
		"postcode": "5163"
	},
	{
		"town": "onslow",
		"state": "wa",
		"postcode": "6710"
	},
	{
		"town": "oodla wirra",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "oodnadatta",
		"state": "sa",
		"postcode": "5734"
	},
	{
		"town": "oolong",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "ooma",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "oombabeer",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "oombulgurri",
		"state": "wa",
		"postcode": "6740"
	},
	{
		"town": "oonah",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "oonoonba",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "ooralea",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "oorindi",
		"state": "qld",
		"postcode": "4824"
	},
	{
		"town": "ootha",
		"state": "nsw",
		"postcode": "2875"
	},
	{
		"town": "opalton",
		"state": "qld",
		"postcode": "4735"
	},
	{
		"town": "ophir",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "opossum bay",
		"state": "tas",
		"postcode": "7023"
	},
	{
		"town": "opossum creek",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "ora banda",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "orama",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "oran park",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "orana",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "orana heights",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "orange",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "orange creek",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "orange east",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "orange grove",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "orange grove",
		"state": "wa",
		"postcode": "6109"
	},
	{
		"town": "orange south",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "orange springs",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "orangeville",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "oranmeir",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "orbost",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "orchard hills",
		"state": "nsw",
		"postcode": "2748"
	},
	{
		"town": "orchid beach",
		"state": "qld",
		"postcode": "4581"
	},
	{
		"town": "orelia",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "orford",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "orford",
		"state": "vic",
		"postcode": "3284"
	},
	{
		"town": "orielton",
		"state": "tas",
		"postcode": "7172"
	},
	{
		"town": "orient point",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "orkabie",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "ormeau",
		"state": "qld",
		"postcode": "4208"
	},
	{
		"town": "ormiston",
		"state": "qld",
		"postcode": "4160"
	},
	{
		"town": "ormley",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "ormond",
		"state": "vic",
		"postcode": "3204"
	},
	{
		"town": "ormond east",
		"state": "vic",
		"postcode": "3204"
	},
	{
		"town": "orroroo",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "orrvale",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "orton park",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "osborne",
		"state": "nsw",
		"postcode": "2656"
	},
	{
		"town": "osborne",
		"state": "qld",
		"postcode": "4806"
	},
	{
		"town": "osborne",
		"state": "sa",
		"postcode": "5017"
	},
	{
		"town": "osborne mine",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "osborne park",
		"state": "nsw",
		"postcode": "2066"
	},
	{
		"town": "osborne park",
		"state": "wa",
		"postcode": "6017"
	},
	{
		"town": "osborne park",
		"state": "wa",
		"postcode": "6916"
	},
	{
		"town": "osborne park",
		"state": "wa",
		"postcode": "6917"
	},
	{
		"town": "osbornes flat",
		"state": "vic",
		"postcode": "3749"
	},
	{
		"town": "osmaston",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "osmington",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "osterley",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "osterley",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "oswald",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "otago",
		"state": "tas",
		"postcode": "7017"
	},
	{
		"town": "otford",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "ottaba",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "ottoway",
		"state": "sa",
		"postcode": "5013"
	},
	{
		"town": "oura",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "ourimbah",
		"state": "nsw",
		"postcode": "2258"
	},
	{
		"town": "ournie",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "ouse",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "outer harbor",
		"state": "sa",
		"postcode": "5018"
	},
	{
		"town": "outtrim",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "ouyen",
		"state": "vic",
		"postcode": "3490"
	},
	{
		"town": "ovens",
		"state": "vic",
		"postcode": "3738"
	},
	{
		"town": "overland corner",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "ovingham",
		"state": "sa",
		"postcode": "5082"
	},
	{
		"town": "owanyilla",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "owen",
		"state": "sa",
		"postcode": "5460"
	},
	{
		"town": "owens creek",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "owens gap",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "oxenford",
		"state": "qld",
		"postcode": "4210"
	},
	{
		"town": "oxford",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "oxford falls",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "oxford park",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "oxley",
		"state": "act",
		"postcode": "2903"
	},
	{
		"town": "oxley",
		"state": "nsw",
		"postcode": "2711"
	},
	{
		"town": "oxley",
		"state": "qld",
		"postcode": "4075"
	},
	{
		"town": "oxley",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "oxley flats",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "oxley island",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "oxley park",
		"state": "nsw",
		"postcode": "2760"
	},
	{
		"town": "oxley vale",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "oyster bay",
		"state": "nsw",
		"postcode": "2225"
	},
	{
		"town": "oyster bay",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "oyster cove",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "oyster cove",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "oyster creek",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "ozenkadnook",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "paaratte",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "pacific fair",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "pacific haven",
		"state": "qld",
		"postcode": "4659"
	},
	{
		"town": "pacific heights",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "pacific palms",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "pacific paradise",
		"state": "qld",
		"postcode": "4564"
	},
	{
		"town": "pacific pines",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "padbury",
		"state": "wa",
		"postcode": "6025"
	},
	{
		"town": "paddington",
		"state": "nsw",
		"postcode": "2021"
	},
	{
		"town": "paddington",
		"state": "qld",
		"postcode": "4064"
	},
	{
		"town": "paddys flat",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "paddys flat",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "paddys plain",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "paddys river",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "paddys river",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "padstow",
		"state": "nsw",
		"postcode": "2211"
	},
	{
		"town": "padstow heights",
		"state": "nsw",
		"postcode": "2211"
	},
	{
		"town": "padthaway",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "page",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "pages creek",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "pages flat",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "pages river",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "paget",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "pagewood",
		"state": "nsw",
		"postcode": "2035"
	},
	{
		"town": "paisley",
		"state": "sa",
		"postcode": "5357"
	},
	{
		"town": "pakenham",
		"state": "vic",
		"postcode": "3810"
	},
	{
		"town": "pakenham south",
		"state": "vic",
		"postcode": "3810"
	},
	{
		"town": "pakenham upper",
		"state": "vic",
		"postcode": "3810"
	},
	{
		"town": "palana",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "palarang",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "palen creek",
		"state": "qld",
		"postcode": "4287"
	},
	{
		"town": "palerang",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "palgarup",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "paling yards",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "palinyewah",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "palkagee",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "pallamallawa",
		"state": "nsw",
		"postcode": "2399"
	},
	{
		"town": "pallamana",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "pallara",
		"state": "qld",
		"postcode": "4110"
	},
	{
		"town": "pallarenda",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "pallas street maryborough",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "palm beach",
		"state": "nsw",
		"postcode": "2108"
	},
	{
		"town": "palm beach",
		"state": "qld",
		"postcode": "4221"
	},
	{
		"town": "palm cove",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "palm grove",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "palm island",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "palm tree",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "palmdale",
		"state": "nsw",
		"postcode": "2258"
	},
	{
		"town": "palmer",
		"state": "sa",
		"postcode": "5237"
	},
	{
		"town": "palmers channel",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "palmers island",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "palmers oaky",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "palmerston",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "palmerston",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "palmerston",
		"state": "nt",
		"postcode": "831"
	},
	{
		"town": "palmvale",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "palmview",
		"state": "qld",
		"postcode": "4553"
	},
	{
		"town": "palmwoods",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "palmwoods",
		"state": "qld",
		"postcode": "4555"
	},
	{
		"town": "palmyra",
		"state": "qld",
		"postcode": "4751"
	},
	{
		"town": "palmyra",
		"state": "wa",
		"postcode": "6157"
	},
	{
		"town": "palmyra",
		"state": "wa",
		"postcode": "6957"
	},
	{
		"town": "paloona",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "paluma",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "pambula",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "pambula beach",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "pampas",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "pampoolah",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "panania",
		"state": "nsw",
		"postcode": "2213"
	},
	{
		"town": "paney",
		"state": "sa",
		"postcode": "5652"
	},
	{
		"town": "panitya",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "panitya",
		"state": "vic",
		"postcode": "3512"
	},
	{
		"town": "panmure",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "pannawonica",
		"state": "wa",
		"postcode": "6716"
	},
	{
		"town": "pannoomilloo",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "panorama",
		"state": "sa",
		"postcode": "5041"
	},
	{
		"town": "pantapin",
		"state": "wa",
		"postcode": "6384"
	},
	{
		"town": "panton hill",
		"state": "vic",
		"postcode": "3759"
	},
	{
		"town": "panuara",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "paper beach",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "pappinbarra",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "papunya",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "para hills",
		"state": "sa",
		"postcode": "5096"
	},
	{
		"town": "para hills west",
		"state": "sa",
		"postcode": "5096"
	},
	{
		"town": "para vista",
		"state": "sa",
		"postcode": "5093"
	},
	{
		"town": "paraburdoo",
		"state": "wa",
		"postcode": "6754"
	},
	{
		"town": "parachilna",
		"state": "sa",
		"postcode": "5730"
	},
	{
		"town": "paracombe",
		"state": "sa",
		"postcode": "5132"
	},
	{
		"town": "paradise",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "paradise",
		"state": "sa",
		"postcode": "5075"
	},
	{
		"town": "paradise",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "paradise",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "paradise beach",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "paradise beach",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "paradise island",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "paradise point",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "paradise point keys",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "paradise waters",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "parafield",
		"state": "sa",
		"postcode": "5106"
	},
	{
		"town": "parafield airport",
		"state": "sa",
		"postcode": "5106"
	},
	{
		"town": "parafield gardens",
		"state": "sa",
		"postcode": "5107"
	},
	{
		"town": "paralowie",
		"state": "sa",
		"postcode": "5108"
	},
	{
		"town": "paramatta",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "parangana",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "parap",
		"state": "nt",
		"postcode": "804"
	},
	{
		"town": "parap",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "paraparap",
		"state": "vic",
		"postcode": "3240"
	},
	{
		"town": "paratoo",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "parattah",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "parawa",
		"state": "sa",
		"postcode": "5203"
	},
	{
		"town": "pardelup",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "parilla",
		"state": "sa",
		"postcode": "5303"
	},
	{
		"town": "paringa",
		"state": "sa",
		"postcode": "5340"
	},
	{
		"town": "paringi",
		"state": "nsw",
		"postcode": "3500"
	},
	{
		"town": "paris creek",
		"state": "sa",
		"postcode": "5201"
	},
	{
		"town": "park avenue",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "park beach",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "park gates",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "park grove",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "park holme",
		"state": "sa",
		"postcode": "5043"
	},
	{
		"town": "park orchards",
		"state": "vic",
		"postcode": "3114"
	},
	{
		"town": "park ridge",
		"state": "qld",
		"postcode": "4125"
	},
	{
		"town": "park ridge south",
		"state": "qld",
		"postcode": "4125"
	},
	{
		"town": "parkdale",
		"state": "vic",
		"postcode": "3194"
	},
	{
		"town": "parker range",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "parkers corner",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "parkerville",
		"state": "wa",
		"postcode": "6081"
	},
	{
		"town": "parkes",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "parkes",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "parkesborough",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "parkesbourne",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "parkeston",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "parkfield",
		"state": "wa",
		"postcode": "6233"
	},
	{
		"town": "parkham",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "parkhurst",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "parkinson",
		"state": "qld",
		"postcode": "4115"
	},
	{
		"town": "parklands",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "parklands",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "parklands",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "parklea",
		"state": "nsw",
		"postcode": "2768"
	},
	{
		"town": "parkside",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "parkside",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "parkside",
		"state": "sa",
		"postcode": "5063"
	},
	{
		"town": "parkville",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "parkville",
		"state": "vic",
		"postcode": "3052"
	},
	{
		"town": "parkwood",
		"state": "qld",
		"postcode": "4214"
	},
	{
		"town": "parkwood",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "parkwood",
		"state": "wa",
		"postcode": "6147"
	},
	{
		"town": "parliament house",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "parliament house",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "parliament house",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "parliament house",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "parliament house",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "parliament house",
		"state": "vic",
		"postcode": "3002"
	},
	{
		"town": "parmelia",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "parnaroo",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "parndana",
		"state": "sa",
		"postcode": "5220"
	},
	{
		"town": "parrakie",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "parramatta",
		"state": "nsw",
		"postcode": "1740"
	},
	{
		"town": "parramatta",
		"state": "nsw",
		"postcode": "1741"
	},
	{
		"town": "parramatta",
		"state": "nsw",
		"postcode": "2123"
	},
	{
		"town": "parramatta",
		"state": "nsw",
		"postcode": "2124"
	},
	{
		"town": "parramatta",
		"state": "nsw",
		"postcode": "2150"
	},
	{
		"town": "parramatta park",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "parramatta westfield",
		"state": "nsw",
		"postcode": "2150"
	},
	{
		"town": "parrawe",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "parraweena",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "parrearra",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "parryville",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "partington",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "paruna",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "parwan",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "pasadena",
		"state": "sa",
		"postcode": "5042"
	},
	{
		"town": "paschendale",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "pascoe vale",
		"state": "vic",
		"postcode": "3044"
	},
	{
		"town": "pascoe vale south",
		"state": "vic",
		"postcode": "3044"
	},
	{
		"town": "pasha",
		"state": "qld",
		"postcode": "4721"
	},
	{
		"town": "paskeville",
		"state": "sa",
		"postcode": "5552"
	},
	{
		"town": "pastoria",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "pastoria east",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "pata",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "patchewollock",
		"state": "vic",
		"postcode": "3491"
	},
	{
		"town": "patchs beach",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "pateena",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "paterson",
		"state": "nsw",
		"postcode": "2421"
	},
	{
		"town": "paterson",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "patersonia",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "patho",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "patho west",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "patjarr",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "patonga",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "patonga beach",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "patrick estate",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "patterson",
		"state": "vic",
		"postcode": "3204"
	},
	{
		"town": "patterson lakes",
		"state": "vic",
		"postcode": "3197"
	},
	{
		"town": "patyah",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "paulls valley",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "pauls pocket",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "paupong",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "pawleena",
		"state": "tas",
		"postcode": "7172"
	},
	{
		"town": "pawtella",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "pax hill",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "paxton",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "paynedale",
		"state": "wa",
		"postcode": "6239"
	},
	{
		"town": "payneham",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "payneham south",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "paynes crossing",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "paynes find",
		"state": "wa",
		"postcode": "6612"
	},
	{
		"town": "paynesville",
		"state": "vic",
		"postcode": "3880"
	},
	{
		"town": "paynesville",
		"state": "wa",
		"postcode": "6638"
	},
	{
		"town": "paynters siding",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "peaceful bay",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "peachester",
		"state": "qld",
		"postcode": "4519"
	},
	{
		"town": "peachna",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "peak crossing",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "peak downs mine",
		"state": "qld",
		"postcode": "4744"
	},
	{
		"town": "peak hill",
		"state": "nsw",
		"postcode": "2869"
	},
	{
		"town": "peak hill",
		"state": "wa",
		"postcode": "6642"
	},
	{
		"town": "peak view",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "peake",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "peakhurst",
		"state": "nsw",
		"postcode": "2210"
	},
	{
		"town": "peakhurst heights",
		"state": "nsw",
		"postcode": "2210"
	},
	{
		"town": "pearce",
		"state": "act",
		"postcode": "2607"
	},
	{
		"town": "pearcedale",
		"state": "vic",
		"postcode": "3912"
	},
	{
		"town": "pearces creek",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "pearl beach",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "pearsall",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "pearshape",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "pearsondale",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "peats ridge",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "pechey",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "pederick",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "pedler creek",
		"state": "sa",
		"postcode": "5171"
	},
	{
		"town": "pedrina park",
		"state": "vic",
		"postcode": "3300"
	},
	{
		"town": "peebinga",
		"state": "sa",
		"postcode": "5304"
	},
	{
		"town": "peechelba",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "peechelba east",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "peedamulla",
		"state": "wa",
		"postcode": "6710"
	},
	{
		"town": "peek-a-doo",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "peel",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "peel island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "peelwood",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "peep hill",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "peeramon",
		"state": "qld",
		"postcode": "4885"
	},
	{
		"town": "pegarah",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "pegs creek",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "pekina",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "pelaw main",
		"state": "nsw",
		"postcode": "2327"
	},
	{
		"town": "pelham",
		"state": "qld",
		"postcode": "4415"
	},
	{
		"town": "pelham",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "pelican",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "pelican lagoon",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "pelican point",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "pelican point",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "pelican waters",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "pella",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "pelluebla",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "pelton",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "pelverata",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "pemberton",
		"state": "wa",
		"postcode": "6260"
	},
	{
		"town": "pembrooke",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "penarie",
		"state": "nsw",
		"postcode": "2715"
	},
	{
		"town": "pendle hill",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "penfield",
		"state": "sa",
		"postcode": "5121"
	},
	{
		"town": "penfield gardens",
		"state": "sa",
		"postcode": "5121"
	},
	{
		"town": "penguin",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "penna",
		"state": "tas",
		"postcode": "7171"
	},
	{
		"town": "pennant hills",
		"state": "nsw",
		"postcode": "1715"
	},
	{
		"town": "pennant hills",
		"state": "nsw",
		"postcode": "1771"
	},
	{
		"town": "pennant hills",
		"state": "nsw",
		"postcode": "2120"
	},
	{
		"town": "penneshaw",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "pennington",
		"state": "sa",
		"postcode": "5013"
	},
	{
		"town": "pennydale",
		"state": "vic",
		"postcode": "3192"
	},
	{
		"town": "pennyroyal",
		"state": "vic",
		"postcode": "3235"
	},
	{
		"town": "penola",
		"state": "sa",
		"postcode": "5277"
	},
	{
		"town": "penong",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "penrith",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "penrith",
		"state": "nsw",
		"postcode": "2751"
	},
	{
		"town": "penrith plaza",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "penrith south",
		"state": "nsw",
		"postcode": "2750"
	},
	{
		"town": "penrose",
		"state": "nsw",
		"postcode": "2579"
	},
	{
		"town": "penshurst",
		"state": "nsw",
		"postcode": "2222"
	},
	{
		"town": "penshurst",
		"state": "vic",
		"postcode": "3289"
	},
	{
		"town": "pental island",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "pentland",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "pentland hills",
		"state": "vic",
		"postcode": "3341"
	},
	{
		"town": "penwhaupell",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "penwortham",
		"state": "sa",
		"postcode": "5453"
	},
	{
		"town": "peppermint grove",
		"state": "wa",
		"postcode": "6011"
	},
	{
		"town": "peppermint grove beach",
		"state": "wa",
		"postcode": "6271"
	},
	{
		"town": "peppers plain",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "peranga",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "percydale",
		"state": "vic",
		"postcode": "3467"
	},
	{
		"town": "peregian beach",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "peregian beach south",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "perekerten",
		"state": "nsw",
		"postcode": "2733"
	},
	{
		"town": "perenjori",
		"state": "wa",
		"postcode": "6620"
	},
	{
		"town": "pericoe",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "perillup",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "perisher valley",
		"state": "nsw",
		"postcode": "2624"
	},
	{
		"town": "perkins reef",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "peron",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "peronne",
		"state": "vic",
		"postcode": "3413"
	},
	{
		"town": "perponda",
		"state": "sa",
		"postcode": "5308"
	},
	{
		"town": "perry bridge",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "perseverance",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "perth",
		"state": "tas",
		"postcode": "7300"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6000"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6001"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6800"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6809"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6812"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6815"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6817"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6820"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6824"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6825"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6826"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6827"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6828"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6829"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6830"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6833"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6834"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6836"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6837"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6838"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6839"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6840"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6841"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6842"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6843"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6844"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6845"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6846"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6847"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6848"
	},
	{
		"town": "perth",
		"state": "wa",
		"postcode": "6851"
	},
	{
		"town": "perth airport",
		"state": "wa",
		"postcode": "6105"
	},
	{
		"town": "perth east st georges tce",
		"state": "wa",
		"postcode": "6832"
	},
	{
		"town": "perth gpo",
		"state": "wa",
		"postcode": "6000"
	},
	{
		"town": "perth st georges tce",
		"state": "wa",
		"postcode": "6831"
	},
	{
		"town": "perthville",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "perulpa island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "perwillowen",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "petcheys bay",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "peterborough",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "peterborough",
		"state": "vic",
		"postcode": "3270"
	},
	{
		"town": "peterhead",
		"state": "sa",
		"postcode": "5016"
	},
	{
		"town": "petersham",
		"state": "nsw",
		"postcode": "2049"
	},
	{
		"town": "petersham north",
		"state": "nsw",
		"postcode": "2049"
	},
	{
		"town": "petersons",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "petersville",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "petford",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "petherick",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "petina",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "petrie",
		"state": "qld",
		"postcode": "4502"
	},
	{
		"town": "petrie terrace",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "petrudor",
		"state": "wa",
		"postcode": "6468"
	},
	{
		"town": "petticoat creek",
		"state": "vic",
		"postcode": "3233"
	},
	{
		"town": "pewsey vale",
		"state": "sa",
		"postcode": "5351"
	},
	{
		"town": "pheasant creek",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "pheasant creek",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "pheasant ground",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "pheasants nest",
		"state": "nsw",
		"postcode": "2574"
	},
	{
		"town": "phegans bay",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "phillip",
		"state": "act",
		"postcode": "2606"
	},
	{
		"town": "phillip bay",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "phillip creek station",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "philpott",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "phoenix park",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "pialba",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "piallamore",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "piallaway",
		"state": "nsw",
		"postcode": "2342"
	},
	{
		"town": "pialligo",
		"state": "act",
		"postcode": "2609"
	},
	{
		"town": "piambie",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "piambong",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "piangil",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "piavella",
		"state": "vic",
		"postcode": "3572"
	},
	{
		"town": "piawaning",
		"state": "wa",
		"postcode": "6572"
	},
	{
		"town": "piccadilly",
		"state": "sa",
		"postcode": "5151"
	},
	{
		"town": "piccadilly",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "pickering brook",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "picketts valley",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "picnic bay",
		"state": "qld",
		"postcode": "4819"
	},
	{
		"town": "picnic point",
		"state": "nsw",
		"postcode": "2213"
	},
	{
		"town": "picnic point",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "picnic point",
		"state": "vic",
		"postcode": "3816"
	},
	{
		"town": "picola",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "picola west",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "picton",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "picton",
		"state": "wa",
		"postcode": "6229"
	},
	{
		"town": "pie creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "piedmont",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "pieper",
		"state": "vic",
		"postcode": "3733"
	},
	{
		"town": "pier millan",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "pierce creek",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "pierces creek",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "piersons point",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "piesse brook",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "piesseville",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "pigeon ponds",
		"state": "vic",
		"postcode": "3407"
	},
	{
		"town": "pigeonbah",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "piggabeen",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "piggoreet",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "pijick",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "pikapene",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "pike river",
		"state": "sa",
		"postcode": "5340"
	},
	{
		"town": "pilchers bridge",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "pile gully",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "pilerwa",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "pillar valley",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "pilliga",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "pilot wilderness",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "pilton",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "pimba",
		"state": "sa",
		"postcode": "5720"
	},
	{
		"town": "pimbaacla",
		"state": "sa",
		"postcode": "5661"
	},
	{
		"town": "pimlico",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "pimlico",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "pimlico island",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "pimpama",
		"state": "qld",
		"postcode": "4209"
	},
	{
		"town": "pimpimbudgee",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "pimpinio",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "pinbarren",
		"state": "qld",
		"postcode": "4568"
	},
	{
		"town": "pinbeyan",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "pindar",
		"state": "wa",
		"postcode": "6631"
	},
	{
		"town": "pindari hills",
		"state": "qld",
		"postcode": "4211"
	},
	{
		"town": "pindaroi",
		"state": "nsw",
		"postcode": "2361"
	},
	{
		"town": "pindi pindi",
		"state": "qld",
		"postcode": "4798"
	},
	{
		"town": "pine clump",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "pine creek",
		"state": "nt",
		"postcode": "847"
	},
	{
		"town": "pine creek",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "pine creek",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "pine grove",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "pine grove east",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "pine hill",
		"state": "sa",
		"postcode": "5269"
	},
	{
		"town": "pine hills",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "pine lodge",
		"state": "nsw",
		"postcode": "2714"
	},
	{
		"town": "pine lodge",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "pine mountain",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "pine point",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "pine ridge",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "pine valley",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "pine view",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "pinelands",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "pinery",
		"state": "sa",
		"postcode": "5460"
	},
	{
		"town": "pines forest",
		"state": "vic",
		"postcode": "3200"
	},
	{
		"town": "pinevale",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "pinewood",
		"state": "vic",
		"postcode": "3149"
	},
	{
		"town": "piney range",
		"state": "nsw",
		"postcode": "2810"
	},
	{
		"town": "pingaring",
		"state": "wa",
		"postcode": "6357"
	},
	{
		"town": "pingelly",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "pingrup",
		"state": "wa",
		"postcode": "6343"
	},
	{
		"town": "pinjar",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "pinjarra",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "pinjarra hills",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "pinkawillinie",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "pinkenba",
		"state": "qld",
		"postcode": "4008"
	},
	{
		"town": "pinkerton plains",
		"state": "sa",
		"postcode": "5400"
	},
	{
		"town": "pinkett",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "pinklands",
		"state": "qld",
		"postcode": "4164"
	},
	{
		"town": "pinks beach",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "pinnacle",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "pinnacle",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "pinnacle swamp",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "pinnacles",
		"state": "qld",
		"postcode": "4815"
	},
	{
		"town": "pinnaroo",
		"state": "sa",
		"postcode": "5304"
	},
	{
		"town": "pintharuka",
		"state": "wa",
		"postcode": "6623"
	},
	{
		"town": "pioneer",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "pioneer",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "pioneer",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "pioneer bay",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "pioneers rest",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "piora",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "pipe clay bay",
		"state": "tas",
		"postcode": "7253"
	},
	{
		"town": "pipeclay",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "pipers bay",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "pipers brook",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "pipers creek",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "pipers flat",
		"state": "nsw",
		"postcode": "2847"
	},
	{
		"town": "pipers river",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "pippingarra",
		"state": "wa",
		"postcode": "6722"
	},
	{
		"town": "pira",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "piree",
		"state": "vic",
		"postcode": "3637"
	},
	{
		"town": "piries",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "pirrinuan",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "pirron yallock",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "pitcairns",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "pitfield",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "pithara",
		"state": "wa",
		"postcode": "6608"
	},
	{
		"town": "pitjantjatjara homelands",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "pitlochry",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "pitnacree",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "pitt town",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "pittong",
		"state": "vic",
		"postcode": "3360"
	},
	{
		"town": "pittsworth",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "placid hills",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "plainby",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "plainland",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "planella",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "planland",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "pleasant hills",
		"state": "nsw",
		"postcode": "2658"
	},
	{
		"town": "pleasant park",
		"state": "sa",
		"postcode": "5277"
	},
	{
		"town": "pleasure point",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "plenty",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "plenty",
		"state": "vic",
		"postcode": "3090"
	},
	{
		"town": "pleystowe",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "plumpton",
		"state": "nsw",
		"postcode": "2761"
	},
	{
		"town": "plumridge lakes",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "plympton",
		"state": "sa",
		"postcode": "5038"
	},
	{
		"town": "plympton park",
		"state": "sa",
		"postcode": "5038"
	},
	{
		"town": "poatina",
		"state": "tas",
		"postcode": "7302"
	},
	{
		"town": "point arkwright",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "point clare",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "point cook",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "point frederick",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "point grey",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "point halloran",
		"state": "qld",
		"postcode": "4165"
	},
	{
		"town": "point leo",
		"state": "vic",
		"postcode": "3916"
	},
	{
		"town": "point lonsdale",
		"state": "vic",
		"postcode": "3225"
	},
	{
		"town": "point lookout",
		"state": "qld",
		"postcode": "4183"
	},
	{
		"town": "point mcleay",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "point nepean",
		"state": "vic",
		"postcode": "3944"
	},
	{
		"town": "point pass",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "point pearce",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "point piper",
		"state": "nsw",
		"postcode": "2027"
	},
	{
		"town": "point plomer",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "point samson",
		"state": "wa",
		"postcode": "6720"
	},
	{
		"town": "point souttar",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "point stephens",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "point sturt",
		"state": "sa",
		"postcode": "5256"
	},
	{
		"town": "point talburpin",
		"state": "qld",
		"postcode": "4165"
	},
	{
		"town": "point turton",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "point vernon",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "point wilson",
		"state": "vic",
		"postcode": "3212"
	},
	{
		"town": "point wolstoncroft",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "pokataroo",
		"state": "nsw",
		"postcode": "2833"
	},
	{
		"town": "pokolbin",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "pola creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "polda",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "police point",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "policeman's point",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "polkemmet",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "polo flat",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "poltalloch",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "pomborneit",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "pomborneit east",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "pomborneit east",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "pomborneit north",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "pomona",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "pomona",
		"state": "qld",
		"postcode": "4568"
	},
	{
		"town": "pomonal",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "pompapiel",
		"state": "vic",
		"postcode": "3571"
	},
	{
		"town": "pompoota",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "ponde",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "ponto",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "pontville",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "pontypool",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "poochera",
		"state": "sa",
		"postcode": "5655"
	},
	{
		"town": "pooginagoric",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "pooginook",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "poolaijelo",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "poona",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "pooncarie",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "poonindie",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "pooraka",
		"state": "sa",
		"postcode": "5095"
	},
	{
		"town": "pootenup",
		"state": "wa",
		"postcode": "6321"
	},
	{
		"town": "pootilla",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "poowong",
		"state": "vic",
		"postcode": "3988"
	},
	{
		"town": "poowong east",
		"state": "vic",
		"postcode": "3988"
	},
	{
		"town": "poowong north",
		"state": "vic",
		"postcode": "3988"
	},
	{
		"town": "poowong south",
		"state": "vic",
		"postcode": "3945"
	},
	{
		"town": "popanyinning",
		"state": "wa",
		"postcode": "6309"
	},
	{
		"town": "porcupine flat",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "porcupine ridge",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "porepunkah",
		"state": "vic",
		"postcode": "3740"
	},
	{
		"town": "porky flat",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "pormpuraaw",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "porongurup",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "port adelaide",
		"state": "sa",
		"postcode": "5015"
	},
	{
		"town": "port albany",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "port albert",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "port arthur",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "port arthur",
		"state": "sa",
		"postcode": "5572"
	},
	{
		"town": "port arthur",
		"state": "tas",
		"postcode": "7182"
	},
	{
		"town": "port augusta",
		"state": "sa",
		"postcode": "5700"
	},
	{
		"town": "port augusta",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "port augusta north",
		"state": "sa",
		"postcode": "5700"
	},
	{
		"town": "port augusta west",
		"state": "sa",
		"postcode": "5700"
	},
	{
		"town": "port botany",
		"state": "nsw",
		"postcode": "2036"
	},
	{
		"town": "port broughton",
		"state": "sa",
		"postcode": "5522"
	},
	{
		"town": "port bundaberg",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "port campbell",
		"state": "vic",
		"postcode": "3269"
	},
	{
		"town": "port clinton",
		"state": "sa",
		"postcode": "5570"
	},
	{
		"town": "port curtis",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "port davey",
		"state": "tas",
		"postcode": "7001"
	},
	{
		"town": "port davis",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "port denison",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "port douglas",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "port elliot",
		"state": "sa",
		"postcode": "5212"
	},
	{
		"town": "port fairy",
		"state": "vic",
		"postcode": "3284"
	},
	{
		"town": "port flinders",
		"state": "sa",
		"postcode": "5495"
	},
	{
		"town": "port franklin",
		"state": "vic",
		"postcode": "3964"
	},
	{
		"town": "port gawler",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "port germein",
		"state": "sa",
		"postcode": "5495"
	},
	{
		"town": "port gibbon",
		"state": "sa",
		"postcode": "5602"
	},
	{
		"town": "port giles",
		"state": "sa",
		"postcode": "5582"
	},
	{
		"town": "port hacking",
		"state": "nsw",
		"postcode": "2229"
	},
	{
		"town": "port hedland",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "port hughes",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "port huon",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "port julia",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "port kembla",
		"state": "nsw",
		"postcode": "2505"
	},
	{
		"town": "port kennedy",
		"state": "wa",
		"postcode": "6172"
	},
	{
		"town": "port kenny",
		"state": "sa",
		"postcode": "5671"
	},
	{
		"town": "port latta",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "port lincoln",
		"state": "sa",
		"postcode": "5606"
	},
	{
		"town": "port lincoln",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "port macdonnell",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "port macquarie",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "port melbourne",
		"state": "vic",
		"postcode": "3207"
	},
	{
		"town": "port melbourne",
		"state": "vic",
		"postcode": "8873"
	},
	{
		"town": "port moorowie",
		"state": "sa",
		"postcode": "5576"
	},
	{
		"town": "port neill",
		"state": "sa",
		"postcode": "5604"
	},
	{
		"town": "port noarlunga",
		"state": "sa",
		"postcode": "5167"
	},
	{
		"town": "port noarlunga south",
		"state": "sa",
		"postcode": "5167"
	},
	{
		"town": "port pirie",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "port pirie south",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "port pirie west",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "port rickaby",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "port sorell",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "port stanvac",
		"state": "sa",
		"postcode": "5160"
	},
	{
		"town": "port victoria",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "port vincent",
		"state": "sa",
		"postcode": "5581"
	},
	{
		"town": "port wakefield",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "port welshpool",
		"state": "vic",
		"postcode": "3965"
	},
	{
		"town": "port willunga",
		"state": "sa",
		"postcode": "5173"
	},
	{
		"town": "portarlington",
		"state": "vic",
		"postcode": "3223"
	},
	{
		"town": "porters retreat",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "portland",
		"state": "nsw",
		"postcode": "2847"
	},
	{
		"town": "portland",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "portland junction",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "portland north",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "portland west",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "portsea",
		"state": "vic",
		"postcode": "3944"
	},
	{
		"town": "portsmith",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "poseidon",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "possum brush",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "possum creek",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "post office museum",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "postans",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "postmans ridge",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "potato point",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "potts hill",
		"state": "nsw",
		"postcode": "2143"
	},
	{
		"town": "potts point",
		"state": "nsw",
		"postcode": "1335"
	},
	{
		"town": "potts point",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "pottsville beach",
		"state": "nsw",
		"postcode": "2489"
	},
	{
		"town": "pound creek",
		"state": "vic",
		"postcode": "3996"
	},
	{
		"town": "powelltown",
		"state": "vic",
		"postcode": "3797"
	},
	{
		"town": "powers creek",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "powlett plains",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "powlett river",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "powranna",
		"state": "tas",
		"postcode": "7300"
	},
	{
		"town": "pozieres",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "prahran",
		"state": "vic",
		"postcode": "3181"
	},
	{
		"town": "prahran east",
		"state": "vic",
		"postcode": "3181"
	},
	{
		"town": "prairie",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "prairie",
		"state": "vic",
		"postcode": "3572"
	},
	{
		"town": "prairiewood",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "pranjip",
		"state": "vic",
		"postcode": "3665"
	},
	{
		"town": "pratten",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "prawle",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "premaydena",
		"state": "tas",
		"postcode": "7185"
	},
	{
		"town": "premer",
		"state": "nsw",
		"postcode": "2381"
	},
	{
		"town": "prentice north",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "prenzlau",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "preolenna",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "preservation bay",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "preston",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "preston",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "preston",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "preston",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "preston beach",
		"state": "wa",
		"postcode": "6215"
	},
	{
		"town": "preston lower",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "preston south",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "preston west",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "prestons",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "pretty beach",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "pretty gully",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "pretty pine",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "pretty plains",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "pretty valley",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "prevelly",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "price",
		"state": "sa",
		"postcode": "5570"
	},
	{
		"town": "priestdale",
		"state": "qld",
		"postcode": "4127"
	},
	{
		"town": "priests gully",
		"state": "qld",
		"postcode": "4123"
	},
	{
		"town": "primbee",
		"state": "nsw",
		"postcode": "2502"
	},
	{
		"town": "primrose",
		"state": "tas",
		"postcode": "7470"
	},
	{
		"town": "primrose hill",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "primrose sands",
		"state": "tas",
		"postcode": "7173"
	},
	{
		"town": "prince henry heights",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "princes hill",
		"state": "vic",
		"postcode": "3054"
	},
	{
		"town": "princess alexandra hospital",
		"state": "qld",
		"postcode": "4102"
	},
	{
		"town": "princess river",
		"state": "tas",
		"postcode": "7466"
	},
	{
		"town": "princetown",
		"state": "vic",
		"postcode": "3269"
	},
	{
		"town": "priors pocket",
		"state": "qld",
		"postcode": "4070"
	},
	{
		"town": "priory",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "proctors",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "promised land",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "promisedland",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "proof range",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "prooinga",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "proserpine",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "prospect",
		"state": "nsw",
		"postcode": "2148"
	},
	{
		"town": "prospect",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "prospect",
		"state": "sa",
		"postcode": "5082"
	},
	{
		"town": "prospect",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "prospect east",
		"state": "sa",
		"postcode": "5082"
	},
	{
		"town": "prospect hill",
		"state": "sa",
		"postcode": "5201"
	},
	{
		"town": "prospect vale",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "prospect west",
		"state": "sa",
		"postcode": "5082"
	},
	{
		"town": "proston",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "providence portal",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "prunevale",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "pucawan",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "puckapunyal milpo",
		"state": "vic",
		"postcode": "3662"
	},
	{
		"town": "puddledock",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "pularumpi",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "pulganbar",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "pullabooka",
		"state": "nsw",
		"postcode": "2810"
	},
	{
		"town": "pullaming",
		"state": "nsw",
		"postcode": "2381"
	},
	{
		"town": "pullenvale",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "pulletop",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "pullut",
		"state": "vic",
		"postcode": "3422"
	},
	{
		"town": "pulumpa",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "pumpenbil",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "pumphreys bridge",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "punchbowl",
		"state": "nsw",
		"postcode": "2196"
	},
	{
		"town": "punchbowl",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "punchbowl",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "punchbowl",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "punchs creek",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "puntabie",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "punthari",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "punyelroo",
		"state": "sa",
		"postcode": "5354"
	},
	{
		"town": "pura pura",
		"state": "vic",
		"postcode": "3271"
	},
	{
		"town": "puralka",
		"state": "vic",
		"postcode": "3311"
	},
	{
		"town": "purdeet",
		"state": "vic",
		"postcode": "3289"
	},
	{
		"town": "pureba",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "purfleet",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "purga",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "purlewaugh",
		"state": "nsw",
		"postcode": "2357"
	},
	{
		"town": "purnim",
		"state": "vic",
		"postcode": "3278"
	},
	{
		"town": "purnong landing",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "purono park",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "purrawunda",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "putney",
		"state": "nsw",
		"postcode": "2112"
	},
	{
		"town": "putta bucca",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "putty",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "pyalong",
		"state": "vic",
		"postcode": "3521"
	},
	{
		"town": "pyangle",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "pyap",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "pyap west",
		"state": "sa",
		"postcode": "5333"
	},
	{
		"town": "pyengana",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "pyes creek",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "pygery",
		"state": "sa",
		"postcode": "5655"
	},
	{
		"town": "pymble",
		"state": "nsw",
		"postcode": "2073"
	},
	{
		"town": "pyramid",
		"state": "qld",
		"postcode": "4865"
	},
	{
		"town": "pyramid hill",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "pyramul",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "pyree",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "pyrmont",
		"state": "nsw",
		"postcode": "2009"
	},
	{
		"town": "q supercentre",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "quaama",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "quairading",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "quakers hill",
		"state": "nsw",
		"postcode": "2763"
	},
	{
		"town": "quakers hill",
		"state": "nsw",
		"postcode": "2764"
	},
	{
		"town": "qualco",
		"state": "sa",
		"postcode": "5320"
	},
	{
		"town": "qualco",
		"state": "sa",
		"postcode": "5322"
	},
	{
		"town": "qualeup",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "quambatook",
		"state": "vic",
		"postcode": "3540"
	},
	{
		"town": "quambone",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "quamby bend",
		"state": "tas",
		"postcode": "7292"
	},
	{
		"town": "quamby brook",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "quandary",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "quandialla",
		"state": "nsw",
		"postcode": "2721"
	},
	{
		"town": "quandong",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "quantong",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "quarry hill",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "queanbeyan",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "queanbeyan east",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "quedjinup",
		"state": "wa",
		"postcode": "6281"
	},
	{
		"town": "queen victoria building",
		"state": "nsw",
		"postcode": "1226"
	},
	{
		"town": "queen victoria building",
		"state": "nsw",
		"postcode": "1227"
	},
	{
		"town": "queen victoria building",
		"state": "nsw",
		"postcode": "1228"
	},
	{
		"town": "queen victoria building",
		"state": "nsw",
		"postcode": "1229"
	},
	{
		"town": "queen victoria building",
		"state": "nsw",
		"postcode": "1230"
	},
	{
		"town": "queen victoria building",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "queens beach",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "queens domain",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "queens park",
		"state": "nsw",
		"postcode": "2022"
	},
	{
		"town": "queens park",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "queens pinch",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "queens road melbourne",
		"state": "vic",
		"postcode": "3004"
	},
	{
		"town": "queenscliff",
		"state": "nsw",
		"postcode": "2096"
	},
	{
		"town": "queenscliff",
		"state": "vic",
		"postcode": "3225"
	},
	{
		"town": "queensferry",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "queenstown",
		"state": "sa",
		"postcode": "5014"
	},
	{
		"town": "queenstown",
		"state": "tas",
		"postcode": "7467"
	},
	{
		"town": "queenstown",
		"state": "vic",
		"postcode": "3761"
	},
	{
		"town": "queenton",
		"state": "qld",
		"postcode": "4820"
	},
	{
		"town": "quelagetting",
		"state": "wa",
		"postcode": "6405"
	},
	{
		"town": "quellington",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "quialigo",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "quidong",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "quilpie",
		"state": "qld",
		"postcode": "4480"
	},
	{
		"town": "quinalow",
		"state": "qld",
		"postcode": "4403"
	},
	{
		"town": "quindalup",
		"state": "wa",
		"postcode": "6281"
	},
	{
		"town": "quindanning",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "quinninup",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "quinns rocks",
		"state": "wa",
		"postcode": "6030"
	},
	{
		"town": "quipolly",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "quirindi",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "qunaba",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "quoiba",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "quorn",
		"state": "sa",
		"postcode": "5433"
	},
	{
		"town": "quorrobolong",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "raby",
		"state": "nsw",
		"postcode": "2566"
	},
	{
		"town": "raby bay",
		"state": "qld",
		"postcode": "4163"
	},
	{
		"town": "racecourse",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "racecourse bay",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "raceview",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "radford",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "radnor",
		"state": "tas",
		"postcode": "7182"
	},
	{
		"town": "raglan",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "raglan",
		"state": "qld",
		"postcode": "4697"
	},
	{
		"town": "raglan",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "railton",
		"state": "tas",
		"postcode": "7305"
	},
	{
		"town": "railway estate",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "rainbow",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "rainbow bay",
		"state": "qld",
		"postcode": "4225"
	},
	{
		"town": "rainbow beach",
		"state": "qld",
		"postcode": "4581"
	},
	{
		"town": "rainbow flat",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "rainbow reach",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "rainworth",
		"state": "qld",
		"postcode": "4065"
	},
	{
		"town": "raleigh",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "raluana",
		"state": "vic",
		"postcode": "3387"
	},
	{
		"town": "ramco",
		"state": "sa",
		"postcode": "5322"
	},
	{
		"town": "ramco heights",
		"state": "sa",
		"postcode": "5322"
	},
	{
		"town": "raminea",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "ramingining",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "ramornie",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "ramsay",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "ramsay",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "ramsgate",
		"state": "nsw",
		"postcode": "2217"
	},
	{
		"town": "ramsgate beach",
		"state": "nsw",
		"postcode": "2217"
	},
	{
		"town": "ranceby",
		"state": "vic",
		"postcode": "3951"
	},
	{
		"town": "rand",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "randalls bay",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "randwick",
		"state": "nsw",
		"postcode": "2031"
	},
	{
		"town": "ranelagh",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "ranford",
		"state": "wa",
		"postcode": "6390"
	},
	{
		"town": "ranga",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "rangari",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "rangers valley",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "ranges bridge",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "rangeview",
		"state": "vic",
		"postcode": "3132"
	},
	{
		"town": "rangeville",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "rangeway",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "rangewood",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "rangie",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "rankin park",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "rankins springs",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "rannes",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "rannock",
		"state": "nsw",
		"postcode": "2701"
	},
	{
		"town": "ransome",
		"state": "qld",
		"postcode": "4154"
	},
	{
		"town": "rapid bay",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "rapid creek",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "rappville",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "rasmussen",
		"state": "qld",
		"postcode": "4815"
	},
	{
		"town": "rathdowney",
		"state": "qld",
		"postcode": "4287"
	},
	{
		"town": "rathluba lagoon",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "rathluba ridge",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "rathmines",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "rathscar",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "rathscar west",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "raukkan",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "ravenhall",
		"state": "vic",
		"postcode": "3023"
	},
	{
		"town": "ravenna",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "ravensbourne",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "ravensdale",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "ravensdale",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "ravenshoe",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "ravensthorpe",
		"state": "wa",
		"postcode": "6346"
	},
	{
		"town": "ravenswood",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "ravenswood",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "ravenswood",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "ravenswood",
		"state": "vic",
		"postcode": "3453"
	},
	{
		"town": "ravenswood",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "ravenswood south",
		"state": "vic",
		"postcode": "3453"
	},
	{
		"town": "ravensworth",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "rawbelle",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "rawdon island",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "rawdon vale",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "rawlinna",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "raworth",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "rawson",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "rawsonville",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "raymond island",
		"state": "vic",
		"postcode": "3880"
	},
	{
		"town": "raymond terrace",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "raymond terrace east",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "raymonds hill",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "raywood",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "razorback",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "razorback",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "recherche",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "red banks",
		"state": "sa",
		"postcode": "5502"
	},
	{
		"town": "red bluff",
		"state": "vic",
		"postcode": "3695"
	},
	{
		"town": "red camp",
		"state": "vic",
		"postcode": "3732"
	},
	{
		"town": "red cliffs",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "red creek",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "red gully",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "red head",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "red hill",
		"state": "act",
		"postcode": "2603"
	},
	{
		"town": "red hill",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "red hill",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "red hill",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "red hill",
		"state": "qld",
		"postcode": "4059"
	},
	{
		"town": "red hill",
		"state": "vic",
		"postcode": "3937"
	},
	{
		"town": "red hill",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "red hill south",
		"state": "vic",
		"postcode": "3937"
	},
	{
		"town": "red hills",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "red lake",
		"state": "wa",
		"postcode": "6446"
	},
	{
		"town": "red range",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "red rock",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "redan",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "redbank",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "redbank",
		"state": "qld",
		"postcode": "4301"
	},
	{
		"town": "redbank",
		"state": "qld",
		"postcode": "4865"
	},
	{
		"town": "redbank",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "redbank",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "redbank creek",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "redbank plains",
		"state": "qld",
		"postcode": "4301"
	},
	{
		"town": "redbournberry",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "redcastle",
		"state": "vic",
		"postcode": "3523"
	},
	{
		"town": "redcliffe",
		"state": "qld",
		"postcode": "4020"
	},
	{
		"town": "redcliffe",
		"state": "wa",
		"postcode": "6104"
	},
	{
		"town": "redcliffe north",
		"state": "qld",
		"postcode": "4020"
	},
	{
		"town": "reddestone",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "redesdale",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "redfern",
		"state": "nsw",
		"postcode": "2016"
	},
	{
		"town": "redgate",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "redgate",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "redhead",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "redhill",
		"state": "sa",
		"postcode": "5521"
	},
	{
		"town": "redhill farms",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "redland bay",
		"state": "qld",
		"postcode": "4165"
	},
	{
		"town": "redlands",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "redlynch",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "redmond",
		"state": "wa",
		"postcode": "6327"
	},
	{
		"town": "redpa",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "redridge",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "redwood",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "redwood park",
		"state": "sa",
		"postcode": "5097"
	},
	{
		"town": "reedy",
		"state": "wa",
		"postcode": "6640"
	},
	{
		"town": "reedy creek",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "reedy creek",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "reedy creek",
		"state": "qld",
		"postcode": "4228"
	},
	{
		"town": "reedy creek",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "reedy creek",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "reedy creek",
		"state": "vic",
		"postcode": "3895"
	},
	{
		"town": "reedy dam",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "reedy lake",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "reedy marsh",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "reedy swamp",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "reefton",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "reefton",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "reekara",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "reesville",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "reeves plains",
		"state": "sa",
		"postcode": "5502"
	},
	{
		"town": "regans ford",
		"state": "wa",
		"postcode": "6507"
	},
	{
		"town": "regatta point",
		"state": "tas",
		"postcode": "7468"
	},
	{
		"town": "regency downs",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "regency park",
		"state": "sa",
		"postcode": "5010"
	},
	{
		"town": "regency park",
		"state": "sa",
		"postcode": "5942"
	},
	{
		"town": "regent west",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "regents park",
		"state": "nsw",
		"postcode": "2143"
	},
	{
		"town": "regents park",
		"state": "qld",
		"postcode": "4118"
	},
	{
		"town": "regentville",
		"state": "nsw",
		"postcode": "2745"
	},
	{
		"town": "reid",
		"state": "act",
		"postcode": "2612"
	},
	{
		"town": "reid",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "reids creek",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "reids creek",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "reids flat",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "reidsdale",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "reidtown",
		"state": "nsw",
		"postcode": "2519"
	},
	{
		"town": "reinscourt",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "rekuna",
		"state": "tas",
		"postcode": "7026"
	},
	{
		"town": "relbia",
		"state": "tas",
		"postcode": "7258"
	},
	{
		"town": "remlaw",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "rendelsham",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "renison bell",
		"state": "tas",
		"postcode": "7469"
	},
	{
		"town": "renmark",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "renmark north",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "renmark south",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "renmark west",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "renner springs",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "rennie",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "reno",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "renown park",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "repentance creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "repton",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "research",
		"state": "vic",
		"postcode": "3095"
	},
	{
		"town": "reseigh",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "reserve creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "reservoir",
		"state": "vic",
		"postcode": "3073"
	},
	{
		"town": "reservoir",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "reservoir east",
		"state": "vic",
		"postcode": "3073"
	},
	{
		"town": "reservoir north",
		"state": "vic",
		"postcode": "3073"
	},
	{
		"town": "reservoir south",
		"state": "vic",
		"postcode": "3073"
	},
	{
		"town": "retreat",
		"state": "nsw",
		"postcode": "2713"
	},
	{
		"town": "retreat",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "revesby",
		"state": "nsw",
		"postcode": "2212"
	},
	{
		"town": "revesby heights",
		"state": "nsw",
		"postcode": "2212"
	},
	{
		"town": "revesby north",
		"state": "nsw",
		"postcode": "2212"
	},
	{
		"town": "reynella",
		"state": "sa",
		"postcode": "5161"
	},
	{
		"town": "reynella east",
		"state": "sa",
		"postcode": "5161"
	},
	{
		"town": "rheban",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "rheola",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "rhine falls",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "rhodes",
		"state": "nsw",
		"postcode": "2138"
	},
	{
		"town": "rhydding",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "rhyll",
		"state": "vic",
		"postcode": "3923"
	},
	{
		"town": "rhymney",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "rhyndaston",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "rhynie",
		"state": "sa",
		"postcode": "5412"
	},
	{
		"town": "riachella",
		"state": "vic",
		"postcode": "3385"
	},
	{
		"town": "rialto",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "riamukka",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "riana",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "rich avon",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "rich avon east",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "rich avon west",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "richanna heights",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "richardson",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "richlands",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "richlands",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "richmond",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "richmond",
		"state": "nsw",
		"postcode": "2755"
	},
	{
		"town": "richmond",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "richmond",
		"state": "qld",
		"postcode": "4822"
	},
	{
		"town": "richmond",
		"state": "sa",
		"postcode": "5033"
	},
	{
		"town": "richmond",
		"state": "tas",
		"postcode": "7025"
	},
	{
		"town": "richmond",
		"state": "vic",
		"postcode": "3121"
	},
	{
		"town": "richmond east",
		"state": "vic",
		"postcode": "3121"
	},
	{
		"town": "richmond hill",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "richmond hill",
		"state": "qld",
		"postcode": "4820"
	},
	{
		"town": "richmond hill",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "richmond north",
		"state": "vic",
		"postcode": "3121"
	},
	{
		"town": "richmond plains",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "richmond south",
		"state": "vic",
		"postcode": "3121"
	},
	{
		"town": "ricketts point",
		"state": "vic",
		"postcode": "3193"
	},
	{
		"town": "riddell",
		"state": "vic",
		"postcode": "3431"
	},
	{
		"town": "riddells creek",
		"state": "vic",
		"postcode": "3431"
	},
	{
		"town": "ridgehaven",
		"state": "sa",
		"postcode": "5097"
	},
	{
		"town": "ridgelands",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "ridgeway",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "ridgeway",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "ridgewood",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "ridgewood",
		"state": "wa",
		"postcode": "6030"
	},
	{
		"town": "ridgley",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "ridleyton",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "rifle range",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "riggs creek",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "rileys hill",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "ringa",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "ringarooma",
		"state": "tas",
		"postcode": "7263"
	},
	{
		"town": "ringtail creek",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "ringwood",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "ringwood",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "ringwood",
		"state": "vic",
		"postcode": "3134"
	},
	{
		"town": "ringwood east",
		"state": "vic",
		"postcode": "3135"
	},
	{
		"town": "ringwood north",
		"state": "vic",
		"postcode": "3134"
	},
	{
		"town": "rio vista",
		"state": "qld",
		"postcode": "4218"
	},
	{
		"town": "riordanvale",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "ripley",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "ripplebrook",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "rippleside",
		"state": "vic",
		"postcode": "3215"
	},
	{
		"town": "ripponhurst",
		"state": "vic",
		"postcode": "3286"
	},
	{
		"town": "ripponlea",
		"state": "vic",
		"postcode": "3185"
	},
	{
		"town": "risdon",
		"state": "tas",
		"postcode": "7017"
	},
	{
		"town": "risdon park",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "risdon park south",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "risdon vale",
		"state": "tas",
		"postcode": "7016"
	},
	{
		"town": "rising sun",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "rita island",
		"state": "qld",
		"postcode": "4807"
	},
	{
		"town": "river heads",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "river ranch",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "riverford",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "riverglades",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "riverglen",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "riverhills",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "riverina msc",
		"state": "nsw",
		"postcode": "2678"
	},
	{
		"town": "riverlea",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "riverleigh",
		"state": "qld",
		"postcode": "4626"
	},
	{
		"town": "riverside",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "riverside",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "riverside",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "riverside centre",
		"state": "qld",
		"postcode": "4001"
	},
	{
		"town": "riverslea",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "riverstone",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "riverton",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "riverton",
		"state": "sa",
		"postcode": "5412"
	},
	{
		"town": "riverton",
		"state": "wa",
		"postcode": "6148"
	},
	{
		"town": "rivertree",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "rivervale",
		"state": "wa",
		"postcode": "6103"
	},
	{
		"town": "riverview",
		"state": "nsw",
		"postcode": "2066"
	},
	{
		"town": "riverview",
		"state": "qld",
		"postcode": "4303"
	},
	{
		"town": "riverview",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "riverwood",
		"state": "nsw",
		"postcode": "2210"
	},
	{
		"town": "rivett",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "rixs creek",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "roadvale",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "rob roy",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "robbins island",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "robe",
		"state": "sa",
		"postcode": "5276"
	},
	{
		"town": "robertson",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "robertson",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "robertson",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "robertsons beach",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "robertstown",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "robigana",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "robin hill",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "robin hood",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "robina",
		"state": "qld",
		"postcode": "4226"
	},
	{
		"town": "robina town centre",
		"state": "qld",
		"postcode": "4230"
	},
	{
		"town": "robinson",
		"state": "vic",
		"postcode": "3019"
	},
	{
		"town": "robinson",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "robinvale",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "rochedale",
		"state": "qld",
		"postcode": "4123"
	},
	{
		"town": "rochedale south",
		"state": "qld",
		"postcode": "4123"
	},
	{
		"town": "rocherlea",
		"state": "tas",
		"postcode": "7248"
	},
	{
		"town": "roches beach",
		"state": "tas",
		"postcode": "7170"
	},
	{
		"town": "rochester",
		"state": "sa",
		"postcode": "5464"
	},
	{
		"town": "rochester",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "rochester west",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "rochford",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "rock flat",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "rock forest",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "rock valley",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "rock valley",
		"state": "vic",
		"postcode": "3699"
	},
	{
		"town": "rockbank",
		"state": "vic",
		"postcode": "3335"
	},
	{
		"town": "rockdale",
		"state": "nsw",
		"postcode": "2216"
	},
	{
		"town": "rockhampton",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "rockhampton city",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "rockhampton hospital",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "rockhampton north",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "rockhampton shopping fair",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "rockingham",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "rockingham",
		"state": "wa",
		"postcode": "6968"
	},
	{
		"town": "rockingham beach",
		"state": "wa",
		"postcode": "6168"
	},
	{
		"town": "rockingham beach",
		"state": "wa",
		"postcode": "6969"
	},
	{
		"town": "rocklands",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "rocklea",
		"state": "qld",
		"postcode": "4106"
	},
	{
		"town": "rocklea",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "rockleigh",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "rockley",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "rockley mount",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "rocklyn",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "rockmount",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "rocks crossing",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "rocksberg",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "rockside",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "rockton",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "rockville",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "rockwell",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "rocky cape",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "rocky creek",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "rocky creek",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "rocky crossing",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "rocky glen",
		"state": "nsw",
		"postcode": "2357"
	},
	{
		"town": "rocky gully",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "rocky gully",
		"state": "wa",
		"postcode": "6397"
	},
	{
		"town": "rocky hall",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "rocky hills",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "rocky lead",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "rocky plain",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "rocky point",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "rocky point",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "rocky point",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "rocky river",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "rockyview",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "rodborough",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "rodd point",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "rodds bay",
		"state": "qld",
		"postcode": "4678"
	},
	{
		"town": "roebourne",
		"state": "wa",
		"postcode": "6718"
	},
	{
		"town": "roebuck",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "roelands",
		"state": "wa",
		"postcode": "6226"
	},
	{
		"town": "rogans hill",
		"state": "nsw",
		"postcode": "2154"
	},
	{
		"town": "roger river",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "rogues point",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "rokeby",
		"state": "tas",
		"postcode": "7019"
	},
	{
		"town": "rokeby",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "rokewood",
		"state": "vic",
		"postcode": "3330"
	},
	{
		"town": "rokewood junction",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "roland",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "roleystone",
		"state": "wa",
		"postcode": "6111"
	},
	{
		"town": "rollands plains",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "rolleston",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "rollingstone",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "roma",
		"state": "qld",
		"postcode": "4455"
	},
	{
		"town": "romaine",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "romsey",
		"state": "vic",
		"postcode": "3434"
	},
	{
		"town": "rookhurst",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "rookwood",
		"state": "nsw",
		"postcode": "2141"
	},
	{
		"town": "rooty hill",
		"state": "nsw",
		"postcode": "2766"
	},
	{
		"town": "ropeley",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "rosa brook",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "rosa glen",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "rosalie",
		"state": "qld",
		"postcode": "4064"
	},
	{
		"town": "rosalind park",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "rosanna",
		"state": "vic",
		"postcode": "3084"
	},
	{
		"town": "rose bay",
		"state": "nsw",
		"postcode": "2029"
	},
	{
		"town": "rose bay",
		"state": "qld",
		"postcode": "4805"
	},
	{
		"town": "rose bay",
		"state": "tas",
		"postcode": "7015"
	},
	{
		"town": "rose bay north",
		"state": "nsw",
		"postcode": "2030"
	},
	{
		"town": "rose park",
		"state": "sa",
		"postcode": "5067"
	},
	{
		"town": "rose river",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "rose valley",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "rose valley",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "rosebank",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "roseberry",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "rosebery",
		"state": "nsw",
		"postcode": "1445"
	},
	{
		"town": "rosebery",
		"state": "nsw",
		"postcode": "2018"
	},
	{
		"town": "rosebery",
		"state": "nt",
		"postcode": "832"
	},
	{
		"town": "rosebery",
		"state": "tas",
		"postcode": "7470"
	},
	{
		"town": "rosebery",
		"state": "vic",
		"postcode": "3395"
	},
	{
		"town": "rosebery heights",
		"state": "nt",
		"postcode": "832"
	},
	{
		"town": "rosebrook",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "rosebrook",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "rosebud",
		"state": "vic",
		"postcode": "3939"
	},
	{
		"town": "rosebud plaza",
		"state": "vic",
		"postcode": "3939"
	},
	{
		"town": "rosebud west",
		"state": "vic",
		"postcode": "3940"
	},
	{
		"town": "rosedale",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "rosedale",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "rosedale",
		"state": "sa",
		"postcode": "5350"
	},
	{
		"town": "rosedale",
		"state": "vic",
		"postcode": "3847"
	},
	{
		"town": "rosegarland",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "rosehill",
		"state": "nsw",
		"postcode": "2142"
	},
	{
		"town": "roselands",
		"state": "nsw",
		"postcode": "2196"
	},
	{
		"town": "rosella",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "rosemeadow",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "rosemeath",
		"state": "nsw",
		"postcode": "2632"
	},
	{
		"town": "rosemount",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "roseneath",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "rosenthal",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "rosenthal",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "roses tier",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "rosetown",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "rosetta",
		"state": "tas",
		"postcode": "7010"
	},
	{
		"town": "rosevale",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "rosevale",
		"state": "tas",
		"postcode": "7292"
	},
	{
		"town": "rosevears",
		"state": "tas",
		"postcode": "7277"
	},
	{
		"town": "roseville",
		"state": "nsw",
		"postcode": "2069"
	},
	{
		"town": "roseville chase",
		"state": "nsw",
		"postcode": "2069"
	},
	{
		"town": "rosewater",
		"state": "sa",
		"postcode": "5013"
	},
	{
		"town": "rosewater east",
		"state": "sa",
		"postcode": "5013"
	},
	{
		"town": "rosewhite",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "rosewood",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "rosewood",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "rosewood",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "rosewood",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "roseworthy",
		"state": "sa",
		"postcode": "5371"
	},
	{
		"town": "roslyn",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "roslynmead",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "rosny",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "rosny park",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "ross",
		"state": "tas",
		"postcode": "7209"
	},
	{
		"town": "ross creek",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "ross hill",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "rossarden",
		"state": "tas",
		"postcode": "7213"
	},
	{
		"town": "rossbridge",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "rossglen",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "rossgole",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "rossi",
		"state": "nsw",
		"postcode": "2621"
	},
	{
		"town": "rosslea",
		"state": "qld",
		"postcode": "4812"
	},
	{
		"town": "rosslyn",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "rosslyn park",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "rossmore",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "rossmore",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "rossmoya",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "rossmoyne",
		"state": "wa",
		"postcode": "6148"
	},
	{
		"town": "rossvale",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "rossville",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "rostrevor",
		"state": "sa",
		"postcode": "5073"
	},
	{
		"town": "rostrevor",
		"state": "vic",
		"postcode": "3739"
	},
	{
		"town": "rostron",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "rosyth",
		"state": "vic",
		"postcode": "3468"
	},
	{
		"town": "rothbury",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "rothwell",
		"state": "qld",
		"postcode": "4022"
	},
	{
		"town": "roto",
		"state": "nsw",
		"postcode": "2675"
	},
	{
		"town": "rottnest island",
		"state": "wa",
		"postcode": "6161"
	},
	{
		"town": "rouchel",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "roughit",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "round corner",
		"state": "nsw",
		"postcode": "2158"
	},
	{
		"town": "round hill",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "round hill",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "round hill",
		"state": "wa",
		"postcode": "6510"
	},
	{
		"town": "round mountain",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "round swamp",
		"state": "nsw",
		"postcode": "2846"
	},
	{
		"town": "roundstone",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "rous",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "rous mill",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "rouse hill",
		"state": "nsw",
		"postcode": "2155"
	},
	{
		"town": "rowallan",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "rowan",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "rowella",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "rowena",
		"state": "nsw",
		"postcode": "2387"
	},
	{
		"town": "rowes bay",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "rowland",
		"state": "vic",
		"postcode": "3578"
	},
	{
		"town": "rowland flat",
		"state": "sa",
		"postcode": "5352"
	},
	{
		"town": "rowlands creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "rowsley",
		"state": "vic",
		"postcode": "3340"
	},
	{
		"town": "rowville",
		"state": "vic",
		"postcode": "3178"
	},
	{
		"town": "roxburgh",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "roxburgh park",
		"state": "vic",
		"postcode": "3064"
	},
	{
		"town": "roxby downs",
		"state": "sa",
		"postcode": "5725"
	},
	{
		"town": "roy hill",
		"state": "wa",
		"postcode": "6753"
	},
	{
		"town": "royal australian navy warships",
		"state": "wa",
		"postcode": "6958"
	},
	{
		"town": "royal brisbane hospital",
		"state": "qld",
		"postcode": "4029"
	},
	{
		"town": "royal exchange",
		"state": "nsw",
		"postcode": "1221"
	},
	{
		"town": "royal exchange",
		"state": "nsw",
		"postcode": "1222"
	},
	{
		"town": "royal exchange",
		"state": "nsw",
		"postcode": "1223"
	},
	{
		"town": "royal exchange",
		"state": "nsw",
		"postcode": "1224"
	},
	{
		"town": "royal exchange",
		"state": "nsw",
		"postcode": "1225"
	},
	{
		"town": "royal george",
		"state": "tas",
		"postcode": "7213"
	},
	{
		"town": "royal melbourne hospital",
		"state": "vic",
		"postcode": "3050"
	},
	{
		"town": "royal north shore hospital",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "royal park",
		"state": "sa",
		"postcode": "5014"
	},
	{
		"town": "royalla",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "roys",
		"state": "vic",
		"postcode": "3869"
	},
	{
		"town": "royston",
		"state": "vic",
		"postcode": "3712"
	},
	{
		"town": "royston park",
		"state": "sa",
		"postcode": "5070"
	},
	{
		"town": "rozelle",
		"state": "nsw",
		"postcode": "2039"
	},
	{
		"town": "ruabon",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "rubicon",
		"state": "vic",
		"postcode": "3712"
	},
	{
		"town": "rubicon free bag",
		"state": "vic",
		"postcode": "3639"
	},
	{
		"town": "ruby",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "rubyanna",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "rubyvale",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "rudall",
		"state": "sa",
		"postcode": "5642"
	},
	{
		"town": "rudds gully",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "ruffy",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "rufus river",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "rugby",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "rukenvale",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "rules beach",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "rumbug",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "run-o-waters",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "runaway bay",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "runcorn",
		"state": "qld",
		"postcode": "4113"
	},
	{
		"town": "rundells",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "rundle mall",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "running creek",
		"state": "qld",
		"postcode": "4287"
	},
	{
		"town": "running creek",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "running stream",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "runnyford",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "runnymede",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "runnymede",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "runnymede",
		"state": "vic",
		"postcode": "3559"
	},
	{
		"town": "rupanyup",
		"state": "vic",
		"postcode": "3388"
	},
	{
		"town": "rupertswood",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "rupertswood",
		"state": "vic",
		"postcode": "3429"
	},
	{
		"town": "rural view",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "ruse",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "rush creek",
		"state": "qld",
		"postcode": "4521"
	},
	{
		"town": "rushcutters bay",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "rushforth",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "rushworth",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "rushy lagoon",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "russell",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "russell hill",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "russell island",
		"state": "qld",
		"postcode": "4184"
	},
	{
		"town": "russell lea",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "russell vale",
		"state": "nsw",
		"postcode": "2517"
	},
	{
		"town": "russells bridge",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "russells creek",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "rutherford",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "rutherglen",
		"state": "vic",
		"postcode": "3685"
	},
	{
		"town": "ruthven",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "rutland",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "ryan",
		"state": "nsw",
		"postcode": "2658"
	},
	{
		"town": "ryan",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "ryans creek",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "ryans estate",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "ryanston",
		"state": "vic",
		"postcode": "3992"
	},
	{
		"town": "rydal",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "rydalmere",
		"state": "nsw",
		"postcode": "2116"
	},
	{
		"town": "ryde",
		"state": "nsw",
		"postcode": "1680"
	},
	{
		"town": "ryde",
		"state": "nsw",
		"postcode": "2112"
	},
	{
		"town": "rye",
		"state": "vic",
		"postcode": "3941"
	},
	{
		"town": "rye park",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "ryeford",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "ryhope",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "rylstone",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "rynaby",
		"state": "vic",
		"postcode": "3595"
	},
	{
		"town": "rythdale",
		"state": "vic",
		"postcode": "3810"
	},
	{
		"town": "ryton",
		"state": "vic",
		"postcode": "3870"
	},
	{
		"town": "sabina river",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "sackville",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "sackville north",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "saddleback mountain",
		"state": "nsw",
		"postcode": "2533"
	},
	{
		"town": "saddleworth",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "sadleir",
		"state": "nsw",
		"postcode": "2168"
	},
	{
		"town": "sadliers crossing",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "safety bay",
		"state": "wa",
		"postcode": "6169"
	},
	{
		"town": "safety beach",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "safety beach",
		"state": "vic",
		"postcode": "3936"
	},
	{
		"town": "saibai island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "sailors falls",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "sailors gully",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "saint ronans",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "saints",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "salamander bay",
		"state": "nsw",
		"postcode": "2317"
	},
	{
		"town": "sale",
		"state": "vic",
		"postcode": "3850"
	},
	{
		"town": "sale",
		"state": "vic",
		"postcode": "3853"
	},
	{
		"town": "sale north",
		"state": "vic",
		"postcode": "3850"
	},
	{
		"town": "salem",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "salisbury",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "salisbury",
		"state": "qld",
		"postcode": "4107"
	},
	{
		"town": "salisbury",
		"state": "sa",
		"postcode": "5108"
	},
	{
		"town": "salisbury downs",
		"state": "sa",
		"postcode": "5108"
	},
	{
		"town": "salisbury east",
		"state": "qld",
		"postcode": "4107"
	},
	{
		"town": "salisbury east",
		"state": "sa",
		"postcode": "5109"
	},
	{
		"town": "salisbury heights",
		"state": "sa",
		"postcode": "5109"
	},
	{
		"town": "salisbury north",
		"state": "sa",
		"postcode": "5108"
	},
	{
		"town": "salisbury north whites road",
		"state": "sa",
		"postcode": "5108"
	},
	{
		"town": "salisbury park",
		"state": "sa",
		"postcode": "5109"
	},
	{
		"town": "salisbury plain",
		"state": "sa",
		"postcode": "5109"
	},
	{
		"town": "salisbury south",
		"state": "sa",
		"postcode": "5106"
	},
	{
		"town": "salisbury west",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "sallys flat",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "salmon gums",
		"state": "wa",
		"postcode": "6445"
	},
	{
		"town": "salonika beach",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "salt ash",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "salt creek",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "salt creek",
		"state": "vic",
		"postcode": "3272"
	},
	{
		"town": "salt lakes",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "salter point",
		"state": "wa",
		"postcode": "6152"
	},
	{
		"town": "salter springs",
		"state": "sa",
		"postcode": "5401"
	},
	{
		"town": "saltern",
		"state": "qld",
		"postcode": "4725"
	},
	{
		"town": "saltwater",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "saltwater river",
		"state": "tas",
		"postcode": "7186"
	},
	{
		"town": "samaria",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "samford",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "samford valley",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "samford village",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "sampson flat",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "samson",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "samsonvale",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "san isidore",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "san remo",
		"state": "nsw",
		"postcode": "2262"
	},
	{
		"town": "san remo",
		"state": "vic",
		"postcode": "3925"
	},
	{
		"town": "san remo",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "sancrox",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "sanctuary cove",
		"state": "qld",
		"postcode": "4212"
	},
	{
		"town": "sanctuary lakes",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "sanctuary point",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "sandalwood",
		"state": "sa",
		"postcode": "5309"
	},
	{
		"town": "sandbar",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "sandergrove",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "sanderson",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "sanderson",
		"state": "nt",
		"postcode": "813"
	},
	{
		"town": "sanderston",
		"state": "sa",
		"postcode": "5237"
	},
	{
		"town": "sandfly",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "sandford",
		"state": "tas",
		"postcode": "7020"
	},
	{
		"town": "sandford",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "sandgate",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "sandgate",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "sandhill",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "sandhill lake",
		"state": "vic",
		"postcode": "3581"
	},
	{
		"town": "sandhurst east",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "sandiford",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "sandigo",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "sandilands",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "sandmount",
		"state": "vic",
		"postcode": "3640"
	},
	{
		"town": "sandon",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "sandon",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "sandown park",
		"state": "vic",
		"postcode": "3171"
	},
	{
		"town": "sandown village",
		"state": "vic",
		"postcode": "3171"
	},
	{
		"town": "sandringham",
		"state": "nsw",
		"postcode": "2219"
	},
	{
		"town": "sandringham",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "sandringham",
		"state": "vic",
		"postcode": "3191"
	},
	{
		"town": "sandsmere",
		"state": "vic",
		"postcode": "3419"
	},
	{
		"town": "sandsprings",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "sandstone",
		"state": "wa",
		"postcode": "6639"
	},
	{
		"town": "sandstone point",
		"state": "qld",
		"postcode": "4511"
	},
	{
		"town": "sandy bay",
		"state": "tas",
		"postcode": "7005"
	},
	{
		"town": "sandy bay",
		"state": "tas",
		"postcode": "7006"
	},
	{
		"town": "sandy beach",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "sandy camp",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "sandy creek",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "sandy creek",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "sandy creek",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "sandy creek",
		"state": "sa",
		"postcode": "5350"
	},
	{
		"town": "sandy creek",
		"state": "vic",
		"postcode": "3695"
	},
	{
		"town": "sandy crossing",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "sandy flat",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "sandy grove",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "sandy gully",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "sandy gully",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "sandy hill",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "sandy hollow",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "sandy point",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "sandy point",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "sandy ridges",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "sans souci",
		"state": "nsw",
		"postcode": "2219"
	},
	{
		"town": "sans souci",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "santa barbara",
		"state": "qld",
		"postcode": "4212"
	},
	{
		"town": "santa fe heights",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "santa teresa",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "sapphire",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "sapphire",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "sapphire beach",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "sapphiretown",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "sarabah",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "saratoga",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "sardine creek",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "sarina",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "sarina beach",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "sarina range",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "sarsfield",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "sassafras",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "sassafras",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "sassafras",
		"state": "vic",
		"postcode": "3787"
	},
	{
		"town": "sassafras gully",
		"state": "vic",
		"postcode": "3787"
	},
	{
		"town": "sassafras south",
		"state": "vic",
		"postcode": "3791"
	},
	{
		"town": "satur",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "saunders beach",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "savage river",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "savernake",
		"state": "nsw",
		"postcode": "2646"
	},
	{
		"town": "sawmill settlement",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "sawpit creek",
		"state": "nsw",
		"postcode": "2627"
	},
	{
		"town": "sawtell",
		"state": "nsw",
		"postcode": "2452"
	},
	{
		"town": "sawyers gully",
		"state": "nsw",
		"postcode": "2326"
	},
	{
		"town": "sawyers valley",
		"state": "wa",
		"postcode": "6074"
	},
	{
		"town": "saxa",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "scaddan",
		"state": "wa",
		"postcode": "6447"
	},
	{
		"town": "scamander",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "scarborough",
		"state": "nsw",
		"postcode": "2515"
	},
	{
		"town": "scarborough",
		"state": "qld",
		"postcode": "4020"
	},
	{
		"town": "scarborough",
		"state": "wa",
		"postcode": "6019"
	},
	{
		"town": "scarborough",
		"state": "wa",
		"postcode": "6922"
	},
	{
		"town": "scarness",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "scarsdale",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "sceale bay",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "schell well",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "scheyville",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "schofields",
		"state": "nsw",
		"postcode": "2762"
	},
	{
		"town": "schroeder",
		"state": "wa",
		"postcode": "6285"
	},
	{
		"town": "scone",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "scoresby",
		"state": "vic",
		"postcode": "3179"
	},
	{
		"town": "scotchman",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "scotchmans",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "scotchy pocket",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "scotia",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "scotland island",
		"state": "nsw",
		"postcode": "2105"
	},
	{
		"town": "scotsburn",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "scotsmans lead",
		"state": "vic",
		"postcode": "3357"
	},
	{
		"town": "scott creek",
		"state": "sa",
		"postcode": "5153"
	},
	{
		"town": "scott river",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "scotts creek",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "scotts creek",
		"state": "vic",
		"postcode": "3267"
	},
	{
		"town": "scotts flat",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "scotts head",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "scotts point",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "scottsdale",
		"state": "tas",
		"postcode": "7260"
	},
	{
		"town": "scottville",
		"state": "qld",
		"postcode": "4804"
	},
	{
		"town": "scrub creek",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "scrubby creek",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "scrubby lake",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "scrubby mountain",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "scullin",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "sea elephant",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "sea lake",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "seabird",
		"state": "wa",
		"postcode": "6042"
	},
	{
		"town": "seabrook",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "seabrook",
		"state": "vic",
		"postcode": "3028"
	},
	{
		"town": "seacliff",
		"state": "sa",
		"postcode": "5049"
	},
	{
		"town": "seacliff park",
		"state": "sa",
		"postcode": "5049"
	},
	{
		"town": "seacombe",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "seacombe gardens",
		"state": "sa",
		"postcode": "5047"
	},
	{
		"town": "seacombe heights",
		"state": "sa",
		"postcode": "5047"
	},
	{
		"town": "seaford",
		"state": "sa",
		"postcode": "5169"
	},
	{
		"town": "seaford",
		"state": "vic",
		"postcode": "3198"
	},
	{
		"town": "seaford heights",
		"state": "sa",
		"postcode": "5169"
	},
	{
		"town": "seaford meadows",
		"state": "sa",
		"postcode": "5169"
	},
	{
		"town": "seaford rise",
		"state": "sa",
		"postcode": "5169"
	},
	{
		"town": "seaforth",
		"state": "nsw",
		"postcode": "2092"
	},
	{
		"town": "seaforth",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "seaham",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "seahampton",
		"state": "nsw",
		"postcode": "2286"
	},
	{
		"town": "seaholme",
		"state": "vic",
		"postcode": "3018"
	},
	{
		"town": "seal bay",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "seal rocks",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "seaspray",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "seaton",
		"state": "sa",
		"postcode": "5023"
	},
	{
		"town": "seaton",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "seaton north",
		"state": "sa",
		"postcode": "5023"
	},
	{
		"town": "seaview",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "seaview downs",
		"state": "sa",
		"postcode": "5049"
	},
	{
		"town": "seaview heights",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "seaview heights",
		"state": "qld",
		"postcode": "4750"
	},
	{
		"town": "sebastian",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "sebastopol",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "sebastopol",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "sebastopol",
		"state": "vic",
		"postcode": "3356"
	},
	{
		"town": "second valley",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "secret harbour",
		"state": "wa",
		"postcode": "6173"
	},
	{
		"town": "sedan",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "seddon",
		"state": "vic",
		"postcode": "3011"
	},
	{
		"town": "seddon west",
		"state": "vic",
		"postcode": "3011"
	},
	{
		"town": "sedgefield",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "sedgwick",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "seelands",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "sefton",
		"state": "nsw",
		"postcode": "2162"
	},
	{
		"town": "sefton park",
		"state": "sa",
		"postcode": "5083"
	},
	{
		"town": "segenhoe",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "seisia",
		"state": "qld",
		"postcode": "4876"
	},
	{
		"town": "selbourne",
		"state": "tas",
		"postcode": "7292"
	},
	{
		"town": "selby",
		"state": "vic",
		"postcode": "3159"
	},
	{
		"town": "selene",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "sellheim",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "sellicks beach",
		"state": "sa",
		"postcode": "5174"
	},
	{
		"town": "sellicks hill",
		"state": "sa",
		"postcode": "5174"
	},
	{
		"town": "semaphore",
		"state": "sa",
		"postcode": "5019"
	},
	{
		"town": "semaphore park",
		"state": "sa",
		"postcode": "5019"
	},
	{
		"town": "semaphore south",
		"state": "sa",
		"postcode": "5019"
	},
	{
		"town": "senior",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "separation creek",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "seppeltsfield",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "seppings",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "septimus",
		"state": "qld",
		"postcode": "4754"
	},
	{
		"town": "serene valley",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "serpentine",
		"state": "vic",
		"postcode": "3517"
	},
	{
		"town": "serpentine",
		"state": "wa",
		"postcode": "6125"
	},
	{
		"town": "serviceton",
		"state": "qld",
		"postcode": "4077"
	},
	{
		"town": "serviceton",
		"state": "vic",
		"postcode": "3420"
	},
	{
		"town": "settlement city",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "settlement creek",
		"state": "vic",
		"postcode": "3737"
	},
	{
		"town": "seven creeks",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "seven hills",
		"state": "nsw",
		"postcode": "1730"
	},
	{
		"town": "seven hills",
		"state": "nsw",
		"postcode": "2147"
	},
	{
		"town": "seven hills",
		"state": "qld",
		"postcode": "4170"
	},
	{
		"town": "seven hills west",
		"state": "nsw",
		"postcode": "2147"
	},
	{
		"town": "seven mile beach",
		"state": "tas",
		"postcode": "7170"
	},
	{
		"town": "seven oaks",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "sevenhill",
		"state": "sa",
		"postcode": "5453"
	},
	{
		"town": "seventeen mile",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "seventeen mile rocks",
		"state": "qld",
		"postcode": "4073"
	},
	{
		"town": "seventeen seventy",
		"state": "qld",
		"postcode": "4677"
	},
	{
		"town": "severnlea",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "seville",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "seville east",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "sexton",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "sextonville",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "seymour",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "seymour",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "seymour",
		"state": "vic",
		"postcode": "3661"
	},
	{
		"town": "seymour south",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "shackleton",
		"state": "wa",
		"postcode": "6386"
	},
	{
		"town": "shadforth",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "shady creek",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "shailer park",
		"state": "qld",
		"postcode": "4128"
	},
	{
		"town": "shallow inlet",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "shallow rush",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "shalvey",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "shanes park",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "shannon",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "shannon brook",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "shannon river mill",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "shannon vale",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "shannondale",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "shannons flat",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "shannonvale",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "shark creek",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "shark point",
		"state": "tas",
		"postcode": "7171"
	},
	{
		"town": "sharon",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "sharps creek",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "shaugh",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "shaw",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "shay gap",
		"state": "wa",
		"postcode": "6761"
	},
	{
		"town": "shays flat",
		"state": "vic",
		"postcode": "3384"
	},
	{
		"town": "she oaks",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "shea-oak log",
		"state": "sa",
		"postcode": "5371"
	},
	{
		"town": "sheans creek",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "sheaoak flat",
		"state": "sa",
		"postcode": "5581"
	},
	{
		"town": "shearwater",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "sheep hills",
		"state": "vic",
		"postcode": "3392"
	},
	{
		"town": "sheffield",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "sheidow park",
		"state": "sa",
		"postcode": "5158"
	},
	{
		"town": "shelbourne",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "shelbourne",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "sheldon",
		"state": "qld",
		"postcode": "4157"
	},
	{
		"town": "shelford",
		"state": "vic",
		"postcode": "3329"
	},
	{
		"town": "shell cove",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "shelley",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "shelley",
		"state": "wa",
		"postcode": "6148"
	},
	{
		"town": "shellharbour",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "shellharbour city centre",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "shellharbour square",
		"state": "nsw",
		"postcode": "2529"
	},
	{
		"town": "shelly beach",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "shelly beach",
		"state": "qld",
		"postcode": "4551"
	},
	{
		"town": "shelly beach",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "shenton park",
		"state": "wa",
		"postcode": "6008"
	},
	{
		"town": "shepherds",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "shepherds creek",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "shepherds flat",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "shepparton",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "shepparton",
		"state": "vic",
		"postcode": "3632"
	},
	{
		"town": "shepparton east",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "shepparton north",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "shepparton park",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "shepparton south",
		"state": "vic",
		"postcode": "3630"
	},
	{
		"town": "sherbrooke",
		"state": "vic",
		"postcode": "3789"
	},
	{
		"town": "sheringa",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "sherlock",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "sherwood",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "sherwood",
		"state": "qld",
		"postcode": "4075"
	},
	{
		"town": "sherwood",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "shinfield",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "shipley",
		"state": "nsw",
		"postcode": "2785"
	},
	{
		"town": "shipwrights point",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "shirley",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "shoal bay",
		"state": "nsw",
		"postcode": "2315"
	},
	{
		"town": "shoal bay",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "shoal point",
		"state": "qld",
		"postcode": "4750"
	},
	{
		"town": "shoalhaven heads",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "shoalwater",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "shoalwater",
		"state": "wa",
		"postcode": "6169"
	},
	{
		"town": "shooters hill",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "shoreham",
		"state": "vic",
		"postcode": "3916"
	},
	{
		"town": "shorewell park",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "shorncliffe",
		"state": "qld",
		"postcode": "4017"
	},
	{
		"town": "short",
		"state": "sa",
		"postcode": "5279"
	},
	{
		"town": "shortland",
		"state": "nsw",
		"postcode": "2307"
	},
	{
		"town": "shotts",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "shute harbour",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "shutehaven",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "sidmouth",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "sidonia",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "siesta park",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "silent grove",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "silkstone",
		"state": "qld",
		"postcode": "4304"
	},
	{
		"town": "silkwood",
		"state": "qld",
		"postcode": "4856"
	},
	{
		"town": "silkwood east",
		"state": "qld",
		"postcode": "4857"
	},
	{
		"town": "silvan",
		"state": "vic",
		"postcode": "3795"
	},
	{
		"town": "silver creek",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "silver creek",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "silver pinch",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "silver ridge",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "silver sands",
		"state": "sa",
		"postcode": "5173"
	},
	{
		"town": "silver sands",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "silver spur",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "silverdale",
		"state": "nsw",
		"postcode": "2752"
	},
	{
		"town": "silverdale",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "silverleaf",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "silverleaves",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "silverton",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "silverton",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "silverwater",
		"state": "nsw",
		"postcode": "2128"
	},
	{
		"town": "silverwater",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "simmie",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "simpson",
		"state": "vic",
		"postcode": "3266"
	},
	{
		"town": "simpsons bay",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "simpsons creek",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "simson",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "sinagra",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "sinclair",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "singleton",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "singleton",
		"state": "wa",
		"postcode": "6175"
	},
	{
		"town": "singleton heights",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "singleton milpo",
		"state": "nsw",
		"postcode": "2331"
	},
	{
		"town": "sinnamon park",
		"state": "qld",
		"postcode": "4073"
	},
	{
		"town": "sippy downs",
		"state": "qld",
		"postcode": "4556"
	},
	{
		"town": "sisters beach",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "sisters creek",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "sisters creek",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "six mile flat",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "six mile swamp",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "skeleton rock",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "skenes creek",
		"state": "vic",
		"postcode": "3233"
	},
	{
		"town": "skenes creek north",
		"state": "vic",
		"postcode": "3233"
	},
	{
		"town": "skennars head",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "skibo",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "skillion flat",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "skinners shoot",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "skipton",
		"state": "vic",
		"postcode": "3361"
	},
	{
		"town": "skye",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "skye",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "skyring reserve",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "slacks creek",
		"state": "qld",
		"postcode": "4127"
	},
	{
		"town": "slade point",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "slaty creek",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "sleepy hollow",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "slopen main beach",
		"state": "tas",
		"postcode": "7186"
	},
	{
		"town": "sloping main",
		"state": "tas",
		"postcode": "7186"
	},
	{
		"town": "smeaton",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "smeaton grange",
		"state": "nsw",
		"postcode": "2567"
	},
	{
		"town": "smiggin holes",
		"state": "nsw",
		"postcode": "2624"
	},
	{
		"town": "smithfield",
		"state": "nsw",
		"postcode": "2164"
	},
	{
		"town": "smithfield",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "smithfield",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "smithfield heights",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "smithfield plains",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "smithfield west",
		"state": "nsw",
		"postcode": "2164"
	},
	{
		"town": "smithfield west",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "smithlea",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "smiths beach",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "smiths creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "smiths gully",
		"state": "vic",
		"postcode": "3760"
	},
	{
		"town": "smiths lake",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "smithton",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "smithtown",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "smithville",
		"state": "sa",
		"postcode": "5302"
	},
	{
		"town": "smokey town",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "smoko",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "smoky bay",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "smoky creek",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "smythes creek",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "smythesdale",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "snake gully",
		"state": "tas",
		"postcode": "7470"
	},
	{
		"town": "snake valley",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "snakes plain",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "snobs creek",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "snowball",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "snowtown",
		"state": "sa",
		"postcode": "5520"
	},
	{
		"town": "snowy creek",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "snowy plains",
		"state": "nsw",
		"postcode": "2628"
	},
	{
		"town": "snug",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "sodwalls",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "sofala",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "soldiers hill",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "soldiers hill",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "soldiers point",
		"state": "nsw",
		"postcode": "2317"
	},
	{
		"town": "solomon",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "solomontown",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "solus",
		"state": "wa",
		"postcode": "6207"
	},
	{
		"town": "somers",
		"state": "vic",
		"postcode": "3927"
	},
	{
		"town": "somersby",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "somerset",
		"state": "tas",
		"postcode": "7322"
	},
	{
		"town": "somerset dam",
		"state": "qld",
		"postcode": "4312"
	},
	{
		"town": "somerset hill",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "somerset hills",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "somerton",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "somerton",
		"state": "vic",
		"postcode": "3062"
	},
	{
		"town": "somerton park",
		"state": "sa",
		"postcode": "5044"
	},
	{
		"town": "somerton park",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "somerville",
		"state": "vic",
		"postcode": "3912"
	},
	{
		"town": "somerville",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "sorell",
		"state": "tas",
		"postcode": "7172"
	},
	{
		"town": "sorell creek",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "sorlie",
		"state": "nsw",
		"postcode": "2086"
	},
	{
		"town": "sorrento",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "sorrento",
		"state": "vic",
		"postcode": "3943"
	},
	{
		"town": "sorrento",
		"state": "wa",
		"postcode": "6020"
	},
	{
		"town": "south albury",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "south arm",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "south arm",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "south arm",
		"state": "tas",
		"postcode": "7022"
	},
	{
		"town": "south ballina",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "south bank",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "south bathurst",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "south bingera",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "south bodallin",
		"state": "wa",
		"postcode": "6424"
	},
	{
		"town": "south boulder",
		"state": "wa",
		"postcode": "6432"
	},
	{
		"town": "south brighton",
		"state": "sa",
		"postcode": "5048"
	},
	{
		"town": "south brisbane",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "south broken hill",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "south bruny",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "south bunbury",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "south burnie",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "south canary island",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "south carnarvon",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "south caroling",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "south coogee",
		"state": "nsw",
		"postcode": "2034"
	},
	{
		"town": "south doodlakine",
		"state": "wa",
		"postcode": "6411"
	},
	{
		"town": "south dudley",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "south durras",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "south east nanango",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "south end",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "south fremantle",
		"state": "wa",
		"postcode": "6162"
	},
	{
		"town": "south geelong",
		"state": "vic",
		"postcode": "3220"
	},
	{
		"town": "south gladstone",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "south golden beach",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "south grafton",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "south greenough",
		"state": "wa",
		"postcode": "6528"
	},
	{
		"town": "south guildford",
		"state": "wa",
		"postcode": "6055"
	},
	{
		"town": "south gundagai",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "south gundurimba",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "south guyra",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "south hedland",
		"state": "wa",
		"postcode": "6722"
	},
	{
		"town": "south hill",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "south hobart",
		"state": "tas",
		"postcode": "7004"
	},
	{
		"town": "south hummocks",
		"state": "sa",
		"postcode": "5550"
	},
	{
		"town": "south hurstville",
		"state": "nsw",
		"postcode": "2221"
	},
	{
		"town": "south isis",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "south johnstone",
		"state": "qld",
		"postcode": "4859"
	},
	{
		"town": "south kalgoorlie",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "south kempsey",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "south kilkerran",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "south kingsville",
		"state": "vic",
		"postcode": "3015"
	},
	{
		"town": "south kinypanial",
		"state": "vic",
		"postcode": "3520"
	},
	{
		"town": "south kolan",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "south kumminin",
		"state": "wa",
		"postcode": "6368"
	},
	{
		"town": "south lake",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "south launceston",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "south lismore",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "south mackay",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "south maclean",
		"state": "qld",
		"postcode": "4280"
	},
	{
		"town": "south maitland",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "south maroota",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "south melbourne",
		"state": "vic",
		"postcode": "3205"
	},
	{
		"town": "south melbourne",
		"state": "vic",
		"postcode": "8865"
	},
	{
		"town": "south mission beach",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "south molle",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "south morang",
		"state": "vic",
		"postcode": "3752"
	},
	{
		"town": "south mount cameron",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "south nanango",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "south pambula",
		"state": "nsw",
		"postcode": "2549"
	},
	{
		"town": "south perth",
		"state": "wa",
		"postcode": "6151"
	},
	{
		"town": "south perth",
		"state": "wa",
		"postcode": "6951"
	},
	{
		"town": "south perth angelo st",
		"state": "wa",
		"postcode": "6151"
	},
	{
		"town": "south pindimar",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "south plantations",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "south plympton",
		"state": "sa",
		"postcode": "5038"
	},
	{
		"town": "south purrumbete",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "south queenstown",
		"state": "tas",
		"postcode": "7466"
	},
	{
		"town": "south riana",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "south spreyton",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "south stirling",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "south tacoma",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "south talwood",
		"state": "qld",
		"postcode": "4496"
	},
	{
		"town": "south toowoomba",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "south townsville",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "south trees",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "south turramurra",
		"state": "nsw",
		"postcode": "2074"
	},
	{
		"town": "south wentworthville",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "south west rocks",
		"state": "nsw",
		"postcode": "2431"
	},
	{
		"town": "south western suburbs pc",
		"state": "nsw",
		"postcode": "2202"
	},
	{
		"town": "south windsor",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "south wolumla",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "south yarra",
		"state": "vic",
		"postcode": "3141"
	},
	{
		"town": "south yilgarn",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "south yunderup",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "southbank",
		"state": "vic",
		"postcode": "3006"
	},
	{
		"town": "southbrook",
		"state": "qld",
		"postcode": "4363"
	},
	{
		"town": "southend",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "southern brook",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "southern cross",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "southern cross",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "southern river",
		"state": "wa",
		"postcode": "6110"
	},
	{
		"town": "southern suburbs pc",
		"state": "nsw",
		"postcode": "2051"
	},
	{
		"town": "southgate",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "southhampton",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "southland centre",
		"state": "vic",
		"postcode": "3192"
	},
	{
		"town": "southport",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "southport",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "southport",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "southport lagoon",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "southport park",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "southside",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "southtown",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "sovereign hill",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "sovereign islands",
		"state": "qld",
		"postcode": "4216"
	},
	{
		"town": "spalding",
		"state": "sa",
		"postcode": "5454"
	},
	{
		"town": "spalding",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "spalford",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "spargo creek",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "spearwood",
		"state": "wa",
		"postcode": "6163"
	},
	{
		"town": "specimen hill",
		"state": "vic",
		"postcode": "3555"
	},
	{
		"town": "spectacle lake",
		"state": "sa",
		"postcode": "5345"
	},
	{
		"town": "speed",
		"state": "vic",
		"postcode": "3488"
	},
	{
		"town": "speedwell",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "speers point",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "speewa",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "speewa island",
		"state": "vic",
		"postcode": "2734"
	},
	{
		"town": "spence",
		"state": "act",
		"postcode": "2615"
	},
	{
		"town": "spence",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "spencer",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "spencer park",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "spencers brook",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "spicers creek",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "spinifex",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "spit junction",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "splinter creek",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "split yard creek",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "splitters creek",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "spotswood",
		"state": "vic",
		"postcode": "3015"
	},
	{
		"town": "sprent",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "spreyton",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "spring bay",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "spring beach",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "spring bluff",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "spring creek",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "spring creek",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "spring creek",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "spring creek",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "spring creek",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "spring farm",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "spring flat",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "spring gardens",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "spring grove",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "spring gully",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "spring hill",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "spring hill",
		"state": "qld",
		"postcode": "4000"
	},
	{
		"town": "spring hill",
		"state": "qld",
		"postcode": "4004"
	},
	{
		"town": "spring hill",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "spring hill",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "spring mountain",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "spring plains",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "spring plains",
		"state": "nsw",
		"postcode": "2397"
	},
	{
		"town": "spring plains",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "spring ridge",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "spring terrace",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "spring valley",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "spring valley",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "springbank",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "springbrook",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "springdale",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "springdale heights",
		"state": "nsw",
		"postcode": "2641"
	},
	{
		"town": "springdallah",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "springfield",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "springfield",
		"state": "qld",
		"postcode": "4300"
	},
	{
		"town": "springfield",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "springfield",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "springfield",
		"state": "vic",
		"postcode": "3434"
	},
	{
		"town": "springfield",
		"state": "vic",
		"postcode": "3531"
	},
	{
		"town": "springfield",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "springhurst",
		"state": "vic",
		"postcode": "3682"
	},
	{
		"town": "springmount",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "springs",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "springside",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "springside",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "springsure",
		"state": "qld",
		"postcode": "4722"
	},
	{
		"town": "springton",
		"state": "sa",
		"postcode": "5235"
	},
	{
		"town": "springvale",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "springvale",
		"state": "vic",
		"postcode": "3171"
	},
	{
		"town": "springvale south",
		"state": "vic",
		"postcode": "3172"
	},
	{
		"town": "springwood",
		"state": "nsw",
		"postcode": "2777"
	},
	{
		"town": "springwood",
		"state": "qld",
		"postcode": "4127"
	},
	{
		"town": "square mile",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "squeaking point",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "st agnes",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "st agnes",
		"state": "sa",
		"postcode": "5097"
	},
	{
		"town": "st albans",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "st albans",
		"state": "vic",
		"postcode": "3021"
	},
	{
		"town": "st albans park",
		"state": "vic",
		"postcode": "3219"
	},
	{
		"town": "st andrews",
		"state": "nsw",
		"postcode": "2566"
	},
	{
		"town": "st andrews",
		"state": "vic",
		"postcode": "3761"
	},
	{
		"town": "st andrews beach",
		"state": "vic",
		"postcode": "3941"
	},
	{
		"town": "st arnaud",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "st arnaud east",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "st arnaud north",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "st aubyn",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "st bernard hospice",
		"state": "vic",
		"postcode": "3741"
	},
	{
		"town": "st clair",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "st clair",
		"state": "nsw",
		"postcode": "2759"
	},
	{
		"town": "st clair",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "st evins",
		"state": "vic",
		"postcode": "3317"
	},
	{
		"town": "st fillans",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "st fillans",
		"state": "vic",
		"postcode": "3778"
	},
	{
		"town": "st george",
		"state": "qld",
		"postcode": "4487"
	},
	{
		"town": "st georges",
		"state": "sa",
		"postcode": "5064"
	},
	{
		"town": "st georges basin",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "st germains",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "st helena",
		"state": "nsw",
		"postcode": "2479"
	},
	{
		"town": "st helena",
		"state": "vic",
		"postcode": "3088"
	},
	{
		"town": "st helens",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "st helens",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "st helens",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "st helens",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "st helens beach",
		"state": "qld",
		"postcode": "4798"
	},
	{
		"town": "st helens park",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "st helens plains",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "st helier",
		"state": "vic",
		"postcode": "3989"
	},
	{
		"town": "st huberts island",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "st ives",
		"state": "nsw",
		"postcode": "2075"
	},
	{
		"town": "st ives chase",
		"state": "nsw",
		"postcode": "2075"
	},
	{
		"town": "st james",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "st james",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "st james",
		"state": "wa",
		"postcode": "6102"
	},
	{
		"town": "st johns",
		"state": "sa",
		"postcode": "5373"
	},
	{
		"town": "st johns park",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "st johns wood",
		"state": "qld",
		"postcode": "4060"
	},
	{
		"town": "st kilda",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "st kilda",
		"state": "sa",
		"postcode": "5110"
	},
	{
		"town": "st kilda",
		"state": "vic",
		"postcode": "3182"
	},
	{
		"town": "st kilda east",
		"state": "vic",
		"postcode": "3183"
	},
	{
		"town": "st kilda road",
		"state": "vic",
		"postcode": "8004"
	},
	{
		"town": "st kilda road central",
		"state": "vic",
		"postcode": "3004"
	},
	{
		"town": "st kilda road central",
		"state": "vic",
		"postcode": "8008"
	},
	{
		"town": "st kilda road delivery annexe",
		"state": "vic",
		"postcode": "3004"
	},
	{
		"town": "st kilda road melbourne",
		"state": "vic",
		"postcode": "3004"
	},
	{
		"town": "st kilda south",
		"state": "vic",
		"postcode": "3182"
	},
	{
		"town": "st kilda west",
		"state": "vic",
		"postcode": "3182"
	},
	{
		"town": "st kitts",
		"state": "sa",
		"postcode": "5356"
	},
	{
		"town": "st lawrence",
		"state": "qld",
		"postcode": "4707"
	},
	{
		"town": "st leonards",
		"state": "nsw",
		"postcode": "1590"
	},
	{
		"town": "st leonards",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "st leonards",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "st leonards",
		"state": "vic",
		"postcode": "3223"
	},
	{
		"town": "st lucia",
		"state": "qld",
		"postcode": "4067"
	},
	{
		"town": "st lucia south",
		"state": "qld",
		"postcode": "4067"
	},
	{
		"town": "st mary",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "st marys",
		"state": "nsw",
		"postcode": "1790"
	},
	{
		"town": "st marys",
		"state": "nsw",
		"postcode": "2760"
	},
	{
		"town": "st marys",
		"state": "sa",
		"postcode": "5042"
	},
	{
		"town": "st marys",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "st marys east",
		"state": "nsw",
		"postcode": "2760"
	},
	{
		"town": "st marys south",
		"state": "nsw",
		"postcode": "2760"
	},
	{
		"town": "st morris",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "st patricks",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "st pauls",
		"state": "nsw",
		"postcode": "2031"
	},
	{
		"town": "st peters",
		"state": "nsw",
		"postcode": "2044"
	},
	{
		"town": "st peters",
		"state": "sa",
		"postcode": "5069"
	},
	{
		"town": "st peters pass",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "st ruth",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "stableford",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "staceys bridge",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "stafford",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "stafford city",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "stafford heights",
		"state": "qld",
		"postcode": "4053"
	},
	{
		"town": "staffordshire reef",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "staghorn flat",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "stake hill",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "stalworth",
		"state": "qld",
		"postcode": "4613"
	},
	{
		"town": "stamford",
		"state": "qld",
		"postcode": "4821"
	},
	{
		"town": "stanage",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "stanborough",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "stanbridge",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "stanford merthyr",
		"state": "nsw",
		"postcode": "2327"
	},
	{
		"town": "stanhope",
		"state": "nsw",
		"postcode": "2335"
	},
	{
		"town": "stanhope",
		"state": "vic",
		"postcode": "3623"
	},
	{
		"town": "stanhope gardens",
		"state": "nsw",
		"postcode": "2768"
	},
	{
		"town": "stanhope south",
		"state": "vic",
		"postcode": "3623"
	},
	{
		"town": "stanley",
		"state": "tas",
		"postcode": "7331"
	},
	{
		"town": "stanley",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "stanley bridge",
		"state": "qld",
		"postcode": "4169"
	},
	{
		"town": "stanmore",
		"state": "nsw",
		"postcode": "2048"
	},
	{
		"town": "stanmore",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "stanmore",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "stannifer",
		"state": "nsw",
		"postcode": "2369"
	},
	{
		"town": "stannum",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "stansbury",
		"state": "sa",
		"postcode": "5582"
	},
	{
		"town": "stanthorpe",
		"state": "qld",
		"postcode": "4380"
	},
	{
		"town": "stanwell",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "stanwell park",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "stanwell tops",
		"state": "nsw",
		"postcode": "2508"
	},
	{
		"town": "stapylton",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "state pc",
		"state": "nsw",
		"postcode": "2201"
	},
	{
		"town": "station arcade",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "statue bay",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "staughton vale",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "stavely",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "staverton",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "stawell",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "stawell west",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "steam plains",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "steels creek",
		"state": "vic",
		"postcode": "3775"
	},
	{
		"town": "steeple flat",
		"state": "nsw",
		"postcode": "2631"
	},
	{
		"town": "steiglitz",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "steiglitz",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "steinbrook",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "steinfeld",
		"state": "sa",
		"postcode": "5356"
	},
	{
		"town": "stenhouse bay",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "stephens",
		"state": "qld",
		"postcode": "4227"
	},
	{
		"town": "stephens creek",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "stephens island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "stephenson",
		"state": "sa",
		"postcode": "5433"
	},
	{
		"town": "stepney",
		"state": "sa",
		"postcode": "5069"
	},
	{
		"town": "steppes",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "steve kings plains",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "stewart",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "stewart range",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "stewarton",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "stewarton",
		"state": "vic",
		"postcode": "3725"
	},
	{
		"town": "stewarts bay",
		"state": "tas",
		"postcode": "7182"
	},
	{
		"town": "stewarts brook",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "stewarts mount",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "stewarts river",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "stieglitz",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "stirling",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "stirling",
		"state": "sa",
		"postcode": "5152"
	},
	{
		"town": "stirling",
		"state": "wa",
		"postcode": "6021"
	},
	{
		"town": "stirling estate",
		"state": "wa",
		"postcode": "6271"
	},
	{
		"town": "stirling north",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "stockdale",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "stockhaven",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "stockinbingal",
		"state": "nsw",
		"postcode": "2725"
	},
	{
		"town": "stockleigh",
		"state": "qld",
		"postcode": "4280"
	},
	{
		"town": "stockport",
		"state": "sa",
		"postcode": "5410"
	},
	{
		"town": "stockrington",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "stockton",
		"state": "nsw",
		"postcode": "2295"
	},
	{
		"town": "stockwell",
		"state": "sa",
		"postcode": "5355"
	},
	{
		"town": "stockyard",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "stockyard",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "stockyard creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "stockyard creek",
		"state": "sa",
		"postcode": "5460"
	},
	{
		"town": "stockyard hill",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "stockyard plain",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "stokers siding",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "stokes bay",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "stone hut",
		"state": "sa",
		"postcode": "5480"
	},
	{
		"town": "stone well",
		"state": "sa",
		"postcode": "5352"
	},
	{
		"town": "stonehaven",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "stonehenge",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "stonehenge",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "stonehenge",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "stonehenge",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "stonelands",
		"state": "qld",
		"postcode": "4612"
	},
	{
		"town": "stoneleigh",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "stoneleigh",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "stones corner",
		"state": "qld",
		"postcode": "4120"
	},
	{
		"town": "stoneville",
		"state": "wa",
		"postcode": "6081"
	},
	{
		"town": "stonewell",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "stoney creek",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "stonor",
		"state": "tas",
		"postcode": "7119"
	},
	{
		"town": "stony chute",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "stony creek",
		"state": "nsw",
		"postcode": "2545"
	},
	{
		"town": "stony creek",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "stony creek",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "stony creek",
		"state": "vic",
		"postcode": "3957"
	},
	{
		"town": "stony crossing",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "stony head",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "stony rise",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "stonyfell",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "stonyford",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "stoodley",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "store creek",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "stormlea",
		"state": "tas",
		"postcode": "7184"
	},
	{
		"town": "storys creek",
		"state": "tas",
		"postcode": "7213"
	},
	{
		"town": "stotts creek",
		"state": "nsw",
		"postcode": "2487"
	},
	{
		"town": "stove hill",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "stow",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "stowport",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "stradbroke",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "strahan",
		"state": "tas",
		"postcode": "7468"
	},
	{
		"town": "strangways",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "stratford",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "stratford",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "stratford",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "strath creek",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "strathalbyn",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "strathalbyn",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "strathallan",
		"state": "vic",
		"postcode": "3622"
	},
	{
		"town": "stratham",
		"state": "wa",
		"postcode": "6237"
	},
	{
		"town": "strathblane",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "strathbogie",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "strathbogie north",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "strathcedar",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "strathcona",
		"state": "vic",
		"postcode": "3387"
	},
	{
		"town": "strathdale",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "strathdickie",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "strathdownie",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "stratheden",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "stratherne",
		"state": "wa",
		"postcode": "6309"
	},
	{
		"town": "strathewen",
		"state": "vic",
		"postcode": "3099"
	},
	{
		"town": "strathfield",
		"state": "nsw",
		"postcode": "1819"
	},
	{
		"town": "strathfield",
		"state": "nsw",
		"postcode": "2135"
	},
	{
		"town": "strathfield",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "strathfield south",
		"state": "nsw",
		"postcode": "2136"
	},
	{
		"town": "strathfield west",
		"state": "nsw",
		"postcode": "2140"
	},
	{
		"town": "strathfieldsaye",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "strathgordon",
		"state": "tas",
		"postcode": "7139"
	},
	{
		"town": "strathkellar",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "strathlea",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "strathmerton",
		"state": "vic",
		"postcode": "3641"
	},
	{
		"town": "strathmore",
		"state": "vic",
		"postcode": "3041"
	},
	{
		"town": "strathmore heights",
		"state": "vic",
		"postcode": "3041"
	},
	{
		"town": "strathpine",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "strathpine centre",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "strathpine city",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "stratton",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1420"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1422"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1423"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1424"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1425"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1426"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1427"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1428"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "1429"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "2010"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "2012"
	},
	{
		"town": "strawberry hills",
		"state": "nsw",
		"postcode": "2013"
	},
	{
		"town": "streaky bay",
		"state": "sa",
		"postcode": "5680"
	},
	{
		"town": "streatham",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "strelley",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "stretton",
		"state": "qld",
		"postcode": "4116"
	},
	{
		"town": "strickland",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "stringer creek",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "stroud",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "stroud road",
		"state": "nsw",
		"postcode": "2415"
	},
	{
		"town": "struck oil",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "strzelecki",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "strzelecki",
		"state": "vic",
		"postcode": "3950"
	},
	{
		"town": "stuart",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "stuart mill",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "stuart park",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "stuart town",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "stuartholme",
		"state": "qld",
		"postcode": "4066"
	},
	{
		"town": "stuarts point",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "stubbo",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "stud park",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "studfield",
		"state": "vic",
		"postcode": "3152"
	},
	{
		"town": "studio village",
		"state": "qld",
		"postcode": "4210"
	},
	{
		"town": "stunsail boom",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "sturt",
		"state": "qld",
		"postcode": "4829"
	},
	{
		"town": "sturt",
		"state": "sa",
		"postcode": "5047"
	},
	{
		"town": "sturt street",
		"state": "sa",
		"postcode": "5000"
	},
	{
		"town": "styx",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "subiaco",
		"state": "wa",
		"postcode": "6008"
	},
	{
		"town": "subiaco",
		"state": "wa",
		"postcode": "6904"
	},
	{
		"town": "subiaco",
		"state": "wa",
		"postcode": "6927"
	},
	{
		"town": "subiaco",
		"state": "wa",
		"postcode": "6928"
	},
	{
		"town": "subiaco east",
		"state": "wa",
		"postcode": "6008"
	},
	{
		"town": "success",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "success",
		"state": "wa",
		"postcode": "6964"
	},
	{
		"town": "suffolk park",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "sugarloaf",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "sugarloaf",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "sugarloaf creek",
		"state": "vic",
		"postcode": "3659"
	},
	{
		"town": "suggan buggan",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "sulky",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "sulky gully",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "sulphur",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "sulphur creek",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "suma park",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "sumarez",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "summer hill",
		"state": "nsw",
		"postcode": "2130"
	},
	{
		"town": "summer hill",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "summer hill",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "summer island",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "summerdale",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "summerfield",
		"state": "vic",
		"postcode": "3570"
	},
	{
		"town": "summerhill",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "summerholm",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "summerland point",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "summerlands",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "summers",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "summertown",
		"state": "sa",
		"postcode": "5141"
	},
	{
		"town": "sumner",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "sun valley",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "sunbury",
		"state": "vic",
		"postcode": "3429"
	},
	{
		"town": "sundale",
		"state": "qld",
		"postcode": "4215"
	},
	{
		"town": "sunday creek",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "sunday island",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "sunderland bay",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "sundown",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "sunlands",
		"state": "sa",
		"postcode": "5322"
	},
	{
		"town": "sunny corner",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "sunny corner",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "sunny creek",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "sunny nook",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "sunny view",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "sunnybank",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "sunnybank hills",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "sunnybank south",
		"state": "qld",
		"postcode": "4109"
	},
	{
		"town": "sunnybrae",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "sunnycliffs",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "sunnyside",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "sunnyside",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "sunnyside",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "sunnyside",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "sunnyside",
		"state": "tas",
		"postcode": "7305"
	},
	{
		"town": "sunnyside",
		"state": "wa",
		"postcode": "6256"
	},
	{
		"town": "sunnyvale",
		"state": "sa",
		"postcode": "5552"
	},
	{
		"town": "sunrise beach",
		"state": "qld",
		"postcode": "4567"
	},
	{
		"town": "sunrise hills",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "sunset",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "sunset beach",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "sunset strip",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "sunshine",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "sunshine",
		"state": "vic",
		"postcode": "3020"
	},
	{
		"town": "sunshine acres",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "sunshine bay",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "sunshine beach",
		"state": "qld",
		"postcode": "4567"
	},
	{
		"town": "sunshine north",
		"state": "vic",
		"postcode": "3020"
	},
	{
		"town": "sunshine plaza",
		"state": "qld",
		"postcode": "4558"
	},
	{
		"town": "sunshine west",
		"state": "vic",
		"postcode": "3020"
	},
	{
		"town": "suntop",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "surat",
		"state": "qld",
		"postcode": "4417"
	},
	{
		"town": "surf beach",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "surf beach",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "surfers paradise",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "surfside",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "surges bay",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "surprise bay",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "surrey downs",
		"state": "sa",
		"postcode": "5126"
	},
	{
		"town": "surrey hills",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "surrey hills",
		"state": "vic",
		"postcode": "3127"
	},
	{
		"town": "surrey hills north",
		"state": "vic",
		"postcode": "3127"
	},
	{
		"town": "surrey hills south",
		"state": "vic",
		"postcode": "3125"
	},
	{
		"town": "surry hills",
		"state": "nsw",
		"postcode": "2010"
	},
	{
		"town": "surveyors bay",
		"state": "tas",
		"postcode": "7116"
	},
	{
		"town": "susan river",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "sussex inlet",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "sutherland",
		"state": "nsw",
		"postcode": "1499"
	},
	{
		"town": "sutherland",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "sutherland",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "sutherlands",
		"state": "sa",
		"postcode": "5374"
	},
	{
		"town": "sutherlands creek",
		"state": "vic",
		"postcode": "3331"
	},
	{
		"town": "sutton",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "sutton forest",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "sutton grange",
		"state": "vic",
		"postcode": "3448"
	},
	{
		"town": "suttontown",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "suttor",
		"state": "qld",
		"postcode": "4743"
	},
	{
		"town": "svensson heights",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "swan bay",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "swan bay",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "swan bay",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "swan creek",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "swan hill",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "swan hill north",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "swan hill pioneer",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "swan island",
		"state": "vic",
		"postcode": "3225"
	},
	{
		"town": "swan marsh",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "swan point",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "swan reach",
		"state": "sa",
		"postcode": "5354"
	},
	{
		"town": "swan reach",
		"state": "vic",
		"postcode": "3903"
	},
	{
		"town": "swan vale",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "swan view",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "swanbank",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "swanbourne",
		"state": "wa",
		"postcode": "6010"
	},
	{
		"town": "swanbrook",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "swanfels",
		"state": "qld",
		"postcode": "4371"
	},
	{
		"town": "swanhaven",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "swanpool",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "swanport",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "swansea",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "swansea",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "swansea heads",
		"state": "nsw",
		"postcode": "2281"
	},
	{
		"town": "swanston",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "swanwater",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "swanwater west",
		"state": "vic",
		"postcode": "3480"
	},
	{
		"town": "swede flat",
		"state": "sa",
		"postcode": "5270"
	},
	{
		"town": "sweetmans creek",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "swifts creek",
		"state": "vic",
		"postcode": "3896"
	},
	{
		"town": "swinger hill",
		"state": "act",
		"postcode": "2606"
	},
	{
		"town": "switzerland",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "sydenham",
		"state": "nsw",
		"postcode": "2044"
	},
	{
		"town": "sydenham",
		"state": "vic",
		"postcode": "3037"
	},
	{
		"town": "sydenham inlet",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1001"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1002"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1003"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1004"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1005"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1006"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1007"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1008"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1009"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1010"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1011"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1012"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1013"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1015"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1016"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1017"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1018"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1019"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1020"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1021"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1022"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1023"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1024"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1025"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1026"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1027"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1028"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1029"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1030"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1031"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1032"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1033"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1034"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1035"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1036"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1037"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1038"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1039"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1040"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1041"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1042"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1043"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1044"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1045"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1046"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1100"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1101"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1102"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1103"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1104"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1105"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1106"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1107"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1108"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1109"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1110"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1112"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1113"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1114"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1115"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1116"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1117"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1118"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1119"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1120"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1121"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1122"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1123"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1124"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1125"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1126"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1127"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1128"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1129"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1130"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1131"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1132"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1133"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1134"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1135"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1136"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1137"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1138"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1139"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1140"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1141"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1142"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1143"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1144"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1145"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1146"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1147"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1148"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1149"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1150"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1151"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1152"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1153"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1154"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1155"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1156"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1157"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1158"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1159"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1160"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1161"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1162"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1163"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1164"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1165"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1166"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1167"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1168"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1169"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1170"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1171"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1172"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1173"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1174"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1175"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1176"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1177"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1178"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1179"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1180"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1181"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1182"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1183"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1184"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1185"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1186"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1187"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1188"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1189"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1190"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1191"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1192"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1193"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1194"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1195"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1196"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1197"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1198"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1199"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1201"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1202"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1203"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1205"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1207"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1241"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1242"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1243"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1244"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1245"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1246"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1247"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1248"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1249"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1250"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1291"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1292"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1293"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1294"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1295"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1296"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1297"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1298"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "1299"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "sydney",
		"state": "nsw",
		"postcode": "2001"
	},
	{
		"town": "sydney airport",
		"state": "nsw",
		"postcode": "2020"
	},
	{
		"town": "sydney international airport",
		"state": "nsw",
		"postcode": "2020"
	},
	{
		"town": "sydney markets",
		"state": "nsw",
		"postcode": "2129"
	},
	{
		"town": "sydney showground",
		"state": "nsw",
		"postcode": "2021"
	},
	{
		"town": "sydney south",
		"state": "nsw",
		"postcode": "1231"
	},
	{
		"town": "sydney south",
		"state": "nsw",
		"postcode": "1232"
	},
	{
		"town": "sydney south",
		"state": "nsw",
		"postcode": "1233"
	},
	{
		"town": "sydney south",
		"state": "nsw",
		"postcode": "1234"
	},
	{
		"town": "sydney south",
		"state": "nsw",
		"postcode": "1235"
	},
	{
		"town": "sydney south",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "sylvania",
		"state": "nsw",
		"postcode": "2224"
	},
	{
		"town": "sylvania southgate",
		"state": "nsw",
		"postcode": "2224"
	},
	{
		"town": "sylvania waters",
		"state": "nsw",
		"postcode": "2224"
	},
	{
		"town": "sylvaterre",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "sylvester",
		"state": "vic",
		"postcode": "3072"
	},
	{
		"town": "sylvia vale",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "symonston",
		"state": "act",
		"postcode": "2609"
	},
	{
		"town": "syndal",
		"state": "vic",
		"postcode": "3149"
	},
	{
		"town": "taabinga",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "taabinga village",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "tabberabbera",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "tabbimoble",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "tabbita",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "tabilk",
		"state": "vic",
		"postcode": "3607"
	},
	{
		"town": "table cape",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "table top",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "tablelands",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "tablelands",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "tabooba",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "tabor",
		"state": "vic",
		"postcode": "3289"
	},
	{
		"town": "tabourie lake",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "tabragalba",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "tabulam",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "tacoma",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "taggerty",
		"state": "vic",
		"postcode": "3714"
	},
	{
		"town": "tahara",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "tahara bridge",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "tahara west",
		"state": "vic",
		"postcode": "3310"
	},
	{
		"town": "tahlee",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "tahmoor",
		"state": "nsw",
		"postcode": "2573"
	},
	{
		"town": "taigum",
		"state": "qld",
		"postcode": "4018"
	},
	{
		"town": "tailem bend",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "tailem bend",
		"state": "sa",
		"postcode": "5260"
	},
	{
		"town": "takilberan",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "takone",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "takura",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "talandji",
		"state": "wa",
		"postcode": "6710"
	},
	{
		"town": "talarm",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "talbingo",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "talbot",
		"state": "vic",
		"postcode": "3371"
	},
	{
		"town": "talbot",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "talbot island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "talbotville",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "talbragar",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "taldra",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "talegalla weir",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "talgarno",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "talia",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "talisker",
		"state": "vic",
		"postcode": "3310"
	},
	{
		"town": "tallaganda",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "tallageira",
		"state": "vic",
		"postcode": "3319"
	},
	{
		"town": "tallai",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "tallandoon",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "tallandouring",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "tallangatta",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "tallangatta east",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "tallangatta south",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "tallangatta valley",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "tallarook",
		"state": "vic",
		"postcode": "3659"
	},
	{
		"town": "tallawang",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "tallebudgera",
		"state": "qld",
		"postcode": "4228"
	},
	{
		"town": "tallebudgera valley",
		"state": "qld",
		"postcode": "4228"
	},
	{
		"town": "tallegalla",
		"state": "qld",
		"postcode": "4340"
	},
	{
		"town": "tallimba",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "tallong",
		"state": "nsw",
		"postcode": "2579"
	},
	{
		"town": "tallwood",
		"state": "nsw",
		"postcode": "2798"
	},
	{
		"town": "tallwoods village",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "tally valley",
		"state": "qld",
		"postcode": "4220"
	},
	{
		"town": "tallygaroopna",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "talmalmo",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "talofa",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "taloumbi",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "talwood",
		"state": "qld",
		"postcode": "4496"
	},
	{
		"town": "tamala park",
		"state": "wa",
		"postcode": "6030"
	},
	{
		"town": "tamarama",
		"state": "nsw",
		"postcode": "2026"
	},
	{
		"town": "tamaree",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "tamarind gardens",
		"state": "qld",
		"postcode": "4869"
	},
	{
		"town": "tamban",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "tambar springs",
		"state": "nsw",
		"postcode": "2381"
	},
	{
		"town": "tambaroora",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "tambaroora",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "tambellup",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "tambo",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "tambo crossing",
		"state": "vic",
		"postcode": "3893"
	},
	{
		"town": "tambo upper",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "tamboon",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "tamborine",
		"state": "qld",
		"postcode": "4270"
	},
	{
		"town": "tamborine village",
		"state": "qld",
		"postcode": "4270"
	},
	{
		"town": "tamboritha",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "tamboy",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "tambrey centre",
		"state": "wa",
		"postcode": "6714"
	},
	{
		"town": "taminda",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "taminick",
		"state": "vic",
		"postcode": "3675"
	},
	{
		"town": "tamleugh",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "tamleugh north",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "tamleugh west",
		"state": "vic",
		"postcode": "3631"
	},
	{
		"town": "tammin",
		"state": "wa",
		"postcode": "6409"
	},
	{
		"town": "tamrookum",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "tamrookum creek",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "tamworth",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "tamworth south",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "tanah merah",
		"state": "qld",
		"postcode": "4128"
	},
	{
		"town": "tanawha",
		"state": "qld",
		"postcode": "4556"
	},
	{
		"town": "tanbar",
		"state": "qld",
		"postcode": "4481"
	},
	{
		"town": "tanby",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "tandarook",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "tandarra",
		"state": "vic",
		"postcode": "3571"
	},
	{
		"town": "tandora",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tandur",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "tangalooma",
		"state": "qld",
		"postcode": "4025"
	},
	{
		"town": "tangambalanga",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "tanglewood",
		"state": "nsw",
		"postcode": "2488"
	},
	{
		"town": "tangmangaroo",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "tanilba bay",
		"state": "nsw",
		"postcode": "2319"
	},
	{
		"town": "tanja",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "tanjil",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "tanjil bren",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "tanjil east",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "tanjil south",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "tankerton",
		"state": "vic",
		"postcode": "3921"
	},
	{
		"town": "tannahills",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "tannum sands",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "tannymorel",
		"state": "qld",
		"postcode": "4372"
	},
	{
		"town": "tansey",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "tantangara",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "tantanoola",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "tantaraboo",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "tantawangalo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "tantonan",
		"state": "nsw",
		"postcode": "2731"
	},
	{
		"town": "tanunda",
		"state": "sa",
		"postcode": "5352"
	},
	{
		"town": "tanwood",
		"state": "vic",
		"postcode": "3467"
	},
	{
		"town": "tanybryn",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "taperoo",
		"state": "sa",
		"postcode": "5017"
	},
	{
		"town": "tapitallee",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "taplan",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "tapping",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "tara",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "tara",
		"state": "qld",
		"postcode": "4421"
	},
	{
		"town": "taradale",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "taradale",
		"state": "vic",
		"postcode": "3447"
	},
	{
		"town": "tarago",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "tarago",
		"state": "vic",
		"postcode": "3818"
	},
	{
		"town": "taragoola",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "taralga",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "tarampa",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "tarana",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "taranganba",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "taranna",
		"state": "tas",
		"postcode": "7180"
	},
	{
		"town": "taratap",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "tarawera",
		"state": "qld",
		"postcode": "4494"
	},
	{
		"town": "tarban",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "tarbuck bay",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "tarbucks",
		"state": "vic",
		"postcode": "3889"
	},
	{
		"town": "tarcombe",
		"state": "vic",
		"postcode": "3666"
	},
	{
		"town": "tarcoola",
		"state": "sa",
		"postcode": "5710"
	},
	{
		"town": "tarcoola beach",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "tarcowie",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "tarcutta",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "tardie",
		"state": "wa",
		"postcode": "6635"
	},
	{
		"town": "tardun",
		"state": "wa",
		"postcode": "6628"
	},
	{
		"town": "taree",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "taree south",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "taree west",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "taren point",
		"state": "nsw",
		"postcode": "2229"
	},
	{
		"town": "targa",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "targinie",
		"state": "qld",
		"postcode": "4694"
	},
	{
		"town": "tarilta",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "tarin rock",
		"state": "wa",
		"postcode": "6353"
	},
	{
		"town": "taringa",
		"state": "qld",
		"postcode": "4068"
	},
	{
		"town": "taripta",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "tarkeeth",
		"state": "nsw",
		"postcode": "2455"
	},
	{
		"town": "tarlee",
		"state": "sa",
		"postcode": "5411"
	},
	{
		"town": "tarleton",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "tarlo",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "tarnagulla",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "tarneit",
		"state": "vic",
		"postcode": "3029"
	},
	{
		"town": "tarnma",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "tarnook",
		"state": "vic",
		"postcode": "3670"
	},
	{
		"town": "tarome",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "taromeo",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "tarong",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "taronga",
		"state": "tas",
		"postcode": "7053"
	},
	{
		"town": "taroom",
		"state": "qld",
		"postcode": "4420"
	},
	{
		"town": "taroomball",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "taroon",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "taroona",
		"state": "tas",
		"postcode": "7053"
	},
	{
		"town": "tarpeena",
		"state": "sa",
		"postcode": "5277"
	},
	{
		"town": "tarra valley",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "tarrabandra",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "tarragal",
		"state": "vic",
		"postcode": "3305"
	},
	{
		"town": "tarraganda",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "tarragindi",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "tarraleah",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "tarramba",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "tarranyurk",
		"state": "vic",
		"postcode": "3422"
	},
	{
		"town": "tarraville",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "tarrawanna",
		"state": "nsw",
		"postcode": "2518"
	},
	{
		"town": "tarrawarra",
		"state": "qld",
		"postcode": "4868"
	},
	{
		"town": "tarrawarra",
		"state": "vic",
		"postcode": "3775"
	},
	{
		"town": "tarrawingee",
		"state": "vic",
		"postcode": "3746"
	},
	{
		"town": "tarrayoukyan",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "tarrengower",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "tarrenlea",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "tarriaro",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "tarrington",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "tarro",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "tarrone",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "tarwin",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "tarwin east",
		"state": "vic",
		"postcode": "3871"
	},
	{
		"town": "tarwin lower",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "tarwonga",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "tarzali",
		"state": "qld",
		"postcode": "4885"
	},
	{
		"town": "tascott",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "tasman island",
		"state": "tas",
		"postcode": "7001"
	},
	{
		"town": "tatachilla",
		"state": "sa",
		"postcode": "5171"
	},
	{
		"town": "tatana",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "tatham",
		"state": "nsw",
		"postcode": "2471"
	},
	{
		"town": "tathra",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "tatong",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "tatton",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "tatura",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "tatura east",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "tatyoon",
		"state": "vic",
		"postcode": "3378"
	},
	{
		"town": "taunton",
		"state": "qld",
		"postcode": "4674"
	},
	{
		"town": "tawonga",
		"state": "vic",
		"postcode": "3697"
	},
	{
		"town": "tawonga south",
		"state": "vic",
		"postcode": "3698"
	},
	{
		"town": "tayene",
		"state": "tas",
		"postcode": "7259"
	},
	{
		"town": "taylor",
		"state": "act",
		"postcode": "2913"
	},
	{
		"town": "taylor square",
		"state": "nsw",
		"postcode": "2010"
	},
	{
		"town": "taylors arm",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "taylors beach",
		"state": "nsw",
		"postcode": "2316"
	},
	{
		"town": "taylors beach",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "taylors flat",
		"state": "nsw",
		"postcode": "2586"
	},
	{
		"town": "taylors hill",
		"state": "vic",
		"postcode": "3037"
	},
	{
		"town": "taylors lakes",
		"state": "vic",
		"postcode": "3038"
	},
	{
		"town": "taylors point",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "taylorville",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "te kowai",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "tea gardens",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "tea tree",
		"state": "tas",
		"postcode": "7017"
	},
	{
		"town": "tea tree gully",
		"state": "sa",
		"postcode": "5091"
	},
	{
		"town": "teal point",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "tecoma",
		"state": "vic",
		"postcode": "3160"
	},
	{
		"town": "teddington",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "teddington",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "teddywaddy",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "teddywaddy west",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "teebar",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "teelah",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "teesdale",
		"state": "vic",
		"postcode": "3328"
	},
	{
		"town": "teesdale",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "teewah",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "telangatuk east",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "telarah",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "telegherry",
		"state": "nsw",
		"postcode": "2415"
	},
	{
		"town": "telegraph point",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "telfer",
		"state": "wa",
		"postcode": "6762"
	},
	{
		"town": "telford",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "telina",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "telina heights",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "telita",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "tellebang",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "telopea",
		"state": "nsw",
		"postcode": "2117"
	},
	{
		"town": "telopea downs",
		"state": "vic",
		"postcode": "3419"
	},
	{
		"town": "telowie",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "temagog",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "temma",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "temora",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "tempe",
		"state": "nsw",
		"postcode": "2044"
	},
	{
		"town": "templers",
		"state": "sa",
		"postcode": "5371"
	},
	{
		"town": "templestowe",
		"state": "vic",
		"postcode": "3106"
	},
	{
		"town": "templestowe heights",
		"state": "vic",
		"postcode": "3107"
	},
	{
		"town": "templestowe lower",
		"state": "vic",
		"postcode": "3107"
	},
	{
		"town": "templin",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "tempy",
		"state": "vic",
		"postcode": "3489"
	},
	{
		"town": "ten mile creek",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "ten mile hollow",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "tenalga",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "tenambit",
		"state": "nsw",
		"postcode": "2323"
	},
	{
		"town": "tenandra",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "tenby point",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "teneriffe",
		"state": "qld",
		"postcode": "4005"
	},
	{
		"town": "tenindewa",
		"state": "wa",
		"postcode": "6632"
	},
	{
		"town": "tennant creek",
		"state": "nt",
		"postcode": "860"
	},
	{
		"town": "tennant creek",
		"state": "nt",
		"postcode": "861"
	},
	{
		"town": "tennant creek",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "tennyson",
		"state": "nsw",
		"postcode": "2111"
	},
	{
		"town": "tennyson",
		"state": "nsw",
		"postcode": "2754"
	},
	{
		"town": "tennyson",
		"state": "qld",
		"postcode": "4105"
	},
	{
		"town": "tennyson",
		"state": "sa",
		"postcode": "5022"
	},
	{
		"town": "tennyson",
		"state": "vic",
		"postcode": "3572"
	},
	{
		"town": "tent hill",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "tenterden",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "tenterden",
		"state": "wa",
		"postcode": "6322"
	},
	{
		"town": "tenterfield",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "tepko",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "teralba",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "terang",
		"state": "vic",
		"postcode": "3264"
	},
	{
		"town": "terania creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "terara",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "teridgerie",
		"state": "nsw",
		"postcode": "2829"
	},
	{
		"town": "teringie",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "terip terip",
		"state": "vic",
		"postcode": "3719"
	},
	{
		"town": "termeil",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "terowie",
		"state": "sa",
		"postcode": "5421"
	},
	{
		"town": "terrabella",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "terrace creek",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "terragon",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "terramungamine",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "terranora",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "terrappee",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "terrey hills",
		"state": "nsw",
		"postcode": "2084"
	},
	{
		"town": "terrica",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "terrick terrick",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "terrick terrick east",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "terrigal",
		"state": "nsw",
		"postcode": "2260"
	},
	{
		"town": "terry hie hie",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "tesbury",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "tetoora road",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "teutonic",
		"state": "wa",
		"postcode": "6438"
	},
	{
		"town": "teven",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "teviotville",
		"state": "qld",
		"postcode": "4309"
	},
	{
		"town": "tewantin",
		"state": "qld",
		"postcode": "4565"
	},
	{
		"town": "tewinga",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "tewkesbury",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "texas",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "thabeban",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "thagoona",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "thalaba",
		"state": "nsw",
		"postcode": "2397"
	},
	{
		"town": "thalaba",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "thalgarrah",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "thalia",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "thallon",
		"state": "qld",
		"postcode": "4497"
	},
	{
		"town": "thaloo",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "thangkenharenge",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "thangool",
		"state": "qld",
		"postcode": "4716"
	},
	{
		"town": "tharbogang",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "thargomindah",
		"state": "qld",
		"postcode": "4492"
	},
	{
		"town": "tharwa",
		"state": "act",
		"postcode": "2620"
	},
	{
		"town": "the basin",
		"state": "nsw",
		"postcode": "2108"
	},
	{
		"town": "the basin",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "the basin",
		"state": "vic",
		"postcode": "3154"
	},
	{
		"town": "the bight",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "the bluff",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "the branch",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "the brothers",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "the brothers",
		"state": "vic",
		"postcode": "3900"
	},
	{
		"town": "the cascade",
		"state": "vic",
		"postcode": "3701"
	},
	{
		"town": "the caves",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "the channon",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "the chimneys",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "the chimneys",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "the common",
		"state": "qld",
		"postcode": "4701"
	},
	{
		"town": "the cove",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "the dawn",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "the dimonds",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "the entrance",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "the entrance north",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "the fingerboard",
		"state": "vic",
		"postcode": "3864"
	},
	{
		"town": "the forest",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "the freshwater",
		"state": "nsw",
		"postcode": "2466"
	},
	{
		"town": "the gap",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "the gap",
		"state": "qld",
		"postcode": "4061"
	},
	{
		"town": "the gap",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "the gardens",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "the gardens",
		"state": "tas",
		"postcode": "7216"
	},
	{
		"town": "the glen",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "the grange",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "the grove",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "the gulf",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "the gulf",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "the gums",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "the gums",
		"state": "vic",
		"postcode": "3274"
	},
	{
		"town": "the gurdies",
		"state": "vic",
		"postcode": "3984"
	},
	{
		"town": "the hatch",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "the heart",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "the hermitage",
		"state": "vic",
		"postcode": "3778"
	},
	{
		"town": "the hill",
		"state": "nsw",
		"postcode": "2300"
	},
	{
		"town": "the honeysuckles",
		"state": "vic",
		"postcode": "3851"
	},
	{
		"town": "the hummock",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "the junction",
		"state": "nsw",
		"postcode": "2291"
	},
	{
		"town": "the keppels",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "the lagoon",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "the lakes",
		"state": "wa",
		"postcode": "6556"
	},
	{
		"town": "the leap",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "the levels",
		"state": "sa",
		"postcode": "5095"
	},
	{
		"town": "the limits",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "the marra",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "the meadows",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "the mine",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "the monument",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "the narrows",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "the narrows",
		"state": "qld",
		"postcode": "4695"
	},
	{
		"town": "the oaks",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "the palms",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "the patch",
		"state": "vic",
		"postcode": "3792"
	},
	{
		"town": "the percy group",
		"state": "qld",
		"postcode": "4707"
	},
	{
		"town": "the pilliga",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "the pines",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "the pines",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "the pines",
		"state": "vic",
		"postcode": "3109"
	},
	{
		"town": "the pinnacles",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "the plains",
		"state": "wa",
		"postcode": "6237"
	},
	{
		"town": "the pocket",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "the point",
		"state": "sa",
		"postcode": "5254"
	},
	{
		"town": "the range",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "the range",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "the ridge",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "the risk",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "the rock",
		"state": "nsw",
		"postcode": "2655"
	},
	{
		"town": "the rocks",
		"state": "nsw",
		"postcode": "2000"
	},
	{
		"town": "the rocks",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "the sandon",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "the scrub",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "the settlement",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "the shades",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "the sisters",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "the slopes",
		"state": "nsw",
		"postcode": "2754"
	},
	{
		"town": "the spectacles",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "the spit",
		"state": "nsw",
		"postcode": "2088"
	},
	{
		"town": "the spit",
		"state": "qld",
		"postcode": "4217"
	},
	{
		"town": "the summit",
		"state": "qld",
		"postcode": "4377"
	},
	{
		"town": "the troffs",
		"state": "nsw",
		"postcode": "2875"
	},
	{
		"town": "the university of adelaide",
		"state": "sa",
		"postcode": "5005"
	},
	{
		"town": "the university of sydney",
		"state": "nsw",
		"postcode": "2006"
	},
	{
		"town": "the vale",
		"state": "nsw",
		"postcode": "2715"
	},
	{
		"town": "the vines",
		"state": "wa",
		"postcode": "6069"
	},
	{
		"town": "the walnuts",
		"state": "vic",
		"postcode": "3898"
	},
	{
		"town": "the whiteman",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "thebarton",
		"state": "sa",
		"postcode": "5031"
	},
	{
		"town": "theebine",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "theodore",
		"state": "act",
		"postcode": "2905"
	},
	{
		"town": "theodore",
		"state": "qld",
		"postcode": "4719"
	},
	{
		"town": "theresa creek",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "theresa park",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "thevenard",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "thevenard island",
		"state": "wa",
		"postcode": "6711"
	},
	{
		"town": "thinoomba",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "third creek",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "thirlmere",
		"state": "nsw",
		"postcode": "2572"
	},
	{
		"town": "thirloene",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "thirlstane",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "thirroul",
		"state": "nsw",
		"postcode": "2515"
	},
	{
		"town": "thistlebrook",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "thologolong",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "thomas plains",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "thomastown",
		"state": "vic",
		"postcode": "3074"
	},
	{
		"town": "thompson estate",
		"state": "qld",
		"postcode": "4103"
	},
	{
		"town": "thompson point",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "thomson",
		"state": "vic",
		"postcode": "3219"
	},
	{
		"town": "thoona",
		"state": "vic",
		"postcode": "3726"
	},
	{
		"town": "thoopara",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "thora",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "thorley",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "thornbury",
		"state": "vic",
		"postcode": "3071"
	},
	{
		"town": "thornbury north",
		"state": "vic",
		"postcode": "3071"
	},
	{
		"town": "thorneside",
		"state": "qld",
		"postcode": "4158"
	},
	{
		"town": "thorngate",
		"state": "sa",
		"postcode": "5082"
	},
	{
		"town": "thornlands",
		"state": "qld",
		"postcode": "4164"
	},
	{
		"town": "thornlea",
		"state": "sa",
		"postcode": "5280"
	},
	{
		"town": "thornleigh",
		"state": "nsw",
		"postcode": "2120"
	},
	{
		"town": "thornlie",
		"state": "wa",
		"postcode": "6108"
	},
	{
		"town": "thornlie",
		"state": "wa",
		"postcode": "6988"
	},
	{
		"town": "thornton",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "thornton",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "thornton",
		"state": "vic",
		"postcode": "3712"
	},
	{
		"town": "thornville",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "thorpdale",
		"state": "vic",
		"postcode": "3835"
	},
	{
		"town": "thorpdale south",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "thowgla valley",
		"state": "vic",
		"postcode": "3707"
	},
	{
		"town": "thredbo village",
		"state": "nsw",
		"postcode": "2625"
	},
	{
		"town": "three bridges",
		"state": "vic",
		"postcode": "3797"
	},
	{
		"town": "three hummock island",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "three mile",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "three moon",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "three springs",
		"state": "wa",
		"postcode": "6519"
	},
	{
		"town": "three ways",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "thrington",
		"state": "sa",
		"postcode": "5552"
	},
	{
		"town": "throsby",
		"state": "act",
		"postcode": "2914"
	},
	{
		"town": "throssell",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "thrumster",
		"state": "nsw",
		"postcode": "2444"
	},
	{
		"town": "thuddungra",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "thule",
		"state": "nsw",
		"postcode": "2732"
	},
	{
		"town": "thulimbah",
		"state": "qld",
		"postcode": "4376"
	},
	{
		"town": "thumb creek",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "thurgoona",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "thuringowa central",
		"state": "qld",
		"postcode": "4817"
	},
	{
		"town": "thursday island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "ti tree",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "tia",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "tiaro",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tibbuc",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "tiberias",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "tibooburra",
		"state": "nsw",
		"postcode": "2880"
	},
	{
		"town": "tibradden",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "tichborne",
		"state": "nsw",
		"postcode": "2870"
	},
	{
		"town": "tichular",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "tickera",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "tidal river",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "tiddy widdy beach",
		"state": "sa",
		"postcode": "5571"
	},
	{
		"town": "tieri",
		"state": "qld",
		"postcode": "4709"
	},
	{
		"town": "tighes hill",
		"state": "nsw",
		"postcode": "2297"
	},
	{
		"town": "tikitere",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "tilba tilba",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "tilbuster",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "tillegra",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "tilley swamp",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "tilpa",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "timbarra",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "timber creek",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "timberlands",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "timbertop",
		"state": "vic",
		"postcode": "3722"
	},
	{
		"town": "timbillica",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "timboon",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "timboon west",
		"state": "vic",
		"postcode": "3268"
	},
	{
		"town": "timbumburi",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "timmering",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "timmsvale",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "timor",
		"state": "nsw",
		"postcode": "2338"
	},
	{
		"town": "timor",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "timor west",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "tin can bay",
		"state": "qld",
		"postcode": "4580"
	},
	{
		"town": "tinamba",
		"state": "vic",
		"postcode": "3859"
	},
	{
		"town": "tinamba west",
		"state": "vic",
		"postcode": "3859"
	},
	{
		"town": "tinana",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tinana south",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tinaroo",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "tinbeerwah",
		"state": "qld",
		"postcode": "4563"
	},
	{
		"town": "tincurrin",
		"state": "wa",
		"postcode": "6361"
	},
	{
		"town": "tindal raaf",
		"state": "nt",
		"postcode": "853"
	},
	{
		"town": "tindarey",
		"state": "nsw",
		"postcode": "2835"
	},
	{
		"town": "tinderbox",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "tingalpa",
		"state": "qld",
		"postcode": "4173"
	},
	{
		"town": "tingha",
		"state": "nsw",
		"postcode": "2369"
	},
	{
		"town": "tingira heights",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "tingledale",
		"state": "wa",
		"postcode": "6333"
	},
	{
		"town": "tingoora",
		"state": "qld",
		"postcode": "4608"
	},
	{
		"town": "tinnanbar",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tinonee",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "tinpot",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "tintaldra",
		"state": "vic",
		"postcode": "3708"
	},
	{
		"town": "tintenbar",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "tintinara",
		"state": "sa",
		"postcode": "5266"
	},
	{
		"town": "tintinhull",
		"state": "nsw",
		"postcode": "2352"
	},
	{
		"town": "tiona",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "tipperary",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "tipton",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "tiri",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "tirrannaville",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "tirroan",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "titaatee creek",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "titybong",
		"state": "vic",
		"postcode": "3542"
	},
	{
		"town": "tivoli",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "tiwi",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "tjirrkarli",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "tjukurla",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "tocal",
		"state": "nsw",
		"postcode": "2421"
	},
	{
		"town": "tocal",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "tocumwal",
		"state": "nsw",
		"postcode": "2714"
	},
	{
		"town": "togari",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "toiberry",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "tol tol",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "tolderol",
		"state": "sa",
		"postcode": "5256"
	},
	{
		"town": "tolga",
		"state": "qld",
		"postcode": "4882"
	},
	{
		"town": "tolland",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "tolmans hill",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "tolmie",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "tom price",
		"state": "wa",
		"postcode": "6751"
	},
	{
		"town": "tomago",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "tomahawk",
		"state": "tas",
		"postcode": "7262"
	},
	{
		"town": "tomakin",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "tomalla",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "tombong",
		"state": "nsw",
		"postcode": "2633"
	},
	{
		"town": "tomboye",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "tomerong",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "tomewin",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "tomingley",
		"state": "nsw",
		"postcode": "2869"
	},
	{
		"town": "tomki",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "tommys hut",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "toms creek",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "tonderburine",
		"state": "nsw",
		"postcode": "2828"
	},
	{
		"town": "tone river mill",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "tonebridge",
		"state": "wa",
		"postcode": "6244"
	},
	{
		"town": "tongala",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "tonganah",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "tongarra",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "tonghi creek",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "tongio",
		"state": "vic",
		"postcode": "3896"
	},
	{
		"town": "tonimbuk",
		"state": "vic",
		"postcode": "3815"
	},
	{
		"town": "tooan",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "toobanna",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "toobeah",
		"state": "qld",
		"postcode": "4498"
	},
	{
		"town": "tooborac",
		"state": "vic",
		"postcode": "3522"
	},
	{
		"town": "toodyay",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "toogong",
		"state": "nsw",
		"postcode": "2864"
	},
	{
		"town": "toogoolawah",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "toogoom",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "toolakea",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "toolamba",
		"state": "vic",
		"postcode": "3614"
	},
	{
		"town": "toolamba east",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "toolamba west",
		"state": "vic",
		"postcode": "3616"
	},
	{
		"town": "toolangi",
		"state": "vic",
		"postcode": "3777"
	},
	{
		"town": "toolara",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "toolara forest",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "toolbrunup",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "toolern vale",
		"state": "vic",
		"postcode": "3337"
	},
	{
		"town": "tooleybuc",
		"state": "nsw",
		"postcode": "2736"
	},
	{
		"town": "toolibin",
		"state": "wa",
		"postcode": "6312"
	},
	{
		"town": "tooligie",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "toolijooa",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "toolleen",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "toolondo",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "toolong",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "toolooa",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "tooloom",
		"state": "nsw",
		"postcode": "2475"
	},
	{
		"town": "tooloonook",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "tooma",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "toombul",
		"state": "qld",
		"postcode": "4012"
	},
	{
		"town": "toombullup",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "toompup",
		"state": "wa",
		"postcode": "6336"
	},
	{
		"town": "tooms lake",
		"state": "tas",
		"postcode": "7209"
	},
	{
		"town": "toomuc valley",
		"state": "vic",
		"postcode": "3810"
	},
	{
		"town": "toomulla",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "toondahra",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "toongabbie",
		"state": "nsw",
		"postcode": "2146"
	},
	{
		"town": "toongabbie",
		"state": "vic",
		"postcode": "3856"
	},
	{
		"town": "toongabbie east",
		"state": "nsw",
		"postcode": "2146"
	},
	{
		"town": "toongi",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "toonpan",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "toonumbar",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "tooperang",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "toora",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "toora",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "toora north",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "tooradin",
		"state": "vic",
		"postcode": "3980"
	},
	{
		"town": "tooradin north",
		"state": "vic",
		"postcode": "3977"
	},
	{
		"town": "toorak",
		"state": "vic",
		"postcode": "3142"
	},
	{
		"town": "toorak gardens",
		"state": "sa",
		"postcode": "5065"
	},
	{
		"town": "tooraweenah",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "toorbul",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "toorbul point",
		"state": "qld",
		"postcode": "4511"
	},
	{
		"town": "toorloo arm",
		"state": "vic",
		"postcode": "3909"
	},
	{
		"town": "toormina",
		"state": "nsw",
		"postcode": "2452"
	},
	{
		"town": "toorooka",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "tooroonga falls",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "tootgarook",
		"state": "vic",
		"postcode": "3941"
	},
	{
		"town": "toothdale",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "tootool",
		"state": "nsw",
		"postcode": "2655"
	},
	{
		"town": "tootra",
		"state": "wa",
		"postcode": "6574"
	},
	{
		"town": "toowong",
		"state": "qld",
		"postcode": "4066"
	},
	{
		"town": "toowoomba city",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "toowoomba village fair",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "toowoon bay",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "tooyal",
		"state": "nsw",
		"postcode": "2701"
	},
	{
		"town": "top camp",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "top creek",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "top naas",
		"state": "act",
		"postcode": "2620"
	},
	{
		"town": "topaz",
		"state": "qld",
		"postcode": "4885"
	},
	{
		"town": "topi topi",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "topiram",
		"state": "vic",
		"postcode": "3988"
	},
	{
		"town": "torbanlea",
		"state": "qld",
		"postcode": "4662"
	},
	{
		"town": "torbay",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "toronto",
		"state": "nsw",
		"postcode": "2283"
	},
	{
		"town": "torquay",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "torquay",
		"state": "vic",
		"postcode": "3228"
	},
	{
		"town": "torrens",
		"state": "act",
		"postcode": "2607"
	},
	{
		"town": "torrens creek",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "torrens park",
		"state": "sa",
		"postcode": "5062"
	},
	{
		"town": "torrens vale",
		"state": "sa",
		"postcode": "5203"
	},
	{
		"town": "torrensville",
		"state": "sa",
		"postcode": "5031"
	},
	{
		"town": "torrensville plaza",
		"state": "sa",
		"postcode": "5031"
	},
	{
		"town": "torrington",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "torrington",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "torrita",
		"state": "vic",
		"postcode": "3490"
	},
	{
		"town": "torrumbarry",
		"state": "vic",
		"postcode": "3562"
	},
	{
		"town": "torryburn",
		"state": "nsw",
		"postcode": "2421"
	},
	{
		"town": "tortilla flats",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "torwood",
		"state": "qld",
		"postcode": "4066"
	},
	{
		"town": "torwood",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "tostaree",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "tothill creek",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "totnes valley",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "tottenham",
		"state": "nsw",
		"postcode": "2873"
	},
	{
		"town": "tottenham",
		"state": "vic",
		"postcode": "3012"
	},
	{
		"town": "tottington",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "toukley",
		"state": "nsw",
		"postcode": "2263"
	},
	{
		"town": "tourello",
		"state": "vic",
		"postcode": "3363"
	},
	{
		"town": "towac",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "towallum",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "towamba",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "towan",
		"state": "vic",
		"postcode": "3596"
	},
	{
		"town": "towaninny",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "towaninny south",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "towen mountain",
		"state": "qld",
		"postcode": "4560"
	},
	{
		"town": "tower hill",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "tower hill",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "towitta",
		"state": "sa",
		"postcode": "5353"
	},
	{
		"town": "townsend",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "townsendale",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "townson",
		"state": "qld",
		"postcode": "4341"
	},
	{
		"town": "townsville",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "townsville milpo",
		"state": "qld",
		"postcode": "4813"
	},
	{
		"town": "townsville west",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "townview",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "towong",
		"state": "vic",
		"postcode": "3707"
	},
	{
		"town": "towong upper",
		"state": "vic",
		"postcode": "3707"
	},
	{
		"town": "towradgi",
		"state": "nsw",
		"postcode": "2518"
	},
	{
		"town": "towrang",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "trafalgar",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "trafalgar east",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "trafalgar south",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "tragowel",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "trajere",
		"state": "nsw",
		"postcode": "2806"
	},
	{
		"town": "trangie",
		"state": "nsw",
		"postcode": "2823"
	},
	{
		"town": "tranmere",
		"state": "sa",
		"postcode": "5073"
	},
	{
		"town": "tranmere",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "tranmere north",
		"state": "sa",
		"postcode": "5073"
	},
	{
		"town": "traralgon",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "traralgon east",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "traralgon south",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "travancore",
		"state": "vic",
		"postcode": "3032"
	},
	{
		"town": "travellers rest",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "traveston",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "trawalla",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "trawool",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "trayning",
		"state": "wa",
		"postcode": "6488"
	},
	{
		"town": "traynors lagoon",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "trebonne",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "treesville",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "treeton",
		"state": "wa",
		"postcode": "6284"
	},
	{
		"town": "tregeagle",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tregear",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "tremont",
		"state": "vic",
		"postcode": "3785"
	},
	{
		"town": "trenah",
		"state": "tas",
		"postcode": "7263"
	},
	{
		"town": "trenayr",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "trentham",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "trentham cliffs",
		"state": "nsw",
		"postcode": "2738"
	},
	{
		"town": "trentham east",
		"state": "vic",
		"postcode": "3458"
	},
	{
		"town": "trenton valley",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "tresco",
		"state": "vic",
		"postcode": "3583"
	},
	{
		"town": "tresco west",
		"state": "vic",
		"postcode": "3584"
	},
	{
		"town": "trevallyn",
		"state": "nsw",
		"postcode": "2421"
	},
	{
		"town": "trevallyn",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "trewilga",
		"state": "nsw",
		"postcode": "2869"
	},
	{
		"town": "triabunna",
		"state": "tas",
		"postcode": "7190"
	},
	{
		"town": "triamble",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "triangle flat",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "trida",
		"state": "nsw",
		"postcode": "2878"
	},
	{
		"town": "trida",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "trigg",
		"state": "wa",
		"postcode": "6029"
	},
	{
		"town": "trigwell",
		"state": "wa",
		"postcode": "6393"
	},
	{
		"town": "trihi",
		"state": "sa",
		"postcode": "5279"
	},
	{
		"town": "triholm",
		"state": "vic",
		"postcode": "3988"
	},
	{
		"town": "trinder park",
		"state": "qld",
		"postcode": "4114"
	},
	{
		"town": "trinity beach",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "trinity gardens",
		"state": "sa",
		"postcode": "5068"
	},
	{
		"town": "trinity park",
		"state": "qld",
		"postcode": "4879"
	},
	{
		"town": "trott park",
		"state": "sa",
		"postcode": "5158"
	},
	{
		"town": "trotter creek",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "trowutta",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "troy junction",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "truganina",
		"state": "vic",
		"postcode": "3029"
	},
	{
		"town": "trunding",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "trundle",
		"state": "nsw",
		"postcode": "2875"
	},
	{
		"town": "trungley hall",
		"state": "nsw",
		"postcode": "2666"
	},
	{
		"town": "trunk lead",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "trunkey",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "truro",
		"state": "sa",
		"postcode": "5356"
	},
	{
		"town": "truslove",
		"state": "wa",
		"postcode": "6446"
	},
	{
		"town": "tuan",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tuan forest",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "tuart hill",
		"state": "wa",
		"postcode": "6060"
	},
	{
		"town": "tuart hill",
		"state": "wa",
		"postcode": "6937"
	},
	{
		"town": "tuart hill",
		"state": "wa",
		"postcode": "6938"
	},
	{
		"town": "tuart hill",
		"state": "wa",
		"postcode": "6939"
	},
	{
		"town": "tuart hill",
		"state": "wa",
		"postcode": "6940"
	},
	{
		"town": "tubbamurra",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "tubbul",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "tubbut",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "tucabia",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "tuchekoi",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "tuckanarra",
		"state": "wa",
		"postcode": "6640"
	},
	{
		"town": "tucki tucki",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tucklan",
		"state": "nsw",
		"postcode": "2844"
	},
	{
		"town": "tuckombil",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "tuckurimba",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tudor",
		"state": "vic",
		"postcode": "3596"
	},
	{
		"town": "tueloga",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "tuena",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "tuerong",
		"state": "vic",
		"postcode": "3933"
	},
	{
		"town": "tuggerah",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "tuggeranong",
		"state": "act",
		"postcode": "2900"
	},
	{
		"town": "tuggerawong",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "tugrabakh",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "tugrah",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "tugun",
		"state": "qld",
		"postcode": "4224"
	},
	{
		"town": "tugun heights",
		"state": "qld",
		"postcode": "4224"
	},
	{
		"town": "tulendeena",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "tulka",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "tulka north",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "tulkara",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "tullah",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "tullakool",
		"state": "nsw",
		"postcode": "2732"
	},
	{
		"town": "tullamarine",
		"state": "vic",
		"postcode": "3043"
	},
	{
		"town": "tullamarine airport",
		"state": "vic",
		"postcode": "3045"
	},
	{
		"town": "tullamore",
		"state": "nsw",
		"postcode": "2874"
	},
	{
		"town": "tullaroop dam",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "tullera",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tullibigeal",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "tullimbar",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "tullis",
		"state": "wa",
		"postcode": "6390"
	},
	{
		"town": "tullochgorum",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "tulloona",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "tully",
		"state": "qld",
		"postcode": "4854"
	},
	{
		"town": "tullymorgan",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "tullyvea",
		"state": "vic",
		"postcode": "3423"
	},
	{
		"town": "tumbarumba",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "tumbi umbi",
		"state": "nsw",
		"postcode": "2261"
	},
	{
		"town": "tumbling waters",
		"state": "vic",
		"postcode": "3712"
	},
	{
		"town": "tumblong",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "tumbulgum",
		"state": "nsw",
		"postcode": "2490"
	},
	{
		"town": "tumby bay",
		"state": "sa",
		"postcode": "5605"
	},
	{
		"town": "tummaville",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "tumorrama",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "tumoulin",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "tumut",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "tumut plains",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "tunbridge",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "tuncester",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tuncurry",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "tungamah",
		"state": "vic",
		"postcode": "3728"
	},
	{
		"town": "tungamull",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "tungatinah",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "tungkillo",
		"state": "sa",
		"postcode": "5236"
	},
	{
		"town": "tunglebung",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "tungsten",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "tunkalilla",
		"state": "sa",
		"postcode": "5203"
	},
	{
		"town": "tunnack",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "tunnel",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "tunney",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "tunstall square po",
		"state": "vic",
		"postcode": "3109"
	},
	{
		"town": "tuntable creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tuntable falls",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "tuppal",
		"state": "nsw",
		"postcode": "2714"
	},
	{
		"town": "tura beach",
		"state": "nsw",
		"postcode": "2548"
	},
	{
		"town": "turallin",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "turill",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "turkey beach",
		"state": "qld",
		"postcode": "4678"
	},
	{
		"town": "turkey hill",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "turkey point",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "turlinjah",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "turner",
		"state": "act",
		"postcode": "2612"
	},
	{
		"town": "turners",
		"state": "vic",
		"postcode": "3946"
	},
	{
		"town": "turners beach",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "turners flat",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "turners marsh",
		"state": "tas",
		"postcode": "7267"
	},
	{
		"town": "turoar",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "turondale",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "tuross",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "tuross head",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "turramurra",
		"state": "nsw",
		"postcode": "2074"
	},
	{
		"town": "turrawan",
		"state": "nsw",
		"postcode": "2390"
	},
	{
		"town": "turrawulla",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "turrella",
		"state": "nsw",
		"postcode": "2205"
	},
	{
		"town": "turriff",
		"state": "vic",
		"postcode": "3488"
	},
	{
		"town": "turriff east",
		"state": "vic",
		"postcode": "3488"
	},
	{
		"town": "turtons creek",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "turvey park",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "tusmore",
		"state": "sa",
		"postcode": "5065"
	},
	{
		"town": "tutunup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "tutye",
		"state": "vic",
		"postcode": "3490"
	},
	{
		"town": "tweed heads",
		"state": "nsw",
		"postcode": "2485"
	},
	{
		"town": "tweed heads south",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "tweed heads west",
		"state": "nsw",
		"postcode": "2485"
	},
	{
		"town": "twelve mile",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "twelve mile creek",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "twenty forests",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "two mile",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "two mile flat",
		"state": "nsw",
		"postcode": "2852"
	},
	{
		"town": "two rocks",
		"state": "wa",
		"postcode": "6037"
	},
	{
		"town": "two wells",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "tyaak",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "tyabb",
		"state": "vic",
		"postcode": "3913"
	},
	{
		"town": "tyagarah",
		"state": "nsw",
		"postcode": "2481"
	},
	{
		"town": "tyalgum",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "tyalgum creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "tyenna",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "tyers",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "tyers junction",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "tygalgah",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "tylden",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "tylden south",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "tyndale",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "tynong",
		"state": "vic",
		"postcode": "3813"
	},
	{
		"town": "tynong north",
		"state": "vic",
		"postcode": "3813"
	},
	{
		"town": "tyntynder",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "tyntynder south",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "tyrendarra",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "tyrendarra east",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "tyringham",
		"state": "nsw",
		"postcode": "2453"
	},
	{
		"town": "tyrrell",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "tyrrell downs",
		"state": "vic",
		"postcode": "3533"
	},
	{
		"town": "tysons reef",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "uarbry",
		"state": "nsw",
		"postcode": "2329"
	},
	{
		"town": "ubobo",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "ucarty",
		"state": "wa",
		"postcode": "6462"
	},
	{
		"town": "ucarty west",
		"state": "wa",
		"postcode": "6460"
	},
	{
		"town": "ucolta",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "uduc",
		"state": "wa",
		"postcode": "6220"
	},
	{
		"town": "uki",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "ulamambri",
		"state": "nsw",
		"postcode": "2357"
	},
	{
		"town": "ulan",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "ularring",
		"state": "wa",
		"postcode": "6436"
	},
	{
		"town": "uleybury",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "ulladulla",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "ullamalla",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "ullina",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "ullswater",
		"state": "vic",
		"postcode": "3318"
	},
	{
		"town": "ulmarra",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "ulogie",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "ulong",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "ulooloo",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "ultima",
		"state": "vic",
		"postcode": "3544"
	},
	{
		"town": "ultima east",
		"state": "vic",
		"postcode": "3586"
	},
	{
		"town": "ultimo",
		"state": "nsw",
		"postcode": "2007"
	},
	{
		"town": "ulupna",
		"state": "vic",
		"postcode": "3641"
	},
	{
		"town": "uluru",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "ulverstone",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "ulyerra",
		"state": "sa",
		"postcode": "5670"
	},
	{
		"town": "umagico",
		"state": "qld",
		"postcode": "4876"
	},
	{
		"town": "umbakumba",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "umbiram",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "umina",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "umina beach",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "umpangara",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "unanderra",
		"state": "nsw",
		"postcode": "2526"
	},
	{
		"town": "undera",
		"state": "vic",
		"postcode": "3629"
	},
	{
		"town": "underbank",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "underbool",
		"state": "vic",
		"postcode": "3509"
	},
	{
		"town": "undercliffe",
		"state": "nsw",
		"postcode": "2206"
	},
	{
		"town": "underdale",
		"state": "sa",
		"postcode": "5032"
	},
	{
		"town": "underwood",
		"state": "qld",
		"postcode": "4119"
	},
	{
		"town": "underwood",
		"state": "tas",
		"postcode": "7268"
	},
	{
		"town": "undullah",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "ungarie",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "ungarra",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "unicup",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "university of adelaide",
		"state": "sa",
		"postcode": "5005"
	},
	{
		"town": "university of canberra",
		"state": "act",
		"postcode": "2601"
	},
	{
		"town": "university of melbourne",
		"state": "vic",
		"postcode": "3010"
	},
	{
		"town": "university of new england",
		"state": "nsw",
		"postcode": "2351"
	},
	{
		"town": "university of queensland",
		"state": "qld",
		"postcode": "4072"
	},
	{
		"town": "university of tasmania",
		"state": "tas",
		"postcode": "7005"
	},
	{
		"town": "university of wollongong",
		"state": "nsw",
		"postcode": "2522"
	},
	{
		"town": "unley",
		"state": "sa",
		"postcode": "5061"
	},
	{
		"town": "unley park",
		"state": "sa",
		"postcode": "5061"
	},
	{
		"town": "unsw sydney",
		"state": "nsw",
		"postcode": "2052"
	},
	{
		"town": "unumgar",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "uplands",
		"state": "vic",
		"postcode": "3900"
	},
	{
		"town": "upotipotpon",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "upper barron",
		"state": "qld",
		"postcode": "4883"
	},
	{
		"town": "upper bingara",
		"state": "nsw",
		"postcode": "2404"
	},
	{
		"town": "upper blessington",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "upper bowman",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "upper brogo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "upper brookfield",
		"state": "qld",
		"postcode": "4069"
	},
	{
		"town": "upper burnie",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "upper burringbar",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "upper bylong",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "upper caboolture",
		"state": "qld",
		"postcode": "4510"
	},
	{
		"town": "upper castra",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "upper chichester",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "upper colo",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "upper coomera",
		"state": "qld",
		"postcode": "4209"
	},
	{
		"town": "upper coopers creek",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "upper copmanhurst",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "upper corindi",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "upper crystal creek",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "upper duroby",
		"state": "nsw",
		"postcode": "2486"
	},
	{
		"town": "upper eden creek",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "upper esk",
		"state": "tas",
		"postcode": "7214"
	},
	{
		"town": "upper ferntree gully",
		"state": "vic",
		"postcode": "3156"
	},
	{
		"town": "upper fine flower",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "upper flagstone",
		"state": "qld",
		"postcode": "4344"
	},
	{
		"town": "upper gellibrand",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "upper growee",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "upper gundowring",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "upper hermitage",
		"state": "sa",
		"postcode": "5131"
	},
	{
		"town": "upper horton",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "upper kalgan",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "upper kangaroo valley",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "upper kedron",
		"state": "qld",
		"postcode": "4055"
	},
	{
		"town": "upper lansdowne",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "upper lockyer",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "upper lurg",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "upper macdonald",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "upper main arm",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "upper mangrove",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "upper manilla",
		"state": "nsw",
		"postcode": "2346"
	},
	{
		"town": "upper meroo",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "upper mount gravatt",
		"state": "qld",
		"postcode": "4122"
	},
	{
		"town": "upper myall",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "upper nambucca",
		"state": "nsw",
		"postcode": "2449"
	},
	{
		"town": "upper natone",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "upper nile",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "upper orara",
		"state": "nsw",
		"postcode": "2450"
	},
	{
		"town": "upper pappinbarra",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "upper pilton",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "upper pinelands",
		"state": "qld",
		"postcode": "4355"
	},
	{
		"town": "upper plenty",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "upper plenty",
		"state": "vic",
		"postcode": "3756"
	},
	{
		"town": "upper rollands plains",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "upper rouchel",
		"state": "nsw",
		"postcode": "2336"
	},
	{
		"town": "upper ryans creek",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "upper scamander",
		"state": "tas",
		"postcode": "7215"
	},
	{
		"town": "upper stone",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "upper stowport",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "upper sturt",
		"state": "sa",
		"postcode": "5156"
	},
	{
		"town": "upper swan",
		"state": "wa",
		"postcode": "6069"
	},
	{
		"town": "upper tenthill",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "upper thora",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "upper turon",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "upper woodstock",
		"state": "tas",
		"postcode": "7150"
	},
	{
		"town": "upper yarrowitch",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "upsalls creek",
		"state": "nsw",
		"postcode": "2439"
	},
	{
		"town": "upwey",
		"state": "vic",
		"postcode": "3158"
	},
	{
		"town": "uraidla",
		"state": "sa",
		"postcode": "5142"
	},
	{
		"town": "uralba",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "uralla",
		"state": "nsw",
		"postcode": "2358"
	},
	{
		"town": "urana",
		"state": "nsw",
		"postcode": "2645"
	},
	{
		"town": "urangan",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "urangeline",
		"state": "nsw",
		"postcode": "2656"
	},
	{
		"town": "urangeline east",
		"state": "nsw",
		"postcode": "2656"
	},
	{
		"town": "urania",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "uranquinty",
		"state": "nsw",
		"postcode": "2652"
	},
	{
		"town": "urapuntja",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "urbenville",
		"state": "nsw",
		"postcode": "2475"
	},
	{
		"town": "uriarra",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "uriarra forest",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "urisino",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "urliup",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "uroly",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "urraween",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "urrbrae",
		"state": "sa",
		"postcode": "5064"
	},
	{
		"town": "urunga",
		"state": "nsw",
		"postcode": "2455"
	},
	{
		"town": "useless loop",
		"state": "wa",
		"postcode": "6537"
	},
	{
		"town": "usher",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "utakarra",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "utungun",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "uworra",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "uxbridge",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "vacy",
		"state": "nsw",
		"postcode": "2421"
	},
	{
		"town": "valdora",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "vale park",
		"state": "sa",
		"postcode": "5081"
	},
	{
		"town": "vale view",
		"state": "qld",
		"postcode": "4358"
	},
	{
		"town": "valencia creek",
		"state": "vic",
		"postcode": "3860"
	},
	{
		"town": "valentine",
		"state": "nsw",
		"postcode": "2280"
	},
	{
		"town": "valentine plains",
		"state": "qld",
		"postcode": "4715"
	},
	{
		"town": "valery",
		"state": "nsw",
		"postcode": "2454"
	},
	{
		"town": "valettas estate",
		"state": "qld",
		"postcode": "4860"
	},
	{
		"town": "valkyrie",
		"state": "qld",
		"postcode": "4742"
	},
	{
		"town": "valla",
		"state": "nsw",
		"postcode": "2448"
	},
	{
		"town": "valla beach",
		"state": "nsw",
		"postcode": "2448"
	},
	{
		"town": "valley heights",
		"state": "nsw",
		"postcode": "2777"
	},
	{
		"town": "valley view",
		"state": "sa",
		"postcode": "5093"
	},
	{
		"town": "valley view",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "varley",
		"state": "wa",
		"postcode": "6355"
	},
	{
		"town": "varroville",
		"state": "nsw",
		"postcode": "2566"
	},
	{
		"town": "vasey",
		"state": "vic",
		"postcode": "3407"
	},
	{
		"town": "vasse",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "vaucluse",
		"state": "nsw",
		"postcode": "2030"
	},
	{
		"town": "vaughan",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "vectis",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "veitch",
		"state": "sa",
		"postcode": "5312"
	},
	{
		"town": "velore",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "ventnor",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "ventnor",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "venus bay",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "venus bay",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "veradilla",
		"state": "qld",
		"postcode": "4347"
	},
	{
		"town": "verdant vale",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "verdun",
		"state": "sa",
		"postcode": "5245"
	},
	{
		"town": "veresdale",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "veresdale scrub",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "vergemont",
		"state": "qld",
		"postcode": "4730"
	},
	{
		"town": "verges creek",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "vermont",
		"state": "vic",
		"postcode": "3133"
	},
	{
		"town": "vermont east",
		"state": "vic",
		"postcode": "3133"
	},
	{
		"town": "vermont south",
		"state": "vic",
		"postcode": "3133"
	},
	{
		"town": "vernor",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "verona",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "verona sands",
		"state": "tas",
		"postcode": "7112"
	},
	{
		"town": "verran",
		"state": "sa",
		"postcode": "5603"
	},
	{
		"town": "verrierdale",
		"state": "qld",
		"postcode": "4562"
	},
	{
		"town": "vervale",
		"state": "vic",
		"postcode": "3814"
	},
	{
		"town": "vesper",
		"state": "vic",
		"postcode": "3833"
	},
	{
		"town": "veteran",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "victor harbor",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "victoria estate",
		"state": "qld",
		"postcode": "4850"
	},
	{
		"town": "victoria hill",
		"state": "qld",
		"postcode": "4361"
	},
	{
		"town": "victoria park",
		"state": "vic",
		"postcode": "3460"
	},
	{
		"town": "victoria park",
		"state": "wa",
		"postcode": "6100"
	},
	{
		"town": "victoria park",
		"state": "wa",
		"postcode": "6979"
	},
	{
		"town": "victoria plains",
		"state": "qld",
		"postcode": "4751"
	},
	{
		"town": "victoria point",
		"state": "qld",
		"postcode": "4165"
	},
	{
		"town": "victoria point",
		"state": "vic",
		"postcode": "3314"
	},
	{
		"town": "victoria point west",
		"state": "qld",
		"postcode": "4165"
	},
	{
		"town": "victoria river downs",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "victoria valley",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "victoria valley",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "victory heights",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "victory heights",
		"state": "wa",
		"postcode": "6432"
	},
	{
		"town": "view point",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "viewbank",
		"state": "vic",
		"postcode": "3084"
	},
	{
		"town": "viewmont",
		"state": "nsw",
		"postcode": "2448"
	},
	{
		"town": "villawood",
		"state": "nsw",
		"postcode": "2163"
	},
	{
		"town": "villeneuve",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "vincent",
		"state": "qld",
		"postcode": "4814"
	},
	{
		"town": "vincent",
		"state": "vic",
		"postcode": "3677"
	},
	{
		"town": "vincentia",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "vinegar hill",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "vineyard",
		"state": "nsw",
		"postcode": "2765"
	},
	{
		"town": "vinifera",
		"state": "vic",
		"postcode": "3591"
	},
	{
		"town": "violet town",
		"state": "vic",
		"postcode": "3669"
	},
	{
		"town": "virginia",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "virginia",
		"state": "nt",
		"postcode": "835"
	},
	{
		"town": "virginia",
		"state": "qld",
		"postcode": "4014"
	},
	{
		"town": "virginia",
		"state": "sa",
		"postcode": "5120"
	},
	{
		"town": "vista",
		"state": "sa",
		"postcode": "5091"
	},
	{
		"town": "vite vite",
		"state": "vic",
		"postcode": "3325"
	},
	{
		"town": "vite vite north",
		"state": "vic",
		"postcode": "3325"
	},
	{
		"town": "vittoria",
		"state": "nsw",
		"postcode": "2799"
	},
	{
		"town": "vittoria",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "viveash",
		"state": "wa",
		"postcode": "6056"
	},
	{
		"town": "vivonne bay",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "voyager point",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "w tree",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "waaia",
		"state": "vic",
		"postcode": "3637"
	},
	{
		"town": "waanyarra",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "waarre",
		"state": "vic",
		"postcode": "3269"
	},
	{
		"town": "wacol",
		"state": "qld",
		"postcode": "4076"
	},
	{
		"town": "wacol east immigration centre",
		"state": "qld",
		"postcode": "4076"
	},
	{
		"town": "wadalba",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wadbilliga",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "waddamana",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "waddi forest",
		"state": "wa",
		"postcode": "6515"
	},
	{
		"town": "waddikee",
		"state": "sa",
		"postcode": "5640"
	},
	{
		"town": "waddington",
		"state": "wa",
		"postcode": "6509"
	},
	{
		"town": "wadeville",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "wadeye",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "waeel",
		"state": "wa",
		"postcode": "6407"
	},
	{
		"town": "wagait beach",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "wagaman",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "wagerup",
		"state": "wa",
		"postcode": "6215"
	},
	{
		"town": "wagga wagga",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "wagga wagga",
		"state": "nsw",
		"postcode": "2651"
	},
	{
		"town": "wagga wagga north",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "wagga wagga south",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "waggarandall",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "waggrakine",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "wagin",
		"state": "wa",
		"postcode": "6315"
	},
	{
		"town": "wagoora",
		"state": "qld",
		"postcode": "4798"
	},
	{
		"town": "wagra",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "wagragobilly",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "wagstaffe",
		"state": "nsw",
		"postcode": "2257"
	},
	{
		"town": "wahgunyah",
		"state": "vic",
		"postcode": "3687"
	},
	{
		"town": "wahoon",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "wahpunga",
		"state": "qld",
		"postcode": "4571"
	},
	{
		"town": "wahring",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "wahroonga",
		"state": "nsw",
		"postcode": "2076"
	},
	{
		"town": "waikerie",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "waikiki",
		"state": "wa",
		"postcode": "6169"
	},
	{
		"town": "wail",
		"state": "vic",
		"postcode": "3414"
	},
	{
		"town": "wail west",
		"state": "vic",
		"postcode": "3415"
	},
	{
		"town": "wainui",
		"state": "qld",
		"postcode": "4404"
	},
	{
		"town": "wairewa",
		"state": "vic",
		"postcode": "3887"
	},
	{
		"town": "waitara",
		"state": "nsw",
		"postcode": "2077"
	},
	{
		"town": "waitchie",
		"state": "vic",
		"postcode": "3544"
	},
	{
		"town": "waitpinga",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "waitui",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "wakefield",
		"state": "nsw",
		"postcode": "2278"
	},
	{
		"town": "wakeley",
		"state": "nsw",
		"postcode": "2176"
	},
	{
		"town": "wakerley",
		"state": "qld",
		"postcode": "4154"
	},
	{
		"town": "wakiti",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "wakool",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "wal wal",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "walang",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "walbundrie",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "walcha",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "walcha road",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "waldara",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "walebing",
		"state": "wa",
		"postcode": "6510"
	},
	{
		"town": "walgett",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "walgoolan",
		"state": "wa",
		"postcode": "6422"
	},
	{
		"town": "walhalla",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "walkamin",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "walkaway",
		"state": "wa",
		"postcode": "6528"
	},
	{
		"town": "walker flat",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "walkers point",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "walkerston",
		"state": "qld",
		"postcode": "4751"
	},
	{
		"town": "walkervale",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "walkerville",
		"state": "sa",
		"postcode": "5081"
	},
	{
		"town": "walkerville",
		"state": "vic",
		"postcode": "3956"
	},
	{
		"town": "walkerville north",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "walkerville south",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "walkley heights",
		"state": "sa",
		"postcode": "5098"
	},
	{
		"town": "wall",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "walla walla",
		"state": "nsw",
		"postcode": "2659"
	},
	{
		"town": "wallabadah",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "wallabi point",
		"state": "nsw",
		"postcode": "2430"
	},
	{
		"town": "wallaby creek",
		"state": "nsw",
		"postcode": "2475"
	},
	{
		"town": "wallaby creek",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "wallace",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "wallace rockhole",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "wallacedale",
		"state": "vic",
		"postcode": "3303"
	},
	{
		"town": "wallaces creek",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "wallacetown",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "wallacia",
		"state": "nsw",
		"postcode": "2745"
	},
	{
		"town": "wallaga lake",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "wallaga lake heights",
		"state": "nsw",
		"postcode": "2546"
	},
	{
		"town": "wallagoot",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "wallalong",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "wallaloo",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "wallaloo east",
		"state": "vic",
		"postcode": "3381"
	},
	{
		"town": "wallamore",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "wallan",
		"state": "vic",
		"postcode": "3756"
	},
	{
		"town": "wallan east",
		"state": "vic",
		"postcode": "3756"
	},
	{
		"town": "wallanbah",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "wallangarra",
		"state": "qld",
		"postcode": "4383"
	},
	{
		"town": "wallangra",
		"state": "nsw",
		"postcode": "2360"
	},
	{
		"town": "wallanthery",
		"state": "nsw",
		"postcode": "2675"
	},
	{
		"town": "wallarah",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wallareenya",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "wallarobba",
		"state": "nsw",
		"postcode": "2420"
	},
	{
		"town": "wallaroo",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "wallaroo",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "wallaroo",
		"state": "sa",
		"postcode": "5556"
	},
	{
		"town": "wallaroo mines",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "wallaroo plain",
		"state": "sa",
		"postcode": "5556"
	},
	{
		"town": "wallaville",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "wallaway",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "wallendbeen",
		"state": "nsw",
		"postcode": "2588"
	},
	{
		"town": "wallerawang",
		"state": "nsw",
		"postcode": "2845"
	},
	{
		"town": "walleroobie",
		"state": "nsw",
		"postcode": "2665"
	},
	{
		"town": "walligan",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "wallinduc",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "wallingat",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "wallington",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "walliston",
		"state": "wa",
		"postcode": "6076"
	},
	{
		"town": "walloon",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "wallsend",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "wallsend south",
		"state": "nsw",
		"postcode": "2287"
	},
	{
		"town": "wallu",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "wallumbilla",
		"state": "qld",
		"postcode": "4428"
	},
	{
		"town": "wallup",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "walmer",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "walmer",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "walmsley",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "walmul",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "walpa",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "walpeup",
		"state": "vic",
		"postcode": "3507"
	},
	{
		"town": "walpole",
		"state": "wa",
		"postcode": "6398"
	},
	{
		"town": "walsall",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "walterhall",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "waltowa",
		"state": "sa",
		"postcode": "5264"
	},
	{
		"town": "walwa",
		"state": "vic",
		"postcode": "3709"
	},
	{
		"town": "walwa east",
		"state": "vic",
		"postcode": "3708"
	},
	{
		"town": "walyormouring",
		"state": "wa",
		"postcode": "6460"
	},
	{
		"town": "walyurin",
		"state": "wa",
		"postcode": "6363"
	},
	{
		"town": "wamban",
		"state": "nsw",
		"postcode": "2537"
	},
	{
		"town": "wambat creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "wamberal",
		"state": "nsw",
		"postcode": "2260"
	},
	{
		"town": "wamboin",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "wambool",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "wambrook",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "wamenusking",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "wamoon",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "wamuran",
		"state": "qld",
		"postcode": "4512"
	},
	{
		"town": "wanaaring",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "wanalta",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "wanarn",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "wanbi",
		"state": "sa",
		"postcode": "5310"
	},
	{
		"town": "wandal",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "wandana",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "wandana heights",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "wandandian",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "wandearah",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "wandearah east",
		"state": "sa",
		"postcode": "5523"
	},
	{
		"town": "wandella",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "wandella",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "wandering",
		"state": "wa",
		"postcode": "6308"
	},
	{
		"town": "wandi",
		"state": "wa",
		"postcode": "6167"
	},
	{
		"town": "wandiligong",
		"state": "vic",
		"postcode": "3744"
	},
	{
		"town": "wandillup",
		"state": "wa",
		"postcode": "6256"
	},
	{
		"town": "wandilo",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "wandin east",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "wandin north",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "wandina",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "wando vale",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "wandoan",
		"state": "qld",
		"postcode": "4419"
	},
	{
		"town": "wandong",
		"state": "vic",
		"postcode": "3758"
	},
	{
		"town": "wandook",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "wandsworth",
		"state": "nsw",
		"postcode": "2365"
	},
	{
		"town": "wanerie",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "wang wauk",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "wangan",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "wangandary",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "wanganella",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "wangara",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "wangarabell",
		"state": "vic",
		"postcode": "3891"
	},
	{
		"town": "wangaratta",
		"state": "vic",
		"postcode": "3676"
	},
	{
		"town": "wangaratta",
		"state": "vic",
		"postcode": "3677"
	},
	{
		"town": "wangaratta forward",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "wangaratta north",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "wangaratta south",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "wangaratta west",
		"state": "vic",
		"postcode": "3677"
	},
	{
		"town": "wangary",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "wangetti beach",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "wangi wangi",
		"state": "nsw",
		"postcode": "2267"
	},
	{
		"town": "wangolina",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "wangoom",
		"state": "vic",
		"postcode": "3279"
	},
	{
		"town": "wanguri",
		"state": "nt",
		"postcode": "810"
	},
	{
		"town": "wanilla",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "wannamal",
		"state": "wa",
		"postcode": "6505"
	},
	{
		"town": "wannanup",
		"state": "wa",
		"postcode": "6210"
	},
	{
		"town": "wanneroo",
		"state": "wa",
		"postcode": "6065"
	},
	{
		"town": "wanneroo",
		"state": "wa",
		"postcode": "6946"
	},
	{
		"town": "wanniassa",
		"state": "act",
		"postcode": "2903"
	},
	{
		"town": "wannon",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "wanora",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "wansbrough",
		"state": "wa",
		"postcode": "6320"
	},
	{
		"town": "wantabadgery",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "wantagong",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "wantiool",
		"state": "nsw",
		"postcode": "2663"
	},
	{
		"town": "wantirna",
		"state": "vic",
		"postcode": "3152"
	},
	{
		"town": "wantirna south",
		"state": "vic",
		"postcode": "3152"
	},
	{
		"town": "wanurp",
		"state": "vic",
		"postcode": "3573"
	},
	{
		"town": "wapengo",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "wappilka",
		"state": "sa",
		"postcode": "5332"
	},
	{
		"town": "wapra",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "warabrook",
		"state": "nsw",
		"postcode": "2304"
	},
	{
		"town": "warakurna",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "waramanga",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "warana",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "warana beach",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "waranga",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "waratah",
		"state": "nsw",
		"postcode": "2298"
	},
	{
		"town": "waratah",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "waratah bay",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "waratah north",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "waratah west",
		"state": "nsw",
		"postcode": "2298"
	},
	{
		"town": "warawarrup",
		"state": "wa",
		"postcode": "6220"
	},
	{
		"town": "warburn",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "warburto",
		"state": "sa",
		"postcode": "5556"
	},
	{
		"town": "warburton",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "warburton community",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "ward belt",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "ward hill",
		"state": "sa",
		"postcode": "5522"
	},
	{
		"town": "wardell",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "wardering",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "warding east",
		"state": "wa",
		"postcode": "6405"
	},
	{
		"town": "wardrop valley",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "wards mistake",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "wards river",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "wareek",
		"state": "vic",
		"postcode": "3465"
	},
	{
		"town": "wareemba",
		"state": "nsw",
		"postcode": "2046"
	},
	{
		"town": "wargambegal",
		"state": "nsw",
		"postcode": "2672"
	},
	{
		"town": "wargan",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "warialda",
		"state": "nsw",
		"postcode": "2402"
	},
	{
		"town": "warialda rail",
		"state": "nsw",
		"postcode": "2402"
	},
	{
		"town": "warilla",
		"state": "nsw",
		"postcode": "2528"
	},
	{
		"town": "warkworth",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "warmun",
		"state": "wa",
		"postcode": "6743"
	},
	{
		"town": "warmur",
		"state": "vic",
		"postcode": "3482"
	},
	{
		"town": "warmur west",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "warnbro",
		"state": "wa",
		"postcode": "6169"
	},
	{
		"town": "warncoort",
		"state": "vic",
		"postcode": "3243"
	},
	{
		"town": "warne",
		"state": "vic",
		"postcode": "3530"
	},
	{
		"town": "warnecliffe",
		"state": "nsw",
		"postcode": "2866"
	},
	{
		"town": "warneet",
		"state": "vic",
		"postcode": "3980"
	},
	{
		"town": "warner",
		"state": "qld",
		"postcode": "4500"
	},
	{
		"town": "warner glen",
		"state": "wa",
		"postcode": "6288"
	},
	{
		"town": "warners bay",
		"state": "nsw",
		"postcode": "2282"
	},
	{
		"town": "warnertown",
		"state": "sa",
		"postcode": "5540"
	},
	{
		"town": "warnervale",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "warnoah",
		"state": "qld",
		"postcode": "4718"
	},
	{
		"town": "warnung",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "warooka",
		"state": "sa",
		"postcode": "5577"
	},
	{
		"town": "waroona",
		"state": "wa",
		"postcode": "6215"
	},
	{
		"town": "warra",
		"state": "qld",
		"postcode": "4411"
	},
	{
		"town": "warraber island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "warrachie",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "warracknabeal",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "warradale",
		"state": "sa",
		"postcode": "5046"
	},
	{
		"town": "warradale north",
		"state": "sa",
		"postcode": "5046"
	},
	{
		"town": "warraderry",
		"state": "nsw",
		"postcode": "2810"
	},
	{
		"town": "warragai creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "warragamba",
		"state": "nsw",
		"postcode": "2752"
	},
	{
		"town": "warragamba",
		"state": "vic",
		"postcode": "3561"
	},
	{
		"town": "warragoon",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "warragul",
		"state": "vic",
		"postcode": "3820"
	},
	{
		"town": "warragul south",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "warragul west",
		"state": "vic",
		"postcode": "3821"
	},
	{
		"town": "warrah",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "warrah creek",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "warrah ridge",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "warrak",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "warral",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "warralakin",
		"state": "wa",
		"postcode": "6421"
	},
	{
		"town": "warramboo",
		"state": "sa",
		"postcode": "5650"
	},
	{
		"town": "warrandyte",
		"state": "vic",
		"postcode": "3113"
	},
	{
		"town": "warrandyte north",
		"state": "vic",
		"postcode": "3113"
	},
	{
		"town": "warrandyte south",
		"state": "vic",
		"postcode": "3134"
	},
	{
		"town": "warrane",
		"state": "tas",
		"postcode": "7018"
	},
	{
		"town": "warranulla",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "warranwood",
		"state": "vic",
		"postcode": "3134"
	},
	{
		"town": "warrawee",
		"state": "nsw",
		"postcode": "2074"
	},
	{
		"town": "warrawidgee",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "warrawong",
		"state": "nsw",
		"postcode": "2502"
	},
	{
		"town": "warrayure",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "warregah island",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "warrego",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "warrell creek",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "warren",
		"state": "nsw",
		"postcode": "2824"
	},
	{
		"town": "warrenbayne",
		"state": "vic",
		"postcode": "3670"
	},
	{
		"town": "warrendine",
		"state": "nsw",
		"postcode": "2800"
	},
	{
		"town": "warrenheip",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "warrenmang",
		"state": "vic",
		"postcode": "3467"
	},
	{
		"town": "warrentinna",
		"state": "tas",
		"postcode": "7261"
	},
	{
		"town": "warrenup",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "warri",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "warriewood",
		"state": "nsw",
		"postcode": "2102"
	},
	{
		"town": "warrigal",
		"state": "nsw",
		"postcode": "2825"
	},
	{
		"town": "warrill view",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "warrimoo",
		"state": "nsw",
		"postcode": "2774"
	},
	{
		"town": "warringa",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "warringah mall",
		"state": "nsw",
		"postcode": "2100"
	},
	{
		"town": "warrion",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "warriwillah",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "warrnambool",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "warrnambool east",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "warrnambool west",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "warrock",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "warrong",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "warroo",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "warroo",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "warrow",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "warrumbungle",
		"state": "nsw",
		"postcode": "2828"
	},
	{
		"town": "wartook",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "warumbul",
		"state": "nsw",
		"postcode": "2229"
	},
	{
		"town": "warunda",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "warwick",
		"state": "qld",
		"postcode": "4370"
	},
	{
		"town": "warwick",
		"state": "wa",
		"postcode": "6024"
	},
	{
		"town": "warwick farm",
		"state": "nsw",
		"postcode": "2170"
	},
	{
		"town": "washpool",
		"state": "nsw",
		"postcode": "2425"
	},
	{
		"town": "wasleys",
		"state": "sa",
		"postcode": "5400"
	},
	{
		"town": "watagan",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "watalgan",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "watanobbi",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "watchbox gully",
		"state": "vic",
		"postcode": "3444"
	},
	{
		"town": "watchem",
		"state": "vic",
		"postcode": "3482"
	},
	{
		"town": "watchem west",
		"state": "vic",
		"postcode": "3482"
	},
	{
		"town": "watcheupga",
		"state": "vic",
		"postcode": "3485"
	},
	{
		"town": "watchman",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "wateranga",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "waterbank",
		"state": "wa",
		"postcode": "6725"
	},
	{
		"town": "watercarrin",
		"state": "wa",
		"postcode": "6407"
	},
	{
		"town": "watercourse",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "waterfall",
		"state": "nsw",
		"postcode": "2233"
	},
	{
		"town": "waterfall gully",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "waterford",
		"state": "qld",
		"postcode": "4133"
	},
	{
		"town": "waterford",
		"state": "vic",
		"postcode": "3862"
	},
	{
		"town": "waterford",
		"state": "wa",
		"postcode": "6152"
	},
	{
		"town": "waterford park",
		"state": "vic",
		"postcode": "3658"
	},
	{
		"town": "waterford west",
		"state": "qld",
		"postcode": "4133"
	},
	{
		"town": "waterfront place",
		"state": "qld",
		"postcode": "4001"
	},
	{
		"town": "waterholes",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "waterhouse",
		"state": "tas",
		"postcode": "7262"
	},
	{
		"town": "waterloo",
		"state": "nsw",
		"postcode": "1440"
	},
	{
		"town": "waterloo",
		"state": "nsw",
		"postcode": "1441"
	},
	{
		"town": "waterloo",
		"state": "nsw",
		"postcode": "2017"
	},
	{
		"town": "waterloo",
		"state": "qld",
		"postcode": "4673"
	},
	{
		"town": "waterloo",
		"state": "sa",
		"postcode": "5413"
	},
	{
		"town": "waterloo",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "waterloo",
		"state": "vic",
		"postcode": "3373"
	},
	{
		"town": "waterloo",
		"state": "wa",
		"postcode": "6228"
	},
	{
		"town": "waterloo corner",
		"state": "sa",
		"postcode": "5110"
	},
	{
		"town": "waterloo plains",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "waterloo primary centre",
		"state": "nsw",
		"postcode": "2017"
	},
	{
		"town": "waterman",
		"state": "wa",
		"postcode": "6020"
	},
	{
		"town": "watervale",
		"state": "sa",
		"postcode": "5452"
	},
	{
		"town": "waterview",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "waterview heights",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "watgania",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "watheroo",
		"state": "wa",
		"postcode": "6513"
	},
	{
		"town": "watraba",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "watson",
		"state": "act",
		"postcode": "2602"
	},
	{
		"town": "watsonia",
		"state": "vic",
		"postcode": "3087"
	},
	{
		"town": "watsonia north",
		"state": "vic",
		"postcode": "3087"
	},
	{
		"town": "watsons bay",
		"state": "nsw",
		"postcode": "2030"
	},
	{
		"town": "watsons creek",
		"state": "nsw",
		"postcode": "2355"
	},
	{
		"town": "watsons crossing",
		"state": "qld",
		"postcode": "4385"
	},
	{
		"town": "wattamolla",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "wattamondara",
		"state": "nsw",
		"postcode": "2794"
	},
	{
		"town": "wattening",
		"state": "wa",
		"postcode": "6568"
	},
	{
		"town": "wattle bank",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "wattle camp",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "wattle creek",
		"state": "vic",
		"postcode": "3384"
	},
	{
		"town": "wattle flat",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "wattle flat",
		"state": "sa",
		"postcode": "5203"
	},
	{
		"town": "wattle flat",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "wattle glen",
		"state": "vic",
		"postcode": "3096"
	},
	{
		"town": "wattle grove",
		"state": "nsw",
		"postcode": "2173"
	},
	{
		"town": "wattle grove",
		"state": "qld",
		"postcode": "4610"
	},
	{
		"town": "wattle grove",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "wattle grove",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "wattle hill",
		"state": "tas",
		"postcode": "7172"
	},
	{
		"town": "wattle park",
		"state": "sa",
		"postcode": "5066"
	},
	{
		"town": "wattle park",
		"state": "vic",
		"postcode": "3128"
	},
	{
		"town": "wattle ponds",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "wattle range",
		"state": "sa",
		"postcode": "5279"
	},
	{
		"town": "wattle ridge",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "wattlebank",
		"state": "qld",
		"postcode": "4704"
	},
	{
		"town": "wattletree road po",
		"state": "vic",
		"postcode": "3145"
	},
	{
		"town": "wattleup",
		"state": "wa",
		"postcode": "6166"
	},
	{
		"town": "watton",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "wattville",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "waubra",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "waubra junction",
		"state": "vic",
		"postcode": "3350"
	},
	{
		"town": "wauchope",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "waukivory",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "wauraltee",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "waurn ponds",
		"state": "vic",
		"postcode": "3216"
	},
	{
		"town": "wave hill",
		"state": "nt",
		"postcode": "852"
	},
	{
		"town": "wavell heights",
		"state": "qld",
		"postcode": "4012"
	},
	{
		"town": "wavell heights north",
		"state": "qld",
		"postcode": "4012"
	},
	{
		"town": "waverley",
		"state": "nsw",
		"postcode": "2024"
	},
	{
		"town": "waverley",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "waverly",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "waverton",
		"state": "nsw",
		"postcode": "2060"
	},
	{
		"town": "way way",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "wayatinah",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "waygara",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "wayo",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "wayville",
		"state": "sa",
		"postcode": "5034"
	},
	{
		"town": "weabonga",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "wean",
		"state": "nsw",
		"postcode": "2382"
	},
	{
		"town": "weatherboard",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "weavers",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "webb beach",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "webberton",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "webbs creek",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "weddell",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "wedderburn",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "wedderburn",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "wedderburn junction",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "wedgefield",
		"state": "wa",
		"postcode": "6721"
	},
	{
		"town": "wee jasper",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "wee waa",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "wee wee rup",
		"state": "vic",
		"postcode": "3568"
	},
	{
		"town": "weeaproinah",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "weedallion",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "weegena",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "weelong",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "weemelah",
		"state": "nsw",
		"postcode": "2406"
	},
	{
		"town": "weengallon",
		"state": "qld",
		"postcode": "4497"
	},
	{
		"town": "weeragua",
		"state": "vic",
		"postcode": "3890"
	},
	{
		"town": "weerangourt",
		"state": "vic",
		"postcode": "3286"
	},
	{
		"town": "weering",
		"state": "vic",
		"postcode": "3251"
	},
	{
		"town": "weerite",
		"state": "vic",
		"postcode": "3260"
	},
	{
		"town": "weerriba",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "weetah",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "weetaliba",
		"state": "nsw",
		"postcode": "2395"
	},
	{
		"town": "weetangera",
		"state": "act",
		"postcode": "2614"
	},
	{
		"town": "weethalle",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "weetulta",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "wehla",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "weilmoringle",
		"state": "nsw",
		"postcode": "2839"
	},
	{
		"town": "weipa",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "weipa airport",
		"state": "qld",
		"postcode": "4874"
	},
	{
		"town": "weir river",
		"state": "qld",
		"postcode": "4406"
	},
	{
		"town": "weismantels",
		"state": "nsw",
		"postcode": "2415"
	},
	{
		"town": "weja",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "welbungin",
		"state": "wa",
		"postcode": "6477"
	},
	{
		"town": "welby",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "welcome creek",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "weldborough",
		"state": "tas",
		"postcode": "7264"
	},
	{
		"town": "welland",
		"state": "sa",
		"postcode": "5007"
	},
	{
		"town": "wellard",
		"state": "wa",
		"postcode": "6170"
	},
	{
		"town": "wellcamp",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "wellers hill",
		"state": "qld",
		"postcode": "4121"
	},
	{
		"town": "wellesley",
		"state": "wa",
		"postcode": "6233"
	},
	{
		"town": "wellington",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "wellington",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "wellington east",
		"state": "sa",
		"postcode": "5259"
	},
	{
		"town": "wellington flat",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "wellington mill",
		"state": "wa",
		"postcode": "6236"
	},
	{
		"town": "wellington park",
		"state": "tas",
		"postcode": "7054"
	},
	{
		"town": "wellington point",
		"state": "qld",
		"postcode": "4160"
	},
	{
		"town": "wellington vale",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "wells crossing",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "wellsford",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "wellstead",
		"state": "wa",
		"postcode": "6328"
	},
	{
		"town": "welsby",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "welshmans reef",
		"state": "vic",
		"postcode": "3462"
	},
	{
		"town": "welshpool",
		"state": "vic",
		"postcode": "3966"
	},
	{
		"town": "welshpool",
		"state": "wa",
		"postcode": "6106"
	},
	{
		"town": "wembley",
		"state": "wa",
		"postcode": "6014"
	},
	{
		"town": "wembley",
		"state": "wa",
		"postcode": "6913"
	},
	{
		"town": "wembley downs",
		"state": "wa",
		"postcode": "6019"
	},
	{
		"town": "wemen",
		"state": "vic",
		"postcode": "3549"
	},
	{
		"town": "wendoree park",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "wendouree",
		"state": "vic",
		"postcode": "3355"
	},
	{
		"town": "wendouree village",
		"state": "vic",
		"postcode": "3355"
	},
	{
		"town": "wendouree west",
		"state": "vic",
		"postcode": "3355"
	},
	{
		"town": "wengenville",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "wensleydale",
		"state": "vic",
		"postcode": "3241"
	},
	{
		"town": "wentworth",
		"state": "nsw",
		"postcode": "2648"
	},
	{
		"town": "wentworth falls",
		"state": "nsw",
		"postcode": "2782"
	},
	{
		"town": "wentworthville",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "wepar",
		"state": "sa",
		"postcode": "5278"
	},
	{
		"town": "wepowie",
		"state": "sa",
		"postcode": "5482"
	},
	{
		"town": "werai",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "weranga",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "were street po",
		"state": "vic",
		"postcode": "3186"
	},
	{
		"town": "wereboldera",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "wermatong",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "werneth",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "werombi",
		"state": "nsw",
		"postcode": "2570"
	},
	{
		"town": "werona",
		"state": "vic",
		"postcode": "3364"
	},
	{
		"town": "werrap",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "werri beach",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "werribee",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "werribee south",
		"state": "vic",
		"postcode": "3030"
	},
	{
		"town": "werrigar east",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "werrimull",
		"state": "vic",
		"postcode": "3496"
	},
	{
		"town": "werrington",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "werrington county",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "werrington downs",
		"state": "nsw",
		"postcode": "2747"
	},
	{
		"town": "werris creek",
		"state": "nsw",
		"postcode": "2341"
	},
	{
		"town": "wesburn",
		"state": "vic",
		"postcode": "3799"
	},
	{
		"town": "wesley hill",
		"state": "vic",
		"postcode": "3450"
	},
	{
		"town": "wesley vale",
		"state": "tas",
		"postcode": "7307"
	},
	{
		"town": "west albury",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "west amberley",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "west armidale",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "west ballina",
		"state": "nsw",
		"postcode": "2478"
	},
	{
		"town": "west barwo",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "west bathurst",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "west beach",
		"state": "sa",
		"postcode": "5024"
	},
	{
		"town": "west beach",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "west bendigo",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "west berrimal",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "west binnu",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "west budgerum",
		"state": "vic",
		"postcode": "3540"
	},
	{
		"town": "west burleigh",
		"state": "qld",
		"postcode": "4219"
	},
	{
		"town": "west busselton",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "west chatswood",
		"state": "nsw",
		"postcode": "1515"
	},
	{
		"town": "west chatswood",
		"state": "nsw",
		"postcode": "1516"
	},
	{
		"town": "west chatswood",
		"state": "nsw",
		"postcode": "1517"
	},
	{
		"town": "west chatswood",
		"state": "nsw",
		"postcode": "2057"
	},
	{
		"town": "west creek",
		"state": "vic",
		"postcode": "3992"
	},
	{
		"town": "west croydon",
		"state": "sa",
		"postcode": "5008"
	},
	{
		"town": "west end",
		"state": "qld",
		"postcode": "4101"
	},
	{
		"town": "west end",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "west end",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "west gladstone",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "west haldon",
		"state": "qld",
		"postcode": "4359"
	},
	{
		"town": "west haven",
		"state": "nsw",
		"postcode": "2443"
	},
	{
		"town": "west hindmarsh",
		"state": "sa",
		"postcode": "5007"
	},
	{
		"town": "west hobart",
		"state": "tas",
		"postcode": "7000"
	},
	{
		"town": "west hoxton",
		"state": "nsw",
		"postcode": "2171"
	},
	{
		"town": "west ipswich",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "west island cocos (keeling) islands",
		"state": "wa",
		"postcode": "6799"
	},
	{
		"town": "west kalgoorlie",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "west kempsey",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "west kentish",
		"state": "tas",
		"postcode": "7306"
	},
	{
		"town": "west lakes",
		"state": "sa",
		"postcode": "5021"
	},
	{
		"town": "west lakes shore",
		"state": "sa",
		"postcode": "5020"
	},
	{
		"town": "west lamington",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "west launceston",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "west leederville",
		"state": "wa",
		"postcode": "6007"
	},
	{
		"town": "west leederville",
		"state": "wa",
		"postcode": "6901"
	},
	{
		"town": "west lyons river",
		"state": "wa",
		"postcode": "6705"
	},
	{
		"town": "west mackay",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "west melbourne",
		"state": "vic",
		"postcode": "3003"
	},
	{
		"town": "west moonah",
		"state": "tas",
		"postcode": "7009"
	},
	{
		"town": "west mooreville",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "west pennant hills",
		"state": "nsw",
		"postcode": "2125"
	},
	{
		"town": "west perth",
		"state": "wa",
		"postcode": "6005"
	},
	{
		"town": "west perth",
		"state": "wa",
		"postcode": "6872"
	},
	{
		"town": "west perth",
		"state": "wa",
		"postcode": "6873"
	},
	{
		"town": "west pine",
		"state": "tas",
		"postcode": "7316"
	},
	{
		"town": "west pinjarra",
		"state": "wa",
		"postcode": "6208"
	},
	{
		"town": "west plane creek",
		"state": "qld",
		"postcode": "4737"
	},
	{
		"town": "west popanyinning",
		"state": "wa",
		"postcode": "6309"
	},
	{
		"town": "west prairie",
		"state": "qld",
		"postcode": "4403"
	},
	{
		"town": "west pymble",
		"state": "nsw",
		"postcode": "2073"
	},
	{
		"town": "west range",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "west richmond",
		"state": "sa",
		"postcode": "5033"
	},
	{
		"town": "west ridgley",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "west rockhampton",
		"state": "qld",
		"postcode": "4700"
	},
	{
		"town": "west ryde",
		"state": "nsw",
		"postcode": "1685"
	},
	{
		"town": "west ryde",
		"state": "nsw",
		"postcode": "2114"
	},
	{
		"town": "west stowe",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "west swan",
		"state": "wa",
		"postcode": "6055"
	},
	{
		"town": "west takone",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "west tamworth",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "west toodyay",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "west ulverstone",
		"state": "tas",
		"postcode": "7315"
	},
	{
		"town": "west wallsend",
		"state": "nsw",
		"postcode": "2286"
	},
	{
		"town": "west woombye",
		"state": "qld",
		"postcode": "4559"
	},
	{
		"town": "west wyalong",
		"state": "nsw",
		"postcode": "2671"
	},
	{
		"town": "westbourne park",
		"state": "sa",
		"postcode": "5041"
	},
	{
		"town": "westbreen",
		"state": "vic",
		"postcode": "3044"
	},
	{
		"town": "westbrook",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "westbrook",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "westbrook",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "westbury",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "westbury",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "westby",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "westby",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "westcliffe",
		"state": "wa",
		"postcode": "6395"
	},
	{
		"town": "westcourt",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "westdale",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "westdale",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "westdale",
		"state": "wa",
		"postcode": "6304"
	},
	{
		"town": "westella",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "western creek",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "western creek",
		"state": "tas",
		"postcode": "7304"
	},
	{
		"town": "western flat",
		"state": "sa",
		"postcode": "5268"
	},
	{
		"town": "western heights",
		"state": "vic",
		"postcode": "3218"
	},
	{
		"town": "western junction",
		"state": "tas",
		"postcode": "7212"
	},
	{
		"town": "western plains msc",
		"state": "nsw",
		"postcode": "2826"
	},
	{
		"town": "western port hotel",
		"state": "vic",
		"postcode": "3925"
	},
	{
		"town": "western river",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "westerway",
		"state": "tas",
		"postcode": "7140"
	},
	{
		"town": "westfield",
		"state": "wa",
		"postcode": "6111"
	},
	{
		"town": "westgate",
		"state": "nsw",
		"postcode": "2048"
	},
	{
		"town": "westlake",
		"state": "qld",
		"postcode": "4074"
	},
	{
		"town": "westleigh",
		"state": "nsw",
		"postcode": "2120"
	},
	{
		"town": "westmead",
		"state": "nsw",
		"postcode": "2145"
	},
	{
		"town": "westmeadows",
		"state": "vic",
		"postcode": "3049"
	},
	{
		"town": "westmere",
		"state": "vic",
		"postcode": "3351"
	},
	{
		"town": "westminster",
		"state": "wa",
		"postcode": "6061"
	},
	{
		"town": "weston",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "weston",
		"state": "nsw",
		"postcode": "2326"
	},
	{
		"town": "weston creek",
		"state": "act",
		"postcode": "2611"
	},
	{
		"town": "westonia",
		"state": "wa",
		"postcode": "6423"
	},
	{
		"town": "westville",
		"state": "nsw",
		"postcode": "2794"
	},
	{
		"town": "westwood",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "westwood",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "westwood",
		"state": "tas",
		"postcode": "7292"
	},
	{
		"town": "wetherill park",
		"state": "nsw",
		"postcode": "2164"
	},
	{
		"town": "wetheron",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "wetuppa",
		"state": "nsw",
		"postcode": "2734"
	},
	{
		"town": "weyba downs",
		"state": "qld",
		"postcode": "4562"
	},
	{
		"town": "weymouth",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "whalan",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "whale beach",
		"state": "nsw",
		"postcode": "2107"
	},
	{
		"town": "wharminda",
		"state": "sa",
		"postcode": "5603"
	},
	{
		"town": "wharparilla",
		"state": "vic",
		"postcode": "3564"
	},
	{
		"town": "wheatlands",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "wheatlands",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "wheatley",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "wheatsheaf",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "wheeler heights",
		"state": "nsw",
		"postcode": "2097"
	},
	{
		"town": "wheelers hill",
		"state": "vic",
		"postcode": "3150"
	},
	{
		"town": "wheeny creek",
		"state": "nsw",
		"postcode": "2758"
	},
	{
		"town": "wheeo",
		"state": "nsw",
		"postcode": "2583"
	},
	{
		"town": "wherrol flat",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "whetstone",
		"state": "qld",
		"postcode": "4387"
	},
	{
		"town": "whian whian",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "whichello",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "whim creek",
		"state": "wa",
		"postcode": "6718"
	},
	{
		"town": "whinstanes",
		"state": "qld",
		"postcode": "4007"
	},
	{
		"town": "whiporie",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "whipstick",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "whirily",
		"state": "vic",
		"postcode": "3483"
	},
	{
		"town": "whitby",
		"state": "wa",
		"postcode": "6123"
	},
	{
		"town": "white beach",
		"state": "tas",
		"postcode": "7184"
	},
	{
		"town": "white cliffs",
		"state": "nsw",
		"postcode": "2836"
	},
	{
		"town": "white gum valley",
		"state": "wa",
		"postcode": "6162"
	},
	{
		"town": "white hill",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "white hills",
		"state": "tas",
		"postcode": "7258"
	},
	{
		"town": "white hills",
		"state": "vic",
		"postcode": "3550"
	},
	{
		"town": "white hut",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "white mountain",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "white patch",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "white peak",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "white rock",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "white rock",
		"state": "qld",
		"postcode": "4868"
	},
	{
		"town": "white sands",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "white top",
		"state": "nsw",
		"postcode": "2675"
	},
	{
		"town": "white well corner",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "whitebridge",
		"state": "nsw",
		"postcode": "2290"
	},
	{
		"town": "whitefoord",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "whiteheads",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "whiteheads creek",
		"state": "vic",
		"postcode": "3660"
	},
	{
		"town": "whitelaw",
		"state": "vic",
		"postcode": "3950"
	},
	{
		"town": "whiteman",
		"state": "wa",
		"postcode": "6068"
	},
	{
		"town": "whiteman creek",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "whitemark",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "whitemore",
		"state": "tas",
		"postcode": "7303"
	},
	{
		"town": "whites hill",
		"state": "qld",
		"postcode": "4152"
	},
	{
		"town": "whites valley",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "whiteside",
		"state": "qld",
		"postcode": "4503"
	},
	{
		"town": "whitfield",
		"state": "qld",
		"postcode": "4870"
	},
	{
		"town": "whitfield",
		"state": "vic",
		"postcode": "3733"
	},
	{
		"town": "whitlands",
		"state": "vic",
		"postcode": "3733"
	},
	{
		"town": "whitsunday",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "whitsundays",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "whittaker",
		"state": "wa",
		"postcode": "6207"
	},
	{
		"town": "whittingham",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "whittington",
		"state": "vic",
		"postcode": "3219"
	},
	{
		"town": "whittlesea",
		"state": "vic",
		"postcode": "3757"
	},
	{
		"town": "whitton",
		"state": "nsw",
		"postcode": "2705"
	},
	{
		"town": "whitwarta",
		"state": "sa",
		"postcode": "5461"
	},
	{
		"town": "whoorel",
		"state": "vic",
		"postcode": "3243"
	},
	{
		"town": "whoota",
		"state": "nsw",
		"postcode": "2428"
	},
	{
		"town": "whorouly",
		"state": "vic",
		"postcode": "3735"
	},
	{
		"town": "whorouly east",
		"state": "vic",
		"postcode": "3735"
	},
	{
		"town": "whorouly south",
		"state": "vic",
		"postcode": "3735"
	},
	{
		"town": "whroo",
		"state": "vic",
		"postcode": "3612"
	},
	{
		"town": "whyalla",
		"state": "sa",
		"postcode": "5600"
	},
	{
		"town": "whyalla jenkins",
		"state": "sa",
		"postcode": "5609"
	},
	{
		"town": "whyalla norrie",
		"state": "sa",
		"postcode": "5608"
	},
	{
		"town": "whyalla norrie east",
		"state": "sa",
		"postcode": "5608"
	},
	{
		"town": "whyalla norrie north",
		"state": "sa",
		"postcode": "5608"
	},
	{
		"town": "whyalla playford",
		"state": "sa",
		"postcode": "5600"
	},
	{
		"town": "whyalla stuart",
		"state": "sa",
		"postcode": "5608"
	},
	{
		"town": "whylandra crossing",
		"state": "nsw",
		"postcode": "2830"
	},
	{
		"town": "whyte yarcowie",
		"state": "sa",
		"postcode": "5420"
	},
	{
		"town": "wiaborough",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "wiagdon",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "wialki",
		"state": "wa",
		"postcode": "6473"
	},
	{
		"town": "wiangaree",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "wiarborough",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "wicherina",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "wicherina south",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "wickepin",
		"state": "wa",
		"postcode": "6370"
	},
	{
		"town": "wickham",
		"state": "nsw",
		"postcode": "2293"
	},
	{
		"town": "wickham",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "wickham",
		"state": "wa",
		"postcode": "6720"
	},
	{
		"town": "wickliffe",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "wicklow hill",
		"state": "wa",
		"postcode": "6566"
	},
	{
		"town": "widden",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "widgee",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "widgelli",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "widgiemooltha",
		"state": "wa",
		"postcode": "6443"
	},
	{
		"town": "widgiewa",
		"state": "nsw",
		"postcode": "2700"
	},
	{
		"town": "wieambilla",
		"state": "qld",
		"postcode": "4413"
	},
	{
		"town": "wights mountain",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "wigley flat",
		"state": "sa",
		"postcode": "5357"
	},
	{
		"town": "wigton",
		"state": "qld",
		"postcode": "4612"
	},
	{
		"town": "wihareja",
		"state": "tas",
		"postcode": "7030"
	},
	{
		"town": "wilberforce",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "wilberforce",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "wilbertree",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "wilbinga",
		"state": "wa",
		"postcode": "6041"
	},
	{
		"town": "wilby",
		"state": "vic",
		"postcode": "3728"
	},
	{
		"town": "wilcannia",
		"state": "nsw",
		"postcode": "2836"
	},
	{
		"town": "wilcherry",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "wild dog valley",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "wild duck creek",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "wild horse plains",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "wildes meadow",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "wildwood",
		"state": "vic",
		"postcode": "3429"
	},
	{
		"town": "wiley park",
		"state": "nsw",
		"postcode": "2195"
	},
	{
		"town": "wilga",
		"state": "wa",
		"postcode": "6243"
	},
	{
		"town": "wilgoyne",
		"state": "wa",
		"postcode": "6479"
	},
	{
		"town": "wilkawatt",
		"state": "sa",
		"postcode": "5301"
	},
	{
		"town": "wilkesdale",
		"state": "qld",
		"postcode": "4608"
	},
	{
		"town": "wilkin",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "wilks creek",
		"state": "vic",
		"postcode": "3779"
	},
	{
		"town": "wilkur",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "wilkur",
		"state": "vic",
		"postcode": "3482"
	},
	{
		"town": "willagee",
		"state": "wa",
		"postcode": "6156"
	},
	{
		"town": "willala",
		"state": "nsw",
		"postcode": "2380"
	},
	{
		"town": "willala",
		"state": "nsw",
		"postcode": "2832"
	},
	{
		"town": "willalo",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "willalooka",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "willamulka",
		"state": "sa",
		"postcode": "5554"
	},
	{
		"town": "willangie",
		"state": "vic",
		"postcode": "3485"
	},
	{
		"town": "willaston",
		"state": "sa",
		"postcode": "5118"
	},
	{
		"town": "willatook",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "willaura",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "willaura north",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "willawarrin",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "willawong",
		"state": "qld",
		"postcode": "4110"
	},
	{
		"town": "willbriggie",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "willenabrina",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "willetton",
		"state": "wa",
		"postcode": "6155"
	},
	{
		"town": "willetton",
		"state": "wa",
		"postcode": "6955"
	},
	{
		"town": "willi willi",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "williams",
		"state": "wa",
		"postcode": "6391"
	},
	{
		"town": "williams raaf",
		"state": "vic",
		"postcode": "3027"
	},
	{
		"town": "williamsdale",
		"state": "nsw",
		"postcode": "2620"
	},
	{
		"town": "williamsford",
		"state": "tas",
		"postcode": "7470"
	},
	{
		"town": "williamstown",
		"state": "sa",
		"postcode": "5351"
	},
	{
		"town": "williamstown",
		"state": "vic",
		"postcode": "3016"
	},
	{
		"town": "williamstown",
		"state": "wa",
		"postcode": "6430"
	},
	{
		"town": "williamstown north",
		"state": "vic",
		"postcode": "3016"
	},
	{
		"town": "williamtown",
		"state": "nsw",
		"postcode": "2318"
	},
	{
		"town": "williamtown raaf",
		"state": "nsw",
		"postcode": "2314"
	},
	{
		"town": "willie ploma",
		"state": "nsw",
		"postcode": "2722"
	},
	{
		"town": "willigobung",
		"state": "nsw",
		"postcode": "2653"
	},
	{
		"town": "willina",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "willmot",
		"state": "nsw",
		"postcode": "2770"
	},
	{
		"town": "willochra",
		"state": "sa",
		"postcode": "5433"
	},
	{
		"town": "willoughby",
		"state": "nsw",
		"postcode": "2068"
	},
	{
		"town": "willoughby",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "willoughby north",
		"state": "nsw",
		"postcode": "2068"
	},
	{
		"town": "willow creek",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "willow grove",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "willow tree",
		"state": "nsw",
		"postcode": "2339"
	},
	{
		"town": "willow vale",
		"state": "nsw",
		"postcode": "2534"
	},
	{
		"town": "willow vale",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "willow vale",
		"state": "qld",
		"postcode": "4209"
	},
	{
		"town": "willowbank",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "willowbank",
		"state": "vic",
		"postcode": "3678"
	},
	{
		"town": "willowbanks",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "willowdene",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "willowie",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "willowmavin",
		"state": "vic",
		"postcode": "3764"
	},
	{
		"town": "willowra",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "willows",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "willows gemfields",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "willowvale",
		"state": "vic",
		"postcode": "3360"
	},
	{
		"town": "willsden",
		"state": "sa",
		"postcode": "5700"
	},
	{
		"town": "willson river",
		"state": "sa",
		"postcode": "5222"
	},
	{
		"town": "willsons downfall",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "willung",
		"state": "vic",
		"postcode": "3847"
	},
	{
		"town": "willung south",
		"state": "vic",
		"postcode": "3844"
	},
	{
		"town": "willunga",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "willunga hill",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "willunga south",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "willurah",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "willyaroo",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "wilmington",
		"state": "sa",
		"postcode": "5485"
	},
	{
		"town": "wilmores lane",
		"state": "tas",
		"postcode": "7301"
	},
	{
		"town": "wilmot",
		"state": "tas",
		"postcode": "7310"
	},
	{
		"town": "wilora",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "wilpinjong",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "wilroy",
		"state": "wa",
		"postcode": "6630"
	},
	{
		"town": "wilson",
		"state": "wa",
		"postcode": "6107"
	},
	{
		"town": "wilson beach",
		"state": "qld",
		"postcode": "4800"
	},
	{
		"town": "wilson valley",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "wilsons creek",
		"state": "nsw",
		"postcode": "2482"
	},
	{
		"town": "wilsons hill",
		"state": "vic",
		"postcode": "3515"
	},
	{
		"town": "wilsons plains",
		"state": "qld",
		"postcode": "4307"
	},
	{
		"town": "wilsons pocket",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "wilsons promontory",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "wilsonton",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "wilston",
		"state": "qld",
		"postcode": "4051"
	},
	{
		"town": "wilton",
		"state": "nsw",
		"postcode": "2571"
	},
	{
		"town": "wiltshire",
		"state": "tas",
		"postcode": "7321"
	},
	{
		"town": "wiluna",
		"state": "wa",
		"postcode": "6646"
	},
	{
		"town": "wilyabrup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "wimbledon",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "wimbledon heights",
		"state": "vic",
		"postcode": "3922"
	},
	{
		"town": "winburndale",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "winchelsea",
		"state": "vic",
		"postcode": "3241"
	},
	{
		"town": "winchelsea south",
		"state": "vic",
		"postcode": "3241"
	},
	{
		"town": "winchester",
		"state": "wa",
		"postcode": "6517"
	},
	{
		"town": "winda woppa",
		"state": "nsw",
		"postcode": "2324"
	},
	{
		"town": "windale",
		"state": "nsw",
		"postcode": "2306"
	},
	{
		"town": "windang",
		"state": "nsw",
		"postcode": "2528"
	},
	{
		"town": "windaroo",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "windarra",
		"state": "wa",
		"postcode": "6440"
	},
	{
		"town": "windella",
		"state": "nsw",
		"postcode": "2320"
	},
	{
		"town": "windellama",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "windera",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "windermere",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "windermere",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "windermere",
		"state": "tas",
		"postcode": "7252"
	},
	{
		"town": "windermere",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "windermere park",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "windeyer",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "windeyer",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "windmill hill",
		"state": "tas",
		"postcode": "7250"
	},
	{
		"town": "windorah",
		"state": "qld",
		"postcode": "4481"
	},
	{
		"town": "windowie",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "windradyne",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "windsor",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "windsor",
		"state": "qld",
		"postcode": "4030"
	},
	{
		"town": "windsor",
		"state": "sa",
		"postcode": "5501"
	},
	{
		"town": "windsor",
		"state": "vic",
		"postcode": "3181"
	},
	{
		"town": "windsor downs",
		"state": "nsw",
		"postcode": "2756"
	},
	{
		"town": "windsor gardens",
		"state": "sa",
		"postcode": "5087"
	},
	{
		"town": "windy",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "winegrove",
		"state": "nsw",
		"postcode": "2460"
	},
	{
		"town": "winfield",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "wingala",
		"state": "nsw",
		"postcode": "2099"
	},
	{
		"town": "wingan river",
		"state": "vic",
		"postcode": "3891"
	},
	{
		"town": "wingaroo",
		"state": "tas",
		"postcode": "7255"
	},
	{
		"town": "wingeel",
		"state": "vic",
		"postcode": "3321"
	},
	{
		"town": "wingellina",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "wingello",
		"state": "nsw",
		"postcode": "2579"
	},
	{
		"town": "wingen",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "wingfield",
		"state": "sa",
		"postcode": "5013"
	},
	{
		"town": "wingham",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "winjallock",
		"state": "vic",
		"postcode": "3380"
	},
	{
		"town": "winkie",
		"state": "sa",
		"postcode": "5343"
	},
	{
		"town": "winkleigh",
		"state": "tas",
		"postcode": "7275"
	},
	{
		"town": "winlaton",
		"state": "vic",
		"postcode": "3585"
	},
	{
		"town": "winmalee",
		"state": "nsw",
		"postcode": "2777"
	},
	{
		"town": "winnaleah",
		"state": "tas",
		"postcode": "7265"
	},
	{
		"town": "winnambool",
		"state": "vic",
		"postcode": "3546"
	},
	{
		"town": "winnap",
		"state": "vic",
		"postcode": "3304"
	},
	{
		"town": "winnejup",
		"state": "wa",
		"postcode": "6255"
	},
	{
		"town": "winnellie",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "winnellie",
		"state": "nt",
		"postcode": "821"
	},
	{
		"town": "winnellie",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "winniburn",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "winnindoo",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "winslow",
		"state": "vic",
		"postcode": "3281"
	},
	{
		"town": "winston",
		"state": "qld",
		"postcode": "4825"
	},
	{
		"town": "winston",
		"state": "vic",
		"postcode": "3529"
	},
	{
		"town": "winston hills",
		"state": "nsw",
		"postcode": "2153"
	},
	{
		"town": "winter grove free bag",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "winters flat",
		"state": "vic",
		"postcode": "3450"
	},
	{
		"town": "winthrop",
		"state": "wa",
		"postcode": "6150"
	},
	{
		"town": "winton",
		"state": "nsw",
		"postcode": "2344"
	},
	{
		"town": "winton",
		"state": "qld",
		"postcode": "4735"
	},
	{
		"town": "winton",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "winton north",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "winulta",
		"state": "sa",
		"postcode": "5555"
	},
	{
		"town": "winwill",
		"state": "qld",
		"postcode": "4347"
	},
	{
		"town": "wirlinga",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "wirra warra",
		"state": "vic",
		"postcode": "3377"
	},
	{
		"town": "wirraba",
		"state": "nsw",
		"postcode": "2849"
	},
	{
		"town": "wirrabara",
		"state": "sa",
		"postcode": "5481"
	},
	{
		"town": "wirradgurie",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "wirrate",
		"state": "vic",
		"postcode": "3608"
	},
	{
		"town": "wirrega",
		"state": "sa",
		"postcode": "5267"
	},
	{
		"town": "wirrimah",
		"state": "nsw",
		"postcode": "2803"
	},
	{
		"town": "wirrimbi",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "wirrina cove",
		"state": "sa",
		"postcode": "5204"
	},
	{
		"town": "wirrinya",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "wirrulla",
		"state": "sa",
		"postcode": "5661"
	},
	{
		"town": "wisanger",
		"state": "sa",
		"postcode": "5223"
	},
	{
		"town": "wiseleigh",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "wisemans creek",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "wisemans ferry",
		"state": "nsw",
		"postcode": "2775"
	},
	{
		"town": "wishart",
		"state": "qld",
		"postcode": "4122"
	},
	{
		"town": "wishart",
		"state": "vic",
		"postcode": "3189"
	},
	{
		"town": "wisteria",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "wistow",
		"state": "sa",
		"postcode": "5251"
	},
	{
		"town": "witchcliffe",
		"state": "wa",
		"postcode": "6286"
	},
	{
		"town": "witchelina",
		"state": "sa",
		"postcode": "5731"
	},
	{
		"town": "withcott",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "witheren",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "withers",
		"state": "wa",
		"postcode": "6230"
	},
	{
		"town": "withersfield",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "witta",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "wittenoom",
		"state": "wa",
		"postcode": "6754"
	},
	{
		"town": "wittitrin",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "wivenhoe",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "wivenhoe",
		"state": "tas",
		"postcode": "7320"
	},
	{
		"town": "wivenhoe hill",
		"state": "qld",
		"postcode": "4311"
	},
	{
		"town": "wivenhoe pocket",
		"state": "qld",
		"postcode": "4306"
	},
	{
		"town": "woden",
		"state": "act",
		"postcode": "2606"
	},
	{
		"town": "wodonga",
		"state": "vic",
		"postcode": "3689"
	},
	{
		"town": "wodonga",
		"state": "vic",
		"postcode": "3690"
	},
	{
		"town": "wodonga forward",
		"state": "vic",
		"postcode": "3691"
	},
	{
		"town": "wodonga plaza",
		"state": "vic",
		"postcode": "3690"
	},
	{
		"town": "woerden",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "wog wog",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "wokalup",
		"state": "wa",
		"postcode": "6221"
	},
	{
		"town": "woko",
		"state": "nsw",
		"postcode": "2422"
	},
	{
		"town": "wokurna",
		"state": "sa",
		"postcode": "5520"
	},
	{
		"town": "wolffdene",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "wolgan valley",
		"state": "nsw",
		"postcode": "2790"
	},
	{
		"town": "wollar",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "wollemi",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "wollert",
		"state": "vic",
		"postcode": "3750"
	},
	{
		"town": "wollogorang",
		"state": "nsw",
		"postcode": "2581"
	},
	{
		"town": "wollogorang station",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "wollombi",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "wollomombi",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "wollongbar",
		"state": "nsw",
		"postcode": "2477"
	},
	{
		"town": "wollongong",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "wollongong",
		"state": "nsw",
		"postcode": "2520"
	},
	{
		"town": "wollongong north",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "wollongong west",
		"state": "nsw",
		"postcode": "2500"
	},
	{
		"town": "wollstonecraft",
		"state": "nsw",
		"postcode": "2065"
	},
	{
		"town": "wollun",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "wolseley",
		"state": "sa",
		"postcode": "5269"
	},
	{
		"town": "wolumla",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "wolvi",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "wombarra",
		"state": "nsw",
		"postcode": "2515"
	},
	{
		"town": "wombat",
		"state": "nsw",
		"postcode": "2587"
	},
	{
		"town": "wombat",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "wombat creek",
		"state": "vic",
		"postcode": "3888"
	},
	{
		"town": "wombelano",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "wombeyan caves",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "womboota",
		"state": "nsw",
		"postcode": "2731"
	},
	{
		"town": "womerah",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "won wron",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "wonbah",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "wonbah forest",
		"state": "qld",
		"postcode": "4671"
	},
	{
		"town": "wonboyn",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "wonboyn lake",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "wonboyn north",
		"state": "nsw",
		"postcode": "2551"
	},
	{
		"town": "wondabyne",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "wondai",
		"state": "qld",
		"postcode": "4606"
	},
	{
		"town": "wondalga",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "wondalli",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "wondocka",
		"state": "vic",
		"postcode": "3858"
	},
	{
		"town": "wondunna",
		"state": "qld",
		"postcode": "4655"
	},
	{
		"town": "wonga",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "wonga beach",
		"state": "qld",
		"postcode": "4873"
	},
	{
		"town": "wonga park",
		"state": "vic",
		"postcode": "3115"
	},
	{
		"town": "wongabel",
		"state": "qld",
		"postcode": "4883"
	},
	{
		"town": "wongaling beach",
		"state": "qld",
		"postcode": "4852"
	},
	{
		"town": "wongamine",
		"state": "wa",
		"postcode": "6401"
	},
	{
		"town": "wongan hills",
		"state": "wa",
		"postcode": "6603"
	},
	{
		"town": "wongarbon",
		"state": "nsw",
		"postcode": "2831"
	},
	{
		"town": "wongarra",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "wongawallan",
		"state": "qld",
		"postcode": "4210"
	},
	{
		"town": "wongawilli",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "wonglepong",
		"state": "qld",
		"postcode": "4275"
	},
	{
		"town": "wongoondy",
		"state": "wa",
		"postcode": "6630"
	},
	{
		"town": "wongulla",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "wongutha",
		"state": "wa",
		"postcode": "6450"
	},
	{
		"town": "wongwibinda",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "wongyarra",
		"state": "sa",
		"postcode": "5481"
	},
	{
		"town": "wonkana",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "wonna",
		"state": "sa",
		"postcode": "5419"
	},
	{
		"town": "wonnerup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "wonthaggi",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "wonthella",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "wonuarra",
		"state": "sa",
		"postcode": "5340"
	},
	{
		"town": "wonwondah",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "wonwondah east",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "wonwondah south",
		"state": "vic",
		"postcode": "3400"
	},
	{
		"town": "wonyip",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "woocoo",
		"state": "qld",
		"postcode": "4620"
	},
	{
		"town": "wood wood",
		"state": "vic",
		"postcode": "3596"
	},
	{
		"town": "woodanilling",
		"state": "wa",
		"postcode": "6316"
	},
	{
		"town": "woodberry",
		"state": "nsw",
		"postcode": "2322"
	},
	{
		"town": "woodbine",
		"state": "nsw",
		"postcode": "2560"
	},
	{
		"town": "woodbine",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "woodbourne",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "woodbridge",
		"state": "tas",
		"postcode": "7162"
	},
	{
		"town": "woodbrook",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "woodburn",
		"state": "nsw",
		"postcode": "2472"
	},
	{
		"town": "woodburn",
		"state": "nsw",
		"postcode": "2538"
	},
	{
		"town": "woodbury",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "woodbury",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "woodchester",
		"state": "sa",
		"postcode": "5255"
	},
	{
		"town": "woodcroft",
		"state": "nsw",
		"postcode": "2767"
	},
	{
		"town": "woodcroft",
		"state": "sa",
		"postcode": "5162"
	},
	{
		"town": "woodenbong",
		"state": "nsw",
		"postcode": "2476"
	},
	{
		"town": "woodend",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "woodend",
		"state": "sa",
		"postcode": "5158"
	},
	{
		"town": "woodend",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "woodend north",
		"state": "vic",
		"postcode": "3442"
	},
	{
		"town": "wooderson",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "woodfield",
		"state": "vic",
		"postcode": "3715"
	},
	{
		"town": "woodford",
		"state": "nsw",
		"postcode": "2463"
	},
	{
		"town": "woodford",
		"state": "nsw",
		"postcode": "2778"
	},
	{
		"town": "woodford",
		"state": "qld",
		"postcode": "4514"
	},
	{
		"town": "woodford",
		"state": "vic",
		"postcode": "3281"
	},
	{
		"town": "woodforde",
		"state": "sa",
		"postcode": "5072"
	},
	{
		"town": "woodgate",
		"state": "qld",
		"postcode": "4660"
	},
	{
		"town": "woodglen",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "woodhill",
		"state": "nsw",
		"postcode": "2535"
	},
	{
		"town": "woodhill",
		"state": "qld",
		"postcode": "4285"
	},
	{
		"town": "woodhouse",
		"state": "vic",
		"postcode": "3294"
	},
	{
		"town": "woodhouselee",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "woodlands",
		"state": "nsw",
		"postcode": "2536"
	},
	{
		"town": "woodlands",
		"state": "qld",
		"postcode": "4343"
	},
	{
		"town": "woodlands",
		"state": "wa",
		"postcode": "6018"
	},
	{
		"town": "woodlands north",
		"state": "vic",
		"postcode": "3384"
	},
	{
		"town": "woodlane",
		"state": "sa",
		"postcode": "5238"
	},
	{
		"town": "woodlawn",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "woodlea",
		"state": "sa",
		"postcode": "5159"
	},
	{
		"town": "woodleigh",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "woodleigh",
		"state": "vic",
		"postcode": "3945"
	},
	{
		"town": "woodleigh gardens",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "woodmillar",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "woodpark",
		"state": "nsw",
		"postcode": "2164"
	},
	{
		"town": "woodridge",
		"state": "qld",
		"postcode": "4114"
	},
	{
		"town": "woodridge",
		"state": "wa",
		"postcode": "6041"
	},
	{
		"town": "woodridge east",
		"state": "qld",
		"postcode": "4114"
	},
	{
		"town": "woodrising",
		"state": "nsw",
		"postcode": "2284"
	},
	{
		"town": "woodroffe",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "woods point",
		"state": "sa",
		"postcode": "5253"
	},
	{
		"town": "woods point",
		"state": "vic",
		"postcode": "3723"
	},
	{
		"town": "woodsdale",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "woodside",
		"state": "nsw",
		"postcode": "2424"
	},
	{
		"town": "woodside",
		"state": "sa",
		"postcode": "5244"
	},
	{
		"town": "woodside",
		"state": "vic",
		"postcode": "3874"
	},
	{
		"town": "woodside beach",
		"state": "vic",
		"postcode": "3874"
	},
	{
		"town": "woodsreef",
		"state": "nsw",
		"postcode": "2347"
	},
	{
		"town": "woodstock",
		"state": "nsw",
		"postcode": "2538"
	},
	{
		"town": "woodstock",
		"state": "nsw",
		"postcode": "2793"
	},
	{
		"town": "woodstock",
		"state": "qld",
		"postcode": "4816"
	},
	{
		"town": "woodstock",
		"state": "tas",
		"postcode": "7109"
	},
	{
		"town": "woodstock",
		"state": "vic",
		"postcode": "3751"
	},
	{
		"town": "woodstock on loddon",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "woodstock west",
		"state": "vic",
		"postcode": "3463"
	},
	{
		"town": "woodstock west",
		"state": "vic",
		"postcode": "3551"
	},
	{
		"town": "woodvale",
		"state": "vic",
		"postcode": "3556"
	},
	{
		"town": "woodvale",
		"state": "wa",
		"postcode": "6026"
	},
	{
		"town": "woodview",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "woodville",
		"state": "nsw",
		"postcode": "2321"
	},
	{
		"town": "woodville",
		"state": "sa",
		"postcode": "5011"
	},
	{
		"town": "woodville gardens",
		"state": "sa",
		"postcode": "5012"
	},
	{
		"town": "woodville north",
		"state": "sa",
		"postcode": "5012"
	},
	{
		"town": "woodville park",
		"state": "sa",
		"postcode": "5011"
	},
	{
		"town": "woodville south",
		"state": "sa",
		"postcode": "5011"
	},
	{
		"town": "woodville west",
		"state": "sa",
		"postcode": "5011"
	},
	{
		"town": "woodwark",
		"state": "qld",
		"postcode": "4802"
	},
	{
		"town": "woody head",
		"state": "nsw",
		"postcode": "2466"
	},
	{
		"town": "woody point",
		"state": "qld",
		"postcode": "4019"
	},
	{
		"town": "woogenilup",
		"state": "wa",
		"postcode": "6324"
	},
	{
		"town": "woohlpooer",
		"state": "vic",
		"postcode": "3314"
	},
	{
		"town": "wool bay",
		"state": "sa",
		"postcode": "5575"
	},
	{
		"town": "wool wool",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "woolamai",
		"state": "vic",
		"postcode": "3995"
	},
	{
		"town": "woolamai waters",
		"state": "vic",
		"postcode": "3925"
	},
	{
		"town": "woolaning",
		"state": "nt",
		"postcode": "822"
	},
	{
		"town": "woolaston",
		"state": "vic",
		"postcode": "3280"
	},
	{
		"town": "woolbrook",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "woolein",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "woolgangie",
		"state": "wa",
		"postcode": "6431"
	},
	{
		"town": "woolgarlo",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "woolgoolga",
		"state": "nsw",
		"postcode": "2456"
	},
	{
		"town": "wooli",
		"state": "nsw",
		"postcode": "2462"
	},
	{
		"town": "woollahra",
		"state": "nsw",
		"postcode": "1350"
	},
	{
		"town": "woollahra",
		"state": "nsw",
		"postcode": "2025"
	},
	{
		"town": "woollamia",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "woolloomooloo",
		"state": "nsw",
		"postcode": "2011"
	},
	{
		"town": "woolloongabba",
		"state": "qld",
		"postcode": "4102"
	},
	{
		"town": "woolmer",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "woolner",
		"state": "nt",
		"postcode": "820"
	},
	{
		"town": "woolners arm",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "woolnorth",
		"state": "tas",
		"postcode": "7330"
	},
	{
		"town": "woolomin",
		"state": "nsw",
		"postcode": "2340"
	},
	{
		"town": "woolooga",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "woolooma",
		"state": "nsw",
		"postcode": "2337"
	},
	{
		"town": "woolooman",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "woolooware",
		"state": "nsw",
		"postcode": "2230"
	},
	{
		"town": "wooloowin",
		"state": "qld",
		"postcode": "4030"
	},
	{
		"town": "wooloweyah",
		"state": "nsw",
		"postcode": "2464"
	},
	{
		"town": "woolpunda",
		"state": "sa",
		"postcode": "5330"
	},
	{
		"town": "woolshed",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "woolsthorpe",
		"state": "vic",
		"postcode": "3276"
	},
	{
		"town": "woolumbool",
		"state": "sa",
		"postcode": "5272"
	},
	{
		"town": "woolundra",
		"state": "wa",
		"postcode": "6410"
	},
	{
		"town": "woolwich",
		"state": "nsw",
		"postcode": "2110"
	},
	{
		"town": "woomargama",
		"state": "nsw",
		"postcode": "2644"
	},
	{
		"town": "woombah",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "woombye",
		"state": "qld",
		"postcode": "4559"
	},
	{
		"town": "woomelang",
		"state": "vic",
		"postcode": "3485"
	},
	{
		"town": "woomera",
		"state": "sa",
		"postcode": "5720"
	},
	{
		"town": "woondul",
		"state": "qld",
		"postcode": "4357"
	},
	{
		"town": "woondum",
		"state": "qld",
		"postcode": "4570"
	},
	{
		"town": "woongarra",
		"state": "qld",
		"postcode": "4670"
	},
	{
		"town": "woongarrah",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "woongoolba",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "woonona",
		"state": "nsw",
		"postcode": "2517"
	},
	{
		"town": "woonona east",
		"state": "nsw",
		"postcode": "2517"
	},
	{
		"town": "woorabinda",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "wooragee",
		"state": "vic",
		"postcode": "3747"
	},
	{
		"town": "wooragee north",
		"state": "vic",
		"postcode": "3688"
	},
	{
		"town": "wooramel",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "woorarra",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "woorarra east",
		"state": "vic",
		"postcode": "3962"
	},
	{
		"town": "woorarra west",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "woorayl",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "wooreen",
		"state": "vic",
		"postcode": "3953"
	},
	{
		"town": "woori yallock",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "woorim",
		"state": "qld",
		"postcode": "4507"
	},
	{
		"town": "woorinen",
		"state": "vic",
		"postcode": "3589"
	},
	{
		"town": "woorinen south",
		"state": "vic",
		"postcode": "3588"
	},
	{
		"town": "wooriwyrite",
		"state": "vic",
		"postcode": "3265"
	},
	{
		"town": "woorndoo",
		"state": "vic",
		"postcode": "3272"
	},
	{
		"town": "wooroloo",
		"state": "wa",
		"postcode": "6558"
	},
	{
		"town": "wooroolin",
		"state": "qld",
		"postcode": "4608"
	},
	{
		"town": "wooroona",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "wooroonden",
		"state": "qld",
		"postcode": "4605"
	},
	{
		"town": "wooroonook",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "wooroowoolgan",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "woorree",
		"state": "wa",
		"postcode": "6530"
	},
	{
		"town": "woosang",
		"state": "vic",
		"postcode": "3518"
	},
	{
		"town": "wootha",
		"state": "qld",
		"postcode": "4552"
	},
	{
		"town": "wootong vale",
		"state": "vic",
		"postcode": "3315"
	},
	{
		"town": "woottating",
		"state": "wa",
		"postcode": "6562"
	},
	{
		"town": "wootton",
		"state": "nsw",
		"postcode": "2423"
	},
	{
		"town": "woowoonga",
		"state": "qld",
		"postcode": "4621"
	},
	{
		"town": "wooyung",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "woree",
		"state": "qld",
		"postcode": "4868"
	},
	{
		"town": "world trade centre",
		"state": "vic",
		"postcode": "3005"
	},
	{
		"town": "world trade centre",
		"state": "vic",
		"postcode": "8005"
	},
	{
		"town": "worlds end",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "worlds end",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "worlds end creek",
		"state": "sa",
		"postcode": "5381"
	},
	{
		"town": "worongary",
		"state": "qld",
		"postcode": "4213"
	},
	{
		"town": "woronora",
		"state": "nsw",
		"postcode": "2232"
	},
	{
		"town": "woronora heights",
		"state": "nsw",
		"postcode": "2233"
	},
	{
		"town": "worrigee",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "worrolong",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "worrowing heights",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "worsley",
		"state": "wa",
		"postcode": "6225"
	},
	{
		"town": "wowagin",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "wowan",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "woy woy",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "woy woy bay",
		"state": "nsw",
		"postcode": "2256"
	},
	{
		"town": "wrattens forest",
		"state": "qld",
		"postcode": "4601"
	},
	{
		"town": "wrattonbully",
		"state": "sa",
		"postcode": "5271"
	},
	{
		"town": "wrightley",
		"state": "vic",
		"postcode": "3673"
	},
	{
		"town": "wrights",
		"state": "vic",
		"postcode": "3781"
	},
	{
		"town": "wrights beach",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "wroxham",
		"state": "vic",
		"postcode": "3891"
	},
	{
		"town": "wubin",
		"state": "wa",
		"postcode": "6612"
	},
	{
		"town": "wudinna",
		"state": "sa",
		"postcode": "5652"
	},
	{
		"town": "wujal wujal",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "wuk wuk",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "wulagi",
		"state": "nt",
		"postcode": "812"
	},
	{
		"town": "wulgulmerang",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "wulgulmerang east",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "wulgulmerang west",
		"state": "vic",
		"postcode": "3885"
	},
	{
		"town": "wulguru",
		"state": "qld",
		"postcode": "4811"
	},
	{
		"town": "wulkuraka",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "wundaru",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "wundowie",
		"state": "wa",
		"postcode": "6560"
	},
	{
		"town": "wunghnu",
		"state": "vic",
		"postcode": "3635"
	},
	{
		"town": "wungong",
		"state": "wa",
		"postcode": "6112"
	},
	{
		"town": "wunkar",
		"state": "sa",
		"postcode": "5311"
	},
	{
		"town": "wura",
		"state": "qld",
		"postcode": "4714"
	},
	{
		"town": "wuraming",
		"state": "wa",
		"postcode": "6213"
	},
	{
		"town": "wurarga",
		"state": "wa",
		"postcode": "6630"
	},
	{
		"town": "wurdiboluc",
		"state": "vic",
		"postcode": "3241"
	},
	{
		"town": "wurdong heights",
		"state": "qld",
		"postcode": "4680"
	},
	{
		"town": "wurruk",
		"state": "vic",
		"postcode": "3850"
	},
	{
		"town": "wurt wurt koort",
		"state": "vic",
		"postcode": "3312"
	},
	{
		"town": "wurtulla",
		"state": "qld",
		"postcode": "4575"
	},
	{
		"town": "wuruma dam",
		"state": "qld",
		"postcode": "4627"
	},
	{
		"town": "wuuluman",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "wy yung",
		"state": "vic",
		"postcode": "3875"
	},
	{
		"town": "wyaga",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "wyalkatchem",
		"state": "wa",
		"postcode": "6485"
	},
	{
		"town": "wyalla",
		"state": "qld",
		"postcode": "4615"
	},
	{
		"town": "wyalla plaza",
		"state": "qld",
		"postcode": "4350"
	},
	{
		"town": "wyalong",
		"state": "nsw",
		"postcode": "2671"
	},
	{
		"town": "wyan",
		"state": "nsw",
		"postcode": "2469"
	},
	{
		"town": "wyanbene",
		"state": "nsw",
		"postcode": "2622"
	},
	{
		"town": "wyandra",
		"state": "qld",
		"postcode": "4489"
	},
	{
		"town": "wyanga",
		"state": "nsw",
		"postcode": "2821"
	},
	{
		"town": "wyangala",
		"state": "nsw",
		"postcode": "2808"
	},
	{
		"town": "wyangala dam",
		"state": "nsw",
		"postcode": "2808"
	},
	{
		"town": "wyangle",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "wyaralong",
		"state": "qld",
		"postcode": "4310"
	},
	{
		"town": "wyberba",
		"state": "qld",
		"postcode": "4382"
	},
	{
		"town": "wybong",
		"state": "nsw",
		"postcode": "2333"
	},
	{
		"town": "wybung",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wycarbah",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "wycheproof",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "wycheproof south",
		"state": "vic",
		"postcode": "3527"
	},
	{
		"town": "wychitella",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "wychitella north",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "wycliffe well",
		"state": "nt",
		"postcode": "862"
	},
	{
		"town": "wye river",
		"state": "vic",
		"postcode": "3221"
	},
	{
		"town": "wyee",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wyee point",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wyeebo",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "wyelangta",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "wyena",
		"state": "tas",
		"postcode": "7254"
	},
	{
		"town": "wyening",
		"state": "wa",
		"postcode": "6568"
	},
	{
		"town": "wylie creek",
		"state": "nsw",
		"postcode": "2372"
	},
	{
		"town": "wylies flat",
		"state": "nsw",
		"postcode": "2330"
	},
	{
		"town": "wymah",
		"state": "nsw",
		"postcode": "2640"
	},
	{
		"town": "wyn wyn",
		"state": "vic",
		"postcode": "3409"
	},
	{
		"town": "wynarka",
		"state": "sa",
		"postcode": "5306"
	},
	{
		"town": "wyndham",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "wyndham",
		"state": "wa",
		"postcode": "6740"
	},
	{
		"town": "wyndham vale",
		"state": "vic",
		"postcode": "3024"
	},
	{
		"town": "wyneden",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "wynn vale",
		"state": "sa",
		"postcode": "5127"
	},
	{
		"town": "wynnum",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "wynnum central",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "wynnum north",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "wynnum plaza",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "wynnum west",
		"state": "qld",
		"postcode": "4178"
	},
	{
		"town": "wynyard",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "wyola",
		"state": "wa",
		"postcode": "6407"
	},
	{
		"town": "wyola west",
		"state": "wa",
		"postcode": "6407"
	},
	{
		"town": "wyomi",
		"state": "sa",
		"postcode": "5275"
	},
	{
		"town": "wyoming",
		"state": "nsw",
		"postcode": "2250"
	},
	{
		"town": "wyong",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wyong creek",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wyongah",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "wyperfield national park",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "wyrallah",
		"state": "nsw",
		"postcode": "2480"
	},
	{
		"town": "wyreema",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "wyuna",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "wyuna east",
		"state": "vic",
		"postcode": "3620"
	},
	{
		"town": "xantippe",
		"state": "wa",
		"postcode": "6609"
	},
	{
		"town": "yaamba",
		"state": "qld",
		"postcode": "4704"
	},
	{
		"town": "yaapeet",
		"state": "vic",
		"postcode": "3424"
	},
	{
		"town": "yabba north",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "yabba patons",
		"state": "vic",
		"postcode": "3700"
	},
	{
		"town": "yabba south",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "yabulu",
		"state": "qld",
		"postcode": "4818"
	},
	{
		"town": "yacka",
		"state": "sa",
		"postcode": "5470"
	},
	{
		"town": "yackandandah",
		"state": "vic",
		"postcode": "3749"
	},
	{
		"town": "yaddra",
		"state": "nsw",
		"postcode": "2669"
	},
	{
		"town": "yagaburne",
		"state": "qld",
		"postcode": "4390"
	},
	{
		"town": "yagoona",
		"state": "nsw",
		"postcode": "2199"
	},
	{
		"town": "yagoona west",
		"state": "nsw",
		"postcode": "2199"
	},
	{
		"town": "yahl",
		"state": "sa",
		"postcode": "5291"
	},
	{
		"town": "yakamia",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "yakapari",
		"state": "qld",
		"postcode": "4740"
	},
	{
		"town": "yalanda",
		"state": "sa",
		"postcode": "5641"
	},
	{
		"town": "yalata",
		"state": "sa",
		"postcode": "5690"
	},
	{
		"town": "yalboroo",
		"state": "qld",
		"postcode": "4741"
	},
	{
		"town": "yalbraith",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "yalca",
		"state": "vic",
		"postcode": "3637"
	},
	{
		"town": "yalgoo",
		"state": "wa",
		"postcode": "6635"
	},
	{
		"town": "yalla y poora",
		"state": "vic",
		"postcode": "3378"
	},
	{
		"town": "yallabatharra",
		"state": "wa",
		"postcode": "6535"
	},
	{
		"town": "yallah",
		"state": "nsw",
		"postcode": "2530"
	},
	{
		"town": "yallakool",
		"state": "nsw",
		"postcode": "2710"
	},
	{
		"town": "yallambie",
		"state": "nsw",
		"postcode": "2325"
	},
	{
		"town": "yallambie",
		"state": "vic",
		"postcode": "3085"
	},
	{
		"town": "yalleroi",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "yallingup",
		"state": "wa",
		"postcode": "6282"
	},
	{
		"town": "yallingup siding",
		"state": "wa",
		"postcode": "6281"
	},
	{
		"town": "yallock",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "yallook",
		"state": "vic",
		"postcode": "3571"
	},
	{
		"town": "yallourn",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "yallourn north",
		"state": "vic",
		"postcode": "3825"
	},
	{
		"town": "yallunda flat",
		"state": "sa",
		"postcode": "5607"
	},
	{
		"town": "yalpara",
		"state": "sa",
		"postcode": "5431"
	},
	{
		"town": "yalwal",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "yalyalup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "yam island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "yamala",
		"state": "qld",
		"postcode": "4720"
	},
	{
		"town": "yamanto",
		"state": "qld",
		"postcode": "4305"
	},
	{
		"town": "yamba",
		"state": "nsw",
		"postcode": "2464"
	},
	{
		"town": "yamba",
		"state": "sa",
		"postcode": "5341"
	},
	{
		"town": "yambacoona",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "yambuk",
		"state": "vic",
		"postcode": "3285"
	},
	{
		"town": "yambulla",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "yambuna",
		"state": "vic",
		"postcode": "3621"
	},
	{
		"town": "yamsion",
		"state": "qld",
		"postcode": "4405"
	},
	{
		"town": "yan yean",
		"state": "vic",
		"postcode": "3755"
	},
	{
		"town": "yan yean south",
		"state": "vic",
		"postcode": "3754"
	},
	{
		"town": "yanac",
		"state": "vic",
		"postcode": "3418"
	},
	{
		"town": "yanakie",
		"state": "vic",
		"postcode": "3960"
	},
	{
		"town": "yanakie south",
		"state": "vic",
		"postcode": "3959"
	},
	{
		"town": "yanchep",
		"state": "wa",
		"postcode": "6035"
	},
	{
		"town": "yanco",
		"state": "nsw",
		"postcode": "2703"
	},
	{
		"town": "yandanooka",
		"state": "wa",
		"postcode": "6522"
	},
	{
		"town": "yandaran",
		"state": "qld",
		"postcode": "4673"
	},
	{
		"town": "yandarlo",
		"state": "qld",
		"postcode": "4478"
	},
	{
		"town": "yanderra",
		"state": "nsw",
		"postcode": "2574"
	},
	{
		"town": "yandilla",
		"state": "qld",
		"postcode": "4352"
	},
	{
		"town": "yandina",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "yandina creek",
		"state": "qld",
		"postcode": "4561"
	},
	{
		"town": "yando",
		"state": "vic",
		"postcode": "3537"
	},
	{
		"town": "yandoit",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "yandoit hills",
		"state": "vic",
		"postcode": "3461"
	},
	{
		"town": "yandoo creek",
		"state": "wa",
		"postcode": "6701"
	},
	{
		"town": "yangan",
		"state": "qld",
		"postcode": "4371"
	},
	{
		"town": "yangebup",
		"state": "wa",
		"postcode": "6164"
	},
	{
		"town": "yangery",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "yaninee",
		"state": "sa",
		"postcode": "5653"
	},
	{
		"town": "yankalilla",
		"state": "sa",
		"postcode": "5203"
	},
	{
		"town": "yankees creek",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "yanmah",
		"state": "wa",
		"postcode": "6258"
	},
	{
		"town": "yannarie",
		"state": "wa",
		"postcode": "6710"
	},
	{
		"town": "yannathan",
		"state": "vic",
		"postcode": "3981"
	},
	{
		"town": "yannawah",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "yannergee",
		"state": "nsw",
		"postcode": "2343"
	},
	{
		"town": "yantabulla",
		"state": "nsw",
		"postcode": "2840"
	},
	{
		"town": "yantanabie",
		"state": "sa",
		"postcode": "5661"
	},
	{
		"town": "yanyarrie",
		"state": "sa",
		"postcode": "5432"
	},
	{
		"town": "yaouk",
		"state": "nsw",
		"postcode": "2630"
	},
	{
		"town": "yapeen",
		"state": "vic",
		"postcode": "3451"
	},
	{
		"town": "yapps",
		"state": "vic",
		"postcode": "3896"
	},
	{
		"town": "yaraka",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "yarawindah",
		"state": "wa",
		"postcode": "6509"
	},
	{
		"town": "yarck",
		"state": "vic",
		"postcode": "3719"
	},
	{
		"town": "yardarino",
		"state": "wa",
		"postcode": "6525"
	},
	{
		"town": "yarding",
		"state": "wa",
		"postcode": "6418"
	},
	{
		"town": "yargullen",
		"state": "qld",
		"postcode": "4401"
	},
	{
		"town": "yarlington",
		"state": "tas",
		"postcode": "7027"
	},
	{
		"town": "yarloop",
		"state": "wa",
		"postcode": "6218"
	},
	{
		"town": "yaroomba",
		"state": "qld",
		"postcode": "4573"
	},
	{
		"town": "yarpturk",
		"state": "vic",
		"postcode": "3283"
	},
	{
		"town": "yarra",
		"state": "nsw",
		"postcode": "2580"
	},
	{
		"town": "yarra creek",
		"state": "tas",
		"postcode": "7256"
	},
	{
		"town": "yarra glen",
		"state": "vic",
		"postcode": "3775"
	},
	{
		"town": "yarra junction",
		"state": "vic",
		"postcode": "3797"
	},
	{
		"town": "yarrabah",
		"state": "qld",
		"postcode": "4871"
	},
	{
		"town": "yarrabandi",
		"state": "nsw",
		"postcode": "2875"
	},
	{
		"town": "yarraberb",
		"state": "vic",
		"postcode": "3516"
	},
	{
		"town": "yarrabilba",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "yarrabin",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "yarraby",
		"state": "vic",
		"postcode": "3595"
	},
	{
		"town": "yarragal",
		"state": "nsw",
		"postcode": "2820"
	},
	{
		"town": "yarragon",
		"state": "vic",
		"postcode": "3823"
	},
	{
		"town": "yarragon south",
		"state": "vic",
		"postcode": "3823"
	},
	{
		"town": "yarragong",
		"state": "nsw",
		"postcode": "2871"
	},
	{
		"town": "yarragrin",
		"state": "nsw",
		"postcode": "2842"
	},
	{
		"town": "yarragundry",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "yarrah",
		"state": "sa",
		"postcode": "5433"
	},
	{
		"town": "yarrahapinni",
		"state": "nsw",
		"postcode": "2441"
	},
	{
		"town": "yarralumla",
		"state": "act",
		"postcode": "2600"
	},
	{
		"town": "yarram",
		"state": "vic",
		"postcode": "3971"
	},
	{
		"town": "yarram park",
		"state": "vic",
		"postcode": "3379"
	},
	{
		"town": "yarramalong",
		"state": "nsw",
		"postcode": "2259"
	},
	{
		"town": "yarraman",
		"state": "nsw",
		"postcode": "2400"
	},
	{
		"town": "yarraman",
		"state": "qld",
		"postcode": "4614"
	},
	{
		"town": "yarrambat",
		"state": "vic",
		"postcode": "3091"
	},
	{
		"town": "yarramundi",
		"state": "nsw",
		"postcode": "2753"
	},
	{
		"town": "yarranbella",
		"state": "nsw",
		"postcode": "2447"
	},
	{
		"town": "yarrangobilly",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "yarrangobilly caves",
		"state": "nsw",
		"postcode": "2720"
	},
	{
		"town": "yarranlea",
		"state": "qld",
		"postcode": "4356"
	},
	{
		"town": "yarras",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "yarras",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "yarratt forest",
		"state": "nsw",
		"postcode": "2429"
	},
	{
		"town": "yarravel",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "yarraville",
		"state": "vic",
		"postcode": "3013"
	},
	{
		"town": "yarraville west",
		"state": "vic",
		"postcode": "3013"
	},
	{
		"town": "yarrawa",
		"state": "nsw",
		"postcode": "2328"
	},
	{
		"town": "yarrawalla",
		"state": "vic",
		"postcode": "3575"
	},
	{
		"town": "yarrawarrah",
		"state": "nsw",
		"postcode": "2233"
	},
	{
		"town": "yarrawonga",
		"state": "nsw",
		"postcode": "2850"
	},
	{
		"town": "yarrawonga",
		"state": "nt",
		"postcode": "830"
	},
	{
		"town": "yarrawonga",
		"state": "qld",
		"postcode": "4810"
	},
	{
		"town": "yarrawonga",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "yarrawonga park",
		"state": "nsw",
		"postcode": "2264"
	},
	{
		"town": "yarrawonga south",
		"state": "vic",
		"postcode": "3730"
	},
	{
		"town": "yarrie lake",
		"state": "nsw",
		"postcode": "2388"
	},
	{
		"town": "yarrock",
		"state": "vic",
		"postcode": "3415"
	},
	{
		"town": "yarrol",
		"state": "qld",
		"postcode": "4630"
	},
	{
		"town": "yarrowee",
		"state": "vic",
		"postcode": "3357"
	},
	{
		"town": "yarroweyah",
		"state": "vic",
		"postcode": "3644"
	},
	{
		"town": "yarrowford",
		"state": "nsw",
		"postcode": "2370"
	},
	{
		"town": "yarrowitch",
		"state": "nsw",
		"postcode": "2354"
	},
	{
		"town": "yarrowyck",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "yarrunga",
		"state": "nsw",
		"postcode": "2577"
	},
	{
		"town": "yarrunga",
		"state": "vic",
		"postcode": "3415"
	},
	{
		"town": "yarrunga",
		"state": "vic",
		"postcode": "3677"
	},
	{
		"town": "yarto",
		"state": "vic",
		"postcode": "3396"
	},
	{
		"town": "yarwun",
		"state": "qld",
		"postcode": "4694"
	},
	{
		"town": "yass",
		"state": "nsw",
		"postcode": "2582"
	},
	{
		"town": "yatala",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "yatala vale",
		"state": "sa",
		"postcode": "5126"
	},
	{
		"town": "yatchaw",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "yathella",
		"state": "nsw",
		"postcode": "2650"
	},
	{
		"town": "yatina",
		"state": "sa",
		"postcode": "5422"
	},
	{
		"town": "yattalunga",
		"state": "nsw",
		"postcode": "2251"
	},
	{
		"town": "yattalunga",
		"state": "sa",
		"postcode": "5114"
	},
	{
		"town": "yatteyattah",
		"state": "nsw",
		"postcode": "2539"
	},
	{
		"town": "yaven creek",
		"state": "nsw",
		"postcode": "2729"
	},
	{
		"town": "yawong hills",
		"state": "vic",
		"postcode": "3478"
	},
	{
		"town": "yea",
		"state": "vic",
		"postcode": "3717"
	},
	{
		"town": "yeal",
		"state": "wa",
		"postcode": "6503"
	},
	{
		"town": "yealering",
		"state": "wa",
		"postcode": "6372"
	},
	{
		"town": "yearinan",
		"state": "nsw",
		"postcode": "2357"
	},
	{
		"town": "yearinga",
		"state": "vic",
		"postcode": "3419"
	},
	{
		"town": "yeelanna",
		"state": "sa",
		"postcode": "5632"
	},
	{
		"town": "yeelirrie",
		"state": "wa",
		"postcode": "6439"
	},
	{
		"town": "yeerip",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "yeerongpilly",
		"state": "qld",
		"postcode": "4105"
	},
	{
		"town": "yelarbon",
		"state": "qld",
		"postcode": "4388"
	},
	{
		"town": "yelbeni",
		"state": "wa",
		"postcode": "6487"
	},
	{
		"town": "yelgun",
		"state": "nsw",
		"postcode": "2483"
	},
	{
		"town": "yellangip",
		"state": "vic",
		"postcode": "3393"
	},
	{
		"town": "yellanup",
		"state": "wa",
		"postcode": "6326"
	},
	{
		"town": "yellingbo",
		"state": "vic",
		"postcode": "3139"
	},
	{
		"town": "yellow dam",
		"state": "nsw",
		"postcode": "2371"
	},
	{
		"town": "yellow pinch",
		"state": "nsw",
		"postcode": "2548"
	},
	{
		"town": "yellow rock",
		"state": "nsw",
		"postcode": "2527"
	},
	{
		"town": "yellow rock",
		"state": "nsw",
		"postcode": "2777"
	},
	{
		"town": "yellow wood",
		"state": "qld",
		"postcode": "4207"
	},
	{
		"town": "yellowdine",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "yelta",
		"state": "sa",
		"postcode": "5558"
	},
	{
		"town": "yelta",
		"state": "vic",
		"postcode": "3505"
	},
	{
		"town": "yelverton",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "yenda",
		"state": "nsw",
		"postcode": "2681"
	},
	{
		"town": "yenda",
		"state": "qld",
		"postcode": "4625"
	},
	{
		"town": "yendon",
		"state": "vic",
		"postcode": "3352"
	},
	{
		"town": "yengarie",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "yennora",
		"state": "nsw",
		"postcode": "2161"
	},
	{
		"town": "yeo",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "yeoburn east",
		"state": "vic",
		"postcode": "3579"
	},
	{
		"town": "yeodene",
		"state": "vic",
		"postcode": "3249"
	},
	{
		"town": "yeoval",
		"state": "nsw",
		"postcode": "2868"
	},
	{
		"town": "yeppoon",
		"state": "qld",
		"postcode": "4703"
	},
	{
		"town": "yerecoin",
		"state": "wa",
		"postcode": "6571"
	},
	{
		"town": "yering",
		"state": "vic",
		"postcode": "3770"
	},
	{
		"town": "yerong creek",
		"state": "nsw",
		"postcode": "2642"
	},
	{
		"town": "yeronga",
		"state": "qld",
		"postcode": "4104"
	},
	{
		"town": "yeronga west",
		"state": "qld",
		"postcode": "4104"
	},
	{
		"town": "yerra",
		"state": "qld",
		"postcode": "4650"
	},
	{
		"town": "yerranderie",
		"state": "nsw",
		"postcode": "2787"
	},
	{
		"town": "yerrinbool",
		"state": "nsw",
		"postcode": "2575"
	},
	{
		"town": "yerriyong",
		"state": "nsw",
		"postcode": "2540"
	},
	{
		"town": "yessabah",
		"state": "nsw",
		"postcode": "2440"
	},
	{
		"town": "yethera",
		"state": "nsw",
		"postcode": "2874"
	},
	{
		"town": "yetholme",
		"state": "nsw",
		"postcode": "2795"
	},
	{
		"town": "yetman",
		"state": "nsw",
		"postcode": "2410"
	},
	{
		"town": "yeungroon",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "yeungroon east",
		"state": "vic",
		"postcode": "3525"
	},
	{
		"town": "yielima",
		"state": "vic",
		"postcode": "3638"
	},
	{
		"town": "yilgarn",
		"state": "wa",
		"postcode": "6426"
	},
	{
		"town": "yilki",
		"state": "sa",
		"postcode": "5211"
	},
	{
		"town": "yilliminning",
		"state": "wa",
		"postcode": "6312"
	},
	{
		"town": "yimbun",
		"state": "qld",
		"postcode": "4313"
	},
	{
		"town": "yinkanie",
		"state": "sa",
		"postcode": "5332"
	},
	{
		"town": "yinnar",
		"state": "vic",
		"postcode": "3869"
	},
	{
		"town": "yinnar south",
		"state": "vic",
		"postcode": "3869"
	},
	{
		"town": "yippin creek",
		"state": "nsw",
		"postcode": "2446"
	},
	{
		"town": "yirrkala",
		"state": "nt",
		"postcode": "880"
	},
	{
		"town": "yoganup",
		"state": "wa",
		"postcode": "6275"
	},
	{
		"town": "yokine",
		"state": "wa",
		"postcode": "6060"
	},
	{
		"town": "yolla",
		"state": "tas",
		"postcode": "7325"
	},
	{
		"town": "yongala",
		"state": "sa",
		"postcode": "5493"
	},
	{
		"town": "yongurra",
		"state": "nsw",
		"postcode": "2474"
	},
	{
		"town": "yoogali",
		"state": "nsw",
		"postcode": "2680"
	},
	{
		"town": "yoongarillup",
		"state": "wa",
		"postcode": "6280"
	},
	{
		"town": "yooroonah",
		"state": "nsw",
		"postcode": "2350"
	},
	{
		"town": "york",
		"state": "wa",
		"postcode": "6302"
	},
	{
		"town": "york plains",
		"state": "tas",
		"postcode": "7120"
	},
	{
		"town": "york town",
		"state": "tas",
		"postcode": "7270"
	},
	{
		"town": "yorke island",
		"state": "qld",
		"postcode": "4875"
	},
	{
		"town": "yorke valley",
		"state": "sa",
		"postcode": "5573"
	},
	{
		"town": "yorketown",
		"state": "sa",
		"postcode": "5576"
	},
	{
		"town": "yorkeys knob",
		"state": "qld",
		"postcode": "4878"
	},
	{
		"town": "yorklea",
		"state": "nsw",
		"postcode": "2470"
	},
	{
		"town": "yorkrakine",
		"state": "wa",
		"postcode": "6409"
	},
	{
		"town": "yorkshire flat",
		"state": "vic",
		"postcode": "3520"
	},
	{
		"town": "yornaning",
		"state": "wa",
		"postcode": "6311"
	},
	{
		"town": "yornup",
		"state": "wa",
		"postcode": "6256"
	},
	{
		"town": "yosemite",
		"state": "nsw",
		"postcode": "2780"
	},
	{
		"town": "yoting",
		"state": "wa",
		"postcode": "6383"
	},
	{
		"town": "youanmi",
		"state": "wa",
		"postcode": "6638"
	},
	{
		"town": "youanmite",
		"state": "vic",
		"postcode": "3646"
	},
	{
		"town": "youarang",
		"state": "vic",
		"postcode": "3728"
	},
	{
		"town": "youndegin",
		"state": "wa",
		"postcode": "6407"
	},
	{
		"town": "young",
		"state": "nsw",
		"postcode": "2594"
	},
	{
		"town": "youngs siding",
		"state": "wa",
		"postcode": "6330"
	},
	{
		"town": "youngtown",
		"state": "tas",
		"postcode": "7249"
	},
	{
		"town": "youngvale",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "yowie bay",
		"state": "nsw",
		"postcode": "2228"
	},
	{
		"town": "yowrie",
		"state": "nsw",
		"postcode": "2550"
	},
	{
		"town": "yuelamu",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "yuendumu",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "yugar",
		"state": "qld",
		"postcode": "4520"
	},
	{
		"town": "yuin",
		"state": "wa",
		"postcode": "6635"
	},
	{
		"town": "yulabilla",
		"state": "qld",
		"postcode": "4416"
	},
	{
		"town": "yulara",
		"state": "nt",
		"postcode": "872"
	},
	{
		"town": "yuleba",
		"state": "qld",
		"postcode": "4427"
	},
	{
		"town": "yulecart",
		"state": "vic",
		"postcode": "3301"
	},
	{
		"town": "yullundry",
		"state": "nsw",
		"postcode": "2867"
	},
	{
		"town": "yulong soldiers settlement",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "yuluma",
		"state": "nsw",
		"postcode": "2645"
	},
	{
		"town": "yulungah",
		"state": "vic",
		"postcode": "3824"
	},
	{
		"town": "yumali",
		"state": "sa",
		"postcode": "5261"
	},
	{
		"town": "yuna",
		"state": "wa",
		"postcode": "6532"
	},
	{
		"town": "yundi",
		"state": "sa",
		"postcode": "5172"
	},
	{
		"town": "yundool",
		"state": "vic",
		"postcode": "3727"
	},
	{
		"town": "yungaburra",
		"state": "qld",
		"postcode": "4872"
	},
	{
		"town": "yungera",
		"state": "vic",
		"postcode": "3597"
	},
	{
		"town": "yunta",
		"state": "sa",
		"postcode": "5440"
	},
	{
		"town": "yuroke",
		"state": "vic",
		"postcode": "3063"
	},
	{
		"town": "yuulong",
		"state": "vic",
		"postcode": "3237"
	},
	{
		"town": "zanthus",
		"state": "wa",
		"postcode": "6434"
	},
	{
		"town": "zara",
		"state": "nsw",
		"postcode": "2484"
	},
	{
		"town": "zeehan",
		"state": "tas",
		"postcode": "7469"
	},
	{
		"town": "zeerust",
		"state": "vic",
		"postcode": "3634"
	},
	{
		"town": "zetland",
		"state": "nsw",
		"postcode": "2017"
	},
	{
		"town": "zillmere",
		"state": "qld",
		"postcode": "4034"
	},
	{
		"town": "zilzie",
		"state": "qld",
		"postcode": "4702"
	},
	{
		"town": "zumsteins",
		"state": "vic",
		"postcode": "3401"
	},
	{
		"town": "zuytdorp",
		"state": "wa",
		"postcode": "6536"
	}
]
